import * as React from 'react';
import React__default, { Component, useState, useEffect, cloneElement, Fragment } from 'react';
import classNames from 'classnames';
import ReactDOM from 'react-dom';
import InputMask from 'react-input-mask';
import Moment from 'moment';
import ReactModal from 'react-modal';

function _typeof$4(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$4 = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof$4 = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof$4(obj);
}

function asyncGeneratorStep$i(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator$i(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep$i(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep$i(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck$m(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$m(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$m(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$m(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$m(Constructor, staticProps);
  return Constructor;
}

function _defineProperty$r(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits$m(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$m(subClass, superClass);
}

function _getPrototypeOf$m(o) {
  _getPrototypeOf$m = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$m(o);
}

function _setPrototypeOf$m(o, p) {
  _setPrototypeOf$m = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$m(o, p);
}

function _isNativeReflectConstruct$m() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized$m(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn$m(self, call) {
  if (call && (_typeof$4(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized$m(self);
}

function _createSuper$m(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$m();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf$m(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$m(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn$m(this, result);
  };
}

var Icon$i = function Icon(_ref) {
  var name = _ref.name,
      style = _ref.style,
      className = _ref.className,
      ariaLabel = _ref.ariaLabel,
      onClick = _ref.onClick,
      src = _ref.src,
      qa = _ref.qa;
  /**
   * Inject SVG icons from core branding into page
   */

  var fetchAntwerpIcons = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator$i( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var xlinkHref, response, svgText, svgWrapper;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (fetch) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              _context.prev = 2;
              xlinkHref = 'https://cdn.antwerpen.be/core_branding_scss/5.0.0/assets/images/ai.svg';
              _context.next = 6;
              return fetch(xlinkHref);

            case 6:
              response = _context.sent;
              _context.next = 9;
              return response.text();

            case 9:
              svgText = _context.sent;
              svgWrapper = document.createElement('svg');
              svgWrapper.id = 'aiSvg';
              svgWrapper.innerHTML = svgText;

              if (!document.getElementById('aiSvg')) {
                document.body.appendChild(svgWrapper);
              }

              _context.next = 19;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](2);
              throw new Error(_context.t0);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 16]]);
    }));

    return function fetchAntwerpIcons() {
      return _ref2.apply(this, arguments);
    };
  }();

  if (typeof document !== 'undefined' && !document.getElementById('aiSvg')) {
    fetchAntwerpIcons();
  }

  var iconClass = classNames(className, name, 'ai');
  return /*#__PURE__*/React__default.createElement("span", {
    className: iconClass,
    style: style,
    "data-qa": qa,
    onClick: onClick
  }, name && /*#__PURE__*/React__default.createElement("svg", {
    "aria-hidden": "true"
  }, /*#__PURE__*/React__default.createElement("use", {
    href: "#".concat(name)
  })), src, ariaLabel && /*#__PURE__*/React__default.createElement("span", {
    className: "u-screen-reader-only"
  }, ariaLabel));
};

var sizeClasses$d = {
  tiny: 'a-button--tiny',
  small: 'a-button--small',
  large: 'a-button--large'
};
var typeClasses$1$1 = {
  primary: '',
  secondary: 'a-button--secondary',
  success: 'a-button--success',
  warning: 'a-button--warning',
  danger: 'a-button--danger',
  transparent: 'a-button--transparent',
  default: 'a-button--default'
};

var Button$b = /*#__PURE__*/function (_Component) {
  _inherits$m(Button, _Component);

  var _super = _createSuper$m(Button);

  function Button() {
    _classCallCheck$m(this, Button);

    return _super.apply(this, arguments);
  }

  _createClass$m(Button, [{
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props = this.props,
          id = _this$props.id,
          negative = _this$props.negative,
          outline = _this$props.outline,
          transparent = _this$props.transparent,
          className = _this$props.className,
          children = _this$props.children,
          icon = _this$props.icon,
          iconLeft = _this$props.iconLeft,
          iconRight = _this$props.iconRight,
          onClick = _this$props.onClick,
          _this$props$title = _this$props.title,
          title = _this$props$title === void 0 ? '' : _this$props$title,
          _this$props$ariaLabel = _this$props.ariaLabel,
          ariaLabel = _this$props$ariaLabel === void 0 ? '' : _this$props$ariaLabel,
          type = _this$props.type,
          size = _this$props.size,
          _this$props$block = _this$props.block,
          block = _this$props$block === void 0 ? false : _this$props$block,
          _this$props$style = _this$props.style,
          style = _this$props$style === void 0 ? {} : _this$props$style,
          _this$props$disabled = _this$props.disabled,
          disabled = _this$props$disabled === void 0 ? false : _this$props$disabled,
          htmlType = _this$props.htmlType,
          qa = _this$props.qa;
      var btnClass = classNames(className, (_classNames = {
        'a-button': !outline && !negative && !(type === 'default' && !!transparent)
      }, _defineProperty$r(_classNames, "".concat(typeClasses$1$1[type]), !!type), _defineProperty$r(_classNames, "".concat(sizeClasses$d[size]), !!size), _defineProperty$r(_classNames, 'has-icon', !!icon), _defineProperty$r(_classNames, 'has-icon-left', !!iconLeft), _defineProperty$r(_classNames, 'has-icon-right', !!iconRight), _defineProperty$r(_classNames, 'a-button-negative', !!negative), _defineProperty$r(_classNames, 'a-button-outline', !!outline), _defineProperty$r(_classNames, 'a-button-transparent', !!transparent), _defineProperty$r(_classNames, 'a-button--block', block), _classNames));
      return /*#__PURE__*/React__default.createElement("button", {
        id: id,
        className: btnClass,
        title: title || '',
        onClick: onClick,
        style: style,
        disabled: disabled,
        type: htmlType,
        "aria-label": ariaLabel,
        "data-qa": qa
      }, icon ? /*#__PURE__*/React__default.createElement(Icon$i, {
        name: icon
      }) : null, iconLeft ? /*#__PURE__*/React__default.createElement(Icon$i, {
        name: iconLeft
      }) : null, iconRight ? /*#__PURE__*/React__default.createElement(Icon$i, {
        name: iconRight
      }) : null, children);
    }
  }]);

  return Button;
}(Component);

var typeClasses$d = {
  success: 'm-alert--success',
  warning: 'm-alert--warning',
  danger: 'm-alert--danger'
};

var Alert = /*#__PURE__*/function (_Component) {
  _inherits$m(Alert, _Component);

  var _super = _createSuper$m(Alert);

  function Alert() {
    var _this;

    _classCallCheck$m(this, Alert);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$r(_assertThisInitialized$m(_this), "state", {
      closing: true,
      closed: false
    });

    _defineProperty$r(_assertThisInitialized$m(_this), "handleClose", function (e) {
      var onClose = _this.props.onClose;
      e.preventDefault();
      onClose && onClose();

      _this.setState({
        closed: true
      });
    });

    return _this;
  }

  _createClass$m(Alert, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          type = _this$props.type,
          title = _this$props.title,
          children = _this$props.children,
          closable = _this$props.closable,
          _this$props$ariaLabel = _this$props.ariaLabelClose,
          ariaLabelClose = _this$props$ariaLabel === void 0 ? 'Sluiten' : _this$props$ariaLabel,
          className = _this$props.className,
          qa = _this$props.qa;
      var closed = this.state.closed;
      var alertClass = classNames('m-alert', _defineProperty$r({}, "".concat(typeClasses$d[type]), !!type), className);
      var closeButton = closable ? /*#__PURE__*/React__default.createElement(Button$b, {
        type: type,
        icon: "ai-close",
        onClick: this.handleClose,
        className: "m-alert__close a-button-transparent",
        ariaLabel: ariaLabelClose
      }) : null;
      return /*#__PURE__*/React__default.createElement("div", {
        role: "alert"
      }, !closed ? /*#__PURE__*/React__default.createElement("div", {
        className: alertClass,
        "data-qa": qa
      }, closeButton, title && /*#__PURE__*/React__default.createElement("h5", {
        className: "u-margin-bottom-xs"
      }, title), children) : /*#__PURE__*/React__default.createElement("div", null));
    }
  }]);

  return Alert;
}(Component);

function ___$insertStyle$5(css) {
  if (!css) {
    return;
  }

  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');
  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

function _typeof$3(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$3 = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$3 = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof$3(obj);
}

function _classCallCheck$1$3(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$1$3(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$1$3(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$1$3(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$1$3(Constructor, staticProps);
  return Constructor;
}

function _defineProperty$1$3(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits$1$3(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$1$3(subClass, superClass);
}

function _getPrototypeOf$1$3(o) {
  _getPrototypeOf$1$3 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$1$3(o);
}

function _setPrototypeOf$1$3(o, p) {
  _setPrototypeOf$1$3 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$1$3(o, p);
}

function _isNativeReflectConstruct$1$3() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized$1$3(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn$1$3(self, call) {
  if (call && (_typeof$4(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized$1$3(self);
}

function _createSuper$1$3(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$1$3();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf$1$3(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$1$3(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn$1$3(this, result);
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray$3(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$3(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray$3(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$3(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$3(o, minLen);
}

function _arrayLikeToArray$3(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

/* global Reflect, Promise */


var _extendStatics = function extendStatics(d, b) {
  _extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return _extendStatics(d, b);
};

function __extends(d, b) {
  _extendStatics(d, b);

  function __() {
    this.constructor = d;
  }

  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
/** PURE_IMPORTS_START  PURE_IMPORTS_END */


function isFunction(x) {
  return typeof x === 'function';
}
/** PURE_IMPORTS_START  PURE_IMPORTS_END */


var _enable_super_gross_mode_that_will_cause_bad_things = false;
var config = {
  Promise: undefined,

  set useDeprecatedSynchronousErrorHandling(value) {
    if (value) {
      var error = /*@__PURE__*/new Error();
      /*@__PURE__*/

      console.warn('DEPRECATED! RxJS was set to use deprecated synchronous error handling behavior by code at: \n' + error.stack);
    }

    _enable_super_gross_mode_that_will_cause_bad_things = value;
  },

  get useDeprecatedSynchronousErrorHandling() {
    return _enable_super_gross_mode_that_will_cause_bad_things;
  }

};
/** PURE_IMPORTS_START  PURE_IMPORTS_END */

function hostReportError(err) {
  setTimeout(function () {
    throw err;
  }, 0);
}
/** PURE_IMPORTS_START _config,_util_hostReportError PURE_IMPORTS_END */


var empty = {
  closed: true,
  next: function next(value) {},
  error: function error(err) {
    if (config.useDeprecatedSynchronousErrorHandling) {
      throw err;
    } else {
      hostReportError(err);
    }
  },
  complete: function complete() {}
};
/** PURE_IMPORTS_START  PURE_IMPORTS_END */

var isArray = /*@__PURE__*/function () {
  return Array.isArray || function (x) {
    return x && typeof x.length === 'number';
  };
}();
/** PURE_IMPORTS_START  PURE_IMPORTS_END */


function isObject$1(x) {
  return x !== null && _typeof$3(x) === 'object';
}
/** PURE_IMPORTS_START  PURE_IMPORTS_END */


var UnsubscriptionErrorImpl = /*@__PURE__*/function () {
  function UnsubscriptionErrorImpl(errors) {
    Error.call(this);
    this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function (err, i) {
      return i + 1 + ") " + err.toString();
    }).join('\n  ') : '';
    this.name = 'UnsubscriptionError';
    this.errors = errors;
    return this;
  }

  UnsubscriptionErrorImpl.prototype = /*@__PURE__*/Object.create(Error.prototype);
  return UnsubscriptionErrorImpl;
}();

var UnsubscriptionError = UnsubscriptionErrorImpl;

var Subscription = function () {
  function Subscription(unsubscribe) {
    this.closed = false;
    this._parentOrParents = null;
    this._subscriptions = null;

    if (unsubscribe) {
      this._ctorUnsubscribe = true;
      this._unsubscribe = unsubscribe;
    }
  }

  Subscription.prototype.unsubscribe = function () {
    var errors;

    if (this.closed) {
      return;
    }

    var _a = this,
        _parentOrParents = _a._parentOrParents,
        _ctorUnsubscribe = _a._ctorUnsubscribe,
        _unsubscribe = _a._unsubscribe,
        _subscriptions = _a._subscriptions;

    this.closed = true;
    this._parentOrParents = null;
    this._subscriptions = null;

    if (_parentOrParents instanceof Subscription) {
      _parentOrParents.remove(this);
    } else if (_parentOrParents !== null) {
      for (var index = 0; index < _parentOrParents.length; ++index) {
        var parent_1 = _parentOrParents[index];
        parent_1.remove(this);
      }
    }

    if (isFunction(_unsubscribe)) {
      if (_ctorUnsubscribe) {
        this._unsubscribe = undefined;
      }

      try {
        _unsubscribe.call(this);
      } catch (e) {
        errors = e instanceof UnsubscriptionError ? flattenUnsubscriptionErrors(e.errors) : [e];
      }
    }

    if (isArray(_subscriptions)) {
      var index = -1;
      var len = _subscriptions.length;

      while (++index < len) {
        var sub = _subscriptions[index];

        if (isObject$1(sub)) {
          try {
            sub.unsubscribe();
          } catch (e) {
            errors = errors || [];

            if (e instanceof UnsubscriptionError) {
              errors = errors.concat(flattenUnsubscriptionErrors(e.errors));
            } else {
              errors.push(e);
            }
          }
        }
      }
    }

    if (errors) {
      throw new UnsubscriptionError(errors);
    }
  };

  Subscription.prototype.add = function (teardown) {
    var subscription = teardown;

    if (!teardown) {
      return Subscription.EMPTY;
    }

    switch (_typeof$3(teardown)) {
      case 'function':
        subscription = new Subscription(teardown);

      case 'object':
        if (subscription === this || subscription.closed || typeof subscription.unsubscribe !== 'function') {
          return subscription;
        } else if (this.closed) {
          subscription.unsubscribe();
          return subscription;
        } else if (!(subscription instanceof Subscription)) {
          var tmp = subscription;
          subscription = new Subscription();
          subscription._subscriptions = [tmp];
        }

        break;

      default:
        {
          throw new Error('unrecognized teardown ' + teardown + ' added to Subscription.');
        }
    }

    var _parentOrParents = subscription._parentOrParents;

    if (_parentOrParents === null) {
      subscription._parentOrParents = this;
    } else if (_parentOrParents instanceof Subscription) {
      if (_parentOrParents === this) {
        return subscription;
      }

      subscription._parentOrParents = [_parentOrParents, this];
    } else if (_parentOrParents.indexOf(this) === -1) {
      _parentOrParents.push(this);
    } else {
      return subscription;
    }

    var subscriptions = this._subscriptions;

    if (subscriptions === null) {
      this._subscriptions = [subscription];
    } else {
      subscriptions.push(subscription);
    }

    return subscription;
  };

  Subscription.prototype.remove = function (subscription) {
    var subscriptions = this._subscriptions;

    if (subscriptions) {
      var subscriptionIndex = subscriptions.indexOf(subscription);

      if (subscriptionIndex !== -1) {
        subscriptions.splice(subscriptionIndex, 1);
      }
    }
  };

  Subscription.EMPTY = function (empty) {
    empty.closed = true;
    return empty;
  }(new Subscription());

  return Subscription;
}();

function flattenUnsubscriptionErrors(errors) {
  return errors.reduce(function (errs, err) {
    return errs.concat(err instanceof UnsubscriptionError ? err.errors : err);
  }, []);
}
/** PURE_IMPORTS_START  PURE_IMPORTS_END */


var rxSubscriber = /*@__PURE__*/function () {
  return typeof Symbol === 'function' ? /*@__PURE__*/Symbol('rxSubscriber') : '@@rxSubscriber_' + /*@__PURE__*/Math.random();
}();

var Subscriber = function (_super) {
  __extends(Subscriber, _super);

  function Subscriber(destinationOrNext, error, complete) {
    var _this = _super.call(this) || this;

    _this.syncErrorValue = null;
    _this.syncErrorThrown = false;
    _this.syncErrorThrowable = false;
    _this.isStopped = false;

    switch (arguments.length) {
      case 0:
        _this.destination = empty;
        break;

      case 1:
        if (!destinationOrNext) {
          _this.destination = empty;
          break;
        }

        if (_typeof$3(destinationOrNext) === 'object') {
          if (destinationOrNext instanceof Subscriber) {
            _this.syncErrorThrowable = destinationOrNext.syncErrorThrowable;
            _this.destination = destinationOrNext;
            destinationOrNext.add(_this);
          } else {
            _this.syncErrorThrowable = true;
            _this.destination = new SafeSubscriber(_this, destinationOrNext);
          }

          break;
        }

      default:
        _this.syncErrorThrowable = true;
        _this.destination = new SafeSubscriber(_this, destinationOrNext, error, complete);
        break;
    }

    return _this;
  }

  Subscriber.prototype[rxSubscriber] = function () {
    return this;
  };

  Subscriber.create = function (next, error, complete) {
    var subscriber = new Subscriber(next, error, complete);
    subscriber.syncErrorThrowable = false;
    return subscriber;
  };

  Subscriber.prototype.next = function (value) {
    if (!this.isStopped) {
      this._next(value);
    }
  };

  Subscriber.prototype.error = function (err) {
    if (!this.isStopped) {
      this.isStopped = true;

      this._error(err);
    }
  };

  Subscriber.prototype.complete = function () {
    if (!this.isStopped) {
      this.isStopped = true;

      this._complete();
    }
  };

  Subscriber.prototype.unsubscribe = function () {
    if (this.closed) {
      return;
    }

    this.isStopped = true;

    _super.prototype.unsubscribe.call(this);
  };

  Subscriber.prototype._next = function (value) {
    this.destination.next(value);
  };

  Subscriber.prototype._error = function (err) {
    this.destination.error(err);
    this.unsubscribe();
  };

  Subscriber.prototype._complete = function () {
    this.destination.complete();
    this.unsubscribe();
  };

  Subscriber.prototype._unsubscribeAndRecycle = function () {
    var _parentOrParents = this._parentOrParents;
    this._parentOrParents = null;
    this.unsubscribe();
    this.closed = false;
    this.isStopped = false;
    this._parentOrParents = _parentOrParents;
    return this;
  };

  return Subscriber;
}(Subscription);

var SafeSubscriber = function (_super) {
  __extends(SafeSubscriber, _super);

  function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
    var _this = _super.call(this) || this;

    _this._parentSubscriber = _parentSubscriber;
    var next;
    var context = _this;

    if (isFunction(observerOrNext)) {
      next = observerOrNext;
    } else if (observerOrNext) {
      next = observerOrNext.next;
      error = observerOrNext.error;
      complete = observerOrNext.complete;

      if (observerOrNext !== empty) {
        context = Object.create(observerOrNext);

        if (isFunction(context.unsubscribe)) {
          _this.add(context.unsubscribe.bind(context));
        }

        context.unsubscribe = _this.unsubscribe.bind(_this);
      }
    }

    _this._context = context;
    _this._next = next;
    _this._error = error;
    _this._complete = complete;
    return _this;
  }

  SafeSubscriber.prototype.next = function (value) {
    if (!this.isStopped && this._next) {
      var _parentSubscriber = this._parentSubscriber;

      if (!config.useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
        this.__tryOrUnsub(this._next, value);
      } else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) {
        this.unsubscribe();
      }
    }
  };

  SafeSubscriber.prototype.error = function (err) {
    if (!this.isStopped) {
      var _parentSubscriber = this._parentSubscriber;
      var useDeprecatedSynchronousErrorHandling = config.useDeprecatedSynchronousErrorHandling;

      if (this._error) {
        if (!useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
          this.__tryOrUnsub(this._error, err);

          this.unsubscribe();
        } else {
          this.__tryOrSetError(_parentSubscriber, this._error, err);

          this.unsubscribe();
        }
      } else if (!_parentSubscriber.syncErrorThrowable) {
        this.unsubscribe();

        if (useDeprecatedSynchronousErrorHandling) {
          throw err;
        }

        hostReportError(err);
      } else {
        if (useDeprecatedSynchronousErrorHandling) {
          _parentSubscriber.syncErrorValue = err;
          _parentSubscriber.syncErrorThrown = true;
        } else {
          hostReportError(err);
        }

        this.unsubscribe();
      }
    }
  };

  SafeSubscriber.prototype.complete = function () {
    var _this = this;

    if (!this.isStopped) {
      var _parentSubscriber = this._parentSubscriber;

      if (this._complete) {
        var wrappedComplete = function wrappedComplete() {
          return _this._complete.call(_this._context);
        };

        if (!config.useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
          this.__tryOrUnsub(wrappedComplete);

          this.unsubscribe();
        } else {
          this.__tryOrSetError(_parentSubscriber, wrappedComplete);

          this.unsubscribe();
        }
      } else {
        this.unsubscribe();
      }
    }
  };

  SafeSubscriber.prototype.__tryOrUnsub = function (fn, value) {
    try {
      fn.call(this._context, value);
    } catch (err) {
      this.unsubscribe();

      if (config.useDeprecatedSynchronousErrorHandling) {
        throw err;
      } else {
        hostReportError(err);
      }
    }
  };

  SafeSubscriber.prototype.__tryOrSetError = function (parent, fn, value) {
    if (!config.useDeprecatedSynchronousErrorHandling) {
      throw new Error('bad call');
    }

    try {
      fn.call(this._context, value);
    } catch (err) {
      if (config.useDeprecatedSynchronousErrorHandling) {
        parent.syncErrorValue = err;
        parent.syncErrorThrown = true;
        return true;
      } else {
        hostReportError(err);
        return true;
      }
    }

    return false;
  };

  SafeSubscriber.prototype._unsubscribe = function () {
    var _parentSubscriber = this._parentSubscriber;
    this._context = null;
    this._parentSubscriber = null;

    _parentSubscriber.unsubscribe();
  };

  return SafeSubscriber;
}(Subscriber);
/** PURE_IMPORTS_START _Subscriber PURE_IMPORTS_END */


function canReportError(observer) {
  while (observer) {
    var _a = observer,
        closed_1 = _a.closed,
        destination = _a.destination,
        isStopped = _a.isStopped;

    if (closed_1 || isStopped) {
      return false;
    } else if (destination && destination instanceof Subscriber) {
      observer = destination;
    } else {
      observer = null;
    }
  }

  return true;
}
/** PURE_IMPORTS_START _Subscriber,_symbol_rxSubscriber,_Observer PURE_IMPORTS_END */


function toSubscriber(nextOrObserver, error, complete) {
  if (nextOrObserver) {
    if (nextOrObserver instanceof Subscriber) {
      return nextOrObserver;
    }

    if (nextOrObserver[rxSubscriber]) {
      return nextOrObserver[rxSubscriber]();
    }
  }

  if (!nextOrObserver && !error && !complete) {
    return new Subscriber(empty);
  }

  return new Subscriber(nextOrObserver, error, complete);
}
/** PURE_IMPORTS_START  PURE_IMPORTS_END */


var observable = /*@__PURE__*/function () {
  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();
/** PURE_IMPORTS_START  PURE_IMPORTS_END */


function identity(x) {
  return x;
}
/** PURE_IMPORTS_START _identity PURE_IMPORTS_END */


function pipeFromArray(fns) {
  if (fns.length === 0) {
    return identity;
  }

  if (fns.length === 1) {
    return fns[0];
  }

  return function piped(input) {
    return fns.reduce(function (prev, fn) {
      return fn(prev);
    }, input);
  };
}
/** PURE_IMPORTS_START _util_canReportError,_util_toSubscriber,_symbol_observable,_util_pipe,_config PURE_IMPORTS_END */


var Observable = function () {
  function Observable(subscribe) {
    this._isScalar = false;

    if (subscribe) {
      this._subscribe = subscribe;
    }
  }

  Observable.prototype.lift = function (operator) {
    var observable = new Observable();
    observable.source = this;
    observable.operator = operator;
    return observable;
  };

  Observable.prototype.subscribe = function (observerOrNext, error, complete) {
    var operator = this.operator;
    var sink = toSubscriber(observerOrNext, error, complete);

    if (operator) {
      sink.add(operator.call(sink, this.source));
    } else {
      sink.add(this.source || config.useDeprecatedSynchronousErrorHandling && !sink.syncErrorThrowable ? this._subscribe(sink) : this._trySubscribe(sink));
    }

    if (config.useDeprecatedSynchronousErrorHandling) {
      if (sink.syncErrorThrowable) {
        sink.syncErrorThrowable = false;

        if (sink.syncErrorThrown) {
          throw sink.syncErrorValue;
        }
      }
    }

    return sink;
  };

  Observable.prototype._trySubscribe = function (sink) {
    try {
      return this._subscribe(sink);
    } catch (err) {
      if (config.useDeprecatedSynchronousErrorHandling) {
        sink.syncErrorThrown = true;
        sink.syncErrorValue = err;
      }

      if (canReportError(sink)) {
        sink.error(err);
      } else {
        console.warn(err);
      }
    }
  };

  Observable.prototype.forEach = function (next, promiseCtor) {
    var _this = this;

    promiseCtor = getPromiseCtor(promiseCtor);
    return new promiseCtor(function (resolve, reject) {
      var subscription;
      subscription = _this.subscribe(function (value) {
        try {
          next(value);
        } catch (err) {
          reject(err);

          if (subscription) {
            subscription.unsubscribe();
          }
        }
      }, reject, resolve);
    });
  };

  Observable.prototype._subscribe = function (subscriber) {
    var source = this.source;
    return source && source.subscribe(subscriber);
  };

  Observable.prototype[observable] = function () {
    return this;
  };

  Observable.prototype.pipe = function () {
    var operations = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      operations[_i] = arguments[_i];
    }

    if (operations.length === 0) {
      return this;
    }

    return pipeFromArray(operations)(this);
  };

  Observable.prototype.toPromise = function (promiseCtor) {
    var _this = this;

    promiseCtor = getPromiseCtor(promiseCtor);
    return new promiseCtor(function (resolve, reject) {
      var value;

      _this.subscribe(function (x) {
        return value = x;
      }, function (err) {
        return reject(err);
      }, function () {
        return resolve(value);
      });
    });
  };

  Observable.create = function (subscribe) {
    return new Observable(subscribe);
  };

  return Observable;
}();

function getPromiseCtor(promiseCtor) {
  if (!promiseCtor) {
    promiseCtor = Promise;
  }

  if (!promiseCtor) {
    throw new Error('no Promise impl found');
  }

  return promiseCtor;
}
/** PURE_IMPORTS_START  PURE_IMPORTS_END */


var ObjectUnsubscribedErrorImpl = /*@__PURE__*/function () {
  function ObjectUnsubscribedErrorImpl() {
    Error.call(this);
    this.message = 'object unsubscribed';
    this.name = 'ObjectUnsubscribedError';
    return this;
  }

  ObjectUnsubscribedErrorImpl.prototype = /*@__PURE__*/Object.create(Error.prototype);
  return ObjectUnsubscribedErrorImpl;
}();

var ObjectUnsubscribedError = ObjectUnsubscribedErrorImpl;
/** PURE_IMPORTS_START tslib,_Subscription PURE_IMPORTS_END */

var SubjectSubscription = function (_super) {
  __extends(SubjectSubscription, _super);

  function SubjectSubscription(subject, subscriber) {
    var _this = _super.call(this) || this;

    _this.subject = subject;
    _this.subscriber = subscriber;
    _this.closed = false;
    return _this;
  }

  SubjectSubscription.prototype.unsubscribe = function () {
    if (this.closed) {
      return;
    }

    this.closed = true;
    var subject = this.subject;
    var observers = subject.observers;
    this.subject = null;

    if (!observers || observers.length === 0 || subject.isStopped || subject.closed) {
      return;
    }

    var subscriberIndex = observers.indexOf(this.subscriber);

    if (subscriberIndex !== -1) {
      observers.splice(subscriberIndex, 1);
    }
  };

  return SubjectSubscription;
}(Subscription);
/** PURE_IMPORTS_START tslib,_Observable,_Subscriber,_Subscription,_util_ObjectUnsubscribedError,_SubjectSubscription,_internal_symbol_rxSubscriber PURE_IMPORTS_END */


var SubjectSubscriber = function (_super) {
  __extends(SubjectSubscriber, _super);

  function SubjectSubscriber(destination) {
    var _this = _super.call(this, destination) || this;

    _this.destination = destination;
    return _this;
  }

  return SubjectSubscriber;
}(Subscriber);

var Subject = function (_super) {
  __extends(Subject, _super);

  function Subject() {
    var _this = _super.call(this) || this;

    _this.observers = [];
    _this.closed = false;
    _this.isStopped = false;
    _this.hasError = false;
    _this.thrownError = null;
    return _this;
  }

  Subject.prototype[rxSubscriber] = function () {
    return new SubjectSubscriber(this);
  };

  Subject.prototype.lift = function (operator) {
    var subject = new AnonymousSubject(this, this);
    subject.operator = operator;
    return subject;
  };

  Subject.prototype.next = function (value) {
    if (this.closed) {
      throw new ObjectUnsubscribedError();
    }

    if (!this.isStopped) {
      var observers = this.observers;
      var len = observers.length;
      var copy = observers.slice();

      for (var i = 0; i < len; i++) {
        copy[i].next(value);
      }
    }
  };

  Subject.prototype.error = function (err) {
    if (this.closed) {
      throw new ObjectUnsubscribedError();
    }

    this.hasError = true;
    this.thrownError = err;
    this.isStopped = true;
    var observers = this.observers;
    var len = observers.length;
    var copy = observers.slice();

    for (var i = 0; i < len; i++) {
      copy[i].error(err);
    }

    this.observers.length = 0;
  };

  Subject.prototype.complete = function () {
    if (this.closed) {
      throw new ObjectUnsubscribedError();
    }

    this.isStopped = true;
    var observers = this.observers;
    var len = observers.length;
    var copy = observers.slice();

    for (var i = 0; i < len; i++) {
      copy[i].complete();
    }

    this.observers.length = 0;
  };

  Subject.prototype.unsubscribe = function () {
    this.isStopped = true;
    this.closed = true;
    this.observers = null;
  };

  Subject.prototype._trySubscribe = function (subscriber) {
    if (this.closed) {
      throw new ObjectUnsubscribedError();
    } else {
      return _super.prototype._trySubscribe.call(this, subscriber);
    }
  };

  Subject.prototype._subscribe = function (subscriber) {
    if (this.closed) {
      throw new ObjectUnsubscribedError();
    } else if (this.hasError) {
      subscriber.error(this.thrownError);
      return Subscription.EMPTY;
    } else if (this.isStopped) {
      subscriber.complete();
      return Subscription.EMPTY;
    } else {
      this.observers.push(subscriber);
      return new SubjectSubscription(this, subscriber);
    }
  };

  Subject.prototype.asObservable = function () {
    var observable = new Observable();
    observable.source = this;
    return observable;
  };

  Subject.create = function (destination, source) {
    return new AnonymousSubject(destination, source);
  };

  return Subject;
}(Observable);

var AnonymousSubject = function (_super) {
  __extends(AnonymousSubject, _super);

  function AnonymousSubject(destination, source) {
    var _this = _super.call(this) || this;

    _this.destination = destination;
    _this.source = source;
    return _this;
  }

  AnonymousSubject.prototype.next = function (value) {
    var destination = this.destination;

    if (destination && destination.next) {
      destination.next(value);
    }
  };

  AnonymousSubject.prototype.error = function (err) {
    var destination = this.destination;

    if (destination && destination.error) {
      this.destination.error(err);
    }
  };

  AnonymousSubject.prototype.complete = function () {
    var destination = this.destination;

    if (destination && destination.complete) {
      this.destination.complete();
    }
  };

  AnonymousSubject.prototype._subscribe = function (subscriber) {
    var source = this.source;

    if (source) {
      return this.source.subscribe(subscriber);
    } else {
      return Subscription.EMPTY;
    }
  };

  return AnonymousSubject;
}(Subject);
/** PURE_IMPORTS_START tslib,_Subscription PURE_IMPORTS_END */


var Action = function (_super) {
  __extends(Action, _super);

  function Action(scheduler, work) {
    return _super.call(this) || this;
  }

  Action.prototype.schedule = function (state, delay) {
    return this;
  };

  return Action;
}(Subscription);
/** PURE_IMPORTS_START tslib,_Action PURE_IMPORTS_END */


var AsyncAction = function (_super) {
  __extends(AsyncAction, _super);

  function AsyncAction(scheduler, work) {
    var _this = _super.call(this, scheduler, work) || this;

    _this.scheduler = scheduler;
    _this.work = work;
    _this.pending = false;
    return _this;
  }

  AsyncAction.prototype.schedule = function (state, delay) {
    if (delay === void 0) {
      delay = 0;
    }

    if (this.closed) {
      return this;
    }

    this.state = state;
    var id = this.id;
    var scheduler = this.scheduler;

    if (id != null) {
      this.id = this.recycleAsyncId(scheduler, id, delay);
    }

    this.pending = true;
    this.delay = delay;
    this.id = this.id || this.requestAsyncId(scheduler, this.id, delay);
    return this;
  };

  AsyncAction.prototype.requestAsyncId = function (scheduler, id, delay) {
    if (delay === void 0) {
      delay = 0;
    }

    return setInterval(scheduler.flush.bind(scheduler, this), delay);
  };

  AsyncAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
    if (delay === void 0) {
      delay = 0;
    }

    if (delay !== null && this.delay === delay && this.pending === false) {
      return id;
    }

    clearInterval(id);
    return undefined;
  };

  AsyncAction.prototype.execute = function (state, delay) {
    if (this.closed) {
      return new Error('executing a cancelled action');
    }

    this.pending = false;

    var error = this._execute(state, delay);

    if (error) {
      return error;
    } else if (this.pending === false && this.id != null) {
      this.id = this.recycleAsyncId(this.scheduler, this.id, null);
    }
  };

  AsyncAction.prototype._execute = function (state, delay) {
    var errored = false;
    var errorValue = undefined;

    try {
      this.work(state);
    } catch (e) {
      errored = true;
      errorValue = !!e && e || new Error(e);
    }

    if (errored) {
      this.unsubscribe();
      return errorValue;
    }
  };

  AsyncAction.prototype._unsubscribe = function () {
    var id = this.id;
    var scheduler = this.scheduler;
    var actions = scheduler.actions;
    var index = actions.indexOf(this);
    this.work = null;
    this.state = null;
    this.pending = false;
    this.scheduler = null;

    if (index !== -1) {
      actions.splice(index, 1);
    }

    if (id != null) {
      this.id = this.recycleAsyncId(scheduler, id, null);
    }

    this.delay = null;
  };

  return AsyncAction;
}(Action);

var Scheduler = function () {
  function Scheduler(SchedulerAction, now) {
    if (now === void 0) {
      now = Scheduler.now;
    }

    this.SchedulerAction = SchedulerAction;
    this.now = now;
  }

  Scheduler.prototype.schedule = function (work, delay, state) {
    if (delay === void 0) {
      delay = 0;
    }

    return new this.SchedulerAction(this, work).schedule(state, delay);
  };

  Scheduler.now = function () {
    return Date.now();
  };

  return Scheduler;
}();
/** PURE_IMPORTS_START tslib,_Scheduler PURE_IMPORTS_END */


var AsyncScheduler = function (_super) {
  __extends(AsyncScheduler, _super);

  function AsyncScheduler(SchedulerAction, now) {
    if (now === void 0) {
      now = Scheduler.now;
    }

    var _this = _super.call(this, SchedulerAction, function () {
      if (AsyncScheduler.delegate && AsyncScheduler.delegate !== _this) {
        return AsyncScheduler.delegate.now();
      } else {
        return now();
      }
    }) || this;

    _this.actions = [];
    _this.active = false;
    _this.scheduled = undefined;
    return _this;
  }

  AsyncScheduler.prototype.schedule = function (work, delay, state) {
    if (delay === void 0) {
      delay = 0;
    }

    if (AsyncScheduler.delegate && AsyncScheduler.delegate !== this) {
      return AsyncScheduler.delegate.schedule(work, delay, state);
    } else {
      return _super.prototype.schedule.call(this, work, delay, state);
    }
  };

  AsyncScheduler.prototype.flush = function (action) {
    var actions = this.actions;

    if (this.active) {
      actions.push(action);
      return;
    }

    var error;
    this.active = true;

    do {
      if (error = action.execute(action.state, action.delay)) {
        break;
      }
    } while (action = actions.shift());

    this.active = false;

    if (error) {
      while (action = actions.shift()) {
        action.unsubscribe();
      }

      throw error;
    }
  };

  return AsyncScheduler;
}(Scheduler);
/** PURE_IMPORTS_START  PURE_IMPORTS_END */


var subscribeToArray = function subscribeToArray(array) {
  return function (subscriber) {
    for (var i = 0, len = array.length; i < len && !subscriber.closed; i++) {
      subscriber.next(array[i]);
    }

    subscriber.complete();
  };
};
/** PURE_IMPORTS_START _AsyncAction,_AsyncScheduler PURE_IMPORTS_END */


var asyncScheduler = /*@__PURE__*/new AsyncScheduler(AsyncAction);
var async = asyncScheduler;
/** PURE_IMPORTS_START  PURE_IMPORTS_END */

function noop() {}
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function map(project, thisArg) {
  return function mapOperation(source) {
    if (typeof project !== 'function') {
      throw new TypeError('argument is not a function. Are you looking for `mapTo()`?');
    }

    return source.lift(new MapOperator(project, thisArg));
  };
}

var MapOperator = function () {
  function MapOperator(project, thisArg) {
    this.project = project;
    this.thisArg = thisArg;
  }

  MapOperator.prototype.call = function (subscriber, source) {
    return source.subscribe(new MapSubscriber(subscriber, this.project, this.thisArg));
  };

  return MapOperator;
}();

var MapSubscriber = function (_super) {
  __extends(MapSubscriber, _super);

  function MapSubscriber(destination, project, thisArg) {
    var _this = _super.call(this, destination) || this;

    _this.project = project;
    _this.count = 0;
    _this.thisArg = thisArg || _this;
    return _this;
  }

  MapSubscriber.prototype._next = function (value) {
    var result;

    try {
      result = this.project.call(this.thisArg, value, this.count++);
    } catch (err) {
      this.destination.error(err);
      return;
    }

    this.destination.next(result);
  };

  return MapSubscriber;
}(Subscriber);
/** PURE_IMPORTS_START _hostReportError PURE_IMPORTS_END */


var subscribeToPromise = function subscribeToPromise(promise) {
  return function (subscriber) {
    promise.then(function (value) {
      if (!subscriber.closed) {
        subscriber.next(value);
        subscriber.complete();
      }
    }, function (err) {
      return subscriber.error(err);
    }).then(null, hostReportError);
    return subscriber;
  };
};
/** PURE_IMPORTS_START  PURE_IMPORTS_END */


function getSymbolIterator() {
  if (typeof Symbol !== 'function' || !Symbol.iterator) {
    return '@@iterator';
  }

  return Symbol.iterator;
}

var iterator = /*@__PURE__*/getSymbolIterator();
/** PURE_IMPORTS_START _symbol_iterator PURE_IMPORTS_END */

var subscribeToIterable = function subscribeToIterable(iterable) {
  return function (subscriber) {
    var iterator$1 = iterable[iterator]();

    do {
      var item = void 0;

      try {
        item = iterator$1.next();
      } catch (err) {
        subscriber.error(err);
        return subscriber;
      }

      if (item.done) {
        subscriber.complete();
        break;
      }

      subscriber.next(item.value);

      if (subscriber.closed) {
        break;
      }
    } while (true);

    if (typeof iterator$1.return === 'function') {
      subscriber.add(function () {
        if (iterator$1.return) {
          iterator$1.return();
        }
      });
    }

    return subscriber;
  };
};
/** PURE_IMPORTS_START _symbol_observable PURE_IMPORTS_END */


var subscribeToObservable = function subscribeToObservable(obj) {
  return function (subscriber) {
    var obs = obj[observable]();

    if (typeof obs.subscribe !== 'function') {
      throw new TypeError('Provided object does not correctly implement Symbol.observable');
    } else {
      return obs.subscribe(subscriber);
    }
  };
};
/** PURE_IMPORTS_START  PURE_IMPORTS_END */


var isArrayLike = function isArrayLike(x) {
  return x && typeof x.length === 'number' && typeof x !== 'function';
};
/** PURE_IMPORTS_START  PURE_IMPORTS_END */


function isPromise(value) {
  return !!value && typeof value.subscribe !== 'function' && typeof value.then === 'function';
}
/** PURE_IMPORTS_START _subscribeToArray,_subscribeToPromise,_subscribeToIterable,_subscribeToObservable,_isArrayLike,_isPromise,_isObject,_symbol_iterator,_symbol_observable PURE_IMPORTS_END */


var subscribeTo = function subscribeTo(result) {
  if (!!result && typeof result[observable] === 'function') {
    return subscribeToObservable(result);
  } else if (isArrayLike(result)) {
    return subscribeToArray(result);
  } else if (isPromise(result)) {
    return subscribeToPromise(result);
  } else if (!!result && typeof result[iterator] === 'function') {
    return subscribeToIterable(result);
  } else {
    var value = isObject$1(result) ? 'an invalid object' : "'" + result + "'";
    var msg = "You provided " + value + " where a stream was expected." + ' You can provide an Observable, Promise, Array, or Iterable.';
    throw new TypeError(msg);
  }
};
/** PURE_IMPORTS_START tslib,_Subscriber,_Observable,_util_subscribeTo PURE_IMPORTS_END */


var SimpleInnerSubscriber = function (_super) {
  __extends(SimpleInnerSubscriber, _super);

  function SimpleInnerSubscriber(parent) {
    var _this = _super.call(this) || this;

    _this.parent = parent;
    return _this;
  }

  SimpleInnerSubscriber.prototype._next = function (value) {
    this.parent.notifyNext(value);
  };

  SimpleInnerSubscriber.prototype._error = function (error) {
    this.parent.notifyError(error);
    this.unsubscribe();
  };

  SimpleInnerSubscriber.prototype._complete = function () {
    this.parent.notifyComplete();
    this.unsubscribe();
  };

  return SimpleInnerSubscriber;
}(Subscriber);

(function (_super) {
  __extends(ComplexInnerSubscriber, _super);

  function ComplexInnerSubscriber(parent, outerValue, outerIndex) {
    var _this = _super.call(this) || this;

    _this.parent = parent;
    _this.outerValue = outerValue;
    _this.outerIndex = outerIndex;
    return _this;
  }

  ComplexInnerSubscriber.prototype._next = function (value) {
    this.parent.notifyNext(this.outerValue, value, this.outerIndex, this);
  };

  ComplexInnerSubscriber.prototype._error = function (error) {
    this.parent.notifyError(error);
    this.unsubscribe();
  };

  ComplexInnerSubscriber.prototype._complete = function () {
    this.parent.notifyComplete(this);
    this.unsubscribe();
  };

  return ComplexInnerSubscriber;
})(Subscriber);

var SimpleOuterSubscriber = function (_super) {
  __extends(SimpleOuterSubscriber, _super);

  function SimpleOuterSubscriber() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  SimpleOuterSubscriber.prototype.notifyNext = function (innerValue) {
    this.destination.next(innerValue);
  };

  SimpleOuterSubscriber.prototype.notifyError = function (err) {
    this.destination.error(err);
  };

  SimpleOuterSubscriber.prototype.notifyComplete = function () {
    this.destination.complete();
  };

  return SimpleOuterSubscriber;
}(Subscriber);

(function (_super) {
  __extends(ComplexOuterSubscriber, _super);

  function ComplexOuterSubscriber() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ComplexOuterSubscriber.prototype.notifyNext = function (_outerValue, innerValue, _outerIndex, _innerSub) {
    this.destination.next(innerValue);
  };

  ComplexOuterSubscriber.prototype.notifyError = function (error) {
    this.destination.error(error);
  };

  ComplexOuterSubscriber.prototype.notifyComplete = function (_innerSub) {
    this.destination.complete();
  };

  return ComplexOuterSubscriber;
})(Subscriber);

function innerSubscribe(result, innerSubscriber) {
  if (innerSubscriber.closed) {
    return undefined;
  }

  if (result instanceof Observable) {
    return result.subscribe(innerSubscriber);
  }

  var subscription;

  try {
    subscription = subscribeTo(result)(innerSubscriber);
  } catch (error) {
    innerSubscriber.error(error);
  }

  return subscription;
}
/** PURE_IMPORTS_START _Observable,_util_isArray,_util_isFunction,_operators_map PURE_IMPORTS_END */


function fromEvent(target, eventName, options, resultSelector) {
  if (isFunction(options)) {
    resultSelector = options;
    options = undefined;
  }

  if (resultSelector) {
    return fromEvent(target, eventName, options).pipe(map(function (args) {
      return isArray(args) ? resultSelector.apply(void 0, args) : resultSelector(args);
    }));
  }

  return new Observable(function (subscriber) {
    function handler(e) {
      if (arguments.length > 1) {
        subscriber.next(Array.prototype.slice.call(arguments));
      } else {
        subscriber.next(e);
      }
    }

    setupSubscription(target, eventName, handler, subscriber, options);
  });
}

function setupSubscription(sourceObj, eventName, handler, subscriber, options) {
  var unsubscribe;

  if (isEventTarget(sourceObj)) {
    var source_1 = sourceObj;
    sourceObj.addEventListener(eventName, handler, options);

    unsubscribe = function unsubscribe() {
      return source_1.removeEventListener(eventName, handler, options);
    };
  } else if (isJQueryStyleEventEmitter(sourceObj)) {
    var source_2 = sourceObj;
    sourceObj.on(eventName, handler);

    unsubscribe = function unsubscribe() {
      return source_2.off(eventName, handler);
    };
  } else if (isNodeStyleEventEmitter(sourceObj)) {
    var source_3 = sourceObj;
    sourceObj.addListener(eventName, handler);

    unsubscribe = function unsubscribe() {
      return source_3.removeListener(eventName, handler);
    };
  } else if (sourceObj && sourceObj.length) {
    for (var i = 0, len = sourceObj.length; i < len; i++) {
      setupSubscription(sourceObj[i], eventName, handler, subscriber, options);
    }
  } else {
    throw new TypeError('Invalid event target');
  }

  subscriber.add(unsubscribe);
}

function isNodeStyleEventEmitter(sourceObj) {
  return sourceObj && typeof sourceObj.addListener === 'function' && typeof sourceObj.removeListener === 'function';
}

function isJQueryStyleEventEmitter(sourceObj) {
  return sourceObj && typeof sourceObj.on === 'function' && typeof sourceObj.off === 'function';
}

function isEventTarget(sourceObj) {
  return sourceObj && typeof sourceObj.addEventListener === 'function' && typeof sourceObj.removeEventListener === 'function';
}
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function filter(predicate, thisArg) {
  return function filterOperatorFunction(source) {
    return source.lift(new FilterOperator(predicate, thisArg));
  };
}

var FilterOperator = function () {
  function FilterOperator(predicate, thisArg) {
    this.predicate = predicate;
    this.thisArg = thisArg;
  }

  FilterOperator.prototype.call = function (subscriber, source) {
    return source.subscribe(new FilterSubscriber(subscriber, this.predicate, this.thisArg));
  };

  return FilterOperator;
}();

var FilterSubscriber = function (_super) {
  __extends(FilterSubscriber, _super);

  function FilterSubscriber(destination, predicate, thisArg) {
    var _this = _super.call(this, destination) || this;

    _this.predicate = predicate;
    _this.thisArg = thisArg;
    _this.count = 0;
    return _this;
  }

  FilterSubscriber.prototype._next = function (value) {
    var result;

    try {
      result = this.predicate.call(this.thisArg, value, this.count++);
    } catch (err) {
      this.destination.error(err);
      return;
    }

    if (result) {
      this.destination.next(value);
    }
  };

  return FilterSubscriber;
}(Subscriber);
/** PURE_IMPORTS_START tslib,_Subscriber,_scheduler_async PURE_IMPORTS_END */


function debounceTime(dueTime, scheduler) {
  if (scheduler === void 0) {
    scheduler = async;
  }

  return function (source) {
    return source.lift(new DebounceTimeOperator(dueTime, scheduler));
  };
}

var DebounceTimeOperator = function () {
  function DebounceTimeOperator(dueTime, scheduler) {
    this.dueTime = dueTime;
    this.scheduler = scheduler;
  }

  DebounceTimeOperator.prototype.call = function (subscriber, source) {
    return source.subscribe(new DebounceTimeSubscriber(subscriber, this.dueTime, this.scheduler));
  };

  return DebounceTimeOperator;
}();

var DebounceTimeSubscriber = function (_super) {
  __extends(DebounceTimeSubscriber, _super);

  function DebounceTimeSubscriber(destination, dueTime, scheduler) {
    var _this = _super.call(this, destination) || this;

    _this.dueTime = dueTime;
    _this.scheduler = scheduler;
    _this.debouncedSubscription = null;
    _this.lastValue = null;
    _this.hasValue = false;
    return _this;
  }

  DebounceTimeSubscriber.prototype._next = function (value) {
    this.clearDebounce();
    this.lastValue = value;
    this.hasValue = true;
    this.add(this.debouncedSubscription = this.scheduler.schedule(dispatchNext, this.dueTime, this));
  };

  DebounceTimeSubscriber.prototype._complete = function () {
    this.debouncedNext();
    this.destination.complete();
  };

  DebounceTimeSubscriber.prototype.debouncedNext = function () {
    this.clearDebounce();

    if (this.hasValue) {
      var lastValue = this.lastValue;
      this.lastValue = null;
      this.hasValue = false;
      this.destination.next(lastValue);
    }
  };

  DebounceTimeSubscriber.prototype.clearDebounce = function () {
    var debouncedSubscription = this.debouncedSubscription;

    if (debouncedSubscription !== null) {
      this.remove(debouncedSubscription);
      debouncedSubscription.unsubscribe();
      this.debouncedSubscription = null;
    }
  };

  return DebounceTimeSubscriber;
}(Subscriber);

function dispatchNext(subscriber) {
  subscriber.debouncedNext();
}
/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */


function takeUntil(notifier) {
  return function (source) {
    return source.lift(new TakeUntilOperator(notifier));
  };
}

var TakeUntilOperator = function () {
  function TakeUntilOperator(notifier) {
    this.notifier = notifier;
  }

  TakeUntilOperator.prototype.call = function (subscriber, source) {
    var takeUntilSubscriber = new TakeUntilSubscriber(subscriber);
    var notifierSubscription = innerSubscribe(this.notifier, new SimpleInnerSubscriber(takeUntilSubscriber));

    if (notifierSubscription && !takeUntilSubscriber.seenValue) {
      takeUntilSubscriber.add(notifierSubscription);
      return source.subscribe(takeUntilSubscriber);
    }

    return takeUntilSubscriber;
  };

  return TakeUntilOperator;
}();

var TakeUntilSubscriber = function (_super) {
  __extends(TakeUntilSubscriber, _super);

  function TakeUntilSubscriber(destination) {
    var _this = _super.call(this, destination) || this;

    _this.seenValue = false;
    return _this;
  }

  TakeUntilSubscriber.prototype.notifyNext = function () {
    this.seenValue = true;
    this.complete();
  };

  TakeUntilSubscriber.prototype.notifyComplete = function () {};

  return TakeUntilSubscriber;
}(SimpleOuterSubscriber);
/** PURE_IMPORTS_START tslib,_Subscriber,_util_noop,_util_isFunction PURE_IMPORTS_END */


function tap(nextOrObserver, error, complete) {
  return function tapOperatorFunction(source) {
    return source.lift(new DoOperator(nextOrObserver, error, complete));
  };
}

var DoOperator = function () {
  function DoOperator(nextOrObserver, error, complete) {
    this.nextOrObserver = nextOrObserver;
    this.error = error;
    this.complete = complete;
  }

  DoOperator.prototype.call = function (subscriber, source) {
    return source.subscribe(new TapSubscriber(subscriber, this.nextOrObserver, this.error, this.complete));
  };

  return DoOperator;
}();

var TapSubscriber = function (_super) {
  __extends(TapSubscriber, _super);

  function TapSubscriber(destination, observerOrNext, error, complete) {
    var _this = _super.call(this, destination) || this;

    _this._tapNext = noop;
    _this._tapError = noop;
    _this._tapComplete = noop;
    _this._tapError = error || noop;
    _this._tapComplete = complete || noop;

    if (isFunction(observerOrNext)) {
      _this._context = _this;
      _this._tapNext = observerOrNext;
    } else if (observerOrNext) {
      _this._context = observerOrNext;
      _this._tapNext = observerOrNext.next || noop;
      _this._tapError = observerOrNext.error || noop;
      _this._tapComplete = observerOrNext.complete || noop;
    }

    return _this;
  }

  TapSubscriber.prototype._next = function (value) {
    try {
      this._tapNext.call(this._context, value);
    } catch (err) {
      this.destination.error(err);
      return;
    }

    this.destination.next(value);
  };

  TapSubscriber.prototype._error = function (err) {
    try {
      this._tapError.call(this._context, err);
    } catch (err) {
      this.destination.error(err);
      return;
    }

    this.destination.error(err);
  };

  TapSubscriber.prototype._complete = function () {
    try {
      this._tapComplete.call(this._context);
    } catch (err) {
      this.destination.error(err);
      return;
    }

    return this.destination.complete();
  };

  return TapSubscriber;
}(Subscriber);

var FlyoutContent$4 = function FlyoutContent(props) {
  var hasPadding = props.hasPadding,
      children = props.children,
      qa = props.qa;
  var classes = classNames('m-flyout__content', {
    'has-padding': !!hasPadding
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: classes,
    "data-qa": qa
  }, children);
};

var TagList$1 = function TagList(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React__default.createElement("ul", {
    className: "o-tag-list"
  }, children);
};

function asyncGeneratorStep$1$3(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator$1$3(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep$1$3(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep$1$3(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck$l(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$l(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$l(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$l(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$l(Constructor, staticProps);
  return Constructor;
}

function _defineProperty$q(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits$l(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$l(subClass, superClass);
}

function _getPrototypeOf$l(o) {
  _getPrototypeOf$l = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$l(o);
}

function _setPrototypeOf$l(o, p) {
  _setPrototypeOf$l = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$l(o, p);
}

function _isNativeReflectConstruct$l() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized$l(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn$l(self, call) {
  if (call && (_typeof$3(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized$l(self);
}

function _createSuper$l(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$l();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf$l(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$l(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn$l(this, result);
  };
}

var Icon$1$3 = function Icon(_ref) {
  var name = _ref.name,
      style = _ref.style,
      className = _ref.className,
      ariaLabel = _ref.ariaLabel,
      onClick = _ref.onClick,
      src = _ref.src,
      qa = _ref.qa;
  /**
   * Inject SVG icons from core branding into page
   */

  var fetchAntwerpIcons = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator$1$3( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var xlinkHref, response, svgText, svgWrapper;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (fetch) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              _context.prev = 2;
              xlinkHref = 'https://cdn.antwerpen.be/core_branding_scss/5.0.0/assets/images/ai.svg';
              _context.next = 6;
              return fetch(xlinkHref);

            case 6:
              response = _context.sent;
              _context.next = 9;
              return response.text();

            case 9:
              svgText = _context.sent;
              svgWrapper = document.createElement('svg');
              svgWrapper.id = 'aiSvg';
              svgWrapper.innerHTML = svgText;

              if (!document.getElementById('aiSvg')) {
                document.body.appendChild(svgWrapper);
              }

              _context.next = 19;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](2);
              throw new Error(_context.t0);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 16]]);
    }));

    return function fetchAntwerpIcons() {
      return _ref2.apply(this, arguments);
    };
  }();

  if (typeof document !== 'undefined' && !document.getElementById('aiSvg')) {
    fetchAntwerpIcons();
  }

  var iconClass = classNames(className, name, 'ai');
  return /*#__PURE__*/React__default.createElement("span", {
    className: iconClass,
    style: style,
    "data-qa": qa,
    onClick: onClick
  }, name && /*#__PURE__*/React__default.createElement("svg", {
    "aria-hidden": "true"
  }, /*#__PURE__*/React__default.createElement("use", {
    href: "#".concat(name)
  })), src, ariaLabel && /*#__PURE__*/React__default.createElement("span", {
    className: "u-screen-reader-only"
  }, ariaLabel));
};

var sizeClasses$c = {
  tiny: 'a-button--tiny',
  small: 'a-button--small',
  large: 'a-button--large'
};
var typeClasses$c = {
  primary: '',
  secondary: 'a-button--secondary',
  success: 'a-button--success',
  warning: 'a-button--warning',
  danger: 'a-button--danger',
  transparent: 'a-button--transparent',
  default: 'a-button--default'
};

var Button$a = /*#__PURE__*/function (_Component) {
  _inherits$l(Button, _Component);

  var _super = _createSuper$l(Button);

  function Button() {
    _classCallCheck$l(this, Button);

    return _super.apply(this, arguments);
  }

  _createClass$l(Button, [{
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props = this.props,
          id = _this$props.id,
          negative = _this$props.negative,
          outline = _this$props.outline,
          transparent = _this$props.transparent,
          className = _this$props.className,
          children = _this$props.children,
          icon = _this$props.icon,
          iconLeft = _this$props.iconLeft,
          iconRight = _this$props.iconRight,
          onClick = _this$props.onClick,
          _this$props$title = _this$props.title,
          title = _this$props$title === void 0 ? '' : _this$props$title,
          _this$props$ariaLabel = _this$props.ariaLabel,
          ariaLabel = _this$props$ariaLabel === void 0 ? '' : _this$props$ariaLabel,
          type = _this$props.type,
          size = _this$props.size,
          _this$props$block = _this$props.block,
          block = _this$props$block === void 0 ? false : _this$props$block,
          _this$props$style = _this$props.style,
          style = _this$props$style === void 0 ? {} : _this$props$style,
          _this$props$disabled = _this$props.disabled,
          disabled = _this$props$disabled === void 0 ? false : _this$props$disabled,
          htmlType = _this$props.htmlType,
          qa = _this$props.qa;
      var btnClass = classNames(className, (_classNames = {
        'a-button': !outline && !negative && !(type === 'default' && !!transparent)
      }, _defineProperty$q(_classNames, "".concat(typeClasses$c[type]), !!type), _defineProperty$q(_classNames, "".concat(sizeClasses$c[size]), !!size), _defineProperty$q(_classNames, 'has-icon', !!icon), _defineProperty$q(_classNames, 'has-icon-left', !!iconLeft), _defineProperty$q(_classNames, 'has-icon-right', !!iconRight), _defineProperty$q(_classNames, 'a-button-negative', !!negative), _defineProperty$q(_classNames, 'a-button-outline', !!outline), _defineProperty$q(_classNames, 'a-button-transparent', !!transparent), _defineProperty$q(_classNames, 'a-button--block', block), _classNames));
      return /*#__PURE__*/React__default.createElement("button", {
        id: id,
        className: btnClass,
        title: title || '',
        onClick: onClick,
        style: style,
        disabled: disabled,
        type: htmlType,
        "aria-label": ariaLabel,
        "data-qa": qa
      }, icon ? /*#__PURE__*/React__default.createElement(Icon$1$3, {
        name: icon
      }) : null, iconLeft ? /*#__PURE__*/React__default.createElement(Icon$1$3, {
        name: iconLeft
      }) : null, iconRight ? /*#__PURE__*/React__default.createElement(Icon$1$3, {
        name: iconRight
      }) : null, children);
    }
  }]);

  return Button;
}(Component);

var TagListItem$1 = /*#__PURE__*/function (_Component) {
  _inherits$l(TagListItem, _Component);

  var _super = _createSuper$l(TagListItem);

  function TagListItem() {
    _classCallCheck$l(this, TagListItem);

    return _super.apply(this, arguments);
  }

  _createClass$l(TagListItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          value = _this$props.value,
          _this$props$closable = _this$props.closable,
          closable = _this$props$closable === void 0 ? false : _this$props$closable,
          _this$props$icon = _this$props.icon,
          icon = _this$props$icon === void 0 ? '' : _this$props$icon;
      _this$props.buttonClass;
      var onClick = _this$props.onClick,
          ariaLabelIcon = _this$props.ariaLabelIcon,
          _this$props$ariaLabel = _this$props.ariaLabelClose,
          ariaLabelClose = _this$props$ariaLabel === void 0 ? 'Sluiten' : _this$props$ariaLabel,
          qa = _this$props.qa;
      return /*#__PURE__*/React__default.createElement("li", {
        className: "m-tag",
        "data-qa": qa
      }, icon && /*#__PURE__*/React__default.createElement(Button$a, {
        size: "small",
        icon: icon,
        ariaLabel: ariaLabelIcon
      }), /*#__PURE__*/React__default.createElement("span", {
        className: "m-tag__label"
      }, value), closable && /*#__PURE__*/React__default.createElement(Button$a, {
        transparent: true,
        size: "small",
        type: "danger",
        icon: "ai-close",
        ariaLabel: ariaLabelClose,
        onClick: onClick
      }));
    }
  }]);

  return TagListItem;
}(Component);

var InputLabel$4 = function InputLabel(props) {
  var style = props.style,
      htmlFor = props.htmlFor,
      children = props.children,
      inline = props.inline,
      id = props.id,
      qa = props.qa;
  var labelClass = classNames('a-input__label', {
    'a-input__label--inline': !!inline
  });
  return /*#__PURE__*/React__default.createElement("label", {
    className: labelClass,
    htmlFor: htmlFor,
    style: style,
    id: id,
    "data-qa": qa
  }, children);
};

function asyncGeneratorStep$h(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator$h(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep$h(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep$h(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var Icon$h = function Icon(_ref) {
  var name = _ref.name,
      style = _ref.style,
      className = _ref.className,
      ariaLabel = _ref.ariaLabel,
      onClick = _ref.onClick,
      src = _ref.src,
      qa = _ref.qa;
  /**
   * Inject SVG icons from core branding into page
   */

  var fetchAntwerpIcons = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator$h( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var xlinkHref, response, svgText, svgWrapper;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (fetch) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              _context.prev = 2;
              xlinkHref = 'https://cdn.antwerpen.be/core_branding_scss/5.0.0/assets/images/ai.svg';
              _context.next = 6;
              return fetch(xlinkHref);

            case 6:
              response = _context.sent;
              _context.next = 9;
              return response.text();

            case 9:
              svgText = _context.sent;
              svgWrapper = document.createElement('svg');
              svgWrapper.id = 'aiSvg';
              svgWrapper.innerHTML = svgText;

              if (!document.getElementById('aiSvg')) {
                document.body.appendChild(svgWrapper);
              }

              _context.next = 19;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](2);
              throw new Error(_context.t0);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 16]]);
    }));

    return function fetchAntwerpIcons() {
      return _ref2.apply(this, arguments);
    };
  }();

  if (typeof document !== 'undefined' && !document.getElementById('aiSvg')) {
    fetchAntwerpIcons();
  }

  var iconClass = classNames(className, name, 'ai');
  return /*#__PURE__*/React__default.createElement("span", {
    className: iconClass,
    style: style,
    "data-qa": qa,
    onClick: onClick
  }, name && /*#__PURE__*/React__default.createElement("svg", {
    "aria-hidden": "true"
  }, /*#__PURE__*/React__default.createElement("use", {
    href: "#".concat(name)
  })), src, ariaLabel && /*#__PURE__*/React__default.createElement("span", {
    className: "u-screen-reader-only"
  }, ariaLabel));
};

var MultipleSelectionMode = /*#__PURE__*/function () {
  function MultipleSelectionMode(component) {
    _classCallCheck$1$3(this, MultipleSelectionMode);

    this.component = component;
  }

  _createClass$1$3(MultipleSelectionMode, [{
    key: "handleDefaultValue",
    value: function handleDefaultValue(defaultValues) {
      var _this = this;

      if (!defaultValues || !defaultValues.length) {
        return;
      }

      if (!Array.isArray(defaultValues)) {
        defaultValues = [defaultValues];
      }

      var selection = defaultValues.map(function (defaultValue) {
        return (_this.component.state.results || []).find(function (item) {
          return item.value === defaultValue;
        });
      });

      if (!selection || !selection.length) {
        return;
      }

      this.component.setState({
        selection: selection
      });

      if (this.component.inputField) {
        this.component.inputField.value = '';
      }
    }
  }, {
    key: "select",
    value: function select(item) {
      if (this.component.state.selection.findIndex(function (s) {
        return s.value === item.value;
      }) > -1) return;
      var selection = this.component.state.selection;
      selection.push(item);
      this.component.setState({
        selection: selection
      });
      this.component.props.onSelection && this.component.props.onSelection(selection.map(function (i) {
        return i.value;
      }));
      if (this.component.inputField) this.component.inputField.value = '';
      this.component.closePane();
    }
  }, {
    key: "unselect",
    value: function unselect(item) {
      var selection = this.component.state.selection;
      var index = selection.findIndex(function (s) {
        return s.value === item.value;
      });
      if (index === -1) return;
      selection.splice(index, 1);
      this.component.setState({
        selection: selection
      });
      this.component.props.onSelection && this.component.props.onSelection(selection.map(function (i) {
        return i.value;
      }));
      if (this.component.searchMode) this.component.searchMode.reset();
    }
  }, {
    key: "getSelection",
    value: function getSelection() {
      return this.component.state.selection;
    }
  }]);

  return MultipleSelectionMode;
}();

var SingleSelectionMode = /*#__PURE__*/function () {
  function SingleSelectionMode(component) {
    _classCallCheck$1$3(this, SingleSelectionMode);

    _defineProperty$1$3(this, "selectedItem", null);

    this.component = component;
  }

  _createClass$1$3(SingleSelectionMode, [{
    key: "handleDefaultValue",
    value: function handleDefaultValue(defaultValue) {
      if (!defaultValue) {
        return;
      }

      var item = (this.component.state.results || []).find(function (result) {
        return result.value === (Array.isArray(defaultValue) ? defaultValue[0] : defaultValue);
      });

      if (!item) {
        return;
      }

      if (this.component.inputField) {
        this.component.inputField.value = item.label;
      }
    }
  }, {
    key: "select",
    value: function select(item) {
      this.selectedItem = item;
      this.component.props.onSelection && this.component.props.onSelection(item.value);
      if (this.component.inputField) this.component.inputField.value = item.label;
      this.component.closePane();
    }
  }, {
    key: "getSelection",
    value: function getSelection() {
      return this.selectedItem ? [this.selectedItem] : [];
    }
  }]);

  return SingleSelectionMode;
}();

var SyncSearchMode = /*#__PURE__*/function () {
  function SyncSearchMode(component) {
    _classCallCheck$1$3(this, SyncSearchMode);

    this.component = component;
  }

  _createClass$1$3(SyncSearchMode, [{
    key: "initialize",
    value: function initialize() {
      this.component.selectionMode.handleDefaultValue(this.component.props.defaultValue);
      return Promise.resolve();
    }
  }, {
    key: "search",
    value: function search(value) {
      if (!value) {
        return Promise.resolve(this.component.props.items);
      }

      var items = this.component.props.items; // Remove already selected items

      var selection = this.component.selectionMode.getSelection();
      items = items.filter(function (item) {
        return !selection.find(function (s) {
          return s.value === item.value;
        });
      }); // Find matches in remaining items

      var matches = items.filter(function (item) {
        return item.label.toLowerCase().includes(value.toLowerCase());
      });
      return Promise.resolve(matches);
    }
  }, {
    key: "reset",
    value: function reset() {
      var items = this.component.props.items;
      var selection = this.component.state.selection || [];
      items = items.filter(function (item) {
        return !selection.find(function (s) {
          return s.value === item.value;
        });
      });
      this.component.setState({
        results: items
      });
    }
  }]);

  return SyncSearchMode;
}();

var AsyncSearchMode = /*#__PURE__*/function () {
  function AsyncSearchMode(component) {
    _classCallCheck$1$3(this, AsyncSearchMode);

    this.component = component;
  }

  _createClass$1$3(AsyncSearchMode, [{
    key: "initialize",
    value: function initialize() {
      var _this = this;

      if (this.component.props && this.component.props.defaultValue && this.component.props.defaultValue.length > 0) {
        var defaultValues = Array.isArray(this.component.props.defaultValue) ? _toConsumableArray(this.component.props.defaultValue) : [this.component.props.defaultValue];
        return Promise.all(defaultValues.map(function (v) {
          return _this.search(v);
        })).then(function (results) {
          if (!results.length) {
            return;
          }

          results = results.reduce(function (acc, searchResultValues) {
            return [].concat(_toConsumableArray(acc), _toConsumableArray(searchResultValues.filter(function (r) {
              return !!r;
            })));
          }, []);

          _this.component.setState({
            results: results
          });

          _this.component.selectionMode.handleDefaultValue(defaultValues);
        });
      }
    }
  }, {
    key: "search",
    value: function search(value) {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        try {
          _this2.component.setState({
            isLoading: true
          });

          _this2.component.props.asyncItems(value, function (results) {
            resolve(results);

            _this2.component.setState({
              isLoading: false
            });
          });
        } catch (e) {
          _this2.component.setState({
            isLoading: false
          });

          reject(e);
        }
      });
    }
  }, {
    key: "reset",
    value: function reset() {// Do nothing
    }
  }]);

  return AsyncSearchMode;
}();

var stateClasses$6 = {
  success: 'has-success',
  warning: 'has-warning',
  error: 'has-error'
};

___$insertStyle$5("/**\n * QUARKS\n * -------------------------------------------------------------------\n */\n/**\n * MIXINS\n * -------------------------------------------------------------------\n * Collection of custom mixins\n */\n/**\n * FONT FACE\n * -------------------------------------------------------------------\n */\n/**\n * BUTTON MIXIN\n * -------------------------------------------------------------------\n */\n/**\n * BUTTON OUTLINE MIXIN\n * -------------------------------------------------------------------\n */\n/**\n * INPUT MIXIN\n * -------------------------------------------------------------------\n */\n/**\n * INPUT PLACEHOLDER MIXIN\n * -------------------------------------------------------------------\n * Change base styling for placeholder text on input fields\n * Note: Styling the placeholder text is not supported on older\n * browsers, use a html5-placeholder polyfill for that\n *\n * Background info:\n * - http://davidwalsh.name/html5-placeholder\n * - http://davidwalsh.name/placeholder-overflow\n * - http://jamesallardice.github.io/Placeholders.js\n */\n/**\n * ALERT MIXIN\n * -------------------------------------------------------------------\n */\n/**\n * BADGE MIXIN\n * -------------------------------------------------------------------\n */\n/**\n * LABEL MIXIN\n * -------------------------------------------------------------------\n */\n/**\n * TOOLTIP MIXIN\n * -------------------------------------------------------------------\n */\n/**\n * FOCUS\n * -------------------------------------------------------------------\n */\n/**\n * CLEARFIX\n * -------------------------------------------------------------------\n */\n/**\n * MEDIA QUERIES MIXIN\n * -------------------------------------------------------------------\n */\n/**\n * FUNCTIONS\n * -------------------------------------------------------------------\n * Collection of custom functions\n */\n/**\n * STRIP UNIT FROM VALUE\n * -------------------------------------------------------------------\n */\n/**\n * CONVERT PX TO REM\n * -------------------------------------------------------------------\n */\n/**\n * RAISE NUMBER TO CERTAIN POWER\n * -------------------------------------------------------------------\n */\n/**\n * HANDLING Z-INDEX LAYERS\n * -------------------------------------------------------------------\n */\n/**\n * COLORS\n * -------------------------------------------------------------------\n * Collection of all available branding colors\n */\n/**\n * COMPLETE COLOR PALETTE\n * -------------------------------------------------------------------\n * Variable names generated by Name That Color\n * http://chir.ag/projects/name-that-color\n */\n/**\n * GRAY COLOR PALETTE\n * -------------------------------------------------------------------\n * Collection of warm gray colors\n */\n/**\n * WEB GRAYSCALE COLOR PALETTE\n * -------------------------------------------------------------------\n * Collection of grayscale colors\n */\n/**\n * SOCIAL BRAND COLOR PALETTE\n * -------------------------------------------------------------------\n * Collection of social branding colors\n */\n/**\n * GLOBAL VARIABLES\n * -------------------------------------------------------------------\n * Leave here for renderer\n */\n/**\n * COLORS\n * -------------------------------------------------------------------\n * Collection of all available branding colors\n */\n/**\n * COMPLETE COLOR PALETTE\n * -------------------------------------------------------------------\n * Variable names generated by Name That Color\n * http://chir.ag/projects/name-that-color\n */\n/**\n * GRAY COLOR PALETTE\n * -------------------------------------------------------------------\n * Collection of warm gray colors\n */\n/**\n * WEB GRAYSCALE COLOR PALETTE\n * -------------------------------------------------------------------\n * Collection of grayscale colors\n */\n/**\n * SOCIAL BRAND COLOR PALETTE\n * -------------------------------------------------------------------\n * Collection of social branding colors\n */\n/**\n * FUNCTIONS\n * -------------------------------------------------------------------\n * Collection of custom functions\n */\n/**\n * STRIP UNIT FROM VALUE\n * -------------------------------------------------------------------\n */\n/**\n * CONVERT PX TO REM\n * -------------------------------------------------------------------\n */\n/**\n * RAISE NUMBER TO CERTAIN POWER\n * -------------------------------------------------------------------\n */\n/**\n * HANDLING Z-INDEX LAYERS\n * -------------------------------------------------------------------\n */\n/**\n * MIXINS\n * -------------------------------------------------------------------\n * Collection of custom mixins\n */\n/**\n * FONT FACE\n * -------------------------------------------------------------------\n */\n/**\n * BUTTON MIXIN\n * -------------------------------------------------------------------\n */\n/**\n * BUTTON OUTLINE MIXIN\n * -------------------------------------------------------------------\n */\n/**\n * INPUT MIXIN\n * -------------------------------------------------------------------\n */\n/**\n * INPUT PLACEHOLDER MIXIN\n * -------------------------------------------------------------------\n * Change base styling for placeholder text on input fields\n * Note: Styling the placeholder text is not supported on older\n * browsers, use a html5-placeholder polyfill for that\n *\n * Background info:\n * - http://davidwalsh.name/html5-placeholder\n * - http://davidwalsh.name/placeholder-overflow\n * - http://jamesallardice.github.io/Placeholders.js\n */\n/**\n * ALERT MIXIN\n * -------------------------------------------------------------------\n */\n/**\n * BADGE MIXIN\n * -------------------------------------------------------------------\n */\n/**\n * LABEL MIXIN\n * -------------------------------------------------------------------\n */\n/**\n * TOOLTIP MIXIN\n * -------------------------------------------------------------------\n */\n/**\n * FOCUS\n * -------------------------------------------------------------------\n */\n/**\n * CLEARFIX\n * -------------------------------------------------------------------\n */\n/**\n * MEDIA QUERIES MIXIN\n * -------------------------------------------------------------------\n */\n/**\n * SPECIFIC COLOR PALETTE\n * -------------------------------------------------------------------\n */\n/**\n * SPACERS\n * -------------------------------------------------------------------\n */\n/**\n * BREAKPOINTS\n * -------------------------------------------------------------------\n */\n/**\n * $screen-xl =\n *    max-width of u-container\n *    + width of official logo * 2\n *    + space between logo and u-container * 2\n */\n/**\n * FONT FAMILIES\n * -------------------------------------------------------------------\n */\n/**\n * FONT SIZES\n * -------------------------------------------------------------------\n */\n/**\n * LINE HEIGHTS\n * -------------------------------------------------------------------\n */\n/**\n * FONT WEIGHTS\n * -------------------------------------------------------------------\n */\n/**\n * OTHER TYPOGRAPHY\n * -------------------------------------------------------------------\n */\n/**\n * ANIMATIONS\n * -------------------------------------------------------------------\n */\n/**\n * Z-INDEXES\n * -------------------------------------------------------------------\n * http://www.sitepoint.com/better-solution-managing-z-index-sass/\n *\n * Use like this:\n *   z-index: layer('overlay');\n *     where overlay is a list item of the default list \"$z-indexes\" (see below)\n *\n * The list is also upgradeable in that nesting is permitted, e.g.:\n * z-indexes: (\n *   'modal': (\n *     'back': 50,\n *     'front': 60\n *   ),\n *   'navigation': 40,\n *   ...\n * )\n */\n/**\n * ICON SIZES\n * -------------------------------------------------------------------\n */\n/**\n * BOX SHADOWS\n * -------------------------------------------------------------------\n */\n/**\n * LINKS\n * -------------------------------------------------------------------\n * Define text and hover color for each hyperlink\n */\n/**\n * LISTS\n * -------------------------------------------------------------------\n * Define default paddings for lists\n */\n/**\n * PRE\n * -------------------------------------------------------------------\n * Define text and background color for each code element\n */\n/**\n * CODE\n * -------------------------------------------------------------------\n * Define text and background color for each code element\n */\n/**\n * MARK\n * -------------------------------------------------------------------\n * Define text and background color for each mark element\n */\n/**\n * CITE\n * -------------------------------------------------------------------\n */\n/**\n * FIGCAPTION\n * -------------------------------------------------------------------\n */\n/**\n * TABLES\n * -------------------------------------------------------------------\n * Define background and border color for each table\n */\n/**\n * BUTTONS\n * -------------------------------------------------------------------\n * Define text, background and border color for each button\n */\n/**\n * FORMS\n * -------------------------------------------------------------------\n * Define text, background, border and placeholder color for each input\n */\n/**\n * RADIO BUTTONS & CHECKBOXES\n * -------------------------------------------------------------------\n */\n/**\n * SWITCHES\n * -------------------------------------------------------------------\n * WATCH OUT\n * $progress-height and $range-slider-height are equal to $switch-height\n * In this way, changing the height of the switch will also affect the height of the progress bar and range slider\n */\n/**\n * FIELDSET\n * -------------------------------------------------------------------\n */\n/**\n * TOOLTIP\n * -------------------------------------------------------------------\n */\n/**\n * PROGRESS\n * -------------------------------------------------------------------\n * WATCH OUT\n * $range-slider-offset is equal to $tooltip-offset\n * In this way, changing the offset of the progress bar will also affect the offset of the range slider\n */\n/**\n * RANGE SLIDER\n * -------------------------------------------------------------------\n */\n/**\n * LINK LIST\n * -------------------------------------------------------------------\n */\n/**\n * DATEPICKER\n * -------------------------------------------------------------------\n */\n/**\n * ACCORDION\n * -------------------------------------------------------------------\n */\n/**\n * ALERTS\n * -------------------------------------------------------------------\n */\n/**\n * AVATARS\n * -------------------------------------------------------------------\n */\n/**\n * BADGES\n * -------------------------------------------------------------------\n */\n/**\n * BREADCRUMBS\n * -------------------------------------------------------------------\n */\n/**\n * CARDS\n * -------------------------------------------------------------------\n */\n/**\n * COPYRIGHT\n * -------------------------------------------------------------------\n */\n/**\n * LABELS\n * -------------------------------------------------------------------\n */\n/**\n * TAGS\n * -------------------------------------------------------------------\n */\n/**\n * FLYOUT\n * -------------------------------------------------------------------\n */\n/**\n * FOOTER\n * -------------------------------------------------------------------\n */\n/**\n * HEADER\n * -------------------------------------------------------------------\n */\n/**\n * SPINNER\n * -------------------------------------------------------------------\n */\n/**\n * ICON LIST\n * -------------------------------------------------------------------\n */\n/**\n * OVERLAY\n * -------------------------------------------------------------------\n */\n/**\n * MODAL\n * -------------------------------------------------------------------\n */\n/**\n * NAVIGATION\n * -------------------------------------------------------------------\n */\n/**\n * PAGINATION\n * -------------------------------------------------------------------\n */\n/**\n * STEP INDICATOR\n * -------------------------------------------------------------------\n */\n/**\n * UPLOAD\n * -------------------------------------------------------------------\n */\n/**\n * GALLERY\n * -------------------------------------------------------------------\n */\n/**\n * SLIDESHOW\n * -------------------------------------------------------------------\n */\n/**\n * NAVIGATION MENU\n * -------------------------------------------------------------------\n */\n/**\n * ARTICLE\n * -------------------------------------------------------------------\n */\n/** Flyout fix **/\n.m-flyout .m-flyout__content {\n  max-height: 0;\n  transition: visibility 0s ease-in-out 0.2s, opacity 0.2s ease-in-out, transform 0.2s ease-in-out, max-height 0.2s ease-in-out;\n}\n\n.m-flyout.is-open .m-flyout__content {\n  max-height: 1000000px;\n}\n\n/** End flyout fix **/\n.m-autocomplete.is-multiple-select .a-input__wrapper {\n  border: 1px solid #6f6f6f;\n  display: flex;\n  flex-direction: row;\n}\n.m-autocomplete.is-multiple-select .a-input__wrapper.has-focus {\n  outline: 5px auto Highlight;\n  outline: 5px auto -webkit-focus-ring-color;\n}\n.m-autocomplete.is-multiple-select .a-input__wrapper .o-tag-list {\n  display: flex;\n  flex-wrap: wrap;\n  padding: 0;\n  margin-bottom: 0;\n}\n.m-autocomplete.is-multiple-select .a-input__wrapper .o-tag-list .m-tag:not(.has-input) {\n  margin: 0.375rem 0 0.375rem 0.375rem;\n}\n.m-autocomplete.is-multiple-select .a-input__wrapper .o-tag-list .m-tag.has-input {\n  margin: 0;\n}\n.m-autocomplete.is-multiple-select .a-input__wrapper .o-tag-list .m-tag.has-input {\n  height: auto;\n  flex-grow: 1;\n}\n.m-autocomplete.is-multiple-select .a-input__wrapper input, .m-autocomplete.is-multiple-select .a-input__wrapper input:focus {\n  border: none !important;\n  padding-left: 0.75rem;\n  box-shadow: none !important;\n  outline: none !important;\n}\n\n.m-selectable-list__item--disabled {\n  cursor: not-allowed;\n  color: #949494;\n  background-color: #f3f3f3;\n}");

var ARROW_KEYS = ['ArrowUp', 'ArrowDown', 'Enter'];

var Autocomplete = /*#__PURE__*/function (_Component) {
  _inherits$1$3(Autocomplete, _Component);

  var _super = _createSuper$1$3(Autocomplete);

  function Autocomplete() {
    var _this;

    _classCallCheck$1$3(this, Autocomplete);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$1$3(_assertThisInitialized$1$3(_this), "autocompleteRef", /*#__PURE__*/React__default.createRef());

    _defineProperty$1$3(_assertThisInitialized$1$3(_this), "state", {
      open: _this.props.open || false,
      results: _this.props.items || [],
      cursor: 0,
      selection: []
    });

    _defineProperty$1$3(_assertThisInitialized$1$3(_this), "selectionMode", _this.props.multipleSelect ? new MultipleSelectionMode(_assertThisInitialized$1$3(_this)) : new SingleSelectionMode(_assertThisInitialized$1$3(_this)));

    _defineProperty$1$3(_assertThisInitialized$1$3(_this), "searchMode", _this.props.asyncItems ? new AsyncSearchMode(_assertThisInitialized$1$3(_this)) : new SyncSearchMode(_assertThisInitialized$1$3(_this)));

    _defineProperty$1$3(_assertThisInitialized$1$3(_this), "destroy$", new Subject());

    _defineProperty$1$3(_assertThisInitialized$1$3(_this), "scrollToItem", function () {
      var domNode = ReactDOM.findDOMNode(_this['item_' + _this.state.cursor]);

      if (!domNode) {
        return;
      }

      domNode.scrollIntoView(false);
    });

    _defineProperty$1$3(_assertThisInitialized$1$3(_this), "handleOutsideClick", function (e) {
      var area = ReactDOM.findDOMNode(_this.autocompleteRef.current);

      if (area && !area.contains(e.target)) {
        _this.closePane();
      }
    });

    _defineProperty$1$3(_assertThisInitialized$1$3(_this), "renderItems", function (item, index) {
      var liClasses = classNames({
        'm-selectable-list__item': true,
        'm-selectable-list__item--active': _this.state.cursor === index,
        'm-selectable-list__item--disabled': item.disabled
      });
      return /*#__PURE__*/React__default.createElement("li", {
        key: item.value,
        "data-value": item.value,
        "data-label": item.label,
        className: liClasses,
        onClick: function onClick() {
          return _this.selectOption(item);
        },
        onKeyPress: function onKeyPress(e) {
          return e.key === 'Enter' ? _this.selectOption(item) : null;
        },
        ref: function ref(item) {
          _this['item_' + index] = item;
        },
        tabIndex: "0"
      }, item.label);
    });

    return _this;
  }

  _createClass$1$3(Autocomplete, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var change$ = fromEvent(this.inputField, 'keydown').pipe(takeUntil(this.destroy$), filter(function (e) {
        return !ARROW_KEYS.some(function (k) {
          return k === e.key;
        });
      }), debounceTime(200), map(function () {
        return _this2.inputField.value;
      }), tap(function (value) {
        if (!_this2.state.open && value && value.length > 0) {
          _this2.openPane();
        }

        _this2.props.onChange && _this2.props.onChange(value);

        _this2.search(value);
      }));
      document.addEventListener('click', this.handleOutsideClick, false);
      var handleArrowKeys$ = fromEvent(this.inputField, 'keydown').pipe(filter(function (e) {
        return ARROW_KEYS.some(function (k) {
          return e.key === k;
        });
      }), takeUntil(this.destroy$), tap(function (e) {
        e.preventDefault();
        var _this2$state = _this2.state,
            results = _this2$state.results,
            cursor = _this2$state.cursor;

        if (e.key === "ArrowDown" && cursor < results.length) {
          _this2.setState({
            open: true,
            cursor: cursor + 1
          }, function () {
            _this2.scrollToItem();
          });
        }

        if (e.key === "ArrowUp" && cursor > 1) {
          _this2.setState({
            open: true,
            cursor: cursor - 1
          }, function () {
            _this2.scrollToItem();
          });
        }

        if (e.key === "Enter") {
          if (cursor === 0) {
            _this2.handleNewEntry(_this2.inputField.value);
          }

          _this2.selectOption(results[cursor - 1]);
        }
      })); // Start the show!

      this.searchMode.initialize();
      handleArrowKeys$.subscribe();
      change$.subscribe();
    }
  }, {
    key: "closePane",
    value: function closePane() {
      this.setState({
        open: false
      });
    }
  }, {
    key: "openPane",
    value: function openPane() {
      this.setState({
        open: true
      });
      this.search(this.inputField.value);
    }
  }, {
    key: "search",
    value: function search(value) {
      var _this3 = this;

      this.searchMode.search(value).then(function (results) {
        _this3.setState({
          results: results,
          cursor: _this3.props.allowNewEntry ? 0 : 1
        });
      });
    }
  }, {
    key: "handleNewEntry",
    value: function handleNewEntry(label) {
      var _this4 = this;

      if (!this.props.onNewEntry) {
        return this.selectionMode.select({
          label: label,
          value: label
        });
      }

      this.props.onNewEntry(label, function (newItem) {
        _this4.selectionMode.select(newItem);
      });
    }
  }, {
    key: "selectOption",
    value: function selectOption(item) {
      if (!item || item.disabled) {
        return;
      }

      this.selectionMode.select(item);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.handleOutsideClick, false);
      this.destroy$.next();
      this.destroy$.complete();
    }
  }, {
    key: "getInput",
    value: function getInput() {
      var _this5 = this;

      return /*#__PURE__*/React__default.createElement("input", {
        id: this.props.id,
        type: "text",
        autoComplete: "off",
        disabled: this.props.disabled,
        ref: function ref(_ref) {
          return _this5.inputField = _ref;
        },
        "data-qa": this.props.qa,
        onFocus: function onFocus() {
          return _this5.openPane();
        },
        placeholder: this.props.placeholder || '',
        required: !!this.props.required
      });
    }
  }, {
    key: "focusOnInput",
    value: function focusOnInput() {
      if (!this.inputField) return;
      this.inputField.focus();
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames,
          _this6 = this;

      var _this$props = this.props,
          noResults = _this$props.noResults,
          loading = _this$props.loading,
          state = _this$props.state,
          qa = _this$props.qa,
          allowNewEntry = _this$props.allowNewEntry,
          newEntryText = _this$props.newEntryText;
      var _this$state = this.state,
          results = _this$state.results,
          open = _this$state.open,
          isLoading = _this$state.isLoading;
      var flyoutClasses = classNames('m-flyout', 'm-flyout--full', 'm-autocomplete', {
        'is-open': open,
        'is-multiple-select': !!this.props.multipleSelect,
        'm-flyout--left': !this.props.direction || this.props.direction === "left",
        'm-flyout--right': this.props.direction === "right"
      });
      var inputClass = classNames('a-input', (_classNames = {
        'has-icon-right': this.props.loading || this.state.isLoading,
        'has-icon-left': this.props.showSearchIcon
      }, _defineProperty$1$3(_classNames, "".concat(stateClasses$6[state]), !!state), _defineProperty$1$3(_classNames, 'is-required', !!this.props.required), _classNames));
      var wrapperClasses = classNames('a-input__wrapper', {
        'has-focus': !!this.inputField && this.inputField === document.activeElement && !!this.props.multipleSelect
      });
      var newEntryClasses = classNames({
        'm-selectable-list__item': true,
        'm-selectable-list__item--active': this.state.cursor === 0
      });
      return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
        className: flyoutClasses,
        ref: this.autocompleteRef
      }, /*#__PURE__*/React__default.createElement("div", {
        className: inputClass,
        "data-qa": qa
      }, /*#__PURE__*/React__default.createElement(InputLabel$4, {
        htmlFor: this.props.id
      }, this.props.label), /*#__PURE__*/React__default.createElement("div", {
        className: wrapperClasses,
        onClick: function onClick() {
          return _this6.focusOnInput();
        }
      }, this.props.multipleSelect && /*#__PURE__*/React__default.createElement(TagList$1, null, this.state.selection.filter(function (s) {
        return !!s;
      }).map(function (s) {
        return /*#__PURE__*/React__default.createElement(TagListItem$1, {
          closable: true,
          onClick: function onClick() {
            return _this6.selectionMode.unselect(s);
          },
          key: s.value,
          value: s.label
        });
      }), /*#__PURE__*/React__default.createElement("li", {
        className: "m-tag has-input"
      }, this.props.multipleSelect && this.getInput())), !this.props.multipleSelect && this.getInput(), this.props.showSearchIcon && /*#__PURE__*/React__default.createElement(Icon$h, {
        name: "ai-search"
      }), (loading || isLoading) && /*#__PURE__*/React__default.createElement(Icon$h, {
        name: "ai-spinner",
        className: "a-spinner a-spinner--sm"
      }))), /*#__PURE__*/React__default.createElement(FlyoutContent$4, {
        hasPadding: false
      }, results.length === 0 && !allowNewEntry || results.length === 0 && allowNewEntry && this.inputField && !this.inputField.value ? /*#__PURE__*/React__default.createElement("p", {
        className: "u-margin-xs u-text-light u-text-center"
      }, noResults || "Geen resultaten") : /*#__PURE__*/React__default.createElement("ul", {
        className: "m-selectable-list m-selectable-list--no-border"
      }, allowNewEntry && this.inputField && this.inputField.value && /*#__PURE__*/React__default.createElement("li", {
        className: newEntryClasses,
        onClick: function onClick() {
          return _this6.handleNewEntry(_this6.inputField.value);
        },
        onKeyPress: function onKeyPress(e) {
          return e.key === 'Enter' ? _this6.selectOption(item) : null;
        },
        ref: function ref(item) {
          _this6['item_' + 0] = item;
        },
        tabIndex: "0"
      }, newEntryText || "Maak een nieuw item voor:", " ", this.inputField.value), results.map(function (item, index) {
        return _this6.renderItems(item, index + 1);
      })))));
    }
  }]);

  return Autocomplete;
}(Component);

_defineProperty$1$3(Autocomplete, "defaultProps", {
  defaultValue: ''
});

function asyncGeneratorStep$g(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator$g(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep$g(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep$g(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _defineProperty$p(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Icon$g = function Icon(_ref) {
  var name = _ref.name,
      style = _ref.style,
      className = _ref.className,
      ariaLabel = _ref.ariaLabel,
      onClick = _ref.onClick,
      src = _ref.src,
      qa = _ref.qa;
  /**
   * Inject SVG icons from core branding into page
   */

  var fetchAntwerpIcons = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator$g( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var xlinkHref, response, svgText, svgWrapper;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (fetch) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              _context.prev = 2;
              xlinkHref = 'https://cdn.antwerpen.be/core_branding_scss/5.0.0/assets/images/ai.svg';
              _context.next = 6;
              return fetch(xlinkHref);

            case 6:
              response = _context.sent;
              _context.next = 9;
              return response.text();

            case 9:
              svgText = _context.sent;
              svgWrapper = document.createElement('svg');
              svgWrapper.id = 'aiSvg';
              svgWrapper.innerHTML = svgText;

              if (!document.getElementById('aiSvg')) {
                document.body.appendChild(svgWrapper);
              }

              _context.next = 19;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](2);
              throw new Error(_context.t0);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 16]]);
    }));

    return function fetchAntwerpIcons() {
      return _ref2.apply(this, arguments);
    };
  }();

  if (typeof document !== 'undefined' && !document.getElementById('aiSvg')) {
    fetchAntwerpIcons();
  }

  var iconClass = classNames(className, name, 'ai');
  return /*#__PURE__*/React__default.createElement("span", {
    className: iconClass,
    style: style,
    "data-qa": qa,
    onClick: onClick
  }, name && /*#__PURE__*/React__default.createElement("svg", {
    "aria-hidden": "true"
  }, /*#__PURE__*/React__default.createElement("use", {
    href: "#".concat(name)
  })), src, ariaLabel && /*#__PURE__*/React__default.createElement("span", {
    className: "u-screen-reader-only"
  }, ariaLabel));
};

var sizeClasses$b = {
  small: 'a-avatar--small',
  medium: 'a-avatar--medium',
  large: 'a-avatar--large'
};

var IconWrapper$1 = function IconWrapper(_ref) {
  var icon = _ref.icon;
  return /*#__PURE__*/React__default.createElement("span", {
    className: "a-avatar__icon"
  }, /*#__PURE__*/React__default.createElement(Icon$g, {
    name: icon
  }));
};

var LetterWrapper$1 = function LetterWrapper(_ref2) {
  var letter = _ref2.letter;
  return /*#__PURE__*/React__default.createElement("span", {
    className: "a-avatar__letter"
  }, letter);
};

var Avatar$1 = function Avatar(props) {
  var size = props.size,
      icon = props.icon,
      children = props.children,
      style = props.style,
      letter = props.letter,
      image = props.image,
      _props$alt = props.alt,
      alt = _props$alt === void 0 ? '' : _props$alt,
      className = props.className,
      qa = props.qa,
      _props$ariaLabel = props.ariaLabel,
      ariaLabel = _props$ariaLabel === void 0 ? 'Gebruiker icoon' : _props$ariaLabel;
  var avatarClass = classNames('a-avatar', _defineProperty$p({}, "".concat(sizeClasses$b[size]), !!size), className);
  return /*#__PURE__*/React__default.createElement("div", {
    className: avatarClass,
    style: style,
    "data-qa": qa
  }, icon && /*#__PURE__*/React__default.createElement(IconWrapper$1, {
    icon: icon
  }), letter && /*#__PURE__*/React__default.createElement(LetterWrapper$1, {
    letter: letter
  }), image && /*#__PURE__*/React__default.createElement("img", {
    src: image,
    alt: alt
  }), children, /*#__PURE__*/React__default.createElement("span", {
    className: "u-screen-reader-only"
  }, ariaLabel));
};

function _defineProperty$o(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var typeClasses$b = {
  primary: 'a-badge--primary',
  secondary: 'a-badge--secondary',
  success: 'a-badge--success',
  warning: 'a-badge--warning',
  danger: 'a-badge--danger'
};

var Badge = function Badge(props) {
  var type = props.type,
      className = props.className,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style,
      children = props.children,
      ariaLabel = props.ariaLabel,
      qa = props.qa;
  var badgeClass = classNames('a-badge', className, _defineProperty$o({}, "".concat(typeClasses$b[type]), !!type));
  return /*#__PURE__*/React__default.createElement("span", {
    className: badgeClass,
    title: ariaLabel,
    "aria-label": ariaLabel,
    style: style,
    "data-qa": qa
  }, children);
};

function asyncGeneratorStep$f(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator$f(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep$f(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep$f(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck$k(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$k(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$k(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$k(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$k(Constructor, staticProps);
  return Constructor;
}

function _defineProperty$n(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits$k(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$k(subClass, superClass);
}

function _getPrototypeOf$k(o) {
  _getPrototypeOf$k = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$k(o);
}

function _setPrototypeOf$k(o, p) {
  _setPrototypeOf$k = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$k(o, p);
}

function _isNativeReflectConstruct$k() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized$k(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn$k(self, call) {
  if (call && (_typeof$4(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized$k(self);
}

function _createSuper$k(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$k();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf$k(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$k(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn$k(this, result);
  };
}

var Icon$f = function Icon(_ref) {
  var name = _ref.name,
      style = _ref.style,
      className = _ref.className,
      ariaLabel = _ref.ariaLabel,
      onClick = _ref.onClick,
      src = _ref.src,
      qa = _ref.qa;
  /**
   * Inject SVG icons from core branding into page
   */

  var fetchAntwerpIcons = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator$f( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var xlinkHref, response, svgText, svgWrapper;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (fetch) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              _context.prev = 2;
              xlinkHref = 'https://cdn.antwerpen.be/core_branding_scss/5.0.0/assets/images/ai.svg';
              _context.next = 6;
              return fetch(xlinkHref);

            case 6:
              response = _context.sent;
              _context.next = 9;
              return response.text();

            case 9:
              svgText = _context.sent;
              svgWrapper = document.createElement('svg');
              svgWrapper.id = 'aiSvg';
              svgWrapper.innerHTML = svgText;

              if (!document.getElementById('aiSvg')) {
                document.body.appendChild(svgWrapper);
              }

              _context.next = 19;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](2);
              throw new Error(_context.t0);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 16]]);
    }));

    return function fetchAntwerpIcons() {
      return _ref2.apply(this, arguments);
    };
  }();

  if (typeof document !== 'undefined' && !document.getElementById('aiSvg')) {
    fetchAntwerpIcons();
  }

  var iconClass = classNames(className, name, 'ai');
  return /*#__PURE__*/React__default.createElement("span", {
    className: iconClass,
    style: style,
    "data-qa": qa,
    onClick: onClick
  }, name && /*#__PURE__*/React__default.createElement("svg", {
    "aria-hidden": "true"
  }, /*#__PURE__*/React__default.createElement("use", {
    href: "#".concat(name)
  })), src, ariaLabel && /*#__PURE__*/React__default.createElement("span", {
    className: "u-screen-reader-only"
  }, ariaLabel));
};

var sizeClasses$a = {
  tiny: 'a-button--tiny',
  small: 'a-button--small',
  large: 'a-button--large'
};
var typeClasses$a = {
  primary: '',
  secondary: 'a-button--secondary',
  success: 'a-button--success',
  warning: 'a-button--warning',
  danger: 'a-button--danger',
  transparent: 'a-button--transparent',
  default: 'a-button--default'
};

var Button$9 = /*#__PURE__*/function (_Component) {
  _inherits$k(Button, _Component);

  var _super = _createSuper$k(Button);

  function Button() {
    _classCallCheck$k(this, Button);

    return _super.apply(this, arguments);
  }

  _createClass$k(Button, [{
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props = this.props,
          id = _this$props.id,
          negative = _this$props.negative,
          outline = _this$props.outline,
          transparent = _this$props.transparent,
          className = _this$props.className,
          children = _this$props.children,
          icon = _this$props.icon,
          iconLeft = _this$props.iconLeft,
          iconRight = _this$props.iconRight,
          onClick = _this$props.onClick,
          _this$props$title = _this$props.title,
          title = _this$props$title === void 0 ? '' : _this$props$title,
          _this$props$ariaLabel = _this$props.ariaLabel,
          ariaLabel = _this$props$ariaLabel === void 0 ? '' : _this$props$ariaLabel,
          type = _this$props.type,
          size = _this$props.size,
          _this$props$block = _this$props.block,
          block = _this$props$block === void 0 ? false : _this$props$block,
          _this$props$style = _this$props.style,
          style = _this$props$style === void 0 ? {} : _this$props$style,
          _this$props$disabled = _this$props.disabled,
          disabled = _this$props$disabled === void 0 ? false : _this$props$disabled,
          htmlType = _this$props.htmlType,
          qa = _this$props.qa;
      var btnClass = classNames(className, (_classNames = {
        'a-button': !outline && !negative && !(type === 'default' && !!transparent)
      }, _defineProperty$n(_classNames, "".concat(typeClasses$a[type]), !!type), _defineProperty$n(_classNames, "".concat(sizeClasses$a[size]), !!size), _defineProperty$n(_classNames, 'has-icon', !!icon), _defineProperty$n(_classNames, 'has-icon-left', !!iconLeft), _defineProperty$n(_classNames, 'has-icon-right', !!iconRight), _defineProperty$n(_classNames, 'a-button-negative', !!negative), _defineProperty$n(_classNames, 'a-button-outline', !!outline), _defineProperty$n(_classNames, 'a-button-transparent', !!transparent), _defineProperty$n(_classNames, 'a-button--block', block), _classNames));
      return /*#__PURE__*/React__default.createElement("button", {
        id: id,
        className: btnClass,
        title: title || '',
        onClick: onClick,
        style: style,
        disabled: disabled,
        type: htmlType,
        "aria-label": ariaLabel,
        "data-qa": qa
      }, icon ? /*#__PURE__*/React__default.createElement(Icon$f, {
        name: icon
      }) : null, iconLeft ? /*#__PURE__*/React__default.createElement(Icon$f, {
        name: iconLeft
      }) : null, iconRight ? /*#__PURE__*/React__default.createElement(Icon$f, {
        name: iconRight
      }) : null, children);
    }
  }]);

  return Button;
}(Component);

var ButtonGroup = function ButtonGroup(props) {
  var children = props.children,
      style = props.style,
      _props$direction = props.direction,
      direction = _props$direction === void 0 ? 'horizontal' : _props$direction,
      qa = props.qa;
  var className = classNames('m-button-group', {
    'm-button-group--vertical': direction === 'vertical'
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: className,
    style: style,
    "data-qa": qa
  }, children);
};

function asyncGeneratorStep$e(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator$e(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep$e(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep$e(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck$j(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$j(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$j(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$j(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$j(Constructor, staticProps);
  return Constructor;
}

function _defineProperty$m(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits$j(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$j(subClass, superClass);
}

function _getPrototypeOf$j(o) {
  _getPrototypeOf$j = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$j(o);
}

function _setPrototypeOf$j(o, p) {
  _setPrototypeOf$j = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$j(o, p);
}

function _isNativeReflectConstruct$j() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized$j(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn$j(self, call) {
  if (call && (_typeof$4(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized$j(self);
}

function _createSuper$j(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$j();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf$j(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$j(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn$j(this, result);
  };
}

var viewTypeMap$2 = {
  days: 'dagen',
  months: 'maanden',
  years: 'jaren'
};

var mapViewType$2 = function mapViewType(viewType) {
  return viewTypeMap$2[viewType];
};

var mapNav$2 = function mapNav(direction, viewType, value) {
  var multi = '';
  var viewTypeDisplay = '';
  var valueDisplay = '';
  var directionDisplay = direction > 0 ? 'volgend' : 'vorig';

  switch (viewType) {
    case 'months':
      viewTypeDisplay = 'jaar';
      valueDisplay = value.clone().add(direction, 'years').format('YYYY');
      break;

    case 'years':
      multi = 'e';
      viewTypeDisplay = 'periode van 12 jaar';
      var years = yearsOfMonth$2(value.clone().add(12 * direction, 'years'));
      valueDisplay = years[0] + '-' + years.slice(-1);
      break;

    default:
      multi = 'e';
      viewTypeDisplay = 'maand';
      valueDisplay = value.clone().add(direction, 'months').format('MMMM YYYY');
  }

  return "Ga naar ".concat(directionDisplay).concat(multi, " ").concat(viewTypeDisplay, ", ").concat(valueDisplay);
};

var aria$2 = {
  mapViewType: mapViewType$2,
  mapNav: mapNav$2
};

function rotateArrayByPosition$2(data, d) {
  var temp = data.splice(0);

  for (var i = 0; i < d - 1; i++) {
    var first = temp.shift();
    temp.push(first);
  }

  return temp;
}

function daysOfMonth$2(displayedMonth) {
  var _i, d;

  var results = [];
  var startOfMonth = displayedMonth.startOf('months');
  var startDayOfWeek = startOfMonth.clone().startOf('isoWeek');
  var startAt = -startOfMonth.diff(startDayOfWeek, 'days');
  var endAt = Math.ceil((displayedMonth.daysInMonth() - startAt) / 7) * 7 + startAt - 1;

  for (d = _i = startAt; startAt <= endAt ? _i <= endAt : _i >= endAt; d = startAt <= endAt ? ++_i : --_i) {
    results.push(displayedMonth.clone().add(d, 'days'));
  }

  return results;
}

function weekEnum$2(daysOfMonth) {
  var results = [];

  for (var _i = 0, _ref = daysOfMonth.length / 7; 0 <= _ref ? _i < _ref : _i > _ref; 0 <= _ref ? _i++ : _i--) {
    results.push(_i);
  }

  return results;
}

function isDateFromNextMonth$2(date, displayedMonth) {
  return date.year() > displayedMonth.year() || date.year() === displayedMonth.year() && date.month() > displayedMonth.month();
}

function isDateFromPrevMonth$2(date, displayedMonth) {
  return date.year() < displayedMonth.year() || date.year() === displayedMonth.year() && date.month() < displayedMonth.month();
}

function yearsOfMonth$2(displayedMonth) {
  var amountOfYearsBack = -11;
  var results = [];

  for (var year = amountOfYearsBack; year < 0; year++) {
    results.push(displayedMonth.clone().add(year, 'years').format('YYYY'));
  }

  results.push(displayedMonth.clone().format('YYYY'));
  return results;
}

function nextItemInArray$2(element, array) {
  var i = array.findIndex(function (k) {
    return k == element;
  });
  i = i + 1;
  i = i % array.length;
  return array[i];
}

var Icon$e = function Icon(_ref) {
  var name = _ref.name,
      style = _ref.style,
      className = _ref.className,
      ariaLabel = _ref.ariaLabel,
      onClick = _ref.onClick,
      src = _ref.src,
      qa = _ref.qa;
  /**
   * Inject SVG icons from core branding into page
   */

  var fetchAntwerpIcons = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator$e( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var xlinkHref, response, svgText, svgWrapper;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (fetch) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              _context.prev = 2;
              xlinkHref = 'https://cdn.antwerpen.be/core_branding_scss/5.0.0/assets/images/ai.svg';
              _context.next = 6;
              return fetch(xlinkHref);

            case 6:
              response = _context.sent;
              _context.next = 9;
              return response.text();

            case 9:
              svgText = _context.sent;
              svgWrapper = document.createElement('svg');
              svgWrapper.id = 'aiSvg';
              svgWrapper.innerHTML = svgText;

              if (!document.getElementById('aiSvg')) {
                document.body.appendChild(svgWrapper);
              }

              _context.next = 19;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](2);
              throw new Error(_context.t0);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 16]]);
    }));

    return function fetchAntwerpIcons() {
      return _ref2.apply(this, arguments);
    };
  }();

  if (typeof document !== 'undefined' && !document.getElementById('aiSvg')) {
    fetchAntwerpIcons();
  }

  var iconClass = classNames(className, name, 'ai');
  return /*#__PURE__*/React__default.createElement("span", {
    className: iconClass,
    style: style,
    "data-qa": qa,
    onClick: onClick
  }, name && /*#__PURE__*/React__default.createElement("svg", {
    "aria-hidden": "true"
  }, /*#__PURE__*/React__default.createElement("use", {
    href: "#".concat(name)
  })), src, ariaLabel && /*#__PURE__*/React__default.createElement("span", {
    className: "u-screen-reader-only"
  }, ariaLabel));
};

var sizeClasses$9 = {
  tiny: 'a-button--tiny',
  small: 'a-button--small',
  large: 'a-button--large'
};
var typeClasses$9 = {
  primary: '',
  secondary: 'a-button--secondary',
  success: 'a-button--success',
  warning: 'a-button--warning',
  danger: 'a-button--danger',
  transparent: 'a-button--transparent',
  default: 'a-button--default'
};

var Button$8 = /*#__PURE__*/function (_Component) {
  _inherits$j(Button, _Component);

  var _super = _createSuper$j(Button);

  function Button() {
    _classCallCheck$j(this, Button);

    return _super.apply(this, arguments);
  }

  _createClass$j(Button, [{
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props = this.props,
          id = _this$props.id,
          negative = _this$props.negative,
          outline = _this$props.outline,
          transparent = _this$props.transparent,
          className = _this$props.className,
          children = _this$props.children,
          icon = _this$props.icon,
          iconLeft = _this$props.iconLeft,
          iconRight = _this$props.iconRight,
          onClick = _this$props.onClick,
          _this$props$title = _this$props.title,
          title = _this$props$title === void 0 ? '' : _this$props$title,
          _this$props$ariaLabel = _this$props.ariaLabel,
          ariaLabel = _this$props$ariaLabel === void 0 ? '' : _this$props$ariaLabel,
          type = _this$props.type,
          size = _this$props.size,
          _this$props$block = _this$props.block,
          block = _this$props$block === void 0 ? false : _this$props$block,
          _this$props$style = _this$props.style,
          style = _this$props$style === void 0 ? {} : _this$props$style,
          _this$props$disabled = _this$props.disabled,
          disabled = _this$props$disabled === void 0 ? false : _this$props$disabled,
          htmlType = _this$props.htmlType,
          qa = _this$props.qa;
      var btnClass = classNames(className, (_classNames = {
        'a-button': !outline && !negative && !(type === 'default' && !!transparent)
      }, _defineProperty$m(_classNames, "".concat(typeClasses$9[type]), !!type), _defineProperty$m(_classNames, "".concat(sizeClasses$9[size]), !!size), _defineProperty$m(_classNames, 'has-icon', !!icon), _defineProperty$m(_classNames, 'has-icon-left', !!iconLeft), _defineProperty$m(_classNames, 'has-icon-right', !!iconRight), _defineProperty$m(_classNames, 'a-button-negative', !!negative), _defineProperty$m(_classNames, 'a-button-outline', !!outline), _defineProperty$m(_classNames, 'a-button-transparent', !!transparent), _defineProperty$m(_classNames, 'a-button--block', block), _classNames));
      return /*#__PURE__*/React__default.createElement("button", {
        id: id,
        className: btnClass,
        title: title || '',
        onClick: onClick,
        style: style,
        disabled: disabled,
        type: htmlType,
        "aria-label": ariaLabel,
        "data-qa": qa
      }, icon ? /*#__PURE__*/React__default.createElement(Icon$e, {
        name: icon
      }) : null, iconLeft ? /*#__PURE__*/React__default.createElement(Icon$e, {
        name: iconLeft
      }) : null, iconRight ? /*#__PURE__*/React__default.createElement(Icon$e, {
        name: iconRight
      }) : null, children);
    }
  }]);

  return Button;
}(Component);

var Nav$2 = /*#__PURE__*/function (_Component) {
  _inherits$j(Nav, _Component);

  var _super = _createSuper$j(Nav);

  function Nav() {
    _classCallCheck$j(this, Nav);

    return _super.apply(this, arguments);
  }

  _createClass$j(Nav, [{
    key: "renderNav",
    value: function renderNav() {
      var _this$props = this.props,
          viewType = _this$props.viewType,
          displayedPeriod = _this$props.displayedPeriod;

      switch (viewType) {
        case 'months':
          return displayedPeriod.format('YYYY');

        case 'years':
          return this.renderYearsNav(displayedPeriod);

        default:
          return displayedPeriod.format('MMMM YYYY');
      }
    }
  }, {
    key: "renderYearsNav",
    value: function renderYearsNav(displayedMonth) {
      var years = yearsOfMonth$2(displayedMonth);
      return years[0] + '-' + years.slice(-1);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          onClickPrevious = _this$props2.onClickPrevious,
          onClickViewType = _this$props2.onClickViewType,
          onClickNext = _this$props2.onClickNext,
          viewType = _this$props2.viewType,
          displayedPeriod = _this$props2.displayedPeriod,
          _this$props2$ariaLabe = _this$props2.ariaLabelPrevious,
          ariaLabelPrevious = _this$props2$ariaLabe === void 0 ? function (viewType, value) {
        return aria$2.mapNav(-1, viewType, value);
      } : _this$props2$ariaLabe,
          _this$props2$ariaLabe2 = _this$props2.ariaLabelNext,
          ariaLabelNext = _this$props2$ariaLabe2 === void 0 ? function (viewType, value) {
        return aria$2.mapNav(1, viewType, value);
      } : _this$props2$ariaLabe2;
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Button$8, {
        htmlType: "button",
        onClick: onClickPrevious,
        className: 'a-button has-icon',
        icon: 'ai-arrow-left-1',
        ariaLabel: ariaLabelPrevious(viewType, displayedPeriod)
      }), /*#__PURE__*/React__default.createElement(Button$8, {
        htmlType: "button",
        onClick: onClickViewType,
        className: 'm-datepicker__title a-button u-text-capitalize'
      }, this.renderNav()), /*#__PURE__*/React__default.createElement(Button$8, {
        htmlType: "button",
        onClick: onClickNext,
        className: 'a-button has-icon',
        icon: 'ai-arrow-right-1',
        ariaLabel: ariaLabelNext(viewType, displayedPeriod)
      }));
    }
  }]);

  return Nav;
}(Component);

var Rows$2 = /*#__PURE__*/function (_Component) {
  _inherits$j(Rows, _Component);

  var _super = _createSuper$j(Rows);

  function Rows() {
    _classCallCheck$j(this, Rows);

    return _super.apply(this, arguments);
  }

  _createClass$j(Rows, [{
    key: "generateRows",
    value: function generateRows() {
      var _this$props = this.props,
          list = _this$props.list,
          rowLength = _this$props.rowLength,
          onClick = _this$props.onClick;
      return list.map(function (content, index) {
        return /*#__PURE__*/React__default.createElement("td", {
          key: index
        }, /*#__PURE__*/React__default.createElement("button", {
          className: "u-text-capitalize",
          tabIndex: index,
          value: content,
          onClick: onClick,
          type: "button"
        }, content.replace(/\./g, ' ')));
      }).reduce(function (r, element, index) {
        // create element groups with size 4, result looks like:
        // [[elem1, elem2, elem3], [elem4, elem5, elem6],x ...]
        index % rowLength === 0 && r.push([]);
        r[r.length - 1].push(element);
        return r;
      }, []).map(function (rowContent, index) {
        // surround every group with a tr
        return /*#__PURE__*/React__default.createElement("tr", {
          key: index
        }, rowContent);
      });
    }
  }, {
    key: "render",
    value: function render() {
      return this.generateRows();
    }
  }]);

  return Rows;
}(Component);

var Day$2 = /*#__PURE__*/function (_Component) {
  _inherits$j(Day, _Component);

  var _super = _createSuper$j(Day);

  function Day() {
    var _this;

    _classCallCheck$j(this, Day);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$m(_assertThisInitialized$j(_this), "handleOnClick", function (day) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          selectDay = _this$props.selectDay;
      if (disabled) return;
      selectDay(day);
    });

    return _this;
  }

  _createClass$j(Day, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          activeDate = _this$props2.activeDate,
          day = _this$props2.day,
          selected = _this$props2.selected,
          disabled = _this$props2.disabled,
          dayNextMonth = _this$props2.dayNextMonth,
          dayPrevMonth = _this$props2.dayPrevMonth,
          dayActiveClassName = _this$props2.dayActiveClassName,
          selectedClassName = _this$props2.selectedClassName,
          dayDisabledClassName = _this$props2.dayDisabledClassName,
          dayFromOtherMonthClassName = _this$props2.dayFromOtherMonthClassName,
          ariaLabelButtonDateFormat = _this$props2.ariaLabelButtonDateFormat;
      var buttonClasses = [];

      if (day.isSame(Moment(), 'day')) {
        buttonClasses.push(selectedClassName);
      }

      if (day.isSame(activeDate, 'day')) {
        buttonClasses.push(dayActiveClassName);
      }

      if (disabled) {
        buttonClasses.push(dayDisabledClassName);
      }

      if (selected) {
        buttonClasses.push(dayActiveClassName);
      }

      if (dayPrevMonth || dayNextMonth) {
        buttonClasses.push(dayFromOtherMonthClassName);
      }

      return /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("button", {
        tabIndex: disabled ? '-1' : '0',
        type: "button",
        onClick: this.handleOnClick.bind(this, day),
        className: buttonClasses.join(' '),
        "aria-label": day.format(ariaLabelButtonDateFormat)
      }, day.date()));
    }
  }]);

  return Day;
}(Component);

_defineProperty$m(Day$2, "defaultProps", {
  dayClassName: '',
  dayActiveClassName: 'is-selected',
  selectedClassName: 'is-current',
  dayDisabledClassName: 'is-unavailable',
  dayFromOtherMonthClassName: 'is-faded',
  ariaLabelButtonDateFormat: 'dddd D MMMM YYYY'
});

var Body$2 = /*#__PURE__*/function (_Component) {
  _inherits$j(Body, _Component);

  var _super = _createSuper$j(Body);

  function Body() {
    var _this;

    _classCallCheck$j(this, Body);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$m(_assertThisInitialized$j(_this), "handleOnClick", function (type, event) {
      var value = event.target.value;
      var newDisplayedPeriod = null;
      var displayedPeriod = _this.props.displayedPeriod;

      if (type === 'days') {
        newDisplayedPeriod = Moment(displayedPeriod.format('YYYY') + value, "YYYY MMM");
      } else if (type === 'months') {
        newDisplayedPeriod = Moment(displayedPeriod.format('MM') + value, "MM YYYY");
      }

      var goToViewType = _this.props.goToViewType;
      goToViewType(type, newDisplayedPeriod);
    });

    return _this;
  }

  _createClass$j(Body, [{
    key: "renderBody",
    value: function renderBody(displayedPeriod) {
      var viewType = this.props.viewType;

      switch (viewType) {
        case 'months':
          return this.renderListMonths();

        case "years":
          return this.renderListYears(displayedPeriod);

        default:
          return this.renderWeeks(displayedPeriod);
      }
    }
  }, {
    key: "renderWeeks",
    value: function renderWeeks(displayMonth) {
      var _this2 = this;

      var _daysOfMonth = daysOfMonth$2(displayMonth);

      var _weekEnum = weekEnum$2(_daysOfMonth);

      return _weekEnum.map(function (week, key) {
        return /*#__PURE__*/React__default.createElement("tr", {
          key: key
        }, _this2.renderDay(_daysOfMonth, week));
      });
    }
  }, {
    key: "renderListMonths",
    value: function renderListMonths() {
      var months = Moment.monthsShort();
      return /*#__PURE__*/React__default.createElement(Rows$2, {
        list: months,
        rowLength: 4,
        onClick: this.handleOnClick.bind(this, 'days')
      });
    }
  }, {
    key: "renderListYears",
    value: function renderListYears(displayMonth) {
      var years = yearsOfMonth$2(displayMonth);
      return /*#__PURE__*/React__default.createElement(Rows$2, {
        list: years,
        rowLength: 4,
        onClick: this.handleOnClick.bind(this, 'months')
      });
    }
  }, {
    key: "renderDay",
    value: function renderDay(_daysOfMonth, week) {
      var _this3 = this;

      var days = [0, 1, 2, 3, 4, 5, 6];
      var _this$props = this.props,
          activeDate = _this$props.activeDate,
          displayedPeriod = _this$props.displayedPeriod,
          selectedDates = _this$props.selectedDates,
          minDate = _this$props.minDate,
          maxDate = _this$props.maxDate,
          format = _this$props.format,
          noWeekends = _this$props.noWeekends,
          selectDay = _this$props.selectDay,
          ariaLabelButtonDateFormat = _this$props.ariaLabelButtonDateFormat;
      return days.map(function (day, key) {
        var date = _daysOfMonth[week * 7 + day];
        var disabled;
        var selected = false;

        if (minDate && maxDate) {
          disabled = date.isBefore(minDate, 'day') || date.isAfter(maxDate, 'day');
        } else if (minDate) {
          disabled = date.isBefore(minDate, 'day');
        } else if (maxDate) {
          disabled = date.isAfter(maxDate, 'day');
        }

        if (noWeekends) {
          disabled = date.day() === 6 || date.day() === 0;
        }

        var dayNextMonth = isDateFromNextMonth$2(date, displayedPeriod);
        var dayPrevMonth = isDateFromPrevMonth$2(date, displayedPeriod);
        selectedDates.forEach(function (selectedDate) {
          if (date.isSame(Moment(selectedDate, format), 'day')) {
            selected = true;
            dayPrevMonth = false;
            dayNextMonth = false;
          }
        });
        return /*#__PURE__*/React__default.createElement(Day$2, {
          key: key,
          day: date,
          selectDay: selectDay.bind(_this3, date),
          disabled: disabled,
          selected: selected,
          dayPrevMonth: dayPrevMonth,
          dayNextMonth: dayNextMonth,
          activeDate: activeDate,
          ariaLabelButtonDateFormat: ariaLabelButtonDateFormat
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var displayedPeriod = this.props.displayedPeriod;
      return this.renderBody(displayedPeriod);
    }
  }]);

  return Body;
}(Component);

_defineProperty$m(Body$2, "defaultProps", {
  selectedDates: []
});

var Head$2 = /*#__PURE__*/function (_Component) {
  _inherits$j(Head, _Component);

  var _super = _createSuper$j(Head);

  function Head() {
    _classCallCheck$j(this, Head);

    return _super.apply(this, arguments);
  }

  _createClass$j(Head, [{
    key: "renderHeader",
    value: function renderHeader() {
      var viewType = this.props.viewType;

      switch (viewType) {
        case 'months':
          return null;

        case 'years':
          return null;

        default:
          return this.renderNameOfDays();
      }
    }
  }, {
    key: "renderNameOfDays",
    value: function renderNameOfDays() {
      // rotate arrays to put monday first, to match <Body>
      var nameOfDays = rotateArrayByPosition$2(Moment.weekdaysMin(), 2);
      var longNameDays = rotateArrayByPosition$2(Moment.weekdays(), 2);
      return /*#__PURE__*/React__default.createElement("tr", {
        className: "m-datepicker__days"
      }, nameOfDays.map(function (day, i) {
        return /*#__PURE__*/React__default.createElement("th", {
          key: i,
          className: "u-text-capitalize",
          "aria-label": longNameDays[i]
        }, day);
      }));
    }
  }, {
    key: "render",
    value: function render() {
      return this.renderHeader();
    }
  }]);

  return Head;
}(Component);

var Calendar$1$2 = /*#__PURE__*/function (_Component) {
  _inherits$j(Calendar, _Component);

  var _super = _createSuper$j(Calendar);

  function Calendar() {
    var _this;

    _classCallCheck$j(this, Calendar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$m(_assertThisInitialized$j(_this), "state", {
      displayedPeriod: _this.props.activeDate ? Moment(_this.props.activeDate, _this.props.format) : Moment(),
      viewType: 'days',
      views: ['days', 'months', 'years']
    });

    return _this;
  }

  _createClass$j(Calendar, [{
    key: "changeViewType",
    value: function changeViewType() {
      var _this$state = this.state,
          viewType = _this$state.viewType,
          views = _this$state.views;
      var switchTo = nextItemInArray$2(viewType, views);
      this.goToViewType(switchTo);
    }
  }, {
    key: "goToViewType",
    value: function goToViewType(switchTo) {
      var displayedPeriod = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      this.setState({
        viewType: switchTo,
        displayedPeriod: displayedPeriod || this.state.displayedPeriod
      });
    }
  }, {
    key: "moveDisplayedPeriod",
    value: function moveDisplayedPeriod(delta) {
      var _this$state2 = this.state,
          viewType = _this$state2.viewType,
          displayedPeriod = _this$state2.displayedPeriod;
      var period = viewType === 'days' ? 'months' : 'years';
      var diffTime = viewType === 'years' ? delta * 12 : delta;
      this.setState({
        displayedPeriod: displayedPeriod.clone().add(diffTime, period)
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          selectDay = _this$props.selectDay,
          activeDate = _this$props.activeDate,
          selectedDates = _this$props.selectedDates,
          minDate = _this$props.minDate,
          maxDate = _this$props.maxDate,
          format = _this$props.format,
          noWeekends = _this$props.noWeekends,
          ariaLabelPrevious = _this$props.ariaLabelPrevious,
          ariaLabelNext = _this$props.ariaLabelNext,
          _this$props$ariaLabel = _this$props.ariaLabelDatePicker,
          ariaLabelDatePicker = _this$props$ariaLabel === void 0 ? function (viewType) {
        return "Datumkiezer ".concat(aria$2.mapViewType(viewType));
      } : _this$props$ariaLabel,
          ariaLabelButtonDateFormat = _this$props.ariaLabelButtonDateFormat;
      var _this$state3 = this.state,
          viewType = _this$state3.viewType,
          displayedPeriod = _this$state3.displayedPeriod;
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        className: "m-datepicker__nav",
        "aria-label": "".concat(ariaLabelDatePicker(viewType)),
        "aria-hidden": "false"
      }, /*#__PURE__*/React__default.createElement(Nav$2, {
        viewType: viewType,
        displayedPeriod: displayedPeriod,
        onClickPrevious: this.moveDisplayedPeriod.bind(this, -1),
        onClickViewType: this.changeViewType.bind(this),
        onClickNext: this.moveDisplayedPeriod.bind(this, 1),
        ariaLabelPrevious: ariaLabelPrevious,
        ariaLabelNext: ariaLabelNext
      })), /*#__PURE__*/React__default.createElement("table", null, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement(Head$2, {
        displayedPeriod: displayedPeriod,
        viewType: viewType
      })), /*#__PURE__*/React__default.createElement("tbody", {
        className: "m-datepicker__calendar"
      }, /*#__PURE__*/React__default.createElement(Body$2, {
        viewType: viewType,
        displayedPeriod: displayedPeriod,
        selectDay: selectDay.bind(this),
        selectedDates: selectedDates,
        minDate: minDate,
        maxDate: maxDate,
        format: format,
        noWeekends: noWeekends,
        activeDate: activeDate,
        ariaLabelButtonDateFormat: ariaLabelButtonDateFormat,
        goToViewType: this.goToViewType.bind(this)
      }))));
    }
  }]);

  return Calendar;
}(Component);

var _this$2 = undefined;

var DatePicker$2 = function DatePicker(_ref) {
  var clickOnDate = _ref.clickOnDate,
      format = _ref.format,
      locale = _ref.locale,
      activeDate = _ref.activeDate,
      selectedDates = _ref.selectedDates,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      noWeekends = _ref.noWeekends,
      ariaLabelPrevious = _ref.ariaLabelPrevious,
      ariaLabelNext = _ref.ariaLabelNext,
      ariaLabelDatePicker = _ref.ariaLabelDatePicker,
      ariaLabelButtonDateFormat = _ref.ariaLabelButtonDateFormat,
      qa = _ref.qa;
  return /*#__PURE__*/React__default.createElement(Calendar$1$2, {
    selectDay: clickOnDate.bind(_this$2),
    format: format,
    locale: locale,
    activeDate: activeDate,
    selectedDates: selectedDates,
    minDate: minDate,
    maxDate: maxDate,
    noWeekends: noWeekends,
    ariaLabelPrevious: ariaLabelPrevious,
    ariaLabelNext: ariaLabelNext,
    ariaLabelDatePicker: ariaLabelDatePicker,
    ariaLabelButtonDateFormat: ariaLabelButtonDateFormat,
    qa: qa
  });
};

var Calendar$3 = /*#__PURE__*/function (_Component) {
  _inherits$j(Calendar, _Component);

  var _super = _createSuper$j(Calendar);

  function Calendar(props) {
    var _this;

    _classCallCheck$j(this, Calendar);

    _this = _super.call(this, props);
    var _this$props = _this.props,
        activeDate = _this$props.activeDate,
        format = _this$props.format,
        locale = _this$props.locale;
    Moment.locale(locale ? locale : 'nl');
    _this.state = {
      activeDate: activeDate ? Moment(activeDate, format) : ''
    };
    return _this;
  }

  _createClass$j(Calendar, [{
    key: "changeDate",
    value: function changeDate(day) {
      var _this$props2 = this.props,
          onChange = _this$props2.onChange,
          format = _this$props2.format;
      if (onChange) onChange(Moment(day).format(format));
      this.setState({
        activeDate: day
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          format = _this$props3.format,
          locale = _this$props3.locale,
          selectedDates = _this$props3.selectedDates,
          minDate = _this$props3.minDate,
          maxDate = _this$props3.maxDate,
          noWeekends = _this$props3.noWeekends,
          ariaLabelPrevious = _this$props3.ariaLabelPrevious,
          ariaLabelNext = _this$props3.ariaLabelNext,
          ariaLabelDatePicker = _this$props3.ariaLabelDatePicker,
          ariaLabelButtonDateFormat = _this$props3.ariaLabelButtonDateFormat,
          qa = _this$props3.qa;
      var activeDate = this.state.activeDate;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "m-datepicker is-open",
        "data-qa": qa
      }, /*#__PURE__*/React__default.createElement(DatePicker$2, {
        format: format,
        locale: locale,
        activeDate: activeDate,
        selectedDates: selectedDates,
        minDate: Moment(minDate, format),
        maxDate: Moment(maxDate, format),
        noWeekends: noWeekends,
        ariaLabelPrevious: ariaLabelPrevious,
        ariaLabelNext: ariaLabelNext,
        ariaLabelDatePicker: ariaLabelDatePicker,
        ariaLabelButtonDateFormat: ariaLabelButtonDateFormat,
        qa: qa,
        clickOnDate: this.changeDate.bind(this)
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.activeDate) {
        return {
          activeDate: Moment(nextProps.activeDate, nextProps.format)
        };
      }

      return null;
    }
  }]);

  return Calendar;
}(Component);

_defineProperty$m(Calendar$3, "defaultProps", {
  format: 'DD/MM/YYYY',
  noWeekends: false
});

function asyncGeneratorStep$d(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator$d(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep$d(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep$d(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck$i(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$i(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$i(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$i(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$i(Constructor, staticProps);
  return Constructor;
}

function _inherits$i(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$i(subClass, superClass);
}

function _getPrototypeOf$i(o) {
  _getPrototypeOf$i = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$i(o);
}

function _setPrototypeOf$i(o, p) {
  _setPrototypeOf$i = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$i(o, p);
}

function _isNativeReflectConstruct$i() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized$i(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn$i(self, call) {
  if (call && (_typeof$4(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized$i(self);
}

function _createSuper$i(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$i();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf$i(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$i(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn$i(this, result);
  };
}

var Card = /*#__PURE__*/function (_Component) {
  _inherits$i(Card, _Component);

  var _super = _createSuper$i(Card);

  function Card() {
    _classCallCheck$i(this, Card);

    return _super.apply(this, arguments);
  }

  _createClass$i(Card, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          style = _this$props.style,
          children = _this$props.children,
          qa = _this$props.qa;
      var cardClass = classNames('m-card', className);
      return /*#__PURE__*/React__default.createElement("div", {
        className: cardClass,
        style: style,
        "data-qa": qa
      }, children);
    }
  }]);

  return Card;
}(Component);

var Contact$1 = function Contact(props) {
  var name = props.name,
      avatar = props.avatar,
      style = props.style,
      info = props.info,
      qa = props.qa;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "m-contact",
    style: style,
    "data-qa": qa
  }, avatar, /*#__PURE__*/React__default.createElement("div", {
    className: "m-contact__info"
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "u-text-bold"
  }, name), info && /*#__PURE__*/React__default.createElement("p", {
    className: "small"
  }, info)));
};

var CardHeader = function CardHeader(props) {
  var title = props.title,
      actions = props.actions,
      avatar = props.avatar;
  var cardHeader = /*#__PURE__*/React__default.createElement("div", {
    className: "m-card__header",
    style: {
      display: 'flex'
    }
  }, /*#__PURE__*/React__default.createElement(Contact$1, {
    avatar: avatar,
    name: title,
    style: {
      flex: 1,
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden'
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    style: {
      float: 'right',
      textAlign: 'right'
    }
  }, actions));
  return title || actions ? cardHeader : null;
};

var CardBody = function CardBody(props) {
  var children = props.children,
      style = props.style;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "m-card__body",
    style: style
  }, children);
};

var CardTitle = function CardTitle(props) {
  var children = props.children,
      style = props.style;
  return /*#__PURE__*/React__default.createElement("h5", {
    className: "u-margin-bottom-xs",
    style: style
  }, children);
};

var CardDescription = function CardDescription(props) {
  var children = props.children,
      style = props.style;
  return /*#__PURE__*/React__default.createElement("p", {
    style: style
  }, children);
};

var CardActions = function CardActions(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames('pull-right u-margin-bottom-xs', className)
  }, children);
};

CardActions.defaultProps = {
  className: ''
};

var Icon$d = function Icon(_ref) {
  var name = _ref.name,
      style = _ref.style,
      className = _ref.className,
      ariaLabel = _ref.ariaLabel,
      onClick = _ref.onClick,
      src = _ref.src,
      qa = _ref.qa;
  /**
   * Inject SVG icons from core branding into page
   */

  var fetchAntwerpIcons = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator$d( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var xlinkHref, response, svgText, svgWrapper;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (fetch) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              _context.prev = 2;
              xlinkHref = 'https://cdn.antwerpen.be/core_branding_scss/5.0.0/assets/images/ai.svg';
              _context.next = 6;
              return fetch(xlinkHref);

            case 6:
              response = _context.sent;
              _context.next = 9;
              return response.text();

            case 9:
              svgText = _context.sent;
              svgWrapper = document.createElement('svg');
              svgWrapper.id = 'aiSvg';
              svgWrapper.innerHTML = svgText;

              if (!document.getElementById('aiSvg')) {
                document.body.appendChild(svgWrapper);
              }

              _context.next = 19;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](2);
              throw new Error(_context.t0);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 16]]);
    }));

    return function fetchAntwerpIcons() {
      return _ref2.apply(this, arguments);
    };
  }();

  if (typeof document !== 'undefined' && !document.getElementById('aiSvg')) {
    fetchAntwerpIcons();
  }

  var iconClass = classNames(className, name, 'ai');
  return /*#__PURE__*/React__default.createElement("span", {
    className: iconClass,
    style: style,
    "data-qa": qa,
    onClick: onClick
  }, name && /*#__PURE__*/React__default.createElement("svg", {
    "aria-hidden": "true"
  }, /*#__PURE__*/React__default.createElement("use", {
    href: "#".concat(name)
  })), src, ariaLabel && /*#__PURE__*/React__default.createElement("span", {
    className: "u-screen-reader-only"
  }, ariaLabel));
};

var CardIcon = function CardIcon(_ref) {
  var icon = _ref.icon,
      className = _ref.className,
      ariaLabel = _ref.ariaLabel;
  return /*#__PURE__*/React__default.createElement("span", {
    className: classNames('pull-left u-margin-right u-margin-bottom', className)
  }, /*#__PURE__*/React__default.createElement(Icon$d, {
    name: icon,
    className: "fa-lg u-text-light",
    ariaLabel: ariaLabel
  }));
};

CardIcon.defaultProps = {
  icon: '',
  className: '',
  ariaLabel: ''
};

var CardImage = function CardImage(_ref) {
  var src = _ref.src,
      alt = _ref.alt,
      className = _ref.className;
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames('pull-left u-margin-right', className)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "a-avatar a-avatar--small"
  }, /*#__PURE__*/React__default.createElement("img", {
    src: src,
    alt: alt
  })));
};

CardImage.defaultProps = {
  className: '',
  alt: 'Default Alt'
};

var Contact = function Contact(props) {
  var name = props.name,
      avatar = props.avatar,
      style = props.style,
      info = props.info,
      qa = props.qa;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "m-contact",
    style: style,
    "data-qa": qa
  }, avatar, /*#__PURE__*/React__default.createElement("div", {
    className: "m-contact__info"
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "u-text-bold"
  }, name), info && /*#__PURE__*/React__default.createElement("p", {
    className: "small"
  }, info)));
};

var Content = function Content(props) {
  var className = props.className,
      children = props.children,
      qa = props.qa;
  var contentClass = classNames('u-wrapper', className);
  return /*#__PURE__*/React__default.createElement("div", {
    className: contentClass
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "u-container",
    "data-qa": qa
  }, children));
};

function _classCallCheck$h(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$h(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$h(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$h(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$h(Constructor, staticProps);
  return Constructor;
}

function _defineProperty$l(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits$h(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$h(subClass, superClass);
}

function _getPrototypeOf$h(o) {
  _getPrototypeOf$h = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$h(o);
}

function _setPrototypeOf$h(o, p) {
  _setPrototypeOf$h = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$h(o, p);
}

function _isNativeReflectConstruct$h() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized$h(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn$h(self, call) {
  if (call && (_typeof$4(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized$h(self);
}

function _createSuper$h(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$h();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf$h(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$h(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn$h(this, result);
  };
}

var FlyoutContent$3 = function FlyoutContent(props) {
  var hasPadding = props.hasPadding,
      children = props.children,
      qa = props.qa;
  var classes = classNames('m-flyout__content', {
    'has-padding': !!hasPadding
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: classes,
    "data-qa": qa
  }, children);
};

var flyoutSizes$3 = {
  small: 'sm',
  medium: 'md',
  large: 'lg',
  full: 'full'
};

var Flyout$1 = /*#__PURE__*/function (_Component) {
  _inherits$h(Flyout, _Component);

  var _super = _createSuper$h(Flyout);

  function Flyout() {
    var _this;

    _classCallCheck$h(this, Flyout);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$l(_assertThisInitialized$h(_this), "state", {
      isOpen: _this.props.open
    });

    _defineProperty$l(_assertThisInitialized$h(_this), "flyoutRef", /*#__PURE__*/React__default.createRef());

    _defineProperty$l(_assertThisInitialized$h(_this), "toggleIsOpen", function () {
      var onStateChange = _this.props.onStateChange;

      if (!_this.state.isOpen) {
        document.addEventListener('click', _this.handleOutsideClick, false);
      } else {
        document.removeEventListener('click', _this.handleOutsideClick, false);
      }

      _this.setState({
        isOpen: !_this.state.isOpen
      });

      onStateChange(_this.state.isOpen);
    });

    _defineProperty$l(_assertThisInitialized$h(_this), "closeFlyout", function () {
      var onStateChange = _this.props.onStateChange;

      if (!_this.state.isOpen) {
        document.addEventListener('click', _this.handleOutsideClick, false);
      } else {
        document.removeEventListener('click', _this.handleOutsideClick, false);
      }

      _this.setState({
        isOpen: false
      });

      onStateChange(false);
    });

    _defineProperty$l(_assertThisInitialized$h(_this), "handleOutsideClick", function (e) {
      var area = ReactDOM.findDOMNode(_this.flyoutRef.current);

      if (area && !area.contains(e.target)) {
        _this.closeFlyout();
      }
    });

    _defineProperty$l(_assertThisInitialized$h(_this), "getClassNames", function () {
      return classNames(_this.props.className, 'm-flyout', "m-flyout--".concat(_this.props.direction), _defineProperty$l({
        'is-open': _this.state.isOpen,
        'm-flyout--scrollable': _this.props.scrollable
      }, "m-flyout--".concat(flyoutSizes$3[_this.props.size]), !!flyoutSizes$3[_this.props.size]));
    });

    return _this;
  }

  _createClass$h(Flyout, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var isOpen = this.state.isOpen;

      if (isOpen) {
        document.addEventListener('click', this.handleOutsideClick, false);
      }

      this.props.triggerClose(this.closeFlyout);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.handleOutsideClick, false);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.open !== prevProps.open) {
        this.setState({
          isOpen: !prevProps.open
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          trigger = _this$props.trigger,
          hasPadding = _this$props.hasPadding,
          children = _this$props.children,
          qa = _this$props.qa;
      var open = this.state.open;
      var flyoutClass = this.getClassNames();
      return trigger && /*#__PURE__*/React__default.createElement("div", {
        className: flyoutClass,
        ref: this.flyoutRef,
        "aria-haspopup": "true",
        "aria-expanded": open,
        "data-qa": qa
      }, /*#__PURE__*/React__default.createElement("div", {
        onClick: this.toggleIsOpen
      }, this.props.trigger), /*#__PURE__*/React__default.createElement(FlyoutContent$3, {
        hasPadding: hasPadding
      }, children));
    }
  }]);

  return Flyout;
}(Component);

_defineProperty$l(Flyout$1, "defaultProps", {
  direction: 'left',
  size: 'medium',
  hasPadding: false,
  open: false,
  onStateChange: function onStateChange() {},
  triggerClose: function triggerClose() {},
  scrollable: false
});

function asyncGeneratorStep$c(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator$c(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep$c(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep$c(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck$g(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$g(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$g(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$g(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$g(Constructor, staticProps);
  return Constructor;
}

function _defineProperty$k(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends$5() {
  _extends$5 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$5.apply(this, arguments);
}

function _inherits$g(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$g(subClass, superClass);
}

function _getPrototypeOf$g(o) {
  _getPrototypeOf$g = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$g(o);
}

function _setPrototypeOf$g(o, p) {
  _setPrototypeOf$g = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$g(o, p);
}

function _isNativeReflectConstruct$g() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _objectWithoutPropertiesLoose$8(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties$8(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$8(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized$g(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn$g(self, call) {
  if (call && (_typeof$4(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized$g(self);
}

function _createSuper$g(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$g();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf$g(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$g(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn$g(this, result);
  };
}

var Icon$c = function Icon(_ref) {
  var name = _ref.name,
      style = _ref.style,
      className = _ref.className,
      ariaLabel = _ref.ariaLabel,
      onClick = _ref.onClick,
      src = _ref.src,
      qa = _ref.qa;
  /**
   * Inject SVG icons from core branding into page
   */

  var fetchAntwerpIcons = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator$c( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var xlinkHref, response, svgText, svgWrapper;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (fetch) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              _context.prev = 2;
              xlinkHref = 'https://cdn.antwerpen.be/core_branding_scss/5.0.0/assets/images/ai.svg';
              _context.next = 6;
              return fetch(xlinkHref);

            case 6:
              response = _context.sent;
              _context.next = 9;
              return response.text();

            case 9:
              svgText = _context.sent;
              svgWrapper = document.createElement('svg');
              svgWrapper.id = 'aiSvg';
              svgWrapper.innerHTML = svgText;

              if (!document.getElementById('aiSvg')) {
                document.body.appendChild(svgWrapper);
              }

              _context.next = 19;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](2);
              throw new Error(_context.t0);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 16]]);
    }));

    return function fetchAntwerpIcons() {
      return _ref2.apply(this, arguments);
    };
  }();

  if (typeof document !== 'undefined' && !document.getElementById('aiSvg')) {
    fetchAntwerpIcons();
  }

  var iconClass = classNames(className, name, 'ai');
  return /*#__PURE__*/React__default.createElement("span", {
    className: iconClass,
    style: style,
    "data-qa": qa,
    onClick: onClick
  }, name && /*#__PURE__*/React__default.createElement("svg", {
    "aria-hidden": "true"
  }, /*#__PURE__*/React__default.createElement("use", {
    href: "#".concat(name)
  })), src, ariaLabel && /*#__PURE__*/React__default.createElement("span", {
    className: "u-screen-reader-only"
  }, ariaLabel));
};

var sizeClasses$8 = {
  tiny: 'a-button--tiny',
  small: 'a-button--small',
  large: 'a-button--large'
};
var typeClasses$8 = {
  primary: '',
  secondary: 'a-button--secondary',
  success: 'a-button--success',
  warning: 'a-button--warning',
  danger: 'a-button--danger',
  transparent: 'a-button--transparent',
  default: 'a-button--default'
};

var Button$7 = /*#__PURE__*/function (_Component) {
  _inherits$g(Button, _Component);

  var _super = _createSuper$g(Button);

  function Button() {
    _classCallCheck$g(this, Button);

    return _super.apply(this, arguments);
  }

  _createClass$g(Button, [{
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props = this.props,
          id = _this$props.id,
          negative = _this$props.negative,
          outline = _this$props.outline,
          transparent = _this$props.transparent,
          className = _this$props.className,
          children = _this$props.children,
          icon = _this$props.icon,
          iconLeft = _this$props.iconLeft,
          iconRight = _this$props.iconRight,
          onClick = _this$props.onClick,
          _this$props$title = _this$props.title,
          title = _this$props$title === void 0 ? '' : _this$props$title,
          _this$props$ariaLabel = _this$props.ariaLabel,
          ariaLabel = _this$props$ariaLabel === void 0 ? '' : _this$props$ariaLabel,
          type = _this$props.type,
          size = _this$props.size,
          _this$props$block = _this$props.block,
          block = _this$props$block === void 0 ? false : _this$props$block,
          _this$props$style = _this$props.style,
          style = _this$props$style === void 0 ? {} : _this$props$style,
          _this$props$disabled = _this$props.disabled,
          disabled = _this$props$disabled === void 0 ? false : _this$props$disabled,
          htmlType = _this$props.htmlType,
          qa = _this$props.qa;
      var btnClass = classNames(className, (_classNames = {
        'a-button': !outline && !negative && !(type === 'default' && !!transparent)
      }, _defineProperty$k(_classNames, "".concat(typeClasses$8[type]), !!type), _defineProperty$k(_classNames, "".concat(sizeClasses$8[size]), !!size), _defineProperty$k(_classNames, 'has-icon', !!icon), _defineProperty$k(_classNames, 'has-icon-left', !!iconLeft), _defineProperty$k(_classNames, 'has-icon-right', !!iconRight), _defineProperty$k(_classNames, 'a-button-negative', !!negative), _defineProperty$k(_classNames, 'a-button-outline', !!outline), _defineProperty$k(_classNames, 'a-button-transparent', !!transparent), _defineProperty$k(_classNames, 'a-button--block', block), _classNames));
      return /*#__PURE__*/React__default.createElement("button", {
        id: id,
        className: btnClass,
        title: title || '',
        onClick: onClick,
        style: style,
        disabled: disabled,
        type: htmlType,
        "aria-label": ariaLabel,
        "data-qa": qa
      }, icon ? /*#__PURE__*/React__default.createElement(Icon$c, {
        name: icon
      }) : null, iconLeft ? /*#__PURE__*/React__default.createElement(Icon$c, {
        name: iconLeft
      }) : null, iconRight ? /*#__PURE__*/React__default.createElement(Icon$c, {
        name: iconRight
      }) : null, children);
    }
  }]);

  return Button;
}(Component);

var FlyoutContent$2 = function FlyoutContent(props) {
  var hasPadding = props.hasPadding,
      children = props.children,
      qa = props.qa;
  var classes = classNames('m-flyout__content', {
    'has-padding': !!hasPadding
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: classes,
    "data-qa": qa
  }, children);
};

var _excluded$8 = ["label", "flyoutHasPadding", "children", "qa"];
var flyoutSizes$2 = {
  small: 'sm',
  medium: 'md',
  large: 'lg',
  full: 'full'
};

var FlyoutButton$1 = /*#__PURE__*/function (_Component) {
  _inherits$g(FlyoutButton, _Component);

  var _super = _createSuper$g(FlyoutButton);

  function FlyoutButton() {
    var _this;

    _classCallCheck$g(this, FlyoutButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$k(_assertThisInitialized$g(_this), "state", {
      isOpen: false
    });

    _defineProperty$k(_assertThisInitialized$g(_this), "handleClick", function (event) {
      if (_this.containerRef && !_this.containerRef.contains(event.target)) {
        _this.close();
      }
    });

    _defineProperty$k(_assertThisInitialized$g(_this), "close", function () {
      return _this.setState({
        isOpen: false
      });
    });

    _defineProperty$k(_assertThisInitialized$g(_this), "toggleIsOpen", function () {
      return _this.setState({
        isOpen: !_this.state.isOpen
      });
    });

    _defineProperty$k(_assertThisInitialized$g(_this), "componentDidMount", function () {
      return document.addEventListener('mousedown', _this.handleClick);
    });

    _defineProperty$k(_assertThisInitialized$g(_this), "componentWillUnMount", function () {
      return document.removeEventListener('mousedown', _this.handleClick);
    });

    _defineProperty$k(_assertThisInitialized$g(_this), "getClassNames", function () {
      return classNames('m-flyout', "m-flyout--".concat(_this.props.flyoutDirection), _defineProperty$k({
        'is-open': _this.state.isOpen
      }, "m-flyout--".concat(flyoutSizes$2[_this.props.flyoutSize]), !!flyoutSizes$2[_this.props.flyoutSize]));
    });

    return _this;
  }

  _createClass$g(FlyoutButton, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          label = _this$props.label,
          flyoutHasPadding = _this$props.flyoutHasPadding;
      _this$props.children;

      var qa = _this$props.qa,
          buttonProps = _objectWithoutProperties$8(_this$props, _excluded$8);

      var isOpen = this.state.isOpen;
      var flyoutClass = this.getClassNames();
      return /*#__PURE__*/React__default.createElement("div", {
        className: flyoutClass,
        ref: function ref(_ref) {
          _this2.containerRef = _ref;
        },
        "aria-haspopup": "true",
        "aria-expanded": isOpen,
        "data-qa": qa
      }, /*#__PURE__*/React__default.createElement(Button$7, _extends$5({}, buttonProps, {
        onClick: this.toggleIsOpen
      }), label), /*#__PURE__*/React__default.createElement(FlyoutContent$2, {
        hasPadding: flyoutHasPadding
      }, this.props.children));
    }
  }]);

  return FlyoutButton;
}(Component);

_defineProperty$k(FlyoutButton$1, "defaultProps", {
  label: '',
  flyoutDirection: 'left',
  flyoutSize: 'medium',
  flyoutHasPadding: false,
  icon: false
});

function asyncGeneratorStep$b(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator$b(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep$b(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep$b(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var Icon$b = function Icon(_ref) {
  var name = _ref.name,
      style = _ref.style,
      className = _ref.className,
      ariaLabel = _ref.ariaLabel,
      onClick = _ref.onClick,
      src = _ref.src,
      qa = _ref.qa;
  /**
   * Inject SVG icons from core branding into page
   */

  var fetchAntwerpIcons = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator$b( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var xlinkHref, response, svgText, svgWrapper;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (fetch) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              _context.prev = 2;
              xlinkHref = 'https://cdn.antwerpen.be/core_branding_scss/5.0.0/assets/images/ai.svg';
              _context.next = 6;
              return fetch(xlinkHref);

            case 6:
              response = _context.sent;
              _context.next = 9;
              return response.text();

            case 9:
              svgText = _context.sent;
              svgWrapper = document.createElement('svg');
              svgWrapper.id = 'aiSvg';
              svgWrapper.innerHTML = svgText;

              if (!document.getElementById('aiSvg')) {
                document.body.appendChild(svgWrapper);
              }

              _context.next = 19;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](2);
              throw new Error(_context.t0);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 16]]);
    }));

    return function fetchAntwerpIcons() {
      return _ref2.apply(this, arguments);
    };
  }();

  if (typeof document !== 'undefined' && !document.getElementById('aiSvg')) {
    fetchAntwerpIcons();
  }

  var iconClass = classNames(className, name, 'ai');
  return /*#__PURE__*/React__default.createElement("span", {
    className: iconClass,
    style: style,
    "data-qa": qa,
    onClick: onClick
  }, name && /*#__PURE__*/React__default.createElement("svg", {
    "aria-hidden": "true"
  }, /*#__PURE__*/React__default.createElement("use", {
    href: "#".concat(name)
  })), src, ariaLabel && /*#__PURE__*/React__default.createElement("span", {
    className: "u-screen-reader-only"
  }, ariaLabel));
};

var Footer = function Footer(props) {
  var style = props.style,
      children = props.children,
      qa = props.qa,
      _props$ariaLabel = props.ariaLabel,
      ariaLabel = _props$ariaLabel === void 0 ? "Ga naar boven" : _props$ariaLabel;

  var scrollToTop = function scrollToTop() {
    window.scrollTo(0, 0);
  };

  return /*#__PURE__*/React__default.createElement("footer", {
    className: "o-footer",
    style: style,
    "data-qa": qa
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "o-footer__label"
  }, children || '© stad Antwerpen'), /*#__PURE__*/React__default.createElement("a", {
    onClick: function onClick() {
      return scrollToTop();
    },
    href: "#",
    className: "o-footer__button a-button a-button--secondary has-icon",
    "aria-label": ariaLabel
  }, /*#__PURE__*/React__default.createElement(Icon$b, {
    name: "ai-arrow-up-1"
  })));
};

function ___$insertStyle$4(css) {
  if (!css) {
    return;
  }

  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');
  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

var Form = function Form(props) {
  var children = props.children,
      style = props.style,
      onSubmit = props.onSubmit;
  return /*#__PURE__*/React__default.createElement("form", {
    className: "a-form",
    style: style,
    onSubmit: onSubmit
  }, children);
};

var Fieldset = function Fieldset(props) {
  var legend = props.legend,
      children = props.children,
      style = props.style,
      qa = props.qa;
  return /*#__PURE__*/React__default.createElement("fieldset", {
    style: style,
    "data-qa": qa
  }, /*#__PURE__*/React__default.createElement("legend", null, legend), children);
};

var InputLabel$3 = function InputLabel(props) {
  var style = props.style,
      htmlFor = props.htmlFor,
      children = props.children,
      inline = props.inline,
      id = props.id,
      qa = props.qa;
  var labelClass = classNames('a-input__label', {
    'a-input__label--inline': !!inline
  });
  return /*#__PURE__*/React__default.createElement("label", {
    className: labelClass,
    htmlFor: htmlFor,
    style: style,
    id: id,
    "data-qa": qa
  }, children);
};

function ownKeys$3(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2$3(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$3(Object(source), true).forEach(function (key) {
        _defineProperty$1$2(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$3(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof$2(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$2 = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$2 = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof$2(obj);
}

function asyncGeneratorStep$1$2(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator$1$2(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep$1$2(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep$1$2(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck$1$2(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$1$2(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$1$2(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$1$2(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$1$2(Constructor, staticProps);
  return Constructor;
}

function _defineProperty$1$2(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends$4() {
  _extends$4 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$4.apply(this, arguments);
}

function _inherits$1$2(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$1$2(subClass, superClass);
}

function _getPrototypeOf$1$2(o) {
  _getPrototypeOf$1$2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$1$2(o);
}

function _setPrototypeOf$1$2(o, p) {
  _setPrototypeOf$1$2 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$1$2(o, p);
}

function _isNativeReflectConstruct$1$2() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _objectWithoutPropertiesLoose$7(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties$7(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$7(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized$1$2(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn$1$2(self, call) {
  if (call && (_typeof$4(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized$1$2(self);
}

function _createSuper$1$2(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$1$2();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf$1$2(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$1$2(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn$1$2(this, result);
  };
}

function _slicedToArray$2(arr, i) {
  return _arrayWithHoles$2(arr) || _iterableToArrayLimit$2(arr, i) || _unsupportedIterableToArray$2(arr, i) || _nonIterableRest$2();
}

function _arrayWithHoles$2(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit$2(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray$2(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$2(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen);
}

function _arrayLikeToArray$2(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _nonIterableRest$2() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var Icon$1$2 = function Icon(_ref) {
  var name = _ref.name,
      style = _ref.style,
      className = _ref.className,
      ariaLabel = _ref.ariaLabel,
      onClick = _ref.onClick,
      src = _ref.src,
      qa = _ref.qa;
  /**
   * Inject SVG icons from core branding into page
   */

  var fetchAntwerpIcons = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator$1$2( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var xlinkHref, response, svgText, svgWrapper;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (fetch) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              _context.prev = 2;
              xlinkHref = 'https://cdn.antwerpen.be/core_branding_scss/5.0.0/assets/images/ai.svg';
              _context.next = 6;
              return fetch(xlinkHref);

            case 6:
              response = _context.sent;
              _context.next = 9;
              return response.text();

            case 9:
              svgText = _context.sent;
              svgWrapper = document.createElement('svg');
              svgWrapper.id = 'aiSvg';
              svgWrapper.innerHTML = svgText;

              if (!document.getElementById('aiSvg')) {
                document.body.appendChild(svgWrapper);
              }

              _context.next = 19;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](2);
              throw new Error(_context.t0);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 16]]);
    }));

    return function fetchAntwerpIcons() {
      return _ref2.apply(this, arguments);
    };
  }();

  if (typeof document !== 'undefined' && !document.getElementById('aiSvg')) {
    fetchAntwerpIcons();
  }

  var iconClass = classNames(className, name, 'ai');
  return /*#__PURE__*/React__default.createElement("span", {
    className: iconClass,
    style: style,
    "data-qa": qa,
    onClick: onClick
  }, name && /*#__PURE__*/React__default.createElement("svg", {
    "aria-hidden": "true"
  }, /*#__PURE__*/React__default.createElement("use", {
    href: "#".concat(name)
  })), src, ariaLabel && /*#__PURE__*/React__default.createElement("span", {
    className: "u-screen-reader-only"
  }, ariaLabel));
};

var _excluded$1$2 = ["id", "label", "description", "required", "mask", "state", "autoComplete", "disabled", "iconright", "iconleft", "loading", "qa", "type", "size", "errorDescription", "className", "addonleft", "addonright"];
var stateClasses$4$1 = {
  success: 'has-success',
  warning: 'has-warning',
  error: 'has-error'
};

var TextField$1 = /*#__PURE__*/function (_Component) {
  _inherits$1$2(TextField, _Component);

  var _super = _createSuper$1$2(TextField);

  function TextField() {
    _classCallCheck$1$2(this, TextField);

    return _super.apply(this, arguments);
  }

  _createClass$1$2(TextField, [{
    key: "render",
    value: function render() {
      var _classNames,
          _this = this;

      var _this$props = this.props,
          id = _this$props.id,
          label = _this$props.label,
          description = _this$props.description,
          required = _this$props.required,
          mask = _this$props.mask,
          state = _this$props.state,
          autoComplete = _this$props.autoComplete,
          disabled = _this$props.disabled,
          iconright = _this$props.iconright,
          iconleft = _this$props.iconleft,
          loading = _this$props.loading,
          qa = _this$props.qa,
          _this$props$type = _this$props.type,
          type = _this$props$type === void 0 ? 'text' : _this$props$type,
          size = _this$props.size,
          errorDescription = _this$props.errorDescription,
          className = _this$props.className,
          addonleft = _this$props.addonleft,
          addonright = _this$props.addonright,
          extraProps = _objectWithoutProperties$7(_this$props, _excluded$1$2);

      var inputClass = classNames('a-input', (_classNames = {
        'has-icon-right': iconright || loading,
        'has-icon-left': iconleft,
        'has-addon': !!addonleft || !!addonright,
        'is-required': !!required
      }, _defineProperty$1$2(_classNames, "".concat(stateClasses$4$1[state]), !!state), _defineProperty$1$2(_classNames, "a-input--".concat(size), !!size), _classNames), className);
      return /*#__PURE__*/React__default.createElement("div", {
        className: inputClass,
        "data-qa": qa
      }, label && /*#__PURE__*/React__default.createElement(InputLabel$3, {
        htmlFor: id
      }, label), /*#__PURE__*/React__default.createElement("div", {
        className: "a-input__wrapper"
      }, addonleft ? /*#__PURE__*/React__default.createElement("div", {
        className: "a-input__addon"
      }, addonleft) : null, iconleft ? /*#__PURE__*/React__default.createElement(Icon$1$2, {
        name: iconleft
      }) : null, mask ? /*#__PURE__*/React__default.createElement(InputMask, this.props) : /*#__PURE__*/React__default.createElement("input", _extends$4({
        id: id,
        type: type,
        autoComplete: autoComplete,
        disabled: disabled,
        ref: function (_ref) {
          function ref(_x) {
            return _ref.apply(this, arguments);
          }

          ref.toString = function () {
            return _ref.toString();
          };

          return ref;
        }(function (ref) {
          return _this.props.inputRef && _this.props.inputRef(ref);
        })
      }, extraProps)), iconright ? /*#__PURE__*/React__default.createElement(Icon$1$2, {
        name: iconright
      }) : null, loading ? /*#__PURE__*/React__default.createElement(Icon$1$2, {
        name: "spinner",
        className: "a-spinner a-spinner--sm"
      }) : null, addonright ? /*#__PURE__*/React__default.createElement("div", {
        className: "a-input__addon"
      }, addonright) : null), description ? /*#__PURE__*/React__default.createElement("small", null, description) : null, errorDescription && /*#__PURE__*/React__default.createElement("small", {
        className: "u-text-danger"
      }, errorDescription));
    }
  }]);

  return TextField;
}(Component);

var Checkbox$1 = /*#__PURE__*/function (_Component) {
  _inherits$1$2(Checkbox, _Component);

  var _super = _createSuper$1$2(Checkbox);

  function Checkbox() {
    var _this;

    _classCallCheck$1$2(this, Checkbox);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$1$2(_assertThisInitialized$1$2(_this), "handleChange", function (e) {
      if (_this.props.onChange) {
        _this.props.onChange(e);
      }
    });

    _defineProperty$1$2(_assertThisInitialized$1$2(_this), "defaultId", 'aui-cb-' + Math.random().toString(36));

    return _this;
  }

  _createClass$1$2(Checkbox, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          id = _this$props.id,
          label = _this$props.label,
          name = _this$props.name,
          required = _this$props.required,
          _this$props$disabled = _this$props.disabled,
          disabled = _this$props$disabled === void 0 ? false : _this$props$disabled,
          qa = _this$props.qa;
      var inputClass = classNames('a-input');
      var requiredLabel = !!required ? /*#__PURE__*/React__default.createElement("span", {
        className: "u-text-danger"
      }, " *") : null;
      return /*#__PURE__*/React__default.createElement("div", {
        className: inputClass,
        "data-qa": qa
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "a-input__checkbox"
      }, /*#__PURE__*/React__default.createElement("input", _extends$4({
        type: "checkbox",
        id: id || this.defaultId,
        name: name,
        onChange: this.handleChange,
        "aria-checked": this.props.checked,
        checked: this.props.checked,
        disabled: disabled
      }, this.props.handler)), /*#__PURE__*/React__default.createElement(InputLabel$3, {
        htmlFor: id || this.defaultId
      }, label, requiredLabel)));
    }
  }]);

  return Checkbox;
}(Component);

var Option$1 = function Option(props) {
  var value = props.value,
      disabled = props.disabled,
      children = props.children;
  return /*#__PURE__*/React__default.createElement("option", {
    value: value,
    disabled: disabled
  }, children);
};

var spinnerSizes$3 = {
  small: 'sm',
  large: 'lg'
};

var Spinner$3 = function Spinner(props) {
  var size = props.size,
      style = props.style,
      className = props.className,
      _props$ariaLabel = props.ariaLabel,
      ariaLabel = _props$ariaLabel === void 0 ? "Wordt geladen" : _props$ariaLabel,
      qa = props.qa;
  var spinnerClass = classNames('a-spinner', className, _defineProperty$1$2({}, "a-spinner--".concat(spinnerSizes$3[size]), !!size));
  return /*#__PURE__*/React__default.createElement("div", {
    className: spinnerClass,
    style: style,
    role: "status",
    "aria-label": ariaLabel,
    "data-qa": qa
  });
};

var stateClasses$3$1 = {
  success: 'has-success',
  warning: 'has-warning',
  error: 'has-error'
};

var Select$1 = /*#__PURE__*/function (_Component) {
  _inherits$1$2(Select, _Component);

  var _super = _createSuper$1$2(Select);

  function Select() {
    _classCallCheck$1$2(this, Select);

    return _super.apply(this, arguments);
  }

  _createClass$1$2(Select, [{
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props = this.props,
          id = _this$props.id,
          label = _this$props.label,
          name = _this$props.name,
          description = _this$props.description,
          errorDescription = _this$props.errorDescription,
          inline = _this$props.inline,
          className = _this$props.className,
          state = _this$props.state;
      _this$props.style;
      var required = _this$props.required,
          disabled = _this$props.disabled,
          placeholder = _this$props.placeholder,
          options = _this$props.options,
          onChange = _this$props.onChange,
          value = _this$props.value,
          loading = _this$props.loading,
          size = _this$props.size,
          ariaLabelledby = _this$props.ariaLabelledby,
          qa = _this$props.qa;
      var selectClass = classNames('a-input', 'has-icon-right', (_classNames = {
        'a-input--inline': !!inline
      }, _defineProperty$1$2(_classNames, "".concat(stateClasses$3$1[state]), !!state), _defineProperty$1$2(_classNames, 'is-required', !!required), _defineProperty$1$2(_classNames, "a-input--".concat(size), !!size), _classNames), className);
      var wrapperClass = classNames('a-input__wrapper', {
        'a-input__wrapper--inline': !!inline
      });
      return /*#__PURE__*/React__default.createElement("div", {
        className: selectClass,
        name: name,
        "data-qa": qa
      }, label && /*#__PURE__*/React__default.createElement(InputLabel$3, {
        inline: inline,
        htmlFor: id
      }, label), /*#__PURE__*/React__default.createElement("div", {
        className: wrapperClass
      }, /*#__PURE__*/React__default.createElement("select", {
        id: id,
        name: name,
        onChange: onChange,
        value: value,
        disabled: disabled,
        "aria-labelledby": ariaLabelledby
      }, placeholder && /*#__PURE__*/React__default.createElement("option", {
        value: "",
        disabled: true
      }, placeholder), options.map(function (option) {
        return /*#__PURE__*/React__default.createElement(Option$1, {
          value: option.value,
          key: option.value,
          id: option.value,
          name: name,
          disabled: option.disabled
        }, option.label);
      })), description ? /*#__PURE__*/React__default.createElement("small", null, description) : null, errorDescription && /*#__PURE__*/React__default.createElement("small", {
        className: "u-text-danger"
      }, errorDescription), loading ? /*#__PURE__*/React__default.createElement(Spinner$3, {
        size: "small",
        className: "ai"
      }) : /*#__PURE__*/React__default.createElement(Icon$1$2, {
        name: "ai-arrow-down-1"
      })));
    }
  }]);

  return Select;
}(Component);

_defineProperty$1$2(Select$1, "defaultProps", {
  value: ''
});

var stateClasses$2 = {
  success: 'has-success',
  warning: 'has-warning',
  error: 'has-error'
};

var Textarea = function Textarea(props) {
  var _classNames;

  var id = props.id,
      label = props.label,
      value = props.value,
      name = props.name,
      disabled = props.disabled,
      placeholder = props.placeholder,
      className = props.className,
      style = props.style,
      required = props.required,
      onChange = props.onChange,
      onBlur = props.onBlur,
      state = props.state,
      qa = props.qa,
      size = props.size,
      onInvalidCapture = props.onInvalidCapture;
  var textareaClass = classNames('a-input', (_classNames = {
    'is-required': !!required
  }, _defineProperty$1$2(_classNames, "".concat(stateClasses$2[state]), !!state), _defineProperty$1$2(_classNames, "a-input--".concat(size), !!size), _classNames), className);
  return /*#__PURE__*/React__default.createElement("div", {
    className: textareaClass,
    style: style,
    "data-qa": qa
  }, label && /*#__PURE__*/React__default.createElement(InputLabel$3, {
    htmlFor: id
  }, label), /*#__PURE__*/React__default.createElement("textarea", {
    id: id,
    placeholder: placeholder,
    name: name,
    value: value,
    onChange: onChange,
    onBlur: onBlur,
    disabled: disabled,
    required: required,
    onInvalidCapture: onInvalidCapture
  }));
};

var Radio = function Radio(props) {
  var id = props.id,
      name = props.name,
      value = props.value,
      checked = props.checked,
      children = props.children,
      disabled = props.disabled,
      required = props.required,
      qa = props.qa;
  var radioClass = classNames('a-input__radio');
  return /*#__PURE__*/React__default.createElement("div", {
    className: radioClass,
    "data-qa": qa
  }, /*#__PURE__*/React__default.createElement("input", {
    type: "radio",
    value: value,
    id: id,
    name: name,
    defaultChecked: checked,
    disabled: disabled,
    required: required
  }), /*#__PURE__*/React__default.createElement("label", {
    htmlFor: id
  }, children));
};

var RadioGroup = function RadioGroup(props) {
  props.id;
  var name = props.name,
      label = props.label,
      value = props.value,
      className = props.className,
      description = props.description,
      style = props.style,
      required = props.required,
      onChange = props.onChange,
      inline = props.inline,
      options = props.options,
      qa = props.qa;
  var radioGroupClass = classNames('a-input', className, {
    'is-required': !!required
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: radioGroupClass,
    style: style,
    onChange: onChange,
    "data-qa": qa
  }, label && /*#__PURE__*/React__default.createElement(InputLabel$3, {
    inline: inline
  }, label), /*#__PURE__*/React__default.createElement("div", {
    className: "a-input__wrapper"
  }, options.map(function (option) {
    return /*#__PURE__*/React__default.createElement(Radio, {
      value: option.value,
      key: option.key || "".concat(name, "_").concat(option.value),
      id: option.key || "".concat(name, "_").concat(option.value),
      name: name,
      disabled: option.disabled,
      checked: value === option.value,
      required: required
    }, option.label);
  })), description ? /*#__PURE__*/React__default.createElement("small", null, description) : null);
};

function asyncGeneratorStep$a(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator$a(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep$a(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep$a(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck$f(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$f(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$f(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$f(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$f(Constructor, staticProps);
  return Constructor;
}

function _defineProperty$j(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits$f(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$f(subClass, superClass);
}

function _getPrototypeOf$f(o) {
  _getPrototypeOf$f = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$f(o);
}

function _setPrototypeOf$f(o, p) {
  _setPrototypeOf$f = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$f(o, p);
}

function _isNativeReflectConstruct$f() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized$f(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn$f(self, call) {
  if (call && (_typeof$2(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized$f(self);
}

function _createSuper$f(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$f();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf$f(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$f(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn$f(this, result);
  };
}

var viewTypeMap$1 = {
  days: 'dagen',
  months: 'maanden',
  years: 'jaren'
};

var mapViewType$1 = function mapViewType(viewType) {
  return viewTypeMap$1[viewType];
};

var mapNav$1 = function mapNav(direction, viewType, value) {
  var multi = '';
  var viewTypeDisplay = '';
  var valueDisplay = '';
  var directionDisplay = direction > 0 ? 'volgend' : 'vorig';

  switch (viewType) {
    case 'months':
      viewTypeDisplay = 'jaar';
      valueDisplay = value.clone().add(direction, 'years').format('YYYY');
      break;

    case 'years':
      multi = 'e';
      viewTypeDisplay = 'periode van 12 jaar';
      var years = yearsOfMonth$1(value.clone().add(12 * direction, 'years'));
      valueDisplay = years[0] + '-' + years.slice(-1);
      break;

    default:
      multi = 'e';
      viewTypeDisplay = 'maand';
      valueDisplay = value.clone().add(direction, 'months').format('MMMM YYYY');
  }

  return "Ga naar ".concat(directionDisplay).concat(multi, " ").concat(viewTypeDisplay, ", ").concat(valueDisplay);
};

var aria$1 = {
  mapViewType: mapViewType$1,
  mapNav: mapNav$1
};

function rotateArrayByPosition$1(data, d) {
  var temp = data.splice(0);

  for (var i = 0; i < d - 1; i++) {
    var first = temp.shift();
    temp.push(first);
  }

  return temp;
}

function daysOfMonth$1(displayedMonth) {
  var _i, d;

  var results = [];
  var startOfMonth = displayedMonth.startOf('months');
  var startDayOfWeek = startOfMonth.clone().startOf('isoWeek');
  var startAt = -startOfMonth.diff(startDayOfWeek, 'days');
  var endAt = Math.ceil((displayedMonth.daysInMonth() - startAt) / 7) * 7 + startAt - 1;

  for (d = _i = startAt; startAt <= endAt ? _i <= endAt : _i >= endAt; d = startAt <= endAt ? ++_i : --_i) {
    results.push(displayedMonth.clone().add(d, 'days'));
  }

  return results;
}

function weekEnum$1(daysOfMonth) {
  var results = [];

  for (var _i = 0, _ref = daysOfMonth.length / 7; 0 <= _ref ? _i < _ref : _i > _ref; 0 <= _ref ? _i++ : _i--) {
    results.push(_i);
  }

  return results;
}

function isDateFromNextMonth$1(date, displayedMonth) {
  return date.year() > displayedMonth.year() || date.year() === displayedMonth.year() && date.month() > displayedMonth.month();
}

function isDateFromPrevMonth$1(date, displayedMonth) {
  return date.year() < displayedMonth.year() || date.year() === displayedMonth.year() && date.month() < displayedMonth.month();
}

function yearsOfMonth$1(displayedMonth) {
  var amountOfYearsBack = -11;
  var results = [];

  for (var year = amountOfYearsBack; year < 0; year++) {
    results.push(displayedMonth.clone().add(year, 'years').format('YYYY'));
  }

  results.push(displayedMonth.clone().format('YYYY'));
  return results;
}

function nextItemInArray$1(element, array) {
  var i = array.findIndex(function (k) {
    return k == element;
  });
  i = i + 1;
  i = i % array.length;
  return array[i];
}

var Icon$a = function Icon(_ref) {
  var name = _ref.name,
      style = _ref.style,
      className = _ref.className,
      ariaLabel = _ref.ariaLabel,
      onClick = _ref.onClick,
      src = _ref.src,
      qa = _ref.qa;
  /**
   * Inject SVG icons from core branding into page
   */

  var fetchAntwerpIcons = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator$a( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var xlinkHref, response, svgText, svgWrapper;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (fetch) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              _context.prev = 2;
              xlinkHref = 'https://cdn.antwerpen.be/core_branding_scss/5.0.0/assets/images/ai.svg';
              _context.next = 6;
              return fetch(xlinkHref);

            case 6:
              response = _context.sent;
              _context.next = 9;
              return response.text();

            case 9:
              svgText = _context.sent;
              svgWrapper = document.createElement('svg');
              svgWrapper.id = 'aiSvg';
              svgWrapper.innerHTML = svgText;

              if (!document.getElementById('aiSvg')) {
                document.body.appendChild(svgWrapper);
              }

              _context.next = 19;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](2);
              throw new Error(_context.t0);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 16]]);
    }));

    return function fetchAntwerpIcons() {
      return _ref2.apply(this, arguments);
    };
  }();

  if (typeof document !== 'undefined' && !document.getElementById('aiSvg')) {
    fetchAntwerpIcons();
  }

  var iconClass = classNames(className, name, 'ai');
  return /*#__PURE__*/React__default.createElement("span", {
    className: iconClass,
    style: style,
    "data-qa": qa,
    onClick: onClick
  }, name && /*#__PURE__*/React__default.createElement("svg", {
    "aria-hidden": "true"
  }, /*#__PURE__*/React__default.createElement("use", {
    href: "#".concat(name)
  })), src, ariaLabel && /*#__PURE__*/React__default.createElement("span", {
    className: "u-screen-reader-only"
  }, ariaLabel));
};

var sizeClasses$7 = {
  tiny: 'a-button--tiny',
  small: 'a-button--small',
  large: 'a-button--large'
};
var typeClasses$7 = {
  primary: '',
  secondary: 'a-button--secondary',
  success: 'a-button--success',
  warning: 'a-button--warning',
  danger: 'a-button--danger',
  transparent: 'a-button--transparent',
  default: 'a-button--default'
};

var Button$6 = /*#__PURE__*/function (_Component) {
  _inherits$f(Button, _Component);

  var _super = _createSuper$f(Button);

  function Button() {
    _classCallCheck$f(this, Button);

    return _super.apply(this, arguments);
  }

  _createClass$f(Button, [{
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props = this.props,
          id = _this$props.id,
          negative = _this$props.negative,
          outline = _this$props.outline,
          transparent = _this$props.transparent,
          className = _this$props.className,
          children = _this$props.children,
          icon = _this$props.icon,
          iconLeft = _this$props.iconLeft,
          iconRight = _this$props.iconRight,
          onClick = _this$props.onClick,
          _this$props$title = _this$props.title,
          title = _this$props$title === void 0 ? '' : _this$props$title,
          _this$props$ariaLabel = _this$props.ariaLabel,
          ariaLabel = _this$props$ariaLabel === void 0 ? '' : _this$props$ariaLabel,
          type = _this$props.type,
          size = _this$props.size,
          _this$props$block = _this$props.block,
          block = _this$props$block === void 0 ? false : _this$props$block,
          _this$props$style = _this$props.style,
          style = _this$props$style === void 0 ? {} : _this$props$style,
          _this$props$disabled = _this$props.disabled,
          disabled = _this$props$disabled === void 0 ? false : _this$props$disabled,
          htmlType = _this$props.htmlType,
          qa = _this$props.qa;
      var btnClass = classNames(className, (_classNames = {
        'a-button': !outline && !negative && !(type === 'default' && !!transparent)
      }, _defineProperty$j(_classNames, "".concat(typeClasses$7[type]), !!type), _defineProperty$j(_classNames, "".concat(sizeClasses$7[size]), !!size), _defineProperty$j(_classNames, 'has-icon', !!icon), _defineProperty$j(_classNames, 'has-icon-left', !!iconLeft), _defineProperty$j(_classNames, 'has-icon-right', !!iconRight), _defineProperty$j(_classNames, 'a-button-negative', !!negative), _defineProperty$j(_classNames, 'a-button-outline', !!outline), _defineProperty$j(_classNames, 'a-button-transparent', !!transparent), _defineProperty$j(_classNames, 'a-button--block', block), _classNames));
      return /*#__PURE__*/React__default.createElement("button", {
        id: id,
        className: btnClass,
        title: title || '',
        onClick: onClick,
        style: style,
        disabled: disabled,
        type: htmlType,
        "aria-label": ariaLabel,
        "data-qa": qa
      }, icon ? /*#__PURE__*/React__default.createElement(Icon$a, {
        name: icon
      }) : null, iconLeft ? /*#__PURE__*/React__default.createElement(Icon$a, {
        name: iconLeft
      }) : null, iconRight ? /*#__PURE__*/React__default.createElement(Icon$a, {
        name: iconRight
      }) : null, children);
    }
  }]);

  return Button;
}(Component);

var Nav$1 = /*#__PURE__*/function (_Component) {
  _inherits$f(Nav, _Component);

  var _super = _createSuper$f(Nav);

  function Nav() {
    _classCallCheck$f(this, Nav);

    return _super.apply(this, arguments);
  }

  _createClass$f(Nav, [{
    key: "renderNav",
    value: function renderNav() {
      var _this$props = this.props,
          viewType = _this$props.viewType,
          displayedPeriod = _this$props.displayedPeriod;

      switch (viewType) {
        case 'months':
          return displayedPeriod.format('YYYY');

        case 'years':
          return this.renderYearsNav(displayedPeriod);

        default:
          return displayedPeriod.format('MMMM YYYY');
      }
    }
  }, {
    key: "renderYearsNav",
    value: function renderYearsNav(displayedMonth) {
      var years = yearsOfMonth$1(displayedMonth);
      return years[0] + '-' + years.slice(-1);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          onClickPrevious = _this$props2.onClickPrevious,
          onClickViewType = _this$props2.onClickViewType,
          onClickNext = _this$props2.onClickNext,
          viewType = _this$props2.viewType,
          displayedPeriod = _this$props2.displayedPeriod,
          _this$props2$ariaLabe = _this$props2.ariaLabelPrevious,
          ariaLabelPrevious = _this$props2$ariaLabe === void 0 ? function (viewType, value) {
        return aria$1.mapNav(-1, viewType, value);
      } : _this$props2$ariaLabe,
          _this$props2$ariaLabe2 = _this$props2.ariaLabelNext,
          ariaLabelNext = _this$props2$ariaLabe2 === void 0 ? function (viewType, value) {
        return aria$1.mapNav(1, viewType, value);
      } : _this$props2$ariaLabe2;
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Button$6, {
        htmlType: "button",
        onClick: onClickPrevious,
        className: 'a-button has-icon',
        icon: 'ai-arrow-left-1',
        ariaLabel: ariaLabelPrevious(viewType, displayedPeriod)
      }), /*#__PURE__*/React__default.createElement(Button$6, {
        htmlType: "button",
        onClick: onClickViewType,
        className: 'm-datepicker__title a-button u-text-capitalize'
      }, this.renderNav()), /*#__PURE__*/React__default.createElement(Button$6, {
        htmlType: "button",
        onClick: onClickNext,
        className: 'a-button has-icon',
        icon: 'ai-arrow-right-1',
        ariaLabel: ariaLabelNext(viewType, displayedPeriod)
      }));
    }
  }]);

  return Nav;
}(Component);

var Rows$1 = /*#__PURE__*/function (_Component) {
  _inherits$f(Rows, _Component);

  var _super = _createSuper$f(Rows);

  function Rows() {
    _classCallCheck$f(this, Rows);

    return _super.apply(this, arguments);
  }

  _createClass$f(Rows, [{
    key: "generateRows",
    value: function generateRows() {
      var _this$props = this.props,
          list = _this$props.list,
          rowLength = _this$props.rowLength,
          onClick = _this$props.onClick;
      return list.map(function (content, index) {
        return /*#__PURE__*/React__default.createElement("td", {
          key: index
        }, /*#__PURE__*/React__default.createElement("button", {
          className: "u-text-capitalize",
          tabIndex: index,
          value: content,
          onClick: onClick,
          type: "button"
        }, content.replace(/\./g, ' ')));
      }).reduce(function (r, element, index) {
        // create element groups with size 4, result looks like:
        // [[elem1, elem2, elem3], [elem4, elem5, elem6],x ...]
        index % rowLength === 0 && r.push([]);
        r[r.length - 1].push(element);
        return r;
      }, []).map(function (rowContent, index) {
        // surround every group with a tr
        return /*#__PURE__*/React__default.createElement("tr", {
          key: index
        }, rowContent);
      });
    }
  }, {
    key: "render",
    value: function render() {
      return this.generateRows();
    }
  }]);

  return Rows;
}(Component);

var Day$1 = /*#__PURE__*/function (_Component) {
  _inherits$f(Day, _Component);

  var _super = _createSuper$f(Day);

  function Day() {
    var _this;

    _classCallCheck$f(this, Day);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$j(_assertThisInitialized$f(_this), "handleOnClick", function (day) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          selectDay = _this$props.selectDay;
      if (disabled) return;
      selectDay(day);
    });

    return _this;
  }

  _createClass$f(Day, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          activeDate = _this$props2.activeDate,
          day = _this$props2.day,
          selected = _this$props2.selected,
          disabled = _this$props2.disabled,
          dayNextMonth = _this$props2.dayNextMonth,
          dayPrevMonth = _this$props2.dayPrevMonth,
          dayActiveClassName = _this$props2.dayActiveClassName,
          selectedClassName = _this$props2.selectedClassName,
          dayDisabledClassName = _this$props2.dayDisabledClassName,
          dayFromOtherMonthClassName = _this$props2.dayFromOtherMonthClassName,
          ariaLabelButtonDateFormat = _this$props2.ariaLabelButtonDateFormat;
      var buttonClasses = [];

      if (day.isSame(Moment(), 'day')) {
        buttonClasses.push(selectedClassName);
      }

      if (day.isSame(activeDate, 'day')) {
        buttonClasses.push(dayActiveClassName);
      }

      if (disabled) {
        buttonClasses.push(dayDisabledClassName);
      }

      if (selected) {
        buttonClasses.push(dayActiveClassName);
      }

      if (dayPrevMonth || dayNextMonth) {
        buttonClasses.push(dayFromOtherMonthClassName);
      }

      return /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("button", {
        tabIndex: disabled ? '-1' : '0',
        type: "button",
        onClick: this.handleOnClick.bind(this, day),
        className: buttonClasses.join(' '),
        "aria-label": day.format(ariaLabelButtonDateFormat)
      }, day.date()));
    }
  }]);

  return Day;
}(Component);

_defineProperty$j(Day$1, "defaultProps", {
  dayClassName: '',
  dayActiveClassName: 'is-selected',
  selectedClassName: 'is-current',
  dayDisabledClassName: 'is-unavailable',
  dayFromOtherMonthClassName: 'is-faded',
  ariaLabelButtonDateFormat: 'dddd D MMMM YYYY'
});

var Body$1 = /*#__PURE__*/function (_Component) {
  _inherits$f(Body, _Component);

  var _super = _createSuper$f(Body);

  function Body() {
    var _this;

    _classCallCheck$f(this, Body);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$j(_assertThisInitialized$f(_this), "handleOnClick", function (type, event) {
      var value = event.target.value;
      var newDisplayedPeriod = null;
      var displayedPeriod = _this.props.displayedPeriod;

      if (type === 'days') {
        newDisplayedPeriod = Moment(displayedPeriod.format('YYYY') + value, "YYYY MMM");
      } else if (type === 'months') {
        newDisplayedPeriod = Moment(displayedPeriod.format('MM') + value, "MM YYYY");
      }

      var goToViewType = _this.props.goToViewType;
      goToViewType(type, newDisplayedPeriod);
    });

    return _this;
  }

  _createClass$f(Body, [{
    key: "renderBody",
    value: function renderBody(displayedPeriod) {
      var viewType = this.props.viewType;

      switch (viewType) {
        case 'months':
          return this.renderListMonths();

        case "years":
          return this.renderListYears(displayedPeriod);

        default:
          return this.renderWeeks(displayedPeriod);
      }
    }
  }, {
    key: "renderWeeks",
    value: function renderWeeks(displayMonth) {
      var _this2 = this;

      var _daysOfMonth = daysOfMonth$1(displayMonth);

      var _weekEnum = weekEnum$1(_daysOfMonth);

      return _weekEnum.map(function (week, key) {
        return /*#__PURE__*/React__default.createElement("tr", {
          key: key
        }, _this2.renderDay(_daysOfMonth, week));
      });
    }
  }, {
    key: "renderListMonths",
    value: function renderListMonths() {
      var months = Moment.monthsShort();
      return /*#__PURE__*/React__default.createElement(Rows$1, {
        list: months,
        rowLength: 4,
        onClick: this.handleOnClick.bind(this, 'days')
      });
    }
  }, {
    key: "renderListYears",
    value: function renderListYears(displayMonth) {
      var years = yearsOfMonth$1(displayMonth);
      return /*#__PURE__*/React__default.createElement(Rows$1, {
        list: years,
        rowLength: 4,
        onClick: this.handleOnClick.bind(this, 'months')
      });
    }
  }, {
    key: "renderDay",
    value: function renderDay(_daysOfMonth, week) {
      var _this3 = this;

      var days = [0, 1, 2, 3, 4, 5, 6];
      var _this$props = this.props,
          activeDate = _this$props.activeDate,
          displayedPeriod = _this$props.displayedPeriod,
          selectedDates = _this$props.selectedDates,
          minDate = _this$props.minDate,
          maxDate = _this$props.maxDate,
          format = _this$props.format,
          noWeekends = _this$props.noWeekends,
          selectDay = _this$props.selectDay,
          ariaLabelButtonDateFormat = _this$props.ariaLabelButtonDateFormat;
      return days.map(function (day, key) {
        var date = _daysOfMonth[week * 7 + day];
        var disabled;
        var selected = false;

        if (minDate && maxDate) {
          disabled = date.isBefore(minDate, 'day') || date.isAfter(maxDate, 'day');
        } else if (minDate) {
          disabled = date.isBefore(minDate, 'day');
        } else if (maxDate) {
          disabled = date.isAfter(maxDate, 'day');
        }

        if (noWeekends) {
          disabled = date.day() === 6 || date.day() === 0;
        }

        var dayNextMonth = isDateFromNextMonth$1(date, displayedPeriod);
        var dayPrevMonth = isDateFromPrevMonth$1(date, displayedPeriod);
        selectedDates.forEach(function (selectedDate) {
          if (date.isSame(Moment(selectedDate, format), 'day')) {
            selected = true;
            dayPrevMonth = false;
            dayNextMonth = false;
          }
        });
        return /*#__PURE__*/React__default.createElement(Day$1, {
          key: key,
          day: date,
          selectDay: selectDay.bind(_this3, date),
          disabled: disabled,
          selected: selected,
          dayPrevMonth: dayPrevMonth,
          dayNextMonth: dayNextMonth,
          activeDate: activeDate,
          ariaLabelButtonDateFormat: ariaLabelButtonDateFormat
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var displayedPeriod = this.props.displayedPeriod;
      return this.renderBody(displayedPeriod);
    }
  }]);

  return Body;
}(Component);

_defineProperty$j(Body$1, "defaultProps", {
  selectedDates: []
});

var Head$1 = /*#__PURE__*/function (_Component) {
  _inherits$f(Head, _Component);

  var _super = _createSuper$f(Head);

  function Head() {
    _classCallCheck$f(this, Head);

    return _super.apply(this, arguments);
  }

  _createClass$f(Head, [{
    key: "renderHeader",
    value: function renderHeader() {
      var viewType = this.props.viewType;

      switch (viewType) {
        case 'months':
          return null;

        case 'years':
          return null;

        default:
          return this.renderNameOfDays();
      }
    }
  }, {
    key: "renderNameOfDays",
    value: function renderNameOfDays() {
      // rotate arrays to put monday first, to match <Body>
      var nameOfDays = rotateArrayByPosition$1(Moment.weekdaysMin(), 2);
      var longNameDays = rotateArrayByPosition$1(Moment.weekdays(), 2);
      return /*#__PURE__*/React__default.createElement("tr", {
        className: "m-datepicker__days"
      }, nameOfDays.map(function (day, i) {
        return /*#__PURE__*/React__default.createElement("th", {
          key: i,
          className: "u-text-capitalize",
          "aria-label": longNameDays[i]
        }, day);
      }));
    }
  }, {
    key: "render",
    value: function render() {
      return this.renderHeader();
    }
  }]);

  return Head;
}(Component);

var Calendar$1$1 = /*#__PURE__*/function (_Component) {
  _inherits$f(Calendar, _Component);

  var _super = _createSuper$f(Calendar);

  function Calendar() {
    var _this;

    _classCallCheck$f(this, Calendar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$j(_assertThisInitialized$f(_this), "state", {
      displayedPeriod: _this.props.activeDate ? Moment(_this.props.activeDate, _this.props.format) : Moment(),
      viewType: 'days',
      views: ['days', 'months', 'years']
    });

    return _this;
  }

  _createClass$f(Calendar, [{
    key: "changeViewType",
    value: function changeViewType() {
      var _this$state = this.state,
          viewType = _this$state.viewType,
          views = _this$state.views;
      var switchTo = nextItemInArray$1(viewType, views);
      this.goToViewType(switchTo);
    }
  }, {
    key: "goToViewType",
    value: function goToViewType(switchTo) {
      var displayedPeriod = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      this.setState({
        viewType: switchTo,
        displayedPeriod: displayedPeriod || this.state.displayedPeriod
      });
    }
  }, {
    key: "moveDisplayedPeriod",
    value: function moveDisplayedPeriod(delta) {
      var _this$state2 = this.state,
          viewType = _this$state2.viewType,
          displayedPeriod = _this$state2.displayedPeriod;
      var period = viewType === 'days' ? 'months' : 'years';
      var diffTime = viewType === 'years' ? delta * 12 : delta;
      this.setState({
        displayedPeriod: displayedPeriod.clone().add(diffTime, period)
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          selectDay = _this$props.selectDay,
          activeDate = _this$props.activeDate,
          selectedDates = _this$props.selectedDates,
          minDate = _this$props.minDate,
          maxDate = _this$props.maxDate,
          format = _this$props.format,
          noWeekends = _this$props.noWeekends,
          ariaLabelPrevious = _this$props.ariaLabelPrevious,
          ariaLabelNext = _this$props.ariaLabelNext,
          _this$props$ariaLabel = _this$props.ariaLabelDatePicker,
          ariaLabelDatePicker = _this$props$ariaLabel === void 0 ? function (viewType) {
        return "Datumkiezer ".concat(aria$1.mapViewType(viewType));
      } : _this$props$ariaLabel,
          ariaLabelButtonDateFormat = _this$props.ariaLabelButtonDateFormat;
      var _this$state3 = this.state,
          viewType = _this$state3.viewType,
          displayedPeriod = _this$state3.displayedPeriod;
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        className: "m-datepicker__nav",
        "aria-label": "".concat(ariaLabelDatePicker(viewType)),
        "aria-hidden": "false"
      }, /*#__PURE__*/React__default.createElement(Nav$1, {
        viewType: viewType,
        displayedPeriod: displayedPeriod,
        onClickPrevious: this.moveDisplayedPeriod.bind(this, -1),
        onClickViewType: this.changeViewType.bind(this),
        onClickNext: this.moveDisplayedPeriod.bind(this, 1),
        ariaLabelPrevious: ariaLabelPrevious,
        ariaLabelNext: ariaLabelNext
      })), /*#__PURE__*/React__default.createElement("table", null, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement(Head$1, {
        displayedPeriod: displayedPeriod,
        viewType: viewType
      })), /*#__PURE__*/React__default.createElement("tbody", {
        className: "m-datepicker__calendar"
      }, /*#__PURE__*/React__default.createElement(Body$1, {
        viewType: viewType,
        displayedPeriod: displayedPeriod,
        selectDay: selectDay.bind(this),
        selectedDates: selectedDates,
        minDate: minDate,
        maxDate: maxDate,
        format: format,
        noWeekends: noWeekends,
        activeDate: activeDate,
        ariaLabelButtonDateFormat: ariaLabelButtonDateFormat,
        goToViewType: this.goToViewType.bind(this)
      }))));
    }
  }]);

  return Calendar;
}(Component);

var _this$1 = undefined;

var DatePicker$1 = function DatePicker(_ref) {
  var clickOnDate = _ref.clickOnDate,
      format = _ref.format,
      locale = _ref.locale,
      activeDate = _ref.activeDate,
      selectedDates = _ref.selectedDates,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      noWeekends = _ref.noWeekends,
      ariaLabelPrevious = _ref.ariaLabelPrevious,
      ariaLabelNext = _ref.ariaLabelNext,
      ariaLabelDatePicker = _ref.ariaLabelDatePicker,
      ariaLabelButtonDateFormat = _ref.ariaLabelButtonDateFormat,
      qa = _ref.qa;
  return /*#__PURE__*/React__default.createElement(Calendar$1$1, {
    selectDay: clickOnDate.bind(_this$1),
    format: format,
    locale: locale,
    activeDate: activeDate,
    selectedDates: selectedDates,
    minDate: minDate,
    maxDate: maxDate,
    noWeekends: noWeekends,
    ariaLabelPrevious: ariaLabelPrevious,
    ariaLabelNext: ariaLabelNext,
    ariaLabelDatePicker: ariaLabelDatePicker,
    ariaLabelButtonDateFormat: ariaLabelButtonDateFormat,
    qa: qa
  });
};

var Calendar$2 = /*#__PURE__*/function (_Component) {
  _inherits$f(Calendar, _Component);

  var _super = _createSuper$f(Calendar);

  function Calendar(props) {
    var _this;

    _classCallCheck$f(this, Calendar);

    _this = _super.call(this, props);
    var _this$props = _this.props,
        activeDate = _this$props.activeDate,
        format = _this$props.format,
        locale = _this$props.locale;
    Moment.locale(locale ? locale : 'nl');
    _this.state = {
      activeDate: activeDate ? Moment(activeDate, format) : ''
    };
    return _this;
  }

  _createClass$f(Calendar, [{
    key: "changeDate",
    value: function changeDate(day) {
      var _this$props2 = this.props,
          onChange = _this$props2.onChange,
          format = _this$props2.format;
      if (onChange) onChange(Moment(day).format(format));
      this.setState({
        activeDate: day
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          format = _this$props3.format,
          locale = _this$props3.locale,
          selectedDates = _this$props3.selectedDates,
          minDate = _this$props3.minDate,
          maxDate = _this$props3.maxDate,
          noWeekends = _this$props3.noWeekends,
          ariaLabelPrevious = _this$props3.ariaLabelPrevious,
          ariaLabelNext = _this$props3.ariaLabelNext,
          ariaLabelDatePicker = _this$props3.ariaLabelDatePicker,
          ariaLabelButtonDateFormat = _this$props3.ariaLabelButtonDateFormat,
          qa = _this$props3.qa;
      var activeDate = this.state.activeDate;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "m-datepicker is-open",
        "data-qa": qa
      }, /*#__PURE__*/React__default.createElement(DatePicker$1, {
        format: format,
        locale: locale,
        activeDate: activeDate,
        selectedDates: selectedDates,
        minDate: Moment(minDate, format),
        maxDate: Moment(maxDate, format),
        noWeekends: noWeekends,
        ariaLabelPrevious: ariaLabelPrevious,
        ariaLabelNext: ariaLabelNext,
        ariaLabelDatePicker: ariaLabelDatePicker,
        ariaLabelButtonDateFormat: ariaLabelButtonDateFormat,
        qa: qa,
        clickOnDate: this.changeDate.bind(this)
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.activeDate) {
        return {
          activeDate: Moment(nextProps.activeDate, nextProps.format)
        };
      }

      return null;
    }
  }]);

  return Calendar;
}(Component);

_defineProperty$j(Calendar$2, "defaultProps", {
  format: 'DD/MM/YYYY',
  noWeekends: false
});

var stateClasses$1$1 = {
  success: 'has-success',
  warning: 'has-warning',
  error: 'has-error'
};

var Datepicker$1 = /*#__PURE__*/function (_Component) {
  _inherits$1$2(Datepicker, _Component);

  var _super = _createSuper$1$2(Datepicker);

  function Datepicker(props) {
    var _this;

    _classCallCheck$1$2(this, Datepicker);

    _this = _super.call(this, props);

    _defineProperty$1$2(_assertThisInitialized$1$2(_this), "defaultId", 'aui-date-' + Math.random().toString(36));

    _defineProperty$1$2(_assertThisInitialized$1$2(_this), "handleClickOutside", function (e) {
      if (_this.datepicker && _this.datepicker.contains(e.target)) {
        return;
      }

      _this.setState({
        open: false
      });
    });

    var open = _this.props.open;
    _this.state = {
      input: '',
      open: open || false
    };
    return _this;
  }

  _createClass$1$2(Datepicker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (typeof window !== 'undefined') {
        document.addEventListener('mousedown', this.handleClickOutside);
        document.addEventListener('touchstart', this.handleClickOutside);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (typeof window !== 'undefined') {
        document.removeEventListener('mousedown', this.handleClickOutside);
        document.removeEventListener('touchstart', this.handleClickOutside);
      }
    }
  }, {
    key: "onClickInput",
    value: function onClickInput() {
      if (this.props.readOnly) {
        this.toggleCalendar();
      }
    }
  }, {
    key: "resetDate",
    value: function resetDate() {
      this.setState({
        input: '',
        activeDate: null
      });
    }
  }, {
    key: "changeDate",
    value: function changeDate(date) {
      var _this$props = this.props,
          onChange = _this$props.onChange,
          format = _this$props.format,
          autoClose = _this$props.autoClose;
      var momentDate = Moment(date, format, true);
      var isValid = momentDate.isValid();
      if (onChange) onChange(date, isValid);
      this.setState(function () {
        var updateDate = {};

        if (isValid) {
          updateDate = {
            activeDate: momentDate
          };
        }

        return _objectSpread2$3(_objectSpread2$3({}, updateDate), {}, {
          input: date,
          open: !autoClose || false
        });
      });
    }
  }, {
    key: "toggleCalendar",
    value: function toggleCalendar() {
      if (!this.props.disabled) {
        this.setState({
          open: !this.state.open
        });
      }
    }
  }, {
    key: "keyPressed",
    value: function keyPressed(e) {
      if (e.key === 'Enter' && !this.props.disabled) {
        this.setState({
          open: !this.state.open
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames,
          _this2 = this;

      var _this$props2 = this.props,
          label = _this$props2.label,
          id = _this$props2.id,
          state = _this$props2.state,
          description = _this$props2.description,
          errorDescription = _this$props2.errorDescription,
          mask = _this$props2.mask,
          required = _this$props2.required,
          disabled = _this$props2.disabled,
          readOnly = _this$props2.readOnly,
          placeholder = _this$props2.placeholder,
          name = _this$props2.name,
          format = _this$props2.format,
          _this$props2$locale = _this$props2.locale,
          locale = _this$props2$locale === void 0 ? 'nl' : _this$props2$locale,
          selectedDates = _this$props2.selectedDates,
          minDate = _this$props2.minDate,
          maxDate = _this$props2.maxDate,
          noWeekends = _this$props2.noWeekends,
          onBlur = _this$props2.onBlur,
          qa = _this$props2.qa,
          size = _this$props2.size;
      var _this$state = this.state,
          input = _this$state.input,
          activeDate = _this$state.activeDate,
          open = _this$state.open;
      var datepickerWrapperClass = classNames('a-input', 'has-icon-right', (_classNames = {
        'is-required': !!required
      }, _defineProperty$1$2(_classNames, "".concat(stateClasses$1$1[state]), !!state), _defineProperty$1$2(_classNames, "a-input--".concat(size), !!size), _classNames));
      var datepickerClass = classNames('m-datepicker', 'm-datepicker--fixed', {
        'is-open': open
      });
      return /*#__PURE__*/React__default.createElement("div", {
        className: datepickerWrapperClass,
        ref: function ref(node) {
          return _this2.datepicker = node;
        },
        "data-qa": qa
      }, label && /*#__PURE__*/React__default.createElement(InputLabel$3, {
        htmlFor: id || this.defaultId
      }, label), /*#__PURE__*/React__default.createElement("div", {
        className: "a-input__wrapper"
      }, /*#__PURE__*/React__default.createElement(TextField$1, {
        mask: mask,
        name: name,
        id: id || this.defaultId,
        value: input,
        placeholder: placeholder,
        required: required,
        readOnly: readOnly,
        disabled: disabled,
        onClick: function onClick() {
          return _this2.onClickInput();
        },
        onChange: function onChange(e) {
          return _this2.changeDate(e.target.value);
        },
        onBlur: onBlur
      }), /*#__PURE__*/React__default.createElement("span", {
        role: "button",
        className: "ai is-clickable",
        tabIndex: "0",
        onClick: this.toggleCalendar.bind(this),
        onKeyPress: this.keyPressed.bind(this),
        "aria-label": "Open"
      }, /*#__PURE__*/React__default.createElement(Icon$1$2, {
        name: "ai-calendar-3"
      })), open && /*#__PURE__*/React__default.createElement("div", {
        className: datepickerClass,
        "aria-hidden": "false"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "m-datepicker is-open"
      }, /*#__PURE__*/React__default.createElement(Calendar$2, {
        locale: locale,
        format: format,
        activeDate: activeDate,
        selectedDates: selectedDates,
        minDate: minDate,
        maxDate: maxDate,
        noWeekends: noWeekends,
        onChange: this.changeDate.bind(this)
      })))), description && /*#__PURE__*/React__default.createElement("small", null, description), errorDescription && /*#__PURE__*/React__default.createElement("small", {
        className: "u-text-danger"
      }, errorDescription));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      // Reset input value
      if (props.activeDate === '') {
        return {
          activeDate: null,
          input: props.activeDate
        };
      }

      if (props.activeDate) {
        var momentDate = Moment(props.activeDate, props.format, true);

        if (momentDate.isValid()) {
          return {
            activeDate: momentDate,
            input: props.activeDate
          };
        }
      }

      return null;
    }
  }]);

  return Datepicker;
}(Component);

_defineProperty$1$2(Datepicker$1, "defaultProps", {
  required: false,
  format: 'DD/MM/YYYY',
  autoClose: true,
  noWeekends: false,
  readOnly: false,
  disabled: false
});

var countryCodes$1 = [{
  "value": "+1",
  "label": "+1"
}, {
  "value": "+20",
  "label": "+20"
}, {
  "value": "+211",
  "label": "+211"
}, {
  "value": "+212",
  "label": "+212"
}, {
  "value": "+213",
  "label": "+213"
}, {
  "value": "+216",
  "label": "+216"
}, {
  "value": "+218",
  "label": "+218"
}, {
  "value": "+220",
  "label": "+220"
}, {
  "value": "+221",
  "label": "+221"
}, {
  "value": "+222",
  "label": "+222"
}, {
  "value": "+223",
  "label": "+223"
}, {
  "value": "+224",
  "label": "+224"
}, {
  "value": "+225",
  "label": "+225"
}, {
  "value": "+226",
  "label": "+226"
}, {
  "value": "+227",
  "label": "+227"
}, {
  "value": "+228",
  "label": "+228"
}, {
  "value": "+229",
  "label": "+229"
}, {
  "value": "+230",
  "label": "+230"
}, {
  "value": "+231",
  "label": "+231"
}, {
  "value": "+232",
  "label": "+232"
}, {
  "value": "+233",
  "label": "+233"
}, {
  "value": "+234",
  "label": "+234"
}, {
  "value": "+235",
  "label": "+235"
}, {
  "value": "+236",
  "label": "+236"
}, {
  "value": "+237",
  "label": "+237"
}, {
  "value": "+238",
  "label": "+238"
}, {
  "value": "+239",
  "label": "+239"
}, {
  "value": "+240",
  "label": "+240"
}, {
  "value": "+241",
  "label": "+241"
}, {
  "value": "+242",
  "label": "+242"
}, {
  "value": "+243",
  "label": "+243"
}, {
  "value": "+244",
  "label": "+244"
}, {
  "value": "+245",
  "label": "+245"
}, {
  "value": "+246",
  "label": "+246"
}, {
  "value": "+248",
  "label": "+248"
}, {
  "value": "+249",
  "label": "+249"
}, {
  "value": "+250",
  "label": "+250"
}, {
  "value": "+251",
  "label": "+251"
}, {
  "value": "+252",
  "label": "+252"
}, {
  "value": "+253",
  "label": "+253"
}, {
  "value": "+254",
  "label": "+254"
}, {
  "value": "+255",
  "label": "+255"
}, {
  "value": "+256",
  "label": "+256"
}, {
  "value": "+257",
  "label": "+257"
}, {
  "value": "+258",
  "label": "+258"
}, {
  "value": "+260",
  "label": "+260"
}, {
  "value": "+261",
  "label": "+261"
}, {
  "value": "+262",
  "label": "+262"
}, {
  "value": "+263",
  "label": "+263"
}, {
  "value": "+264",
  "label": "+264"
}, {
  "value": "+265",
  "label": "+265"
}, {
  "value": "+266",
  "label": "+266"
}, {
  "value": "+267",
  "label": "+267"
}, {
  "value": "+268",
  "label": "+268"
}, {
  "value": "+269",
  "label": "+269"
}, {
  "value": "+27",
  "label": "+27"
}, {
  "value": "+290",
  "label": "+290"
}, {
  "value": "+291",
  "label": "+291"
}, {
  "value": "+297",
  "label": "+297"
}, {
  "value": "+298",
  "label": "+298"
}, {
  "value": "+299",
  "label": "+299"
}, {
  "value": "+30",
  "label": "+30"
}, {
  "value": "+31",
  "label": "+31"
}, {
  "value": "+32",
  "label": "+32"
}, {
  "value": "+33",
  "label": "+33"
}, {
  "value": "+34",
  "label": "+34"
}, {
  "value": "+350",
  "label": "+350"
}, {
  "value": "+351",
  "label": "+351"
}, {
  "value": "+352",
  "label": "+352"
}, {
  "value": "+353",
  "label": "+353"
}, {
  "value": "+354",
  "label": "+354"
}, {
  "value": "+355",
  "label": "+355"
}, {
  "value": "+356",
  "label": "+356"
}, {
  "value": "+357",
  "label": "+357"
}, {
  "value": "+358",
  "label": "+358"
}, {
  "value": "+358-18",
  "label": "+358-18"
}, {
  "value": "+359",
  "label": "+359"
}, {
  "value": "+36",
  "label": "+36"
}, {
  "value": "+370",
  "label": "+370"
}, {
  "value": "+371",
  "label": "+371"
}, {
  "value": "+372",
  "label": "+372"
}, {
  "value": "+373",
  "label": "+373"
}, {
  "value": "+374",
  "label": "+374"
}, {
  "value": "+375",
  "label": "+375"
}, {
  "value": "+376",
  "label": "+376"
}, {
  "value": "+377",
  "label": "+377"
}, {
  "value": "+378",
  "label": "+378"
}, {
  "value": "+379",
  "label": "+379"
}, {
  "value": "+380",
  "label": "+380"
}, {
  "value": "+381",
  "label": "+381"
}, {
  "value": "+382",
  "label": "+382"
}, {
  "value": "+385",
  "label": "+385"
}, {
  "value": "+386",
  "label": "+386"
}, {
  "value": "+387",
  "label": "+387"
}, {
  "value": "+389",
  "label": "+389"
}, {
  "value": "+39",
  "label": "+39"
}, {
  "value": "+40",
  "label": "+40"
}, {
  "value": "+41",
  "label": "+41"
}, {
  "value": "+420",
  "label": "+420"
}, {
  "value": "+421",
  "label": "+421"
}, {
  "value": "+423",
  "label": "+423"
}, {
  "value": "+43",
  "label": "+43"
}, {
  "value": "+44",
  "label": "+44"
}, {
  "value": "+44-1481",
  "label": "+44-1481"
}, {
  "value": "+44-1534",
  "label": "+44-1534"
}, {
  "value": "+44-1624",
  "label": "+44-1624"
}, {
  "value": "+45",
  "label": "+45"
}, {
  "value": "+46",
  "label": "+46"
}, {
  "value": "+47",
  "label": "+47"
}, {
  "value": "+48",
  "label": "+48"
}, {
  "value": "+49",
  "label": "+49"
}, {
  "value": "+500",
  "label": "+500"
}, {
  "value": "+501",
  "label": "+501"
}, {
  "value": "+502",
  "label": "+502"
}, {
  "value": "+503",
  "label": "+503"
}, {
  "value": "+504",
  "label": "+504"
}, {
  "value": "+505",
  "label": "+505"
}, {
  "value": "+506",
  "label": "+506"
}, {
  "value": "+507",
  "label": "+507"
}, {
  "value": "+508",
  "label": "+508"
}, {
  "value": "+509",
  "label": "+509"
}, {
  "value": "+51",
  "label": "+51"
}, {
  "value": "+52",
  "label": "+52"
}, {
  "value": "+53",
  "label": "+53"
}, {
  "value": "+54",
  "label": "+54"
}, {
  "value": "+55",
  "label": "+55"
}, {
  "value": "+56",
  "label": "+56"
}, {
  "value": "+57",
  "label": "+57"
}, {
  "value": "+58",
  "label": "+58"
}, {
  "value": "+590",
  "label": "+590"
}, {
  "value": "+591",
  "label": "+591"
}, {
  "value": "+592",
  "label": "+592"
}, {
  "value": "+593",
  "label": "+593"
}, {
  "value": "+594",
  "label": "+594"
}, {
  "value": "+595",
  "label": "+595"
}, {
  "value": "+596",
  "label": "+596"
}, {
  "value": "+597",
  "label": "+597"
}, {
  "value": "+598",
  "label": "+598"
}, {
  "value": "+599",
  "label": "+599"
}, {
  "value": "+60",
  "label": "+60"
}, {
  "value": "+61",
  "label": "+61"
}, {
  "value": "+62",
  "label": "+62"
}, {
  "value": "+63",
  "label": "+63"
}, {
  "value": "+64",
  "label": "+64"
}, {
  "value": "+65",
  "label": "+65"
}, {
  "value": "+66",
  "label": "+66"
}, {
  "value": "+670",
  "label": "+670"
}, {
  "value": "+672",
  "label": "+672"
}, {
  "value": "+673",
  "label": "+673"
}, {
  "value": "+674",
  "label": "+674"
}, {
  "value": "+675",
  "label": "+675"
}, {
  "value": "+676",
  "label": "+676"
}, {
  "value": "+677",
  "label": "+677"
}, {
  "value": "+678",
  "label": "+678"
}, {
  "value": "+679",
  "label": "+679"
}, {
  "value": "+680",
  "label": "+680"
}, {
  "value": "+681",
  "label": "+681"
}, {
  "value": "+682",
  "label": "+682"
}, {
  "value": "+683",
  "label": "+683"
}, {
  "value": "+685",
  "label": "+685"
}, {
  "value": "+686",
  "label": "+686"
}, {
  "value": "+687",
  "label": "+687"
}, {
  "value": "+688",
  "label": "+688"
}, {
  "value": "+689",
  "label": "+689"
}, {
  "value": "+690",
  "label": "+690"
}, {
  "value": "+691",
  "label": "+691"
}, {
  "value": "+692",
  "label": "+692"
}, {
  "value": "+7",
  "label": "+7"
}, {
  "value": "+81",
  "label": "+81"
}, {
  "value": "+82",
  "label": "+82"
}, {
  "value": "+84",
  "label": "+84"
}, {
  "value": "+850",
  "label": "+850"
}, {
  "value": "+852",
  "label": "+852"
}, {
  "value": "+853",
  "label": "+853"
}, {
  "value": "+855",
  "label": "+855"
}, {
  "value": "+856",
  "label": "+856"
}, {
  "value": "+86",
  "label": "+86"
}, {
  "value": "+870",
  "label": "+870"
}, {
  "value": "+880",
  "label": "+880"
}, {
  "value": "+886",
  "label": "+886"
}, {
  "value": "+90",
  "label": "+90"
}, {
  "value": "+91",
  "label": "+91"
}, {
  "value": "+92",
  "label": "+92"
}, {
  "value": "+93",
  "label": "+93"
}, {
  "value": "+94",
  "label": "+94"
}, {
  "value": "+95",
  "label": "+95"
}, {
  "value": "+960",
  "label": "+960"
}, {
  "value": "+961",
  "label": "+961"
}, {
  "value": "+962",
  "label": "+962"
}, {
  "value": "+963",
  "label": "+963"
}, {
  "value": "+964",
  "label": "+964"
}, {
  "value": "+965",
  "label": "+965"
}, {
  "value": "+966",
  "label": "+966"
}, {
  "value": "+967",
  "label": "+967"
}, {
  "value": "+968",
  "label": "+968"
}, {
  "value": "+970",
  "label": "+970"
}, {
  "value": "+971",
  "label": "+971"
}, {
  "value": "+972",
  "label": "+972"
}, {
  "value": "+973",
  "label": "+973"
}, {
  "value": "+974",
  "label": "+974"
}, {
  "value": "+975",
  "label": "+975"
}, {
  "value": "+976",
  "label": "+976"
}, {
  "value": "+977",
  "label": "+977"
}, {
  "value": "+98",
  "label": "+98"
}, {
  "value": "+992",
  "label": "+992"
}, {
  "value": "+993",
  "label": "+993"
}, {
  "value": "+994",
  "label": "+994"
}, {
  "value": "+995",
  "label": "+995"
}, {
  "value": "+996",
  "label": "+996"
}, {
  "value": "+998",
  "label": "+998"
}];

___$insertStyle$4(".a-input-telephone .a-input__wrapper {\n  display: flex;\n}\n.a-input-telephone .a-input__wrapper .a-input-telephone__number {\n  flex: 1;\n}\n.a-input-telephone .a-input__wrapper .a-input-telephone__number input:not([class*=a-button]):not([type=checkbox]):not([type=radio]) {\n  border-left: none;\n}\n.a-input-telephone .a-input__wrapper .a-input-telephone__area-code select:focus,\n.a-input-telephone .a-input__wrapper input:not([class*=a-button]):not([type=checkbox]):not([type=radio]).a-input-telephone__number:focus {\n  z-index: 1;\n}\n.a-input-telephone .a-input__wrapper .a-input-telephone__area-code select:focus + .ai,\n.a-input-telephone .a-input__wrapper input:not([class*=a-button]):not([type=checkbox]):not([type=radio]).a-input-telephone__number:focus + .ai {\n  z-index: 2;\n}\n\n.a-input.has-success .a-input-telephone__area-code .a-input__wrapper:before, .a-input.has-warning .a-input-telephone__area-code .a-input__wrapper:before, .a-input.has-error .a-input-telephone__area-code .a-input__wrapper:before {\n  content: none;\n}");

var _excluded$7 = ["id", "label", "value", "name", "placeholder", "qa", "className", "style", "required", "state", "loading", "onChange", "defaultAreaCode", "description", "errorDescription"];
var stateClasses$5 = {
  success: 'has-success',
  warning: 'has-warning',
  error: 'has-error'
};

var TelephoneNumber$1 = function TelephoneNumber(props) {
  var id = props.id,
      label = props.label,
      value = props.value,
      name = props.name,
      placeholder = props.placeholder,
      qa = props.qa,
      className = props.className,
      style = props.style,
      required = props.required,
      state = props.state,
      loading = props.loading,
      onChange = props.onChange;
  props.defaultAreaCode;

  var description = props.description,
      errorDescription = props.errorDescription,
      extraProps = _objectWithoutProperties$7(props, _excluded$7);

  var valueIsValidObject = function valueIsValidObject(value) {
    return _typeof$2(value) === 'object' && value !== null;
  };

  var valueIsEqualToInternalValue = function valueIsEqualToInternalValue(val, internalVal) {
    return val.areaCode === internalVal.areaCode && val.number === internalVal.number;
  };

  var _useState = useState(valueIsValidObject(value) ? value : {
    areaCode: internalValue && internalValue.areaCode ? internalValue.areaCode : '+32',
    number: internalValue && internalValue.number ? internalValue.number : ''
  }),
      _useState2 = _slicedToArray$2(_useState, 2),
      internalValue = _useState2[0],
      setInternalValue = _useState2[1];

  useEffect(function () {
    if (!valueIsValidObject(value) || !valueIsEqualToInternalValue(value, internalValue)) {
      onChange(internalValue);
    }
  }, [internalValue]);
  useEffect(function () {
    if (valueIsValidObject(value) && !valueIsEqualToInternalValue(value, internalValue)) {
      setInternalValue(value);
    }
  }, [value]);

  var updateNumber = function updateNumber(e) {
    setInternalValue(_objectSpread2$3(_objectSpread2$3({}, internalValue), {}, {
      number: e.target.value
    }));
  };

  var updateAreaCode = function updateAreaCode(e) {
    setInternalValue(_objectSpread2$3(_objectSpread2$3({}, internalValue), {}, {
      areaCode: e.target.value
    }));
  };

  var options = countryCodes$1;
  var telephoneNumberClass = classNames('a-input', 'a-input-telephone', _defineProperty$1$2({
    'is-required': !!required
  }, "".concat(stateClasses$5[state]), !!state), className);
  return /*#__PURE__*/React__default.createElement("div", {
    className: telephoneNumberClass,
    style: style,
    "data-qa": qa
  }, label && /*#__PURE__*/React__default.createElement(InputLabel$3, {
    id: "".concat(id, "-areacode-label"),
    htmlFor: id
  }, label), /*#__PURE__*/React__default.createElement("div", {
    className: "a-input__wrapper"
  }, /*#__PURE__*/React__default.createElement(Select$1, _extends$4({
    className: "a-input-telephone__area-code",
    id: "".concat(id, "-areacode"),
    ariaLabelledby: "".concat(id, "-areacode-label"),
    name: "".concat(name, "-areacode"),
    required: required,
    onChange: updateAreaCode,
    value: internalValue.areaCode,
    options: options
  }, extraProps)), /*#__PURE__*/React__default.createElement(TextField$1, _extends$4({
    className: "a-input-telephone__number",
    id: id,
    placeholder: placeholder,
    name: name,
    required: required,
    loading: loading,
    onChange: updateNumber,
    value: internalValue.number
  }, extraProps))), description ? /*#__PURE__*/React__default.createElement("small", null, description) : null, errorDescription && /*#__PURE__*/React__default.createElement("small", {
    className: "u-text-danger"
  }, errorDescription));
};

function ___$insertStyle$3(css) {
  if (!css || typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');
  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

function _defineProperty$i(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ENV_IDENTIFIERS$2 = {
  dev: '-o.',
  acc: '-a.',
  local: 'local'
};

function getEnvironment$2() {
  if (typeof window === 'undefined') {
    return process.env.NODE_ENV;
  }

  var currentUrl = window.location.href;
  var env = Object.keys(ENV_IDENTIFIERS$2).find(function (key) {
    return currentUrl.includes(ENV_IDENTIFIERS$2[key]);
  });
  return env || 'prod';
}

function getAstadUrl$2() {
  switch (getEnvironment$2().toLowerCase()) {
    case 'local':
      return 'https://www.dev.dcs.antwerpen.be';

    case 'dev':
      return 'https://www.dev.dcs.antwerpen.be';

    case 'acc':
      return 'https://www.acc.dcs.antwerpen.be';

    default:
      return 'https://www.antwerpen.be';
  }
}

function getShoppingCartUrl$2() {
  switch (getEnvironment$2().toLowerCase()) {
    case 'local':
      return 'https://winkelmand-o.antwerpen.be';

    case 'dev':
      return 'https://winkelmand-o.antwerpen.be';

    case 'acc':
      return 'https://winkelmand-a.antwerpen.be';

    default:
      return 'https://winkelmand.antwerpen.be';
  }
}

function getEloketUrl$2() {
  switch (getEnvironment$2().toLowerCase()) {
    case 'local':
      return 'https://eloket-o.antwerpen.be';

    case 'dev':
      return 'https://eloket-o.antwerpen.be';

    case 'acc':
      return 'https://eloket-a.antwerpen.be';

    default:
      return 'https://eloket.antwerpen.be';
  }
}

var Environment$2 = {
  getEnvironment: getEnvironment$2,
  getAstadUrl: getAstadUrl$2,
  getShoppingCartUrl: getShoppingCartUrl$2,
  getEloketUrl: getEloketUrl$2
};

___$insertStyle$3(".local-header {\n  background-color: #15F4EE;\n}\n\n.dev-header {\n  background-color: #ADFF2F;\n}\n\n.acc-header {\n  background-color: #FF69B4;\n}");

var Header = function Header(props) {
  var children = props.children,
      style = props.style,
      className = props.className,
      logoUrl = props.logoUrl,
      logoSrc = props.logoSrc,
      logoAlt = props.logoAlt,
      type = props.type,
      qa = props.qa;
  var env = Environment$2.getEnvironment();
  var headerClass = classNames('o-header', className, _defineProperty$i({}, "".concat(env, "-header"), type === 'antwerpen'));
  return /*#__PURE__*/React__default.createElement("header", {
    className: headerClass,
    style: style,
    "data-qa": qa
  }, /*#__PURE__*/React__default.createElement("a", {
    href: logoUrl,
    className: "o-header__logo"
  }, /*#__PURE__*/React__default.createElement("img", {
    src: logoSrc,
    alt: logoAlt
  })), children);
};

Header.defaultProps = {
  logoUrl: '/',
  logoSrc: 'https://cdn.antwerpen.be/core_branding_scss/5.0.0/assets/images/a-logo.svg',
  logoAlt: 'Ga naar homepage.'
};

var styles = {
  overflow: 'auto'
};

var Hero = function Hero(props) {
  var children = props.children;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "u-wrapper u-bg-light",
    style: styles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "u-container"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "u-text-center u-margin-lg"
  }, children)));
};

function asyncGeneratorStep$9(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator$9(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep$9(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep$9(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var Icon$9 = function Icon(_ref) {
  var name = _ref.name,
      style = _ref.style,
      className = _ref.className,
      ariaLabel = _ref.ariaLabel,
      onClick = _ref.onClick,
      src = _ref.src,
      qa = _ref.qa;
  /**
   * Inject SVG icons from core branding into page
   */

  var fetchAntwerpIcons = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator$9( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var xlinkHref, response, svgText, svgWrapper;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (fetch) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              _context.prev = 2;
              xlinkHref = 'https://cdn.antwerpen.be/core_branding_scss/5.0.0/assets/images/ai.svg';
              _context.next = 6;
              return fetch(xlinkHref);

            case 6:
              response = _context.sent;
              _context.next = 9;
              return response.text();

            case 9:
              svgText = _context.sent;
              svgWrapper = document.createElement('svg');
              svgWrapper.id = 'aiSvg';
              svgWrapper.innerHTML = svgText;

              if (!document.getElementById('aiSvg')) {
                document.body.appendChild(svgWrapper);
              }

              _context.next = 19;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](2);
              throw new Error(_context.t0);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 16]]);
    }));

    return function fetchAntwerpIcons() {
      return _ref2.apply(this, arguments);
    };
  }();

  if (typeof document !== 'undefined' && !document.getElementById('aiSvg')) {
    fetchAntwerpIcons();
  }

  var iconClass = classNames(className, name, 'ai');
  return /*#__PURE__*/React__default.createElement("span", {
    className: iconClass,
    style: style,
    "data-qa": qa,
    onClick: onClick
  }, name && /*#__PURE__*/React__default.createElement("svg", {
    "aria-hidden": "true"
  }, /*#__PURE__*/React__default.createElement("use", {
    href: "#".concat(name)
  })), src, ariaLabel && /*#__PURE__*/React__default.createElement("span", {
    className: "u-screen-reader-only"
  }, ariaLabel));
};

function _defineProperty$h(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var typeClasses$6 = {
  primary: 'a-label--primary',
  secondary: 'a-label--secondary',
  success: 'a-label--success',
  warning: 'a-label--warning',
  danger: 'a-label--danger'
};

var Label = function Label(props) {
  var type = props.type,
      className = props.className,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style,
      children = props.children,
      qa = props.qa;
  var labelClass = classNames('a-label', className, _defineProperty$h({}, "".concat(typeClasses$6[type]), !!type));
  return /*#__PURE__*/React__default.createElement("span", {
    className: labelClass,
    style: style,
    "data-qa": qa
  }, children);
};

function _classCallCheck$e(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$e(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$e(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$e(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$e(Constructor, staticProps);
  return Constructor;
}

function _inherits$e(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$e(subClass, superClass);
}

function _getPrototypeOf$e(o) {
  _getPrototypeOf$e = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$e(o);
}

function _setPrototypeOf$e(o, p) {
  _setPrototypeOf$e = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$e(o, p);
}

function _isNativeReflectConstruct$e() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized$e(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn$e(self, call) {
  if (call && (_typeof$4(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized$e(self);
}

function _createSuper$e(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$e();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf$e(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$e(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn$e(this, result);
  };
}

var Steps = /*#__PURE__*/function (_Component) {
  _inherits$e(Steps, _Component);

  var _super = _createSuper$e(Steps);

  function Steps() {
    _classCallCheck$e(this, Steps);

    return _super.apply(this, arguments);
  }

  _createClass$e(Steps, [{
    key: "renderStep",
    value: function renderStep(child, i) {
      return /*#__PURE__*/cloneElement(child, {
        completed: i < this.props.current,
        active: i === this.props.current
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          className = _this$props.className,
          qa = _this$props.qa;
      return /*#__PURE__*/React__default.createElement("div", {
        className: className,
        "data-qa": qa
      }, /*#__PURE__*/React__default.createElement("ol", {
        className: "m-step-indicator"
      }, this.props.children.map(function (child, i) {
        return _this.renderStep(child, i);
      })));
    }
  }]);

  return Steps;
}(Component);

var Step = /*#__PURE__*/function (_Component) {
  _inherits$e(Step, _Component);

  var _super = _createSuper$e(Step);

  function Step() {
    _classCallCheck$e(this, Step);

    return _super.apply(this, arguments);
  }

  _createClass$e(Step, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          active = _this$props.active,
          completed = _this$props.completed,
          _this$props$ariaLabel = _this$props.ariaLabelCurrent,
          ariaLabelCurrent = _this$props$ariaLabel === void 0 ? "Huidige:" : _this$props$ariaLabel,
          _this$props$ariaLabel2 = _this$props.ariaLabelCompleted,
          ariaLabelCompleted = _this$props$ariaLabel2 === void 0 ? "Compleet:" : _this$props$ariaLabel2;
      var stepClass = classNames({
        'is-active': !!active,
        'is-completed': !!completed
      });
      return /*#__PURE__*/React__default.createElement("li", {
        className: stepClass
      }, !!completed ? /*#__PURE__*/React__default.createElement("span", {
        className: "u-screen-reader-only"
      }, ariaLabelCompleted) : '', !!active ? /*#__PURE__*/React__default.createElement("span", {
        className: "u-screen-reader-only"
      }, ariaLabelCurrent) : '', /*#__PURE__*/React__default.createElement("span", {
        className: "m-step-indicator__label"
      }, title));
    }
  }]);

  return Step;
}(Component);

function ownKeys$2(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2$2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$2(Object(source), true).forEach(function (key) {
        _defineProperty$g(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$2(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _classCallCheck$d(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$d(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$d(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$d(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$d(Constructor, staticProps);
  return Constructor;
}

function _defineProperty$g(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits$d(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$d(subClass, superClass);
}

function _getPrototypeOf$d(o) {
  _getPrototypeOf$d = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$d(o);
}

function _setPrototypeOf$d(o, p) {
  _setPrototypeOf$d = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$d(o, p);
}

function _isNativeReflectConstruct$d() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized$d(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn$d(self, call) {
  if (call && (_typeof$4(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized$d(self);
}

function _createSuper$d(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$d();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf$d(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$d(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn$d(this, result);
  };
}

var InputLabel$2 = function InputLabel(props) {
  var style = props.style,
      htmlFor = props.htmlFor,
      children = props.children,
      inline = props.inline,
      id = props.id,
      qa = props.qa;
  var labelClass = classNames('a-input__label', {
    'a-input__label--inline': !!inline
  });
  return /*#__PURE__*/React__default.createElement("label", {
    className: labelClass,
    htmlFor: htmlFor,
    style: style,
    id: id,
    "data-qa": qa
  }, children);
};

var Bar = function Bar(_ref) {
  var start = _ref.start,
      end = _ref.end,
      getPositionFromValue = _ref.getPositionFromValue,
      range = _ref.range;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "m-range-slider__bar",
    style: {
      left: range && getPositionFromValue(start) + 'px',
      width: range ? getPositionFromValue(end - start) + 'px' : getPositionFromValue(start) + 'px'
    }
  });
};

var Handle = /*#__PURE__*/function (_Component) {
  _inherits$d(Handle, _Component);

  var _super = _createSuper$d(Handle);

  function Handle() {
    var _this;

    _classCallCheck$d(this, Handle);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$g(_assertThisInitialized$d(_this), "state", {
      limit: 480,
      grab: 5
    });

    _defineProperty$g(_assertThisInitialized$d(_this), "handleNoop", function (e) {
      e.stopPropagation();
      e.preventDefault();
    });

    _defineProperty$g(_assertThisInitialized$d(_this), "handleStart", function () {
      document.addEventListener('mousemove', _this.handleDrag);
      document.addEventListener('mouseup', _this.handleEnd);
    });

    _defineProperty$g(_assertThisInitialized$d(_this), "handleDrag", function (e) {
      _this.handleNoop(e);

      var onChange = _this.props.onChange;
      if (!onChange) return;

      var value = _this.position(e);

      onChange && onChange(value);
    });

    _defineProperty$g(_assertThisInitialized$d(_this), "handleEnd", function (e) {
      document.removeEventListener('mousemove', _this.handleDrag);
      document.removeEventListener('mouseup', _this.handleEnd);
      var onDragEnd = _this.props.onDragEnd;
      if (!onDragEnd) return;

      var value = _this.position(e);

      onDragEnd && onDragEnd(value);
    });

    _defineProperty$g(_assertThisInitialized$d(_this), "position", function (e) {
      var grab = _this.state.grab;
      var direction = _this.props.direction;
      var clientCoordinateStyle = 'clientX';
      var coordinate = !e.touches ? e[clientCoordinateStyle] : e.touches[0][clientCoordinateStyle];
      var pos = coordinate - direction - grab;
      return _this.getValueFromPosition(pos);
    });

    _defineProperty$g(_assertThisInitialized$d(_this), "getValueFromPosition", function (pos) {
      var limit = _this.state.limit;
      var _this$props = _this.props,
          min = _this$props.min,
          max = _this$props.max,
          step = _this$props.step;
      var percentage = clamp(pos, 0, limit) / (limit || 1);
      var baseVal = step * Math.round(percentage * (max - min) / step);
      var value = baseVal + min;
      if (value >= max) value = max;
      if (value <= min) value = min;
      return value;
    });

    _defineProperty$g(_assertThisInitialized$d(_this), "handleKeyPress", function (e) {
      if (e.defaultPrevented) {
        return;
      }

      var _this$props2 = _this.props,
          onChange = _this$props2.onChange,
          step = _this$props2.step,
          min = _this$props2.min,
          max = _this$props2.max,
          value = _this$props2.value;

      if (!onChange) {
        return;
      }

      var newValue = value;
      var key = e.keyCode;

      switch (key) {
        case 39: // right

        case 38:
          // up
          newValue = value + step;
          e.preventDefault();
          break;

        case 37: // left

        case 40:
          // down
          newValue = value - step;
          e.preventDefault();
          break;

        case 35:
          // end
          newValue = max;
          e.preventDefault();
          break;

        case 36:
          // home
          newValue = min;
          e.preventDefault();
          break;
      } // Make sure the slider doesn't get out of bounds


      if (newValue < min || newValue > max) {
        return;
      }

      onChange(newValue);
    });

    _defineProperty$g(_assertThisInitialized$d(_this), "onFocus", function () {
      document.addEventListener('keydown', _this.handleKeyPress);

      _this.setState({
        isFocus: true
      });
    });

    _defineProperty$g(_assertThisInitialized$d(_this), "onBlur", function () {
      document.removeEventListener('keydown', _this.handleKeyPress);

      _this.setState({
        isFocus: false
      });
    });

    return _this;
  }

  _createClass$d(Handle, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          value = _this$props3.value,
          handleNoop = _this$props3.handleNoop,
          getPositionFromValue = _this$props3.getPositionFromValue,
          unit = _this$props3.unit,
          fixed = _this$props3.fixed,
          tooltips = _this$props3.tooltips,
          onDragEnd = _this$props3.onDragEnd,
          min = _this$props3.min,
          max = _this$props3.max;
      _this$props3.label;
      var ariaLabel = _this$props3.ariaLabel,
          id = _this$props3.id;
      var fixedValue = value.toFixed(fixed);
      "".concat(fixedValue.replace(/[.]/, ','), " ").concat(unit);
      return /*#__PURE__*/React__default.createElement("div", {
        className: "m-range-slider__handle",
        tabIndex: "0",
        onMouseDown: this.handleStart,
        onTouchEnd: handleNoop,
        onTouchMove: this.handleDrag,
        onDragExit: onDragEnd,
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        role: "slider",
        "aria-orientation": "horizontal",
        "aria-valuemax": max,
        "aria-valuemin": min,
        "aria-valuenow": fixedValue,
        "aria-label": ariaLabel,
        style: {
          left: getPositionFromValue(value) + 'px'
        }
      }, tooltips ? /*#__PURE__*/React__default.createElement("div", {
        className: "m-range-slider__tooltip a-tooltip a-tooltip--primary a-tooltip--top",
        "aria-labelledby": id
      }, /*#__PURE__*/React__default.createElement("p", {
        id: id
      }, fixedValue.replace(/[.]/, ','), unit)) : /*#__PURE__*/React__default.createElement("span", {
        className: "m-range-slider__value"
      }, fixedValue.replace(/[.]/, ','), unit));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var sliderPos = props.sliderPos;
      var handlePos = 30; // Fills the bar up correctly on the right side

      return _objectSpread2$2(_objectSpread2$2({}, state), {}, {
        limit: sliderPos - handlePos
      });
    }
  }]);

  return Handle;
}(Component);

function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
}

var Slider = /*#__PURE__*/function (_Component) {
  _inherits$d(Slider, _Component);

  var _super = _createSuper$d(Slider);

  function Slider() {
    var _this;

    _classCallCheck$d(this, Slider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$g(_assertThisInitialized$d(_this), "state", {
      limit: 0,
      start: _this.props.start,
      end: _this.props.end
    });

    _defineProperty$g(_assertThisInitialized$d(_this), "onDragEnd", function () {
      var _this$state = _this.state,
          start = _this$state.start,
          end = _this$state.end;
      var onDragEnd = _this.props.onDragEnd;
      if (!onDragEnd) return;
      onDragEnd && onDragEnd(start, end);
    });

    _defineProperty$g(_assertThisInitialized$d(_this), "updateStart", function (start) {
      var end = _this.state.end;
      var minRange = _this.props.minRange;

      if (end - start < minRange) {
        end = start + minRange;
      }

      _this.onChange(start, end);
    });

    _defineProperty$g(_assertThisInitialized$d(_this), "updateEnd", function (end) {
      var start = _this.state.start;
      var minRange = _this.props.minRange;

      if (end - start < minRange) {
        start = end - minRange;
      }

      _this.onChange(start, end);
    });

    _defineProperty$g(_assertThisInitialized$d(_this), "handleUpdate", function () {
      var sliderPos = _this.slider['offsetWidth'];
      var handlePos = 30; // Fills the bar up correctly on the right side

      var node = _this.slider;
      var direction = node.getBoundingClientRect()['left'];

      _this.setState({
        limit: sliderPos - handlePos,
        sliderPos: sliderPos,
        direction: direction
      });
    });

    _defineProperty$g(_assertThisInitialized$d(_this), "handleNoop", function (e) {
      e.stopPropagation();
      e.preventDefault();
    });

    _defineProperty$g(_assertThisInitialized$d(_this), "onChange", function (start, end) {
      var onChange = _this.props.onChange;

      _this.setState({
        start: start,
        end: end
      });

      if (!onChange) return;
      onChange(start, end);
    });

    _defineProperty$g(_assertThisInitialized$d(_this), "getPositionFromValue", function (value) {
      var limit = _this.state.limit;
      var _this$props = _this.props,
          min = _this$props.min,
          max = _this$props.max;
      var diffMaxMin = max - min;
      var diffValMin = value - min;
      var percentage = diffValMin / diffMaxMin;
      return Math.round(percentage * limit);
    });

    return _this;
  }

  _createClass$d(Slider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleUpdate);
      this.handleUpdate();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleUpdate);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          id = _this$props2.id,
          label = _this$props2.label,
          min = _this$props2.min,
          max = _this$props2.max,
          step = _this$props2.step,
          unit = _this$props2.unit,
          minRange = _this$props2.minRange,
          tooltips = _this$props2.tooltips,
          range = _this$props2.range,
          fixed = _this$props2.fixed,
          qa = _this$props2.qa;
      var _this$state2 = this.state,
          sliderPos = _this$state2.sliderPos,
          direction = _this$state2.direction,
          start = _this$state2.start,
          end = _this$state2.end;
      return /*#__PURE__*/React__default.createElement("div", {
        id: id,
        "data-qa": qa
      }, label && /*#__PURE__*/React__default.createElement(InputLabel$2, {
        htmlFor: id
      }, label), /*#__PURE__*/React__default.createElement("div", {
        className: "m-range-slider",
        ref: function ref(s) {
          _this2.slider = s;
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "m-range-slider__inner"
      }, /*#__PURE__*/React__default.createElement(Bar, {
        start: start,
        end: end,
        getPositionFromValue: this.getPositionFromValue,
        range: range
      }), /*#__PURE__*/React__default.createElement(Handle, {
        value: start,
        onChange: this.updateStart,
        min: min,
        max: max - minRange,
        step: step,
        unit: unit,
        fixed: fixed,
        label: label,
        id: "".concat(id, "-handle-1"),
        handleNoop: this.handleNoop,
        sliderPos: sliderPos,
        direction: direction,
        getPositionFromValue: this.getPositionFromValue,
        tooltips: tooltips,
        ariaLabel: "Minimum",
        onDragEnd: this.onDragEnd
      }), range && /*#__PURE__*/React__default.createElement(Handle, {
        value: end,
        onChange: this.updateEnd,
        min: min + minRange,
        max: max,
        step: step,
        unit: unit,
        fixed: fixed,
        label: label,
        id: "".concat(id, "-handle-2"),
        handleNoop: this.handleNoop,
        sliderPos: sliderPos,
        direction: direction,
        getPositionFromValue: this.getPositionFromValue,
        tooltips: tooltips,
        ariaLabel: "Maximum",
        onDragEnd: this.onDragEnd
      }))));
    }
  }]);

  return Slider;
}(Component);

_defineProperty$g(Slider, "defaultProps", {
  start: 0,
  end: 100,
  min: 0,
  max: 100,
  step: 1,
  unit: '%',
  minRange: 0,
  fixed: 0,
  tooltips: false,
  range: false
});

function _defineProperty$f(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var spinnerSizes$2 = {
  small: 'sm',
  large: 'lg'
};

var Spinner$2 = function Spinner(props) {
  var size = props.size,
      style = props.style,
      className = props.className,
      _props$ariaLabel = props.ariaLabel,
      ariaLabel = _props$ariaLabel === void 0 ? "Wordt geladen" : _props$ariaLabel,
      qa = props.qa;
  var spinnerClass = classNames('a-spinner', className, _defineProperty$f({}, "a-spinner--".concat(spinnerSizes$2[size]), !!size));
  return /*#__PURE__*/React__default.createElement("div", {
    className: spinnerClass,
    style: style,
    role: "status",
    "aria-label": ariaLabel,
    "data-qa": qa
  });
};

function _classCallCheck$c(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$c(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$c(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$c(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$c(Constructor, staticProps);
  return Constructor;
}

function _defineProperty$e(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits$c(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$c(subClass, superClass);
}

function _getPrototypeOf$c(o) {
  _getPrototypeOf$c = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$c(o);
}

function _setPrototypeOf$c(o, p) {
  _setPrototypeOf$c = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$c(o, p);
}

function _isNativeReflectConstruct$c() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _objectWithoutPropertiesLoose$6(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties$6(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$6(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized$c(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn$c(self, call) {
  if (call && (_typeof$4(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized$c(self);
}

function _createSuper$c(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$c();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf$c(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$c(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn$c(this, result);
  };
}

var _excluded$6 = ["component", "children"];

var Link$4 = function Link(_ref) {
  var component = _ref.component,
      children = _ref.children,
      props = _objectWithoutProperties$6(_ref, _excluded$6);

  return /*#__PURE__*/React.createElement(component, props, children);
};

Link$4.defaultProps = {
  component: 'a'
};

var Breadcrumbs = /*#__PURE__*/function (_React$Component) {
  _inherits$c(Breadcrumbs, _React$Component);

  var _super = _createSuper$c(Breadcrumbs);

  function Breadcrumbs() {
    _classCallCheck$c(this, Breadcrumbs);

    return _super.apply(this, arguments);
  }

  _createClass$c(Breadcrumbs, [{
    key: "onClick",
    value: function onClick(event, item) {
      event.preventDefault();
      item.onClick();
    }
  }, {
    key: "renderItems",
    value: function renderItems() {
      var _this = this;

      var _this$props = this.props,
          items = _this$props.items,
          linkProps = _this$props.linkProps;
      return items.map(function (item, index) {
        return /*#__PURE__*/React__default.createElement("li", {
          key: item.name
        }, index >= items.length - 1 || !item.target && !item.onClick ? item.name : /*#__PURE__*/React__default.createElement(Link$4, linkProps({
          href: item.target || '#',
          onClick: item.onClick ? function (event) {
            return _this.onClick(event, item);
          } : null
        }), item.name));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          items = _this$props2.items,
          qa = _this$props2.qa;
      return items && items.length > 0 && /*#__PURE__*/React__default.createElement("ul", {
        className: "m-breadcrumbs",
        "data-qa": qa
      }, this.renderItems());
    }
  }]);

  return Breadcrumbs;
}(React__default.Component);

_defineProperty$e(Breadcrumbs, "defaultProps", {
  linkProps: function linkProps(src) {
    return src;
  }
});

function _classCallCheck$b(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$b(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$b(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$b(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$b(Constructor, staticProps);
  return Constructor;
}

function _defineProperty$d(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits$b(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$b(subClass, superClass);
}

function _getPrototypeOf$b(o) {
  _getPrototypeOf$b = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$b(o);
}

function _setPrototypeOf$b(o, p) {
  _setPrototypeOf$b = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$b(o, p);
}

function _isNativeReflectConstruct$b() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized$b(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn$b(self, call) {
  if (call && (_typeof$4(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized$b(self);
}

function _createSuper$b(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$b();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf$b(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$b(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn$b(this, result);
  };
}

var InputLabel$1 = function InputLabel(props) {
  var style = props.style,
      htmlFor = props.htmlFor,
      children = props.children,
      inline = props.inline,
      id = props.id,
      qa = props.qa;
  var labelClass = classNames('a-input__label', {
    'a-input__label--inline': !!inline
  });
  return /*#__PURE__*/React__default.createElement("label", {
    className: labelClass,
    htmlFor: htmlFor,
    style: style,
    id: id,
    "data-qa": qa
  }, children);
};

var Switch = /*#__PURE__*/function (_Component) {
  _inherits$b(Switch, _Component);

  var _super = _createSuper$b(Switch);

  function Switch() {
    var _this;

    _classCallCheck$b(this, Switch);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$d(_assertThisInitialized$b(_this), "state", {
      checked: _this.props.checked || false
    });

    return _this;
  }

  _createClass$b(Switch, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      // If we change the checked property, change our state
      if (prevProps.checked !== this.props.checked) {
        this.setState({
          checked: this.props.checked || false
        });
      }
    }
  }, {
    key: "onClick",
    value: function onClick(e) {
      this.setState({
        checked: !this.state.checked
      });

      if (this.props.onClick && typeof this.props.onClick === 'function') {
        this.props.onClick(e);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          id = _this$props.id,
          label = _this$props.label,
          labelTrue = _this$props.labelTrue,
          labelFalse = _this$props.labelFalse,
          disabled = _this$props.disabled,
          ariaLabel = _this$props.ariaLabel,
          qa = _this$props.qa;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "a-input",
        "data-qa": qa
      }, label && /*#__PURE__*/React__default.createElement(InputLabel$1, {
        htmlFor: id
      }, label), /*#__PURE__*/React__default.createElement("div", {
        className: "a-switch"
      }, /*#__PURE__*/React__default.createElement("button", {
        id: id,
        className: "a-switch__button",
        role: "switch",
        "aria-checked": this.state.checked,
        "aria-label": label || ariaLabel,
        disabled: disabled,
        onClick: function onClick(event) {
          return _this2.onClick(event);
        }
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "a-switch__off"
      }, labelFalse), /*#__PURE__*/React__default.createElement("span", {
        className: "a-switch__on"
      }, labelTrue))));
    }
  }]);

  return Switch;
}(Component);

function _classCallCheck$a(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$a(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$a(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$a(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$a(Constructor, staticProps);
  return Constructor;
}

function _defineProperty$c(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends$3() {
  _extends$3 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$3.apply(this, arguments);
}

function _inherits$a(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$a(subClass, superClass);
}

function _getPrototypeOf$a(o) {
  _getPrototypeOf$a = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$a(o);
}

function _setPrototypeOf$a(o, p) {
  _setPrototypeOf$a = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$a(o, p);
}

function _isNativeReflectConstruct$a() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _objectWithoutPropertiesLoose$5(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties$5(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$5(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized$a(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn$a(self, call) {
  if (call && (_typeof$4(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized$a(self);
}

function _createSuper$a(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$a();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf$a(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$a(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn$a(this, result);
  };
}

var _excluded$5 = ["component", "children"];

var Link$3 = function Link(_ref) {
  var component = _ref.component,
      children = _ref.children,
      props = _objectWithoutProperties$5(_ref, _excluded$5);

  return /*#__PURE__*/React.createElement(component, props, children);
};

Link$3.defaultProps = {
  component: 'a'
};

var Tabs = /*#__PURE__*/function (_React$Component) {
  _inherits$a(Tabs, _React$Component);

  var _super = _createSuper$a(Tabs);

  function Tabs() {
    _classCallCheck$a(this, Tabs);

    return _super.apply(this, arguments);
  }

  _createClass$a(Tabs, [{
    key: "renderItems",
    value: function renderItems() {
      var _this$props = this.props,
          items = _this$props.items,
          linkProps = _this$props.linkProps,
          ariaLabelActive = _this$props.ariaLabelActive;
      return items.map(function (item) {
        return /*#__PURE__*/React__default.createElement("li", {
          key: item.name
        }, /*#__PURE__*/React__default.createElement(Link$3, _extends$3({
          className: classNames({
            'is-active': item.active,
            'is-disabled': item.disabled
          })
        }, linkProps({
          href: item.target
        })), item.active ? /*#__PURE__*/React__default.createElement("span", {
          className: "u-screen-reader-only"
        }, ariaLabelActive) : '', item.name));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          align = _this$props2.align,
          items = _this$props2.items,
          qa = _this$props2.qa;
      var tabClasses = classNames('m-nav-tabs', {
        'm-nav-tabs--left': align === 'left',
        'm-nav-tabs--right': align === 'right'
      });
      return items && items.length > 0 && /*#__PURE__*/React__default.createElement("ul", {
        className: tabClasses,
        "data-qa": qa
      }, this.renderItems());
    }
  }]);

  return Tabs;
}(React__default.Component);

_defineProperty$c(Tabs, "defaultProps", {
  align: 'left',
  linkProps: function linkProps(src) {
    return src;
  },
  ariaLabelActive: 'Actief:'
});

var TagList = function TagList(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React__default.createElement("ul", {
    className: "o-tag-list"
  }, children);
};

function asyncGeneratorStep$8(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator$8(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep$8(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep$8(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck$9(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$9(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$9(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$9(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$9(Constructor, staticProps);
  return Constructor;
}

function _defineProperty$b(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits$9(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$9(subClass, superClass);
}

function _getPrototypeOf$9(o) {
  _getPrototypeOf$9 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$9(o);
}

function _setPrototypeOf$9(o, p) {
  _setPrototypeOf$9 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$9(o, p);
}

function _isNativeReflectConstruct$9() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized$9(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn$9(self, call) {
  if (call && (_typeof$4(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized$9(self);
}

function _createSuper$9(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$9();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf$9(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$9(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn$9(this, result);
  };
}

var Icon$8 = function Icon(_ref) {
  var name = _ref.name,
      style = _ref.style,
      className = _ref.className,
      ariaLabel = _ref.ariaLabel,
      onClick = _ref.onClick,
      src = _ref.src,
      qa = _ref.qa;
  /**
   * Inject SVG icons from core branding into page
   */

  var fetchAntwerpIcons = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator$8( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var xlinkHref, response, svgText, svgWrapper;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (fetch) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              _context.prev = 2;
              xlinkHref = 'https://cdn.antwerpen.be/core_branding_scss/5.0.0/assets/images/ai.svg';
              _context.next = 6;
              return fetch(xlinkHref);

            case 6:
              response = _context.sent;
              _context.next = 9;
              return response.text();

            case 9:
              svgText = _context.sent;
              svgWrapper = document.createElement('svg');
              svgWrapper.id = 'aiSvg';
              svgWrapper.innerHTML = svgText;

              if (!document.getElementById('aiSvg')) {
                document.body.appendChild(svgWrapper);
              }

              _context.next = 19;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](2);
              throw new Error(_context.t0);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 16]]);
    }));

    return function fetchAntwerpIcons() {
      return _ref2.apply(this, arguments);
    };
  }();

  if (typeof document !== 'undefined' && !document.getElementById('aiSvg')) {
    fetchAntwerpIcons();
  }

  var iconClass = classNames(className, name, 'ai');
  return /*#__PURE__*/React__default.createElement("span", {
    className: iconClass,
    style: style,
    "data-qa": qa,
    onClick: onClick
  }, name && /*#__PURE__*/React__default.createElement("svg", {
    "aria-hidden": "true"
  }, /*#__PURE__*/React__default.createElement("use", {
    href: "#".concat(name)
  })), src, ariaLabel && /*#__PURE__*/React__default.createElement("span", {
    className: "u-screen-reader-only"
  }, ariaLabel));
};

var sizeClasses$6 = {
  tiny: 'a-button--tiny',
  small: 'a-button--small',
  large: 'a-button--large'
};
var typeClasses$5 = {
  primary: '',
  secondary: 'a-button--secondary',
  success: 'a-button--success',
  warning: 'a-button--warning',
  danger: 'a-button--danger',
  transparent: 'a-button--transparent',
  default: 'a-button--default'
};

var Button$5 = /*#__PURE__*/function (_Component) {
  _inherits$9(Button, _Component);

  var _super = _createSuper$9(Button);

  function Button() {
    _classCallCheck$9(this, Button);

    return _super.apply(this, arguments);
  }

  _createClass$9(Button, [{
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props = this.props,
          id = _this$props.id,
          negative = _this$props.negative,
          outline = _this$props.outline,
          transparent = _this$props.transparent,
          className = _this$props.className,
          children = _this$props.children,
          icon = _this$props.icon,
          iconLeft = _this$props.iconLeft,
          iconRight = _this$props.iconRight,
          onClick = _this$props.onClick,
          _this$props$title = _this$props.title,
          title = _this$props$title === void 0 ? '' : _this$props$title,
          _this$props$ariaLabel = _this$props.ariaLabel,
          ariaLabel = _this$props$ariaLabel === void 0 ? '' : _this$props$ariaLabel,
          type = _this$props.type,
          size = _this$props.size,
          _this$props$block = _this$props.block,
          block = _this$props$block === void 0 ? false : _this$props$block,
          _this$props$style = _this$props.style,
          style = _this$props$style === void 0 ? {} : _this$props$style,
          _this$props$disabled = _this$props.disabled,
          disabled = _this$props$disabled === void 0 ? false : _this$props$disabled,
          htmlType = _this$props.htmlType,
          qa = _this$props.qa;
      var btnClass = classNames(className, (_classNames = {
        'a-button': !outline && !negative && !(type === 'default' && !!transparent)
      }, _defineProperty$b(_classNames, "".concat(typeClasses$5[type]), !!type), _defineProperty$b(_classNames, "".concat(sizeClasses$6[size]), !!size), _defineProperty$b(_classNames, 'has-icon', !!icon), _defineProperty$b(_classNames, 'has-icon-left', !!iconLeft), _defineProperty$b(_classNames, 'has-icon-right', !!iconRight), _defineProperty$b(_classNames, 'a-button-negative', !!negative), _defineProperty$b(_classNames, 'a-button-outline', !!outline), _defineProperty$b(_classNames, 'a-button-transparent', !!transparent), _defineProperty$b(_classNames, 'a-button--block', block), _classNames));
      return /*#__PURE__*/React__default.createElement("button", {
        id: id,
        className: btnClass,
        title: title || '',
        onClick: onClick,
        style: style,
        disabled: disabled,
        type: htmlType,
        "aria-label": ariaLabel,
        "data-qa": qa
      }, icon ? /*#__PURE__*/React__default.createElement(Icon$8, {
        name: icon
      }) : null, iconLeft ? /*#__PURE__*/React__default.createElement(Icon$8, {
        name: iconLeft
      }) : null, iconRight ? /*#__PURE__*/React__default.createElement(Icon$8, {
        name: iconRight
      }) : null, children);
    }
  }]);

  return Button;
}(Component);

var TagListItem = /*#__PURE__*/function (_Component) {
  _inherits$9(TagListItem, _Component);

  var _super = _createSuper$9(TagListItem);

  function TagListItem() {
    _classCallCheck$9(this, TagListItem);

    return _super.apply(this, arguments);
  }

  _createClass$9(TagListItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          value = _this$props.value,
          _this$props$closable = _this$props.closable,
          closable = _this$props$closable === void 0 ? false : _this$props$closable,
          _this$props$icon = _this$props.icon,
          icon = _this$props$icon === void 0 ? '' : _this$props$icon;
      _this$props.buttonClass;
      var onClick = _this$props.onClick,
          ariaLabelIcon = _this$props.ariaLabelIcon,
          _this$props$ariaLabel = _this$props.ariaLabelClose,
          ariaLabelClose = _this$props$ariaLabel === void 0 ? 'Sluiten' : _this$props$ariaLabel,
          qa = _this$props.qa;
      return /*#__PURE__*/React__default.createElement("li", {
        className: "m-tag",
        "data-qa": qa
      }, icon && /*#__PURE__*/React__default.createElement(Button$5, {
        size: "small",
        icon: icon,
        ariaLabel: ariaLabelIcon
      }), /*#__PURE__*/React__default.createElement("span", {
        className: "m-tag__label"
      }, value), closable && /*#__PURE__*/React__default.createElement(Button$5, {
        transparent: true,
        size: "small",
        type: "danger",
        icon: "ai-close",
        ariaLabel: ariaLabelClose,
        onClick: onClick
      }));
    }
  }]);

  return TagListItem;
}(Component);

function asyncGeneratorStep$7(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator$7(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep$7(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep$7(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck$8(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$8(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$8(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$8(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$8(Constructor, staticProps);
  return Constructor;
}

function _defineProperty$a(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits$8(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$8(subClass, superClass);
}

function _getPrototypeOf$8(o) {
  _getPrototypeOf$8 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$8(o);
}

function _setPrototypeOf$8(o, p) {
  _setPrototypeOf$8 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$8(o, p);
}

function _isNativeReflectConstruct$8() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized$8(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn$8(self, call) {
  if (call && (_typeof$4(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized$8(self);
}

function _createSuper$8(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$8();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf$8(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$8(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn$8(this, result);
  };
}

var Icon$7 = function Icon(_ref) {
  var name = _ref.name,
      style = _ref.style,
      className = _ref.className,
      ariaLabel = _ref.ariaLabel,
      onClick = _ref.onClick,
      src = _ref.src,
      qa = _ref.qa;
  /**
   * Inject SVG icons from core branding into page
   */

  var fetchAntwerpIcons = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator$7( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var xlinkHref, response, svgText, svgWrapper;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (fetch) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              _context.prev = 2;
              xlinkHref = 'https://cdn.antwerpen.be/core_branding_scss/5.0.0/assets/images/ai.svg';
              _context.next = 6;
              return fetch(xlinkHref);

            case 6:
              response = _context.sent;
              _context.next = 9;
              return response.text();

            case 9:
              svgText = _context.sent;
              svgWrapper = document.createElement('svg');
              svgWrapper.id = 'aiSvg';
              svgWrapper.innerHTML = svgText;

              if (!document.getElementById('aiSvg')) {
                document.body.appendChild(svgWrapper);
              }

              _context.next = 19;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](2);
              throw new Error(_context.t0);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 16]]);
    }));

    return function fetchAntwerpIcons() {
      return _ref2.apply(this, arguments);
    };
  }();

  if (typeof document !== 'undefined' && !document.getElementById('aiSvg')) {
    fetchAntwerpIcons();
  }

  var iconClass = classNames(className, name, 'ai');
  return /*#__PURE__*/React__default.createElement("span", {
    className: iconClass,
    style: style,
    "data-qa": qa,
    onClick: onClick
  }, name && /*#__PURE__*/React__default.createElement("svg", {
    "aria-hidden": "true"
  }, /*#__PURE__*/React__default.createElement("use", {
    href: "#".concat(name)
  })), src, ariaLabel && /*#__PURE__*/React__default.createElement("span", {
    className: "u-screen-reader-only"
  }, ariaLabel));
};

var sizeClasses$5 = {
  tiny: 'a-toggle--tiny',
  small: 'a-toggle--small',
  large: 'a-toggle--large'
};
var sizeBtnClasses = {
  tiny: 'a-button--tiny',
  small: 'a-button--small',
  large: 'a-button--large'
};

var Toggle = /*#__PURE__*/function (_Component) {
  _inherits$8(Toggle, _Component);

  var _super = _createSuper$8(Toggle);

  function Toggle(props) {
    var _this;

    _classCallCheck$8(this, Toggle);

    _this = _super.call(this, props);

    _defineProperty$a(_assertThisInitialized$8(_this), "handleChange", function (e) {
      _this.setState({
        checked: !_this.state.checked
      });

      if (_this.props.onChange && typeof _this.props.onChange === 'function') {
        _this.props.onChange(e);
      }

      if (_this.props.onClick && typeof _this.props.onClick === 'function') {
        _this.props.onClick(e);
      }
    });

    _this.state = {
      checked: props.checked || false
    };
    return _this;
  }

  _createClass$8(Toggle, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // check if checked changed
      if (this.props.checked !== prevProps.checked) {
        // check if state change is required
        if (this.props.checked !== this.state.checked) {
          // update state with new checked value
          this.setState({
            checked: this.props.checked
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames2, _classNames3;

      var _this$props = this.props,
          id = _this$props.id,
          size = _this$props.size,
          checkedLabel = _this$props.checkedLabel,
          checkedIcon = _this$props.checkedIcon,
          checkedButtonClass = _this$props.checkedButtonClass,
          uncheckedLabel = _this$props.uncheckedLabel,
          uncheckedIcon = _this$props.uncheckedIcon,
          uncheckedButtonClass = _this$props.uncheckedButtonClass,
          showLabels = _this$props.showLabels,
          qa = _this$props.qa;
      var toggleClass = classNames('a-toggle', _defineProperty$a({}, "".concat(sizeClasses$5[size]), !!size));
      var checkedClasses = classNames('a-toggle__on a-button', showLabels ? 'has-icon-left' : 'has-icon', (_classNames2 = {}, _defineProperty$a(_classNames2, "".concat(checkedButtonClass), checkedButtonClass), _defineProperty$a(_classNames2, "".concat(sizeBtnClasses[size]), !!size), _classNames2));
      var uncheckedClasses = classNames('a-toggle__off a-button', showLabels ? 'has-icon-left' : 'has-icon', (_classNames3 = {}, _defineProperty$a(_classNames3, "".concat(uncheckedButtonClass), uncheckedButtonClass), _defineProperty$a(_classNames3, "".concat(sizeBtnClasses[size]), !!size), _classNames3));
      return /*#__PURE__*/React__default.createElement("div", {
        className: toggleClass,
        "data-qa": qa
      }, /*#__PURE__*/React__default.createElement("button", {
        className: "a-toggle__button",
        id: id,
        "aria-expanded": this.state.checked,
        onClick: this.handleChange
      }, /*#__PURE__*/React__default.createElement("span", {
        className: checkedClasses
      }, /*#__PURE__*/React__default.createElement(Icon$7, {
        name: checkedIcon,
        ariaLabel: showLabels ? '' : checkedLabel
      }), showLabels && /*#__PURE__*/React__default.createElement("span", null, checkedLabel)), /*#__PURE__*/React__default.createElement("span", {
        className: uncheckedClasses
      }, /*#__PURE__*/React__default.createElement(Icon$7, {
        name: uncheckedIcon,
        ariaLabel: showLabels ? '' : uncheckedLabel
      }), showLabels && /*#__PURE__*/React__default.createElement("span", null, uncheckedLabel))));
    }
  }]);

  return Toggle;
}(Component);

_defineProperty$a(Toggle, "defaultProps", {
  id: 'toggle-normal',
  checked: false,
  checkedLabel: '',
  checkedIcon: 'ai-navigation-menu',
  checkedButtonClass: '',
  showLabels: true,
  uncheckedLabel: '',
  uncheckedIcon: 'ai-close',
  uncheckedButtonClass: 'a-button--danger'
});

function ___$insertStyle$2(css) {
  if (!css || typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');
  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

function asyncGeneratorStep$6(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator$6(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep$6(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep$6(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck$7(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$7(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$7(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$7(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$7(Constructor, staticProps);
  return Constructor;
}

function _defineProperty$9(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits$7(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$7(subClass, superClass);
}

function _getPrototypeOf$7(o) {
  _getPrototypeOf$7 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$7(o);
}

function _setPrototypeOf$7(o, p) {
  _setPrototypeOf$7 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$7(o, p);
}

function _isNativeReflectConstruct$7() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized$7(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn$7(self, call) {
  if (call && (_typeof$4(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized$7(self);
}

function _createSuper$7(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$7();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf$7(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$7(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn$7(this, result);
  };
}

var Icon$6 = function Icon(_ref) {
  var name = _ref.name,
      style = _ref.style,
      className = _ref.className,
      ariaLabel = _ref.ariaLabel,
      onClick = _ref.onClick,
      src = _ref.src,
      qa = _ref.qa;
  /**
   * Inject SVG icons from core branding into page
   */

  var fetchAntwerpIcons = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator$6( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var xlinkHref, response, svgText, svgWrapper;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (fetch) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              _context.prev = 2;
              xlinkHref = 'https://cdn.antwerpen.be/core_branding_scss/5.0.0/assets/images/ai.svg';
              _context.next = 6;
              return fetch(xlinkHref);

            case 6:
              response = _context.sent;
              _context.next = 9;
              return response.text();

            case 9:
              svgText = _context.sent;
              svgWrapper = document.createElement('svg');
              svgWrapper.id = 'aiSvg';
              svgWrapper.innerHTML = svgText;

              if (!document.getElementById('aiSvg')) {
                document.body.appendChild(svgWrapper);
              }

              _context.next = 19;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](2);
              throw new Error(_context.t0);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 16]]);
    }));

    return function fetchAntwerpIcons() {
      return _ref2.apply(this, arguments);
    };
  }();

  if (typeof document !== 'undefined' && !document.getElementById('aiSvg')) {
    fetchAntwerpIcons();
  }

  var iconClass = classNames(className, name, 'ai');
  return /*#__PURE__*/React__default.createElement("span", {
    className: iconClass,
    style: style,
    "data-qa": qa,
    onClick: onClick
  }, name && /*#__PURE__*/React__default.createElement("svg", {
    "aria-hidden": "true"
  }, /*#__PURE__*/React__default.createElement("use", {
    href: "#".concat(name)
  })), src, ariaLabel && /*#__PURE__*/React__default.createElement("span", {
    className: "u-screen-reader-only"
  }, ariaLabel));
};

var sizeClasses$1$1 = {
  small: 'a-avatar--small',
  medium: 'a-avatar--medium',
  large: 'a-avatar--large'
};

var IconWrapper = function IconWrapper(_ref) {
  var icon = _ref.icon;
  return /*#__PURE__*/React__default.createElement("span", {
    className: "a-avatar__icon"
  }, /*#__PURE__*/React__default.createElement(Icon$6, {
    name: icon
  }));
};

var LetterWrapper = function LetterWrapper(_ref2) {
  var letter = _ref2.letter;
  return /*#__PURE__*/React__default.createElement("span", {
    className: "a-avatar__letter"
  }, letter);
};

var Avatar = function Avatar(props) {
  var size = props.size,
      icon = props.icon,
      children = props.children,
      style = props.style,
      letter = props.letter,
      image = props.image,
      _props$alt = props.alt,
      alt = _props$alt === void 0 ? '' : _props$alt,
      className = props.className,
      qa = props.qa,
      _props$ariaLabel = props.ariaLabel,
      ariaLabel = _props$ariaLabel === void 0 ? 'Gebruiker icoon' : _props$ariaLabel;
  var avatarClass = classNames('a-avatar', _defineProperty$9({}, "".concat(sizeClasses$1$1[size]), !!size), className);
  return /*#__PURE__*/React__default.createElement("div", {
    className: avatarClass,
    style: style,
    "data-qa": qa
  }, icon && /*#__PURE__*/React__default.createElement(IconWrapper, {
    icon: icon
  }), letter && /*#__PURE__*/React__default.createElement(LetterWrapper, {
    letter: letter
  }), image && /*#__PURE__*/React__default.createElement("img", {
    src: image,
    alt: alt
  }), children, /*#__PURE__*/React__default.createElement("span", {
    className: "u-screen-reader-only"
  }, ariaLabel));
};

var sizeClasses$4 = {
  tiny: 'a-button--tiny',
  small: 'a-button--small',
  large: 'a-button--large'
};
var typeClasses$4 = {
  primary: '',
  secondary: 'a-button--secondary',
  success: 'a-button--success',
  warning: 'a-button--warning',
  danger: 'a-button--danger',
  transparent: 'a-button--transparent',
  default: 'a-button--default'
};

var Button$4 = /*#__PURE__*/function (_Component) {
  _inherits$7(Button, _Component);

  var _super = _createSuper$7(Button);

  function Button() {
    _classCallCheck$7(this, Button);

    return _super.apply(this, arguments);
  }

  _createClass$7(Button, [{
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props = this.props,
          id = _this$props.id,
          negative = _this$props.negative,
          outline = _this$props.outline,
          transparent = _this$props.transparent,
          className = _this$props.className,
          children = _this$props.children,
          icon = _this$props.icon,
          iconLeft = _this$props.iconLeft,
          iconRight = _this$props.iconRight,
          onClick = _this$props.onClick,
          _this$props$title = _this$props.title,
          title = _this$props$title === void 0 ? '' : _this$props$title,
          _this$props$ariaLabel = _this$props.ariaLabel,
          ariaLabel = _this$props$ariaLabel === void 0 ? '' : _this$props$ariaLabel,
          type = _this$props.type,
          size = _this$props.size,
          _this$props$block = _this$props.block,
          block = _this$props$block === void 0 ? false : _this$props$block,
          _this$props$style = _this$props.style,
          style = _this$props$style === void 0 ? {} : _this$props$style,
          _this$props$disabled = _this$props.disabled,
          disabled = _this$props$disabled === void 0 ? false : _this$props$disabled,
          htmlType = _this$props.htmlType,
          qa = _this$props.qa;
      var btnClass = classNames(className, (_classNames = {
        'a-button': !outline && !negative && !(type === 'default' && !!transparent)
      }, _defineProperty$9(_classNames, "".concat(typeClasses$4[type]), !!type), _defineProperty$9(_classNames, "".concat(sizeClasses$4[size]), !!size), _defineProperty$9(_classNames, 'has-icon', !!icon), _defineProperty$9(_classNames, 'has-icon-left', !!iconLeft), _defineProperty$9(_classNames, 'has-icon-right', !!iconRight), _defineProperty$9(_classNames, 'a-button-negative', !!negative), _defineProperty$9(_classNames, 'a-button-outline', !!outline), _defineProperty$9(_classNames, 'a-button-transparent', !!transparent), _defineProperty$9(_classNames, 'a-button--block', block), _classNames));
      return /*#__PURE__*/React__default.createElement("button", {
        id: id,
        className: btnClass,
        title: title || '',
        onClick: onClick,
        style: style,
        disabled: disabled,
        type: htmlType,
        "aria-label": ariaLabel,
        "data-qa": qa
      }, icon ? /*#__PURE__*/React__default.createElement(Icon$6, {
        name: icon
      }) : null, iconLeft ? /*#__PURE__*/React__default.createElement(Icon$6, {
        name: iconLeft
      }) : null, iconRight ? /*#__PURE__*/React__default.createElement(Icon$6, {
        name: iconRight
      }) : null, children);
    }
  }]);

  return Button;
}(Component);

var FlyoutContent$1 = function FlyoutContent(props) {
  var hasPadding = props.hasPadding,
      children = props.children,
      qa = props.qa;
  var classes = classNames('m-flyout__content', {
    'has-padding': !!hasPadding
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: classes,
    "data-qa": qa
  }, children);
};

var flyoutSizes$1 = {
  small: 'sm',
  medium: 'md',
  large: 'lg',
  full: 'full'
};

var Flyout = /*#__PURE__*/function (_Component) {
  _inherits$7(Flyout, _Component);

  var _super = _createSuper$7(Flyout);

  function Flyout() {
    var _this;

    _classCallCheck$7(this, Flyout);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$9(_assertThisInitialized$7(_this), "state", {
      isOpen: _this.props.open
    });

    _defineProperty$9(_assertThisInitialized$7(_this), "flyoutRef", /*#__PURE__*/React__default.createRef());

    _defineProperty$9(_assertThisInitialized$7(_this), "toggleIsOpen", function () {
      var onStateChange = _this.props.onStateChange;

      if (!_this.state.isOpen) {
        document.addEventListener('click', _this.handleOutsideClick, false);
      } else {
        document.removeEventListener('click', _this.handleOutsideClick, false);
      }

      _this.setState({
        isOpen: !_this.state.isOpen
      });

      onStateChange(_this.state.isOpen);
    });

    _defineProperty$9(_assertThisInitialized$7(_this), "closeFlyout", function () {
      var onStateChange = _this.props.onStateChange;

      if (!_this.state.isOpen) {
        document.addEventListener('click', _this.handleOutsideClick, false);
      } else {
        document.removeEventListener('click', _this.handleOutsideClick, false);
      }

      _this.setState({
        isOpen: false
      });

      onStateChange(false);
    });

    _defineProperty$9(_assertThisInitialized$7(_this), "handleOutsideClick", function (e) {
      var area = ReactDOM.findDOMNode(_this.flyoutRef.current);

      if (area && !area.contains(e.target)) {
        _this.closeFlyout();
      }
    });

    _defineProperty$9(_assertThisInitialized$7(_this), "getClassNames", function () {
      return classNames(_this.props.className, 'm-flyout', "m-flyout--".concat(_this.props.direction), _defineProperty$9({
        'is-open': _this.state.isOpen,
        'm-flyout--scrollable': _this.props.scrollable
      }, "m-flyout--".concat(flyoutSizes$1[_this.props.size]), !!flyoutSizes$1[_this.props.size]));
    });

    return _this;
  }

  _createClass$7(Flyout, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var isOpen = this.state.isOpen;

      if (isOpen) {
        document.addEventListener('click', this.handleOutsideClick, false);
      }

      this.props.triggerClose(this.closeFlyout);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.handleOutsideClick, false);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.open !== prevProps.open) {
        this.setState({
          isOpen: !prevProps.open
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          trigger = _this$props.trigger,
          hasPadding = _this$props.hasPadding,
          children = _this$props.children,
          qa = _this$props.qa;
      var open = this.state.open;
      var flyoutClass = this.getClassNames();
      return trigger && /*#__PURE__*/React__default.createElement("div", {
        className: flyoutClass,
        ref: this.flyoutRef,
        "aria-haspopup": "true",
        "aria-expanded": open,
        "data-qa": qa
      }, /*#__PURE__*/React__default.createElement("div", {
        onClick: this.toggleIsOpen
      }, this.props.trigger), /*#__PURE__*/React__default.createElement(FlyoutContent$1, {
        hasPadding: hasPadding
      }, children));
    }
  }]);

  return Flyout;
}(Component);

_defineProperty$9(Flyout, "defaultProps", {
  direction: 'left',
  size: 'medium',
  hasPadding: false,
  open: false,
  onStateChange: function onStateChange() {},
  triggerClose: function triggerClose() {},
  scrollable: false
});

var ENV_IDENTIFIERS$1 = {
  dev: '-o.',
  acc: '-a.',
  local: 'local'
};

function getEnvironment$1() {
  if (typeof window === 'undefined') {
    return process.env.NODE_ENV;
  }

  var currentUrl = window.location.href;
  var env = Object.keys(ENV_IDENTIFIERS$1).find(function (key) {
    return currentUrl.includes(ENV_IDENTIFIERS$1[key]);
  });
  return env || 'prod';
}

function getAstadUrl$1() {
  switch (getEnvironment$1().toLowerCase()) {
    case 'local':
      return 'https://www.dev.dcs.antwerpen.be';

    case 'dev':
      return 'https://www.dev.dcs.antwerpen.be';

    case 'acc':
      return 'https://www.acc.dcs.antwerpen.be';

    default:
      return 'https://www.antwerpen.be';
  }
}

function getShoppingCartUrl$1() {
  switch (getEnvironment$1().toLowerCase()) {
    case 'local':
      return 'https://winkelmand-o.antwerpen.be';

    case 'dev':
      return 'https://winkelmand-o.antwerpen.be';

    case 'acc':
      return 'https://winkelmand-a.antwerpen.be';

    default:
      return 'https://winkelmand.antwerpen.be';
  }
}

function getEloketUrl$1() {
  switch (getEnvironment$1().toLowerCase()) {
    case 'local':
      return 'https://eloket-o.antwerpen.be';

    case 'dev':
      return 'https://eloket-o.antwerpen.be';

    case 'acc':
      return 'https://eloket-a.antwerpen.be';

    default:
      return 'https://eloket.antwerpen.be';
  }
}

var Environment$1 = {
  getEnvironment: getEnvironment$1,
  getAstadUrl: getAstadUrl$1,
  getShoppingCartUrl: getShoppingCartUrl$1,
  getEloketUrl: getEloketUrl$1
};

var notificationsUrl = function notificationsUrl() {
  return "".concat(Environment$1.getAstadUrl(), "/nl/voorkeuren/notificaties");
};

var aProfileUrl = function aProfileUrl() {
  return "".concat(Environment$1.getAstadUrl(), "/nl/voorkeuren/profiel");
};

var favoritesUrl = function favoritesUrl() {
  return "".concat(Environment$1.getAstadUrl(), "/nl/overzicht");
};

var linkingUrl = function linkingUrl() {
  return "".concat(Environment$1.getAstadUrl(), "/nl/voorkeuren/koppelingen");
};

var myEloketUrl = function myEloketUrl() {
  return "".concat(Environment$1.getEloketUrl(), "/nl/eloket/mijnloket/context/burger/aanvragen");
};

var UserNavigation = function UserNavigation(props) {
  var children = props.children,
      _props$notificationsC = props.notificationsCount,
      notificationsCount = _props$notificationsC === void 0 ? '' : _props$notificationsC;
  return /*#__PURE__*/React__default.createElement("ul", {
    className: "m-nav-list m-nav-list--left"
  }, /*#__PURE__*/React__default.createElement("li", null, /*#__PURE__*/React__default.createElement("a", {
    href: notificationsUrl(),
    title: "Notificaties",
    alt: "Klik hier om uw notificaties te bekijken."
  }, "Notificaties", notificationsCount > 0 && /*#__PURE__*/React__default.createElement("span", null, " (", notificationsCount, ")"))), /*#__PURE__*/React__default.createElement("li", null, /*#__PURE__*/React__default.createElement("a", {
    href: aProfileUrl(),
    title: "A-profiel beheren",
    alt: "Hier krijgt u toegang tot uw A-profiel en uw persoonlijke instellingen."
  }, "A-profiel beheren")), /*#__PURE__*/React__default.createElement("li", null, /*#__PURE__*/React__default.createElement("a", {
    href: favoritesUrl(),
    title: "Favorieten",
    alt: "Klik hier om uw favorieten te bekijken."
  }, "Favorieten")), /*#__PURE__*/React__default.createElement("li", null, /*#__PURE__*/React__default.createElement("a", {
    href: linkingUrl(),
    title: "Koppelingen",
    alt: "Klik hier om uw eID, A-kaart en meer te koppelen."
  }, "Koppelingen")), /*#__PURE__*/React__default.createElement("li", null, /*#__PURE__*/React__default.createElement("a", {
    href: myEloketUrl(),
    title: "Mijn e-loket",
    alt: "Mijn e-loket"
  }, "Mijn e-loket")), children);
};

___$insertStyle$2(".m-user-menu-flyout {\n  display: inline-block;\n  position: relative;\n}\n.m-user-menu-flyout .a-avatar-wrapper {\n  align-items: center;\n  display: flex;\n}\n.m-user-menu-flyout .a-button__avatar {\n  padding-bottom: 0;\n  padding-top: 0;\n}\n.m-user-menu-flyout .a-badge {\n  bottom: -0.5625rem;\n  left: 1.5rem;\n  position: absolute;\n  transform: translateX(-50%);\n  z-index: 10;\n}");

var UserMenu = /*#__PURE__*/function (_Component) {
  _inherits$7(UserMenu, _Component);

  var _super = _createSuper$7(UserMenu);

  function UserMenu() {
    _classCallCheck$7(this, UserMenu);

    return _super.apply(this, arguments);
  }

  _createClass$7(UserMenu, [{
    key: "onLogin",
    value: function onLogin() {
      var _this$props = this.props,
          loginUrl = _this$props.loginUrl,
          onClickLogin = _this$props.onClickLogin;

      if (onClickLogin) {
        return onClickLogin();
      }

      window.location.href = loginUrl;
    }
  }, {
    key: "onLogout",
    value: function onLogout() {
      var _this$props2 = this.props,
          logoutUrl = _this$props2.logoutUrl,
          onClickLogout = _this$props2.onClickLogout;

      if (onClickLogout) {
        return onClickLogout();
      }

      window.location.href = logoutUrl;
    }
  }, {
    key: "renderAvatar",
    value: function renderAvatar() {
      var avatarUrl = this.props.user.avatarUrl;
      return /*#__PURE__*/React__default.createElement(Avatar, {
        image: avatarUrl,
        icon: avatarUrl ? null : 'ai-single-neutral',
        alt: "avatar",
        width: "48",
        height: "48",
        style: {
          marginLeft: '-1.5rem',
          marginRight: '1.5rem'
        }
      });
    }
  }, {
    key: "renderBadge",
    value: function renderBadge() {
      var notificationsCount = this.props.notificationsCount;
      return /*#__PURE__*/React__default.createElement("a", {
        className: "a-badge a-badge--warning",
        href: notificationsUrl()
      }, notificationsCount, /*#__PURE__*/React__default.createElement("span", {
        className: "u-screen-reader-only",
        "data-translate": ""
      }, " notificaties"));
    }
  }, {
    key: "renderLoggedInButton",
    value: function renderLoggedInButton() {
      var _this$props$user = this.props.user,
          firstName = _this$props$user.firstName,
          lastName = _this$props$user.lastName;
      return /*#__PURE__*/React__default.createElement(Button$4, {
        className: "a-button-negative a-button__avatar o-header__button"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "a-avatar-wrapper"
      }, this.renderAvatar(), /*#__PURE__*/React__default.createElement("p", null, firstName, "\xA0", lastName)));
    }
  }, {
    key: "renderProfile",
    value: function renderProfile() {
      var _this$props$user2 = this.props.user,
          firstName = _this$props$user2.firstName,
          lastName = _this$props$user2.lastName,
          avatarUrl = _this$props$user2.avatarUrl;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "u-text-center u-margin-top"
      }, /*#__PURE__*/React__default.createElement(Avatar, {
        image: avatarUrl,
        icon: avatarUrl ? null : 'ai-single-neutral',
        alt: "avatar",
        width: "48",
        height: "48"
      }), /*#__PURE__*/React__default.createElement("p", {
        className: "u-margin-top-xs u-margin-bottom h5"
      }, "".concat(firstName, " ").concat(lastName)));
    }
  }, {
    key: "renderLoggedIn",
    value: function renderLoggedIn() {
      var _this = this;

      var _this$props3 = this.props,
          children = _this$props3.children,
          flyoutSize = _this$props3.flyoutSize,
          notificationsCount = _this$props3.notificationsCount,
          ariaLogout = _this$props3.ariaLogout;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "m-user-menu-flyout"
      }, notificationsCount > 0 && this.renderBadge(), /*#__PURE__*/React__default.createElement(Flyout, {
        trigger: this.renderLoggedInButton(),
        direction: "right",
        hasPadding: false,
        size: flyoutSize
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "u-margin"
      }, this.renderProfile(), !this.props.hideExternalLinks && /*#__PURE__*/React__default.createElement(UserNavigation, {
        notificationsCount: notificationsCount,
        children: children
      }), /*#__PURE__*/React__default.createElement(Button$4, {
        className: "u-margin-top",
        onClick: function onClick(e) {
          return _this.onLogout();
        },
        block: true,
        type: "danger",
        iconLeft: "power-off"
      }, ariaLogout))));
    }
  }, {
    key: "renderLoggedOut",
    value: function renderLoggedOut() {
      var _this2 = this;

      var _this$props4 = this.props;
      _this$props4.children;
      _this$props4.flyoutSize;
      _this$props4.notificationsCount;
      var ariaLogin = _this$props4.ariaLogin;
      return /*#__PURE__*/React__default.createElement(Button$4, {
        className: "a-button-negative o-header__button",
        onClick: function onClick(e) {
          return _this2.onLogin();
        },
        iconLeft: "ai-single-neutral"
      }, ariaLogin);
    }
  }, {
    key: "render",
    value: function render() {
      var qa = this.props.qa;
      return /*#__PURE__*/React__default.createElement("div", {
        style: {
          textAlign: this.props.direction
        },
        "data-qa": qa
      }, this.props.loggedIn ? this.renderLoggedIn() : this.renderLoggedOut());
    }
  }]);

  return UserMenu;
}(Component);

_defineProperty$9(UserMenu, "defaultProps", {
  direction: 'right',
  flyoutSize: 'small',
  notificationsCount: 0,
  ariaLogin: 'Aanmelden',
  ariaLogout: 'Afmelden'
});

var Accordion = function Accordion(_ref) {
  var children = _ref.children,
      qa = _ref.qa;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "m-accordion",
    "data-qa": qa
  }, children);
};

Accordion.defaultProps = {
  children: null
};

function _classCallCheck$6(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$6(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$6(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$6(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$6(Constructor, staticProps);
  return Constructor;
}

function _defineProperty$8(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits$6(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$6(subClass, superClass);
}

function _getPrototypeOf$6(o) {
  _getPrototypeOf$6 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$6(o);
}

function _setPrototypeOf$6(o, p) {
  _setPrototypeOf$6 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$6(o, p);
}

function _isNativeReflectConstruct$6() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized$6(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn$6(self, call) {
  if (call && (_typeof$4(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized$6(self);
}

function _createSuper$6(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$6();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf$6(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$6(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn$6(this, result);
  };
}

var AccordionTab = /*#__PURE__*/function (_React$Component) {
  _inherits$6(AccordionTab, _React$Component);

  var _super = _createSuper$6(AccordionTab);

  function AccordionTab() {
    var _this;

    _classCallCheck$6(this, AccordionTab);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$8(_assertThisInitialized$6(_this), "state", {
      isOpen: _this.props.open
    });

    return _this;
  }

  _createClass$6(AccordionTab, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.open !== prevProps.open) {
        this.setState({
          isOpen: this.props.open
        });
      }
    }
  }, {
    key: "toggle",
    value: function toggle(e) {
      if (this.props.toggle) return this.props.toggle(e);
      var isOpen = this.state.isOpen;
      this.setState({
        isOpen: !isOpen
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          qa = _this$props.qa;
      var isOpen = this.state.isOpen;
      return /*#__PURE__*/React__default.createElement("div", {
        role: "button",
        tabIndex: "0",
        "data-qa": qa,
        onKeyPress: function onKeyPress(e) {
          return _this2.toggle(e);
        },
        onClick: function onClick(e) {
          return _this2.toggle(e);
        },
        className: classNames('m-accordion__tab', {
          'is-open': isOpen
        }),
        "aria-expanded": isOpen
      }, children);
    }
  }]);

  return AccordionTab;
}(React__default.Component);

_defineProperty$8(AccordionTab, "defaultProps", {
  open: false
});

var AccordionTabContent = function AccordionTabContent(_ref) {
  var children = _ref.children,
      qa = _ref.qa;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "m-accordion__content",
    "data-qa": qa
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "u-margin"
  }, children));
};

var AccordionTabHeader = function AccordionTabHeader(_ref) {
  var children = _ref.children,
      qa = _ref.qa;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "m-accordion__header",
    "data-qa": qa
  }, children);
};

function _objectWithoutPropertiesLoose$4(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties$4(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$4(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var _excluded$4 = ["component", "children"];

var Link$2 = function Link(_ref) {
  var component = _ref.component,
      children = _ref.children,
      props = _objectWithoutProperties$4(_ref, _excluded$4);

  return /*#__PURE__*/React.createElement(component, props, children);
};

Link$2.defaultProps = {
  component: 'a'
};

function asyncGeneratorStep$5(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator$5(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep$5(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep$5(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck$5(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$5(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$5(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$5(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$5(Constructor, staticProps);
  return Constructor;
}

function _defineProperty$7(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends$2() {
  _extends$2 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$2.apply(this, arguments);
}

function _inherits$5(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$5(subClass, superClass);
}

function _getPrototypeOf$5(o) {
  _getPrototypeOf$5 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$5(o);
}

function _setPrototypeOf$5(o, p) {
  _setPrototypeOf$5 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$5(o, p);
}

function _isNativeReflectConstruct$5() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized$5(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn$5(self, call) {
  if (call && (_typeof$4(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized$5(self);
}

function _createSuper$5(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$5();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf$5(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$5(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn$5(this, result);
  };
}

var Icon$5 = function Icon(_ref) {
  var name = _ref.name,
      style = _ref.style,
      className = _ref.className,
      ariaLabel = _ref.ariaLabel,
      onClick = _ref.onClick,
      src = _ref.src,
      qa = _ref.qa;
  /**
   * Inject SVG icons from core branding into page
   */

  var fetchAntwerpIcons = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator$5( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var xlinkHref, response, svgText, svgWrapper;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (fetch) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              _context.prev = 2;
              xlinkHref = 'https://cdn.antwerpen.be/core_branding_scss/5.0.0/assets/images/ai.svg';
              _context.next = 6;
              return fetch(xlinkHref);

            case 6:
              response = _context.sent;
              _context.next = 9;
              return response.text();

            case 9:
              svgText = _context.sent;
              svgWrapper = document.createElement('svg');
              svgWrapper.id = 'aiSvg';
              svgWrapper.innerHTML = svgText;

              if (!document.getElementById('aiSvg')) {
                document.body.appendChild(svgWrapper);
              }

              _context.next = 19;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](2);
              throw new Error(_context.t0);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 16]]);
    }));

    return function fetchAntwerpIcons() {
      return _ref2.apply(this, arguments);
    };
  }();

  if (typeof document !== 'undefined' && !document.getElementById('aiSvg')) {
    fetchAntwerpIcons();
  }

  var iconClass = classNames(className, name, 'ai');
  return /*#__PURE__*/React__default.createElement("span", {
    className: iconClass,
    style: style,
    "data-qa": qa,
    onClick: onClick
  }, name && /*#__PURE__*/React__default.createElement("svg", {
    "aria-hidden": "true"
  }, /*#__PURE__*/React__default.createElement("use", {
    href: "#".concat(name)
  })), src, ariaLabel && /*#__PURE__*/React__default.createElement("span", {
    className: "u-screen-reader-only"
  }, ariaLabel));
};

var sizeClasses$3 = {
  tiny: 'a-button--tiny',
  small: 'a-button--small',
  large: 'a-button--large'
};
var typeClasses$3 = {
  primary: '',
  secondary: 'a-button--secondary',
  success: 'a-button--success',
  warning: 'a-button--warning',
  danger: 'a-button--danger',
  transparent: 'a-button--transparent',
  default: 'a-button--default'
};

var Button$3 = /*#__PURE__*/function (_Component) {
  _inherits$5(Button, _Component);

  var _super = _createSuper$5(Button);

  function Button() {
    _classCallCheck$5(this, Button);

    return _super.apply(this, arguments);
  }

  _createClass$5(Button, [{
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props = this.props,
          id = _this$props.id,
          negative = _this$props.negative,
          outline = _this$props.outline,
          transparent = _this$props.transparent,
          className = _this$props.className,
          children = _this$props.children,
          icon = _this$props.icon,
          iconLeft = _this$props.iconLeft,
          iconRight = _this$props.iconRight,
          onClick = _this$props.onClick,
          _this$props$title = _this$props.title,
          title = _this$props$title === void 0 ? '' : _this$props$title,
          _this$props$ariaLabel = _this$props.ariaLabel,
          ariaLabel = _this$props$ariaLabel === void 0 ? '' : _this$props$ariaLabel,
          type = _this$props.type,
          size = _this$props.size,
          _this$props$block = _this$props.block,
          block = _this$props$block === void 0 ? false : _this$props$block,
          _this$props$style = _this$props.style,
          style = _this$props$style === void 0 ? {} : _this$props$style,
          _this$props$disabled = _this$props.disabled,
          disabled = _this$props$disabled === void 0 ? false : _this$props$disabled,
          htmlType = _this$props.htmlType,
          qa = _this$props.qa;
      var btnClass = classNames(className, (_classNames = {
        'a-button': !outline && !negative && !(type === 'default' && !!transparent)
      }, _defineProperty$7(_classNames, "".concat(typeClasses$3[type]), !!type), _defineProperty$7(_classNames, "".concat(sizeClasses$3[size]), !!size), _defineProperty$7(_classNames, 'has-icon', !!icon), _defineProperty$7(_classNames, 'has-icon-left', !!iconLeft), _defineProperty$7(_classNames, 'has-icon-right', !!iconRight), _defineProperty$7(_classNames, 'a-button-negative', !!negative), _defineProperty$7(_classNames, 'a-button-outline', !!outline), _defineProperty$7(_classNames, 'a-button-transparent', !!transparent), _defineProperty$7(_classNames, 'a-button--block', block), _classNames));
      return /*#__PURE__*/React__default.createElement("button", {
        id: id,
        className: btnClass,
        title: title || '',
        onClick: onClick,
        style: style,
        disabled: disabled,
        type: htmlType,
        "aria-label": ariaLabel,
        "data-qa": qa
      }, icon ? /*#__PURE__*/React__default.createElement(Icon$5, {
        name: icon
      }) : null, iconLeft ? /*#__PURE__*/React__default.createElement(Icon$5, {
        name: iconLeft
      }) : null, iconRight ? /*#__PURE__*/React__default.createElement(Icon$5, {
        name: iconRight
      }) : null, children);
    }
  }]);

  return Button;
}(Component);

var sizes = {
  normal: '',
  large: 'm-modal--large'
};

var Modal = /*#__PURE__*/function (_React$Component) {
  _inherits$5(Modal, _React$Component);

  var _super = _createSuper$5(Modal);

  function Modal(props) {
    var _this;

    _classCallCheck$5(this, Modal);

    _this = _super.call(this, props);

    _defineProperty$7(_assertThisInitialized$5(_this), "state", {
      showModal: false
    });

    _this.handleToggleModal = _this.handleToggleModal.bind(_assertThisInitialized$5(_this));
    _this.handleConfirm = _this.handleConfirm.bind(_assertThisInitialized$5(_this));
    _this.handleDeny = _this.handleDeny.bind(_assertThisInitialized$5(_this));
    _this.handleRequestClose = _this.handleRequestClose.bind(_assertThisInitialized$5(_this));
    var appElement = props.appElement,
        ariaHideApp = props.ariaHideApp;

    if (!Modal.appElement && ariaHideApp) {
      Modal.appElement = appElement;
      ReactModal.setAppElement(appElement);
    }

    return _this;
  }

  _createClass$5(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var openOnInit = this.props.openOnInit;
      this.handleToggleModal(!!openOnInit);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var showModal = this.state.showModal;
      var onAfterOpen = this.props.onAfterOpen;

      if (showModal) {
        Promise.resolve(onAfterOpen());
      }
    }
  }, {
    key: "handleToggleModal",
    value: function handleToggleModal(show) {
      var showModal = this.state.showModal;
      this.setState({
        showModal: show !== undefined ? show : !showModal
      });
    }
  }, {
    key: "handleConfirm",
    value: function handleConfirm() {
      var _this2 = this;

      var onConfirm = this.props.onConfirm;
      Promise.resolve(onConfirm()).then(function () {
        return _this2.handleToggleModal(false);
      });
    }
  }, {
    key: "handleDeny",
    value: function handleDeny() {
      var _this3 = this;

      var onDeny = this.props.onDeny;
      Promise.resolve(onDeny()).then(function () {
        return _this3.handleToggleModal(false);
      });
    }
  }, {
    key: "handleRequestClose",
    value: function handleRequestClose() {
      var _this4 = this;

      var onRequestClose = this.props.onRequestClose;
      Promise.resolve(onRequestClose()).then(function () {
        return _this4.handleToggleModal(false);
      });
    }
  }, {
    key: "addProps",
    value: function addProps(Comp, props) {
      return /*#__PURE__*/React__default.createElement(Comp.type, _extends$2({}, Comp.props, props));
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var showModal = this.state.showModal;
      var _this$props = this.props;
      _this$props.appElement;
      var children = _this$props.children;
      _this$props.onRequestClose;
      var title = _this$props.title,
          hasCloseButton = _this$props.hasCloseButton,
          confirmElm = _this$props.confirmElm,
          confirmText = _this$props.confirmText,
          denyElm = _this$props.denyElm,
          denyText = _this$props.denyText,
          className = _this$props.className,
          overlayClassName = _this$props.overlayClassName,
          triggerElm = _this$props.triggerElm,
          triggerText = _this$props.triggerText,
          size = _this$props.size,
          ariaHideApp = _this$props.ariaHideApp,
          ariaCloseLabel = _this$props.ariaCloseLabel,
          onConfirm = _this$props.onConfirm,
          onDeny = _this$props.onDeny,
          onAfterOpen = _this$props.onAfterOpen,
          openOnInit = _this$props.openOnInit,
          qa = _this$props.qa;
      var modalTrigger = triggerElm ? this.addProps(triggerElm, {
        onClick: function onClick() {
          return _this5.handleToggleModal(true);
        }
      }) : /*#__PURE__*/React__default.createElement(Button$3, {
        type: "primary",
        onClick: function onClick() {
          return _this5.handleToggleModal(true);
        }
      }, triggerText);
      var confirmTrigger = confirmElm ? this.addProps(confirmElm, {
        onClick: this.handleConfirm
      }) : /*#__PURE__*/React__default.createElement(Button$3, {
        className: "m-modal__confirm",
        onClick: this.handleConfirm
      }, confirmText);
      var denyTrigger = denyElm ? this.addProps(denyElm, {
        onClick: this.handleDeny
      }) : /*#__PURE__*/React__default.createElement(Button$3, {
        className: "m-modal__deny",
        outline: true,
        onClick: this.handleDeny
      }, denyText);
      var sizeClass = sizes[size];
      var showConfirm = confirmElm || confirmText;
      var showDeny = denyElm || denyText;
      var showFooter = showConfirm || showDeny;
      return /*#__PURE__*/React__default.createElement("div", null, modalTrigger, /*#__PURE__*/React__default.createElement(ReactModal, {
        bodyOpenClassName: "u-modal-open",
        htmlOpenClassName: "u-modal-open",
        isOpen: showModal,
        onRequestClose: this.handleRequestClose,
        role: "modal",
        "aria-modal": "true",
        className: classNames('m-modal', sizeClass, className),
        overlayClassName: classNames('m-overlay', 'is-active', overlayClassName),
        "data-qa": qa,
        ariaHideApp: ariaHideApp,
        onConfirm: onConfirm,
        onDeny: onDeny,
        onAfterOpen: onAfterOpen,
        openOnInit: openOnInit
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "m-modal__content"
      }, (title || hasCloseButton) && /*#__PURE__*/React__default.createElement("div", {
        className: "m-modal__header u-margin-bottom-xs"
      }, title && /*#__PURE__*/React__default.createElement("h6", null, title), hasCloseButton && /*#__PURE__*/React__default.createElement(Button$3, {
        className: "m-modal__close",
        icon: "ai-close",
        ariaLabel: ariaCloseLabel,
        type: "default",
        transparent: true,
        onClick: function onClick() {
          return _this5.handleRequestClose();
        }
      })), children && /*#__PURE__*/React__default.createElement("div", {
        className: "u-margin-bottom"
      }, children), showFooter && /*#__PURE__*/React__default.createElement("div", {
        className: "m-modal__footer"
      }, showConfirm && confirmTrigger, showDeny && denyTrigger))));
    }
  }]);

  return Modal;
}(React__default.Component);

_defineProperty$7(Modal, "defaultProps", {
  appElement: '#root',
  ariaHideApp: true,
  ariaCloseLabel: 'Sluiten',
  hasCloseButton: true,
  title: '',
  confirmElm: null,
  confirmText: 'Ja',
  denyElm: null,
  denyText: 'Nee',
  triggerElm: null,
  triggerText: 'Open',
  className: '',
  overlayClassName: '',
  size: 'normal',
  onConfirm: function onConfirm() {},
  onDeny: function onDeny() {},
  onRequestClose: function onRequestClose() {},
  onAfterOpen: function onAfterOpen() {},
  openOnInit: false
});

function asyncGeneratorStep$4(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator$4(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep$4(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep$4(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck$4(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$4(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$4(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$4(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$4(Constructor, staticProps);
  return Constructor;
}

function _defineProperty$6(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits$4(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$4(subClass, superClass);
}

function _getPrototypeOf$4(o) {
  _getPrototypeOf$4 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$4(o);
}

function _setPrototypeOf$4(o, p) {
  _setPrototypeOf$4 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$4(o, p);
}

function _isNativeReflectConstruct$4() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _objectWithoutPropertiesLoose$3(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties$3(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$3(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized$4(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn$4(self, call) {
  if (call && (_typeof$4(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized$4(self);
}

function _createSuper$4(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$4();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf$4(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$4(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn$4(this, result);
  };
}

var _excluded$3 = ["component", "children"];

var Link$1 = function Link(_ref) {
  var component = _ref.component,
      children = _ref.children,
      props = _objectWithoutProperties$3(_ref, _excluded$3);

  return /*#__PURE__*/React.createElement(component, props, children);
};

Link$1.defaultProps = {
  component: 'a'
};

var Icon$4 = function Icon(_ref) {
  var name = _ref.name,
      style = _ref.style,
      className = _ref.className,
      ariaLabel = _ref.ariaLabel,
      onClick = _ref.onClick,
      src = _ref.src,
      qa = _ref.qa;
  /**
   * Inject SVG icons from core branding into page
   */

  var fetchAntwerpIcons = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator$4( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var xlinkHref, response, svgText, svgWrapper;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (fetch) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              _context.prev = 2;
              xlinkHref = 'https://cdn.antwerpen.be/core_branding_scss/5.0.0/assets/images/ai.svg';
              _context.next = 6;
              return fetch(xlinkHref);

            case 6:
              response = _context.sent;
              _context.next = 9;
              return response.text();

            case 9:
              svgText = _context.sent;
              svgWrapper = document.createElement('svg');
              svgWrapper.id = 'aiSvg';
              svgWrapper.innerHTML = svgText;

              if (!document.getElementById('aiSvg')) {
                document.body.appendChild(svgWrapper);
              }

              _context.next = 19;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](2);
              throw new Error(_context.t0);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 16]]);
    }));

    return function fetchAntwerpIcons() {
      return _ref2.apply(this, arguments);
    };
  }();

  if (typeof document !== 'undefined' && !document.getElementById('aiSvg')) {
    fetchAntwerpIcons();
  }

  var iconClass = classNames(className, name, 'ai');
  return /*#__PURE__*/React__default.createElement("span", {
    className: iconClass,
    style: style,
    "data-qa": qa,
    onClick: onClick
  }, name && /*#__PURE__*/React__default.createElement("svg", {
    "aria-hidden": "true"
  }, /*#__PURE__*/React__default.createElement("use", {
    href: "#".concat(name)
  })), src, ariaLabel && /*#__PURE__*/React__default.createElement("span", {
    className: "u-screen-reader-only"
  }, ariaLabel));
};

var Pagination$1 = /*#__PURE__*/function (_Component) {
  _inherits$4(Pagination, _Component);

  var _super = _createSuper$4(Pagination);

  function Pagination(props) {
    var _this;

    _classCallCheck$4(this, Pagination);

    _this = _super.call(this, props);

    _defineProperty$6(_assertThisInitialized$4(_this), "onPrev", function (e) {
      e.preventDefault();
      var currentPage = _this.state.currentPage;

      if (currentPage > 1) {
        _this.onChange(currentPage - 1);
      }

      return false;
    });

    _defineProperty$6(_assertThisInitialized$4(_this), "onNext", function (e) {
      e.preventDefault();
      var _this$state = _this.state,
          currentPage = _this$state.currentPage,
          totalPages = _this$state.totalPages;

      if (currentPage < totalPages) {
        _this.onChange(currentPage + 1);
      }

      return false;
    });

    _this.state = _this.setValues();
    return _this;
  }

  _createClass$4(Pagination, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.currentPage !== this.props.currentPage || prevProps.itemsPerPage !== this.props.itemsPerPage || prevProps.totalValues !== this.props.totalValues) {
        this.setState(this.setValues);
      }
    }
  }, {
    key: "onChange",
    value: function onChange(i, e) {
      if (e) {
        e.preventDefault();
      }

      var onUpdate = this.props.onUpdate;
      var parsedValue = parseInt(i, 10); // input from numbers array is a string

      if (parsedValue && onUpdate) {
        onUpdate(parsedValue);
      }

      return false;
    }
  }, {
    key: "setValues",
    value: function setValues() {
      var _this$props = this.props,
          totalValues = _this$props.totalValues,
          itemsPerPage = _this$props.itemsPerPage,
          currentPage = _this$props.currentPage;
      var _currentPage = 0;
      var _numbers = 0;
      var _totalPages = 0;

      if (totalValues && itemsPerPage) {
        _currentPage = Number(currentPage);
        _totalPages = Math.ceil(totalValues / itemsPerPage);
        var generateNumbers = Array(_totalPages).fill('').map(function (e, i) {
          return String(i + 1);
        });

        if (generateNumbers.length < 8) {
          return {
            numbers: generateNumbers,
            totalPages: _totalPages,
            currentPage: _currentPage
          };
        }

        if (_currentPage < 5) {
          _numbers = generateNumbers.slice(0, 5);
        } else if (_currentPage > _totalPages - 4) {
          _numbers = generateNumbers.slice(_totalPages - 5);
        } else {
          _numbers = generateNumbers.slice(_currentPage - 2, _currentPage + 1);
        } // First page


        if (_numbers.indexOf('1') === -1) {
          _numbers.unshift('1');
        } // Last Page


        if (_numbers.indexOf(String(_totalPages)) === -1) {
          _numbers.push(String(_totalPages));
        } // Add dots at the beginning


        if (_numbers.indexOf('2') === -1) {
          _numbers.splice(1, 0, '...');
        } // Add dots at the end


        if (_numbers.indexOf(String(_totalPages - 1)) === -1) {
          _numbers.splice(_numbers.length - 1, 0, '...');
        }
      }

      return {
        numbers: _numbers,
        totalPages: _totalPages,
        currentPage: _currentPage
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          styling = _this$props2.styling,
          display = _this$props2.display,
          _this$props2$ariaLabe = _this$props2.ariaLabel,
          ariaLabel = _this$props2$ariaLabe === void 0 ? 'Paginering' : _this$props2$ariaLabe,
          _this$props2$ariaLabe2 = _this$props2.ariaLabelNextPage,
          ariaLabelNextPage = _this$props2$ariaLabe2 === void 0 ? 'Volgende pagina' : _this$props2$ariaLabe2,
          _this$props2$ariaLabe3 = _this$props2.ariaLabelPreviousPage,
          ariaLabelPreviousPage = _this$props2$ariaLabe3 === void 0 ? 'Vorige pagina' : _this$props2$ariaLabe3,
          _this$props2$ariaLabe4 = _this$props2.ariaLabelPage,
          ariaLabelPage = _this$props2$ariaLabe4 === void 0 ? 'Pagina' : _this$props2$ariaLabe4,
          qa = _this$props2.qa; // we render this, so it must be capitalized

      var _this$state2 = this.state,
          numbers = _this$state2.numbers,
          currentPage = _this$state2.currentPage,
          totalPages = _this$state2.totalPages;
      var paginationClasses = classNames('m-pagination', styling);
      var previousDisabledClasses = classNames('pagination-prev-page', {
        'is-disabled': currentPage <= 1
      });
      var nextDisabledClasses = classNames('pagination-next-page', {
        'is-disabled': currentPage >= totalPages
      });

      if (totalPages < 1) {
        return null;
      }

      return /*#__PURE__*/React__default.createElement("nav", {
        role: "navigation",
        "aria-label": ariaLabel,
        "data-qa": qa
      }, /*#__PURE__*/React__default.createElement("ul", {
        className: paginationClasses
      }, /*#__PURE__*/React__default.createElement("li", {
        className: "m-pagination__prev",
        key: "pagination__prev"
      }, /*#__PURE__*/React__default.createElement(Link$1, {
        className: previousDisabledClasses,
        href: currentPage > 1 ? '#' : null,
        onClick: function onClick(e) {
          return _this2.onPrev(e);
        },
        "aria-label": ariaLabelPreviousPage
      }, /*#__PURE__*/React__default.createElement(Icon$4, {
        name: "ai-arrow-left-1",
        ariaLabel: ariaLabelPreviousPage
      }))), display === 'text' && /*#__PURE__*/React__default.createElement("li", {
        className: "m-pagination__label",
        key: "pagination__label"
      }, "".concat(currentPage, " - ").concat(totalPages)), display === 'numbers' && numbers.map(function (number, i) {
        if (number === '...') {
          return /*#__PURE__*/React__default.createElement("li", {
            key: i
          }, "...");
        } else {
          return /*#__PURE__*/React__default.createElement("li", {
            key: i
          }, /*#__PURE__*/React__default.createElement(Link$1, {
            className: classNames({
              'is-active': number === "".concat(currentPage)
            }, "pagination-button-".concat(i)),
            href: '#',
            onClick: function onClick(e) {
              return _this2.onChange(number, e);
            },
            "aria-label": "".concat(ariaLabelPage, " ").concat(number),
            "aria-current": number === "".concat(currentPage) ? 'page' : null
          }, number));
        }
      }), /*#__PURE__*/React__default.createElement("li", {
        className: "m-pagination__next",
        key: "pagination__next"
      }, /*#__PURE__*/React__default.createElement(Link$1, {
        className: nextDisabledClasses,
        href: currentPage < totalPages ? '#' : null,
        onClick: function onClick(e) {
          return _this2.onNext(e);
        },
        "aria-label": ariaLabelNextPage
      }, /*#__PURE__*/React__default.createElement(Icon$4, {
        name: "ai-arrow-right-1",
        ariaLabel: ariaLabelNextPage
      })))));
    }
  }]);

  return Pagination;
}(Component);

_defineProperty$6(Pagination$1, "defaultProps", {
  currentPage: 1,
  styling: 'basic',
  display: 'numbers'
});

var ENV_IDENTIFIERS = {
  dev: '-o.',
  acc: '-a.',
  local: 'local'
};

function getEnvironment() {
  if (typeof window === 'undefined') {
    return process.env.NODE_ENV;
  }

  var currentUrl = window.location.href;
  var env = Object.keys(ENV_IDENTIFIERS).find(function (key) {
    return currentUrl.includes(ENV_IDENTIFIERS[key]);
  });
  return env || 'prod';
}

function getAstadUrl() {
  switch (getEnvironment().toLowerCase()) {
    case 'local':
      return 'https://www.dev.dcs.antwerpen.be';

    case 'dev':
      return 'https://www.dev.dcs.antwerpen.be';

    case 'acc':
      return 'https://www.acc.dcs.antwerpen.be';

    default:
      return 'https://www.antwerpen.be';
  }
}

function getShoppingCartUrl() {
  switch (getEnvironment().toLowerCase()) {
    case 'local':
      return 'https://winkelmand-o.antwerpen.be';

    case 'dev':
      return 'https://winkelmand-o.antwerpen.be';

    case 'acc':
      return 'https://winkelmand-a.antwerpen.be';

    default:
      return 'https://winkelmand.antwerpen.be';
  }
}

function getEloketUrl() {
  switch (getEnvironment().toLowerCase()) {
    case 'local':
      return 'https://eloket-o.antwerpen.be';

    case 'dev':
      return 'https://eloket-o.antwerpen.be';

    case 'acc':
      return 'https://eloket-a.antwerpen.be';

    default:
      return 'https://eloket.antwerpen.be';
  }
}

var Environment = {
  getEnvironment: getEnvironment,
  getAstadUrl: getAstadUrl,
  getShoppingCartUrl: getShoppingCartUrl,
  getEloketUrl: getEloketUrl
};

function ___$insertStyle(css) {
  if (!css) {
    return;
  }

  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');
  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$1(Object(source), true).forEach(function (key) {
        _defineProperty$5(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$1(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof$1(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$1 = function _typeof$1(obj) {
      return typeof obj;
    };
  } else {
    _typeof$1 = function _typeof$1(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof$1(obj);
}

function _defineProperty$5(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray$1(arr, i) {
  return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest$1();
}

function _arrayWithHoles$1(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit$1(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray$1(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$1(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen);
}

function _arrayLikeToArray$1(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _nonIterableRest$1() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _defineProperty$4(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var spinnerSizes$1 = {
  small: 'sm',
  large: 'lg'
};

var Spinner$1 = function Spinner(props) {
  var size = props.size,
      style = props.style,
      className = props.className,
      _props$ariaLabel = props.ariaLabel,
      ariaLabel = _props$ariaLabel === void 0 ? "Wordt geladen" : _props$ariaLabel,
      qa = props.qa;
  var spinnerClass = classNames('a-spinner', className, _defineProperty$4({}, "a-spinner--".concat(spinnerSizes$1[size]), !!size));
  return /*#__PURE__*/React__default.createElement("div", {
    className: spinnerClass,
    style: style,
    role: "status",
    "aria-label": ariaLabel,
    "data-qa": qa
  });
};

var TableLoader = function TableLoader(_ref) {
  var loadDataMessage = _ref.loadDataMessage;
  return /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("div", {
    className: "a-table--loading"
  }, /*#__PURE__*/React__default.createElement(Spinner$1, {
    className: "u-margin-right-xs",
    style: {
      display: 'inline'
    }
  }), /*#__PURE__*/React__default.createElement("span", null, loadDataMessage))));
};

function asyncGeneratorStep$3(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator$3(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep$3(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep$3(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck$3(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$3(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$3(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$3(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$3(Constructor, staticProps);
  return Constructor;
}

function _defineProperty$3(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits$3(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$3(subClass, superClass);
}

function _getPrototypeOf$3(o) {
  _getPrototypeOf$3 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$3(o);
}

function _setPrototypeOf$3(o, p) {
  _setPrototypeOf$3 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$3(o, p);
}

function _isNativeReflectConstruct$3() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized$3(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn$3(self, call) {
  if (call && (_typeof$1(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized$3(self);
}

function _createSuper$3(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$3();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf$3(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$3(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn$3(this, result);
  };
}

var Icon$3 = function Icon(_ref) {
  var name = _ref.name,
      style = _ref.style,
      className = _ref.className,
      ariaLabel = _ref.ariaLabel,
      onClick = _ref.onClick,
      src = _ref.src,
      qa = _ref.qa;
  /**
   * Inject SVG icons from core branding into page
   */

  var fetchAntwerpIcons = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator$3( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var xlinkHref, response, svgText, svgWrapper;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (fetch) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              _context.prev = 2;
              xlinkHref = 'https://cdn.antwerpen.be/core_branding_scss/5.0.0/assets/images/ai.svg';
              _context.next = 6;
              return fetch(xlinkHref);

            case 6:
              response = _context.sent;
              _context.next = 9;
              return response.text();

            case 9:
              svgText = _context.sent;
              svgWrapper = document.createElement('svg');
              svgWrapper.id = 'aiSvg';
              svgWrapper.innerHTML = svgText;

              if (!document.getElementById('aiSvg')) {
                document.body.appendChild(svgWrapper);
              }

              _context.next = 19;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](2);
              throw new Error(_context.t0);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 16]]);
    }));

    return function fetchAntwerpIcons() {
      return _ref2.apply(this, arguments);
    };
  }();

  if (typeof document !== 'undefined' && !document.getElementById('aiSvg')) {
    fetchAntwerpIcons();
  }

  var iconClass = classNames(className, name, 'ai');
  return /*#__PURE__*/React__default.createElement("span", {
    className: iconClass,
    style: style,
    "data-qa": qa,
    onClick: onClick
  }, name && /*#__PURE__*/React__default.createElement("svg", {
    "aria-hidden": "true"
  }, /*#__PURE__*/React__default.createElement("use", {
    href: "#".concat(name)
  })), src, ariaLabel && /*#__PURE__*/React__default.createElement("span", {
    className: "u-screen-reader-only"
  }, ariaLabel));
};

var sizeClasses$2 = {
  tiny: 'a-button--tiny',
  small: 'a-button--small',
  large: 'a-button--large'
};
var typeClasses$2 = {
  primary: '',
  secondary: 'a-button--secondary',
  success: 'a-button--success',
  warning: 'a-button--warning',
  danger: 'a-button--danger',
  transparent: 'a-button--transparent',
  default: 'a-button--default'
};

var Button$2 = /*#__PURE__*/function (_Component) {
  _inherits$3(Button, _Component);

  var _super = _createSuper$3(Button);

  function Button() {
    _classCallCheck$3(this, Button);

    return _super.apply(this, arguments);
  }

  _createClass$3(Button, [{
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props = this.props,
          id = _this$props.id,
          negative = _this$props.negative,
          outline = _this$props.outline,
          transparent = _this$props.transparent,
          className = _this$props.className,
          children = _this$props.children,
          icon = _this$props.icon,
          iconLeft = _this$props.iconLeft,
          iconRight = _this$props.iconRight,
          onClick = _this$props.onClick,
          _this$props$title = _this$props.title,
          title = _this$props$title === void 0 ? '' : _this$props$title,
          _this$props$ariaLabel = _this$props.ariaLabel,
          ariaLabel = _this$props$ariaLabel === void 0 ? '' : _this$props$ariaLabel,
          type = _this$props.type,
          size = _this$props.size,
          _this$props$block = _this$props.block,
          block = _this$props$block === void 0 ? false : _this$props$block,
          _this$props$style = _this$props.style,
          style = _this$props$style === void 0 ? {} : _this$props$style,
          _this$props$disabled = _this$props.disabled,
          disabled = _this$props$disabled === void 0 ? false : _this$props$disabled,
          htmlType = _this$props.htmlType,
          qa = _this$props.qa;
      var btnClass = classNames(className, (_classNames = {
        'a-button': !outline && !negative && !(type === 'default' && !!transparent)
      }, _defineProperty$3(_classNames, "".concat(typeClasses$2[type]), !!type), _defineProperty$3(_classNames, "".concat(sizeClasses$2[size]), !!size), _defineProperty$3(_classNames, 'has-icon', !!icon), _defineProperty$3(_classNames, 'has-icon-left', !!iconLeft), _defineProperty$3(_classNames, 'has-icon-right', !!iconRight), _defineProperty$3(_classNames, 'a-button-negative', !!negative), _defineProperty$3(_classNames, 'a-button-outline', !!outline), _defineProperty$3(_classNames, 'a-button-transparent', !!transparent), _defineProperty$3(_classNames, 'a-button--block', block), _classNames));
      return /*#__PURE__*/React__default.createElement("button", {
        id: id,
        className: btnClass,
        title: title || '',
        onClick: onClick,
        style: style,
        disabled: disabled,
        type: htmlType,
        "aria-label": ariaLabel,
        "data-qa": qa
      }, icon ? /*#__PURE__*/React__default.createElement(Icon$3, {
        name: icon
      }) : null, iconLeft ? /*#__PURE__*/React__default.createElement(Icon$3, {
        name: iconLeft
      }) : null, iconRight ? /*#__PURE__*/React__default.createElement(Icon$3, {
        name: iconRight
      }) : null, children);
    }
  }]);

  return Button;
}(Component);

var TableHeader = function TableHeader(_ref) {
  var _ref$sorting = _ref.sorting,
      sorting = _ref$sorting === void 0 ? {
    key: '',
    order: 'asc'
  } : _ref$sorting,
      _ref$as = _ref.as,
      HTMLTag = _ref$as === void 0 ? 'th' : _ref$as,
      classList = _ref.classList,
      className = _ref.className,
      component = _ref.component,
      hideLabel = _ref.hideLabel,
      disableSorting = _ref.disableSorting,
      label = _ref.label,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? '' : _ref$value,
      onSortClick = _ref.onSortClick,
      width = _ref.width;
  var style = width ? {
    width: width
  } : {};

  var renderTableHeader = function renderTableHeader() {
    if (hideLabel) {
      return;
    }

    if (component) {
      return component(value, label);
    }

    if (disableSorting) {
      return label;
    }

    var sortIcon = sorting.key === value ? "ai-arrow-".concat(sorting.order === 'asc' ? 'up' : 'down', "-1") : 'ai-move-expand-vertical';
    var newOrder = sorting.order === 'asc' ? 'desc' : 'asc';
    return /*#__PURE__*/React__default.createElement(Button$2, {
      className: "a-table__header-button",
      iconRight: sortIcon,
      onClick: function onClick() {
        return onSortClick(value, newOrder);
      },
      size: "tiny",
      type: "transparent"
    }, label);
  };

  return /*#__PURE__*/React__default.createElement(HTMLTag, {
    style: style,
    className: classNames(className, classList)
  }, renderTableHeader());
};

var TableRow = function TableRow(_ref) {
  var children = _ref.children,
      className = _ref.className,
      collapseOnDrag = _ref.collapseOnDrag,
      hasClickAction = _ref.hasClickAction,
      isDragging = _ref.isDragging,
      isLast = _ref.isLast,
      level = _ref.level,
      onClick = _ref.onClick,
      trRef = _ref.trRef;
  return /*#__PURE__*/React__default.createElement("tr", {
    ref: trRef,
    className: classNames(className, {
      'a-table--clickable': hasClickAction,
      'a-table__row--hovered': isDragging,
      'a-table__row--collapse': collapseOnDrag,
      'a-table__row--level-1': level === 1,
      'a-table__row--level-2': level === 2,
      'a-table__row--last-in-level': isLast
    }),
    onClick: onClick
  }, children);
};

var TableCell = function TableCell(_ref) {
  var _ref$as = _ref.as,
      HTMLTag = _ref$as === void 0 ? 'td' : _ref$as,
      classList = _ref.classList,
      className = _ref.className,
      component = _ref.component,
      rowData = _ref.rowData,
      rowIndex = _ref.rowIndex,
      value = _ref.value,
      style = _ref.style;
  return /*#__PURE__*/React__default.createElement(HTMLTag, {
    className: classNames(className, classList),
    style: style
  }, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, component ? component(value, rowData, rowIndex) : value));
};

var isNull = function isNull(value) {
  return value === null;
};

var isUndefined = function isUndefined(value) {
  return value === undefined;
};

var isNil = function isNil(value) {
  return isNull(value) || isUndefined(value);
};

var isObject = function isObject(value) {
  var type = _typeof$1(value);

  return !isNull(value) && (type === 'object' || type === 'function');
};

var isString = function isString(value) {
  return typeof value === 'string';
};

var getCellValue = function getCellValue(rowData, key, fallback) {
  if (!key) {
    return null;
  }

  var value = rowData[key];

  if (isObject(value)) {
    return String(value);
  }

  if (isNil(value) && fallback) {
    return fallback;
  }

  return value;
};

var getFormatValue = function getFormatValue(rowData, col, rowIndex) {
  if (isString(col)) {
    return getCellValue(rowData, col);
  }

  var cellValue = getCellValue(rowData, col.value, col.fallback);
  return col.format ? col.format(cellValue, col, rowData, rowIndex) : cellValue;
};

var getHeaderProps = function getHeaderProps(col, sorting, onSortClick, columnIndex) {
  var keyPrefix = 'table-header';

  if (isString(col)) {
    return {
      key: "".concat(keyPrefix, "-").concat(col, "-").concat(columnIndex),
      label: col
    };
  }

  return {
    key: "".concat(keyPrefix, "-").concat(col.label, "-").concat(columnIndex),
    component: col.headerComponent,
    classList: col.classList,
    disableSorting: col.disableSorting,
    label: col.label,
    value: col.value,
    width: col.width,
    hideLabel: col.hideLabel,
    sorting: sorting,
    onSortClick: onSortClick
  };
};

var getCellProps = function getCellProps(col, rowData, rowIndex) {
  var keyPrefix = 'table-cell';

  if (isString(col)) {
    return {
      key: "".concat(keyPrefix, "-").concat(col, "-").concat(rowData.id),
      label: col
    };
  }

  return {
    key: "".concat(keyPrefix, "-").concat(col.label, "-").concat(rowData.id),
    classList: col.classList,
    component: col.component,
    ellipsis: col.ellipsis,
    rowData: rowData,
    rowIndex: rowIndex,
    value: getFormatValue(rowData, col, rowIndex)
  };
};

function ___$insertStyle$1(css) {
  if (!css) {
    return;
  }

  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');
  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

var InputLabel = function InputLabel(props) {
  var style = props.style,
      htmlFor = props.htmlFor,
      children = props.children,
      inline = props.inline,
      id = props.id,
      qa = props.qa;
  var labelClass = classNames('a-input__label', {
    'a-input__label--inline': !!inline
  });
  return /*#__PURE__*/React__default.createElement("label", {
    className: labelClass,
    htmlFor: htmlFor,
    style: style,
    id: id,
    "data-qa": qa
  }, children);
};

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty$1$1(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep$1$1(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator$1$1(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep$1$1(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep$1$1(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck$1$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$1$1(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$1$1(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$1$1(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$1$1(Constructor, staticProps);
  return Constructor;
}

function _defineProperty$1$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends$1() {
  _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1.apply(this, arguments);
}

function _inherits$1$1(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$1$1(subClass, superClass);
}

function _getPrototypeOf$1$1(o) {
  _getPrototypeOf$1$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$1$1(o);
}

function _setPrototypeOf$1$1(o, p) {
  _setPrototypeOf$1$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$1$1(o, p);
}

function _isNativeReflectConstruct$1$1() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _objectWithoutPropertiesLoose$2(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties$2(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$2(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized$1$1(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn$1$1(self, call) {
  if (call && (_typeof$1(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized$1$1(self);
}

function _createSuper$1$1(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$1$1();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf$1$1(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$1$1(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn$1$1(this, result);
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var Icon$1$1 = function Icon(_ref) {
  var name = _ref.name,
      style = _ref.style,
      className = _ref.className,
      ariaLabel = _ref.ariaLabel,
      onClick = _ref.onClick,
      src = _ref.src,
      qa = _ref.qa;
  /**
   * Inject SVG icons from core branding into page
   */

  var fetchAntwerpIcons = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator$1$1( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var xlinkHref, response, svgText, svgWrapper;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (fetch) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              _context.prev = 2;
              xlinkHref = 'https://cdn.antwerpen.be/core_branding_scss/5.0.0/assets/images/ai.svg';
              _context.next = 6;
              return fetch(xlinkHref);

            case 6:
              response = _context.sent;
              _context.next = 9;
              return response.text();

            case 9:
              svgText = _context.sent;
              svgWrapper = document.createElement('svg');
              svgWrapper.id = 'aiSvg';
              svgWrapper.innerHTML = svgText;

              if (!document.getElementById('aiSvg')) {
                document.body.appendChild(svgWrapper);
              }

              _context.next = 19;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](2);
              throw new Error(_context.t0);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 16]]);
    }));

    return function fetchAntwerpIcons() {
      return _ref2.apply(this, arguments);
    };
  }();

  if (typeof document !== 'undefined' && !document.getElementById('aiSvg')) {
    fetchAntwerpIcons();
  }

  var iconClass = classNames(className, name, 'ai');
  return /*#__PURE__*/React__default.createElement("span", {
    className: iconClass,
    style: style,
    "data-qa": qa,
    onClick: onClick
  }, name && /*#__PURE__*/React__default.createElement("svg", {
    "aria-hidden": "true"
  }, /*#__PURE__*/React__default.createElement("use", {
    href: "#".concat(name)
  })), src, ariaLabel && /*#__PURE__*/React__default.createElement("span", {
    className: "u-screen-reader-only"
  }, ariaLabel));
};

var _excluded$1$1 = ["id", "label", "description", "required", "mask", "state", "autoComplete", "disabled", "iconright", "iconleft", "loading", "qa", "type", "size", "errorDescription", "className", "addonleft", "addonright"];
var stateClasses$4 = {
  success: 'has-success',
  warning: 'has-warning',
  error: 'has-error'
};

var TextField = /*#__PURE__*/function (_Component) {
  _inherits$1$1(TextField, _Component);

  var _super = _createSuper$1$1(TextField);

  function TextField() {
    _classCallCheck$1$1(this, TextField);

    return _super.apply(this, arguments);
  }

  _createClass$1$1(TextField, [{
    key: "render",
    value: function render() {
      var _classNames,
          _this = this;

      var _this$props = this.props,
          id = _this$props.id,
          label = _this$props.label,
          description = _this$props.description,
          required = _this$props.required,
          mask = _this$props.mask,
          state = _this$props.state,
          autoComplete = _this$props.autoComplete,
          disabled = _this$props.disabled,
          iconright = _this$props.iconright,
          iconleft = _this$props.iconleft,
          loading = _this$props.loading,
          qa = _this$props.qa,
          _this$props$type = _this$props.type,
          type = _this$props$type === void 0 ? 'text' : _this$props$type,
          size = _this$props.size,
          errorDescription = _this$props.errorDescription,
          className = _this$props.className,
          addonleft = _this$props.addonleft,
          addonright = _this$props.addonright,
          extraProps = _objectWithoutProperties$2(_this$props, _excluded$1$1);

      var inputClass = classNames('a-input', (_classNames = {
        'has-icon-right': iconright || loading,
        'has-icon-left': iconleft,
        'has-addon': !!addonleft || !!addonright,
        'is-required': !!required
      }, _defineProperty$1$1(_classNames, "".concat(stateClasses$4[state]), !!state), _defineProperty$1$1(_classNames, "a-input--".concat(size), !!size), _classNames), className);
      return /*#__PURE__*/React__default.createElement("div", {
        className: inputClass,
        "data-qa": qa
      }, label && /*#__PURE__*/React__default.createElement(InputLabel, {
        htmlFor: id
      }, label), /*#__PURE__*/React__default.createElement("div", {
        className: "a-input__wrapper"
      }, addonleft ? /*#__PURE__*/React__default.createElement("div", {
        className: "a-input__addon"
      }, addonleft) : null, iconleft ? /*#__PURE__*/React__default.createElement(Icon$1$1, {
        name: iconleft
      }) : null, mask ? /*#__PURE__*/React__default.createElement(InputMask, this.props) : /*#__PURE__*/React__default.createElement("input", _extends$1({
        id: id,
        type: type,
        autoComplete: autoComplete,
        disabled: disabled,
        ref: function (_ref) {
          function ref(_x) {
            return _ref.apply(this, arguments);
          }

          ref.toString = function () {
            return _ref.toString();
          };

          return ref;
        }(function (ref) {
          return _this.props.inputRef && _this.props.inputRef(ref);
        })
      }, extraProps)), iconright ? /*#__PURE__*/React__default.createElement(Icon$1$1, {
        name: iconright
      }) : null, loading ? /*#__PURE__*/React__default.createElement(Icon$1$1, {
        name: "spinner",
        className: "a-spinner a-spinner--sm"
      }) : null, addonright ? /*#__PURE__*/React__default.createElement("div", {
        className: "a-input__addon"
      }, addonright) : null), description ? /*#__PURE__*/React__default.createElement("small", null, description) : null, errorDescription && /*#__PURE__*/React__default.createElement("small", {
        className: "u-text-danger"
      }, errorDescription));
    }
  }]);

  return TextField;
}(Component);

var Checkbox = /*#__PURE__*/function (_Component) {
  _inherits$1$1(Checkbox, _Component);

  var _super = _createSuper$1$1(Checkbox);

  function Checkbox() {
    var _this;

    _classCallCheck$1$1(this, Checkbox);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$1$1(_assertThisInitialized$1$1(_this), "handleChange", function (e) {
      if (_this.props.onChange) {
        _this.props.onChange(e);
      }
    });

    _defineProperty$1$1(_assertThisInitialized$1$1(_this), "defaultId", 'aui-cb-' + Math.random().toString(36));

    return _this;
  }

  _createClass$1$1(Checkbox, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          id = _this$props.id,
          label = _this$props.label,
          name = _this$props.name,
          required = _this$props.required,
          _this$props$disabled = _this$props.disabled,
          disabled = _this$props$disabled === void 0 ? false : _this$props$disabled,
          qa = _this$props.qa;
      var inputClass = classNames('a-input');
      var requiredLabel = !!required ? /*#__PURE__*/React__default.createElement("span", {
        className: "u-text-danger"
      }, " *") : null;
      return /*#__PURE__*/React__default.createElement("div", {
        className: inputClass,
        "data-qa": qa
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "a-input__checkbox"
      }, /*#__PURE__*/React__default.createElement("input", _extends$1({
        type: "checkbox",
        id: id || this.defaultId,
        name: name,
        onChange: this.handleChange,
        "aria-checked": this.props.checked,
        checked: this.props.checked,
        disabled: disabled
      }, this.props.handler)), /*#__PURE__*/React__default.createElement(InputLabel, {
        htmlFor: id || this.defaultId
      }, label, requiredLabel)));
    }
  }]);

  return Checkbox;
}(Component);

var Option = function Option(props) {
  var value = props.value,
      disabled = props.disabled,
      children = props.children;
  return /*#__PURE__*/React__default.createElement("option", {
    value: value,
    disabled: disabled
  }, children);
};

var spinnerSizes = {
  small: 'sm',
  large: 'lg'
};

var Spinner = function Spinner(props) {
  var size = props.size,
      style = props.style,
      className = props.className,
      _props$ariaLabel = props.ariaLabel,
      ariaLabel = _props$ariaLabel === void 0 ? "Wordt geladen" : _props$ariaLabel,
      qa = props.qa;
  var spinnerClass = classNames('a-spinner', className, _defineProperty$1$1({}, "a-spinner--".concat(spinnerSizes[size]), !!size));
  return /*#__PURE__*/React__default.createElement("div", {
    className: spinnerClass,
    style: style,
    role: "status",
    "aria-label": ariaLabel,
    "data-qa": qa
  });
};

var stateClasses$3 = {
  success: 'has-success',
  warning: 'has-warning',
  error: 'has-error'
};

var Select = /*#__PURE__*/function (_Component) {
  _inherits$1$1(Select, _Component);

  var _super = _createSuper$1$1(Select);

  function Select() {
    _classCallCheck$1$1(this, Select);

    return _super.apply(this, arguments);
  }

  _createClass$1$1(Select, [{
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props = this.props,
          id = _this$props.id,
          label = _this$props.label,
          name = _this$props.name,
          description = _this$props.description,
          errorDescription = _this$props.errorDescription,
          inline = _this$props.inline,
          className = _this$props.className,
          state = _this$props.state;
      _this$props.style;
      var required = _this$props.required,
          disabled = _this$props.disabled,
          placeholder = _this$props.placeholder,
          options = _this$props.options,
          onChange = _this$props.onChange,
          value = _this$props.value,
          loading = _this$props.loading,
          size = _this$props.size,
          ariaLabelledby = _this$props.ariaLabelledby,
          qa = _this$props.qa;
      var selectClass = classNames('a-input', 'has-icon-right', (_classNames = {
        'a-input--inline': !!inline
      }, _defineProperty$1$1(_classNames, "".concat(stateClasses$3[state]), !!state), _defineProperty$1$1(_classNames, 'is-required', !!required), _defineProperty$1$1(_classNames, "a-input--".concat(size), !!size), _classNames), className);
      var wrapperClass = classNames('a-input__wrapper', {
        'a-input__wrapper--inline': !!inline
      });
      return /*#__PURE__*/React__default.createElement("div", {
        className: selectClass,
        name: name,
        "data-qa": qa
      }, label && /*#__PURE__*/React__default.createElement(InputLabel, {
        inline: inline,
        htmlFor: id
      }, label), /*#__PURE__*/React__default.createElement("div", {
        className: wrapperClass
      }, /*#__PURE__*/React__default.createElement("select", {
        id: id,
        name: name,
        onChange: onChange,
        value: value,
        disabled: disabled,
        "aria-labelledby": ariaLabelledby
      }, placeholder && /*#__PURE__*/React__default.createElement("option", {
        value: "",
        disabled: true
      }, placeholder), options.map(function (option) {
        return /*#__PURE__*/React__default.createElement(Option, {
          value: option.value,
          key: option.value,
          id: option.value,
          name: name,
          disabled: option.disabled
        }, option.label);
      })), description ? /*#__PURE__*/React__default.createElement("small", null, description) : null, errorDescription && /*#__PURE__*/React__default.createElement("small", {
        className: "u-text-danger"
      }, errorDescription), loading ? /*#__PURE__*/React__default.createElement(Spinner, {
        size: "small",
        className: "ai"
      }) : /*#__PURE__*/React__default.createElement(Icon$1$1, {
        name: "ai-arrow-down-1"
      })));
    }
  }]);

  return Select;
}(Component);

_defineProperty$1$1(Select, "defaultProps", {
  value: ''
});

function asyncGeneratorStep$2(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator$2(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep$2(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep$2(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck$2(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$2(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$2(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$2(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$2(Constructor, staticProps);
  return Constructor;
}

function _defineProperty$2(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits$2(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$2(subClass, superClass);
}

function _getPrototypeOf$2(o) {
  _getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$2(o);
}

function _setPrototypeOf$2(o, p) {
  _setPrototypeOf$2 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$2(o, p);
}

function _isNativeReflectConstruct$2() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized$2(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn$2(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized$2(self);
}

function _createSuper$2(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$2();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf$2(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$2(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn$2(this, result);
  };
}

var viewTypeMap = {
  days: 'dagen',
  months: 'maanden',
  years: 'jaren'
};

var mapViewType = function mapViewType(viewType) {
  return viewTypeMap[viewType];
};

var mapNav = function mapNav(direction, viewType, value) {
  var multi = '';
  var viewTypeDisplay = '';
  var valueDisplay = '';
  var directionDisplay = direction > 0 ? 'volgend' : 'vorig';

  switch (viewType) {
    case 'months':
      viewTypeDisplay = 'jaar';
      valueDisplay = value.clone().add(direction, 'years').format('YYYY');
      break;

    case 'years':
      multi = 'e';
      viewTypeDisplay = 'periode van 12 jaar';
      var years = yearsOfMonth(value.clone().add(12 * direction, 'years'));
      valueDisplay = years[0] + '-' + years.slice(-1);
      break;

    default:
      multi = 'e';
      viewTypeDisplay = 'maand';
      valueDisplay = value.clone().add(direction, 'months').format('MMMM YYYY');
  }

  return "Ga naar ".concat(directionDisplay).concat(multi, " ").concat(viewTypeDisplay, ", ").concat(valueDisplay);
};

var aria = {
  mapViewType: mapViewType,
  mapNav: mapNav
};

function rotateArrayByPosition(data, d) {
  var temp = data.splice(0);

  for (var i = 0; i < d - 1; i++) {
    var first = temp.shift();
    temp.push(first);
  }

  return temp;
}

function daysOfMonth(displayedMonth) {
  var _i, d;

  var results = [];
  var startOfMonth = displayedMonth.startOf('months');
  var startDayOfWeek = startOfMonth.clone().startOf('isoWeek');
  var startAt = -startOfMonth.diff(startDayOfWeek, 'days');
  var endAt = Math.ceil((displayedMonth.daysInMonth() - startAt) / 7) * 7 + startAt - 1;

  for (d = _i = startAt; startAt <= endAt ? _i <= endAt : _i >= endAt; d = startAt <= endAt ? ++_i : --_i) {
    results.push(displayedMonth.clone().add(d, 'days'));
  }

  return results;
}

function weekEnum(daysOfMonth) {
  var results = [];

  for (var _i = 0, _ref = daysOfMonth.length / 7; 0 <= _ref ? _i < _ref : _i > _ref; 0 <= _ref ? _i++ : _i--) {
    results.push(_i);
  }

  return results;
}

function isDateFromNextMonth(date, displayedMonth) {
  return date.year() > displayedMonth.year() || date.year() === displayedMonth.year() && date.month() > displayedMonth.month();
}

function isDateFromPrevMonth(date, displayedMonth) {
  return date.year() < displayedMonth.year() || date.year() === displayedMonth.year() && date.month() < displayedMonth.month();
}

function yearsOfMonth(displayedMonth) {
  var amountOfYearsBack = -11;
  var results = [];

  for (var year = amountOfYearsBack; year < 0; year++) {
    results.push(displayedMonth.clone().add(year, 'years').format('YYYY'));
  }

  results.push(displayedMonth.clone().format('YYYY'));
  return results;
}

function nextItemInArray(element, array) {
  var i = array.findIndex(function (k) {
    return k == element;
  });
  i = i + 1;
  i = i % array.length;
  return array[i];
}

var Icon$2 = function Icon(_ref) {
  var name = _ref.name,
      style = _ref.style,
      className = _ref.className,
      ariaLabel = _ref.ariaLabel,
      onClick = _ref.onClick,
      src = _ref.src,
      qa = _ref.qa;
  /**
   * Inject SVG icons from core branding into page
   */

  var fetchAntwerpIcons = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator$2( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var xlinkHref, response, svgText, svgWrapper;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (fetch) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              _context.prev = 2;
              xlinkHref = 'https://cdn.antwerpen.be/core_branding_scss/5.0.0/assets/images/ai.svg';
              _context.next = 6;
              return fetch(xlinkHref);

            case 6:
              response = _context.sent;
              _context.next = 9;
              return response.text();

            case 9:
              svgText = _context.sent;
              svgWrapper = document.createElement('svg');
              svgWrapper.id = 'aiSvg';
              svgWrapper.innerHTML = svgText;

              if (!document.getElementById('aiSvg')) {
                document.body.appendChild(svgWrapper);
              }

              _context.next = 19;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](2);
              throw new Error(_context.t0);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 16]]);
    }));

    return function fetchAntwerpIcons() {
      return _ref2.apply(this, arguments);
    };
  }();

  if (typeof document !== 'undefined' && !document.getElementById('aiSvg')) {
    fetchAntwerpIcons();
  }

  var iconClass = classNames(className, name, 'ai');
  return /*#__PURE__*/React__default.createElement("span", {
    className: iconClass,
    style: style,
    "data-qa": qa,
    onClick: onClick
  }, name && /*#__PURE__*/React__default.createElement("svg", {
    "aria-hidden": "true"
  }, /*#__PURE__*/React__default.createElement("use", {
    href: "#".concat(name)
  })), src, ariaLabel && /*#__PURE__*/React__default.createElement("span", {
    className: "u-screen-reader-only"
  }, ariaLabel));
};

var sizeClasses$1 = {
  tiny: 'a-button--tiny',
  small: 'a-button--small',
  large: 'a-button--large'
};
var typeClasses$1 = {
  primary: '',
  secondary: 'a-button--secondary',
  success: 'a-button--success',
  warning: 'a-button--warning',
  danger: 'a-button--danger',
  transparent: 'a-button--transparent',
  default: 'a-button--default'
};

var Button$1 = /*#__PURE__*/function (_Component) {
  _inherits$2(Button, _Component);

  var _super = _createSuper$2(Button);

  function Button() {
    _classCallCheck$2(this, Button);

    return _super.apply(this, arguments);
  }

  _createClass$2(Button, [{
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props = this.props,
          id = _this$props.id,
          negative = _this$props.negative,
          outline = _this$props.outline,
          transparent = _this$props.transparent,
          className = _this$props.className,
          children = _this$props.children,
          icon = _this$props.icon,
          iconLeft = _this$props.iconLeft,
          iconRight = _this$props.iconRight,
          onClick = _this$props.onClick,
          _this$props$title = _this$props.title,
          title = _this$props$title === void 0 ? '' : _this$props$title,
          _this$props$ariaLabel = _this$props.ariaLabel,
          ariaLabel = _this$props$ariaLabel === void 0 ? '' : _this$props$ariaLabel,
          type = _this$props.type,
          size = _this$props.size,
          _this$props$block = _this$props.block,
          block = _this$props$block === void 0 ? false : _this$props$block,
          _this$props$style = _this$props.style,
          style = _this$props$style === void 0 ? {} : _this$props$style,
          _this$props$disabled = _this$props.disabled,
          disabled = _this$props$disabled === void 0 ? false : _this$props$disabled,
          htmlType = _this$props.htmlType,
          qa = _this$props.qa;
      var btnClass = classNames(className, (_classNames = {
        'a-button': !outline && !negative && !(type === 'default' && !!transparent)
      }, _defineProperty$2(_classNames, "".concat(typeClasses$1[type]), !!type), _defineProperty$2(_classNames, "".concat(sizeClasses$1[size]), !!size), _defineProperty$2(_classNames, 'has-icon', !!icon), _defineProperty$2(_classNames, 'has-icon-left', !!iconLeft), _defineProperty$2(_classNames, 'has-icon-right', !!iconRight), _defineProperty$2(_classNames, 'a-button-negative', !!negative), _defineProperty$2(_classNames, 'a-button-outline', !!outline), _defineProperty$2(_classNames, 'a-button-transparent', !!transparent), _defineProperty$2(_classNames, 'a-button--block', block), _classNames));
      return /*#__PURE__*/React__default.createElement("button", {
        id: id,
        className: btnClass,
        title: title || '',
        onClick: onClick,
        style: style,
        disabled: disabled,
        type: htmlType,
        "aria-label": ariaLabel,
        "data-qa": qa
      }, icon ? /*#__PURE__*/React__default.createElement(Icon$2, {
        name: icon
      }) : null, iconLeft ? /*#__PURE__*/React__default.createElement(Icon$2, {
        name: iconLeft
      }) : null, iconRight ? /*#__PURE__*/React__default.createElement(Icon$2, {
        name: iconRight
      }) : null, children);
    }
  }]);

  return Button;
}(Component);

var Nav = /*#__PURE__*/function (_Component) {
  _inherits$2(Nav, _Component);

  var _super = _createSuper$2(Nav);

  function Nav() {
    _classCallCheck$2(this, Nav);

    return _super.apply(this, arguments);
  }

  _createClass$2(Nav, [{
    key: "renderNav",
    value: function renderNav() {
      var _this$props = this.props,
          viewType = _this$props.viewType,
          displayedPeriod = _this$props.displayedPeriod;

      switch (viewType) {
        case 'months':
          return displayedPeriod.format('YYYY');

        case 'years':
          return this.renderYearsNav(displayedPeriod);

        default:
          return displayedPeriod.format('MMMM YYYY');
      }
    }
  }, {
    key: "renderYearsNav",
    value: function renderYearsNav(displayedMonth) {
      var years = yearsOfMonth(displayedMonth);
      return years[0] + '-' + years.slice(-1);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          onClickPrevious = _this$props2.onClickPrevious,
          onClickViewType = _this$props2.onClickViewType,
          onClickNext = _this$props2.onClickNext,
          viewType = _this$props2.viewType,
          displayedPeriod = _this$props2.displayedPeriod,
          _this$props2$ariaLabe = _this$props2.ariaLabelPrevious,
          ariaLabelPrevious = _this$props2$ariaLabe === void 0 ? function (viewType, value) {
        return aria.mapNav(-1, viewType, value);
      } : _this$props2$ariaLabe,
          _this$props2$ariaLabe2 = _this$props2.ariaLabelNext,
          ariaLabelNext = _this$props2$ariaLabe2 === void 0 ? function (viewType, value) {
        return aria.mapNav(1, viewType, value);
      } : _this$props2$ariaLabe2;
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Button$1, {
        htmlType: "button",
        onClick: onClickPrevious,
        className: 'a-button has-icon',
        icon: 'ai-arrow-left-1',
        ariaLabel: ariaLabelPrevious(viewType, displayedPeriod)
      }), /*#__PURE__*/React__default.createElement(Button$1, {
        htmlType: "button",
        onClick: onClickViewType,
        className: 'm-datepicker__title a-button u-text-capitalize'
      }, this.renderNav()), /*#__PURE__*/React__default.createElement(Button$1, {
        htmlType: "button",
        onClick: onClickNext,
        className: 'a-button has-icon',
        icon: 'ai-arrow-right-1',
        ariaLabel: ariaLabelNext(viewType, displayedPeriod)
      }));
    }
  }]);

  return Nav;
}(Component);

var Rows = /*#__PURE__*/function (_Component) {
  _inherits$2(Rows, _Component);

  var _super = _createSuper$2(Rows);

  function Rows() {
    _classCallCheck$2(this, Rows);

    return _super.apply(this, arguments);
  }

  _createClass$2(Rows, [{
    key: "generateRows",
    value: function generateRows() {
      var _this$props = this.props,
          list = _this$props.list,
          rowLength = _this$props.rowLength,
          onClick = _this$props.onClick;
      return list.map(function (content, index) {
        return /*#__PURE__*/React__default.createElement("td", {
          key: index
        }, /*#__PURE__*/React__default.createElement("button", {
          className: "u-text-capitalize",
          tabIndex: index,
          value: content,
          onClick: onClick,
          type: "button"
        }, content.replace(/\./g, ' ')));
      }).reduce(function (r, element, index) {
        // create element groups with size 4, result looks like:
        // [[elem1, elem2, elem3], [elem4, elem5, elem6],x ...]
        index % rowLength === 0 && r.push([]);
        r[r.length - 1].push(element);
        return r;
      }, []).map(function (rowContent, index) {
        // surround every group with a tr
        return /*#__PURE__*/React__default.createElement("tr", {
          key: index
        }, rowContent);
      });
    }
  }, {
    key: "render",
    value: function render() {
      return this.generateRows();
    }
  }]);

  return Rows;
}(Component);

var Day = /*#__PURE__*/function (_Component) {
  _inherits$2(Day, _Component);

  var _super = _createSuper$2(Day);

  function Day() {
    var _this;

    _classCallCheck$2(this, Day);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$2(_assertThisInitialized$2(_this), "handleOnClick", function (day) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          selectDay = _this$props.selectDay;
      if (disabled) return;
      selectDay(day);
    });

    return _this;
  }

  _createClass$2(Day, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          activeDate = _this$props2.activeDate,
          day = _this$props2.day,
          selected = _this$props2.selected,
          disabled = _this$props2.disabled,
          dayNextMonth = _this$props2.dayNextMonth,
          dayPrevMonth = _this$props2.dayPrevMonth,
          dayActiveClassName = _this$props2.dayActiveClassName,
          selectedClassName = _this$props2.selectedClassName,
          dayDisabledClassName = _this$props2.dayDisabledClassName,
          dayFromOtherMonthClassName = _this$props2.dayFromOtherMonthClassName,
          ariaLabelButtonDateFormat = _this$props2.ariaLabelButtonDateFormat;
      var buttonClasses = [];

      if (day.isSame(Moment(), 'day')) {
        buttonClasses.push(selectedClassName);
      }

      if (day.isSame(activeDate, 'day')) {
        buttonClasses.push(dayActiveClassName);
      }

      if (disabled) {
        buttonClasses.push(dayDisabledClassName);
      }

      if (selected) {
        buttonClasses.push(dayActiveClassName);
      }

      if (dayPrevMonth || dayNextMonth) {
        buttonClasses.push(dayFromOtherMonthClassName);
      }

      return /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("button", {
        tabIndex: disabled ? '-1' : '0',
        type: "button",
        onClick: this.handleOnClick.bind(this, day),
        className: buttonClasses.join(' '),
        "aria-label": day.format(ariaLabelButtonDateFormat)
      }, day.date()));
    }
  }]);

  return Day;
}(Component);

_defineProperty$2(Day, "defaultProps", {
  dayClassName: '',
  dayActiveClassName: 'is-selected',
  selectedClassName: 'is-current',
  dayDisabledClassName: 'is-unavailable',
  dayFromOtherMonthClassName: 'is-faded',
  ariaLabelButtonDateFormat: 'dddd D MMMM YYYY'
});

var Body = /*#__PURE__*/function (_Component) {
  _inherits$2(Body, _Component);

  var _super = _createSuper$2(Body);

  function Body() {
    var _this;

    _classCallCheck$2(this, Body);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$2(_assertThisInitialized$2(_this), "handleOnClick", function (type, event) {
      var value = event.target.value;
      var newDisplayedPeriod = null;
      var displayedPeriod = _this.props.displayedPeriod;

      if (type === 'days') {
        newDisplayedPeriod = Moment(displayedPeriod.format('YYYY') + value, "YYYY MMM");
      } else if (type === 'months') {
        newDisplayedPeriod = Moment(displayedPeriod.format('MM') + value, "MM YYYY");
      }

      var goToViewType = _this.props.goToViewType;
      goToViewType(type, newDisplayedPeriod);
    });

    return _this;
  }

  _createClass$2(Body, [{
    key: "renderBody",
    value: function renderBody(displayedPeriod) {
      var viewType = this.props.viewType;

      switch (viewType) {
        case 'months':
          return this.renderListMonths();

        case "years":
          return this.renderListYears(displayedPeriod);

        default:
          return this.renderWeeks(displayedPeriod);
      }
    }
  }, {
    key: "renderWeeks",
    value: function renderWeeks(displayMonth) {
      var _this2 = this;

      var _daysOfMonth = daysOfMonth(displayMonth);

      var _weekEnum = weekEnum(_daysOfMonth);

      return _weekEnum.map(function (week, key) {
        return /*#__PURE__*/React__default.createElement("tr", {
          key: key
        }, _this2.renderDay(_daysOfMonth, week));
      });
    }
  }, {
    key: "renderListMonths",
    value: function renderListMonths() {
      var months = Moment.monthsShort();
      return /*#__PURE__*/React__default.createElement(Rows, {
        list: months,
        rowLength: 4,
        onClick: this.handleOnClick.bind(this, 'days')
      });
    }
  }, {
    key: "renderListYears",
    value: function renderListYears(displayMonth) {
      var years = yearsOfMonth(displayMonth);
      return /*#__PURE__*/React__default.createElement(Rows, {
        list: years,
        rowLength: 4,
        onClick: this.handleOnClick.bind(this, 'months')
      });
    }
  }, {
    key: "renderDay",
    value: function renderDay(_daysOfMonth, week) {
      var _this3 = this;

      var days = [0, 1, 2, 3, 4, 5, 6];
      var _this$props = this.props,
          activeDate = _this$props.activeDate,
          displayedPeriod = _this$props.displayedPeriod,
          selectedDates = _this$props.selectedDates,
          minDate = _this$props.minDate,
          maxDate = _this$props.maxDate,
          format = _this$props.format,
          noWeekends = _this$props.noWeekends,
          selectDay = _this$props.selectDay,
          ariaLabelButtonDateFormat = _this$props.ariaLabelButtonDateFormat;
      return days.map(function (day, key) {
        var date = _daysOfMonth[week * 7 + day];
        var disabled;
        var selected = false;

        if (minDate && maxDate) {
          disabled = date.isBefore(minDate, 'day') || date.isAfter(maxDate, 'day');
        } else if (minDate) {
          disabled = date.isBefore(minDate, 'day');
        } else if (maxDate) {
          disabled = date.isAfter(maxDate, 'day');
        }

        if (noWeekends) {
          disabled = date.day() === 6 || date.day() === 0;
        }

        var dayNextMonth = isDateFromNextMonth(date, displayedPeriod);
        var dayPrevMonth = isDateFromPrevMonth(date, displayedPeriod);
        selectedDates.forEach(function (selectedDate) {
          if (date.isSame(Moment(selectedDate, format), 'day')) {
            selected = true;
            dayPrevMonth = false;
            dayNextMonth = false;
          }
        });
        return /*#__PURE__*/React__default.createElement(Day, {
          key: key,
          day: date,
          selectDay: selectDay.bind(_this3, date),
          disabled: disabled,
          selected: selected,
          dayPrevMonth: dayPrevMonth,
          dayNextMonth: dayNextMonth,
          activeDate: activeDate,
          ariaLabelButtonDateFormat: ariaLabelButtonDateFormat
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var displayedPeriod = this.props.displayedPeriod;
      return this.renderBody(displayedPeriod);
    }
  }]);

  return Body;
}(Component);

_defineProperty$2(Body, "defaultProps", {
  selectedDates: []
});

var Head = /*#__PURE__*/function (_Component) {
  _inherits$2(Head, _Component);

  var _super = _createSuper$2(Head);

  function Head() {
    _classCallCheck$2(this, Head);

    return _super.apply(this, arguments);
  }

  _createClass$2(Head, [{
    key: "renderHeader",
    value: function renderHeader() {
      var viewType = this.props.viewType;

      switch (viewType) {
        case 'months':
          return null;

        case 'years':
          return null;

        default:
          return this.renderNameOfDays();
      }
    }
  }, {
    key: "renderNameOfDays",
    value: function renderNameOfDays() {
      // rotate arrays to put monday first, to match <Body>
      var nameOfDays = rotateArrayByPosition(Moment.weekdaysMin(), 2);
      var longNameDays = rotateArrayByPosition(Moment.weekdays(), 2);
      return /*#__PURE__*/React__default.createElement("tr", {
        className: "m-datepicker__days"
      }, nameOfDays.map(function (day, i) {
        return /*#__PURE__*/React__default.createElement("th", {
          key: i,
          className: "u-text-capitalize",
          "aria-label": longNameDays[i]
        }, day);
      }));
    }
  }, {
    key: "render",
    value: function render() {
      return this.renderHeader();
    }
  }]);

  return Head;
}(Component);

var Calendar$1 = /*#__PURE__*/function (_Component) {
  _inherits$2(Calendar, _Component);

  var _super = _createSuper$2(Calendar);

  function Calendar() {
    var _this;

    _classCallCheck$2(this, Calendar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$2(_assertThisInitialized$2(_this), "state", {
      displayedPeriod: _this.props.activeDate ? Moment(_this.props.activeDate, _this.props.format) : Moment(),
      viewType: 'days',
      views: ['days', 'months', 'years']
    });

    return _this;
  }

  _createClass$2(Calendar, [{
    key: "changeViewType",
    value: function changeViewType() {
      var _this$state = this.state,
          viewType = _this$state.viewType,
          views = _this$state.views;
      var switchTo = nextItemInArray(viewType, views);
      this.goToViewType(switchTo);
    }
  }, {
    key: "goToViewType",
    value: function goToViewType(switchTo) {
      var displayedPeriod = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      this.setState({
        viewType: switchTo,
        displayedPeriod: displayedPeriod || this.state.displayedPeriod
      });
    }
  }, {
    key: "moveDisplayedPeriod",
    value: function moveDisplayedPeriod(delta) {
      var _this$state2 = this.state,
          viewType = _this$state2.viewType,
          displayedPeriod = _this$state2.displayedPeriod;
      var period = viewType === 'days' ? 'months' : 'years';
      var diffTime = viewType === 'years' ? delta * 12 : delta;
      this.setState({
        displayedPeriod: displayedPeriod.clone().add(diffTime, period)
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          selectDay = _this$props.selectDay,
          activeDate = _this$props.activeDate,
          selectedDates = _this$props.selectedDates,
          minDate = _this$props.minDate,
          maxDate = _this$props.maxDate,
          format = _this$props.format,
          noWeekends = _this$props.noWeekends,
          ariaLabelPrevious = _this$props.ariaLabelPrevious,
          ariaLabelNext = _this$props.ariaLabelNext,
          _this$props$ariaLabel = _this$props.ariaLabelDatePicker,
          ariaLabelDatePicker = _this$props$ariaLabel === void 0 ? function (viewType) {
        return "Datumkiezer ".concat(aria.mapViewType(viewType));
      } : _this$props$ariaLabel,
          ariaLabelButtonDateFormat = _this$props.ariaLabelButtonDateFormat;
      var _this$state3 = this.state,
          viewType = _this$state3.viewType,
          displayedPeriod = _this$state3.displayedPeriod;
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        className: "m-datepicker__nav",
        "aria-label": "".concat(ariaLabelDatePicker(viewType)),
        "aria-hidden": "false"
      }, /*#__PURE__*/React__default.createElement(Nav, {
        viewType: viewType,
        displayedPeriod: displayedPeriod,
        onClickPrevious: this.moveDisplayedPeriod.bind(this, -1),
        onClickViewType: this.changeViewType.bind(this),
        onClickNext: this.moveDisplayedPeriod.bind(this, 1),
        ariaLabelPrevious: ariaLabelPrevious,
        ariaLabelNext: ariaLabelNext
      })), /*#__PURE__*/React__default.createElement("table", null, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement(Head, {
        displayedPeriod: displayedPeriod,
        viewType: viewType
      })), /*#__PURE__*/React__default.createElement("tbody", {
        className: "m-datepicker__calendar"
      }, /*#__PURE__*/React__default.createElement(Body, {
        viewType: viewType,
        displayedPeriod: displayedPeriod,
        selectDay: selectDay.bind(this),
        selectedDates: selectedDates,
        minDate: minDate,
        maxDate: maxDate,
        format: format,
        noWeekends: noWeekends,
        activeDate: activeDate,
        ariaLabelButtonDateFormat: ariaLabelButtonDateFormat,
        goToViewType: this.goToViewType.bind(this)
      }))));
    }
  }]);

  return Calendar;
}(Component);

var _this = undefined;

var DatePicker = function DatePicker(_ref) {
  var clickOnDate = _ref.clickOnDate,
      format = _ref.format,
      locale = _ref.locale,
      activeDate = _ref.activeDate,
      selectedDates = _ref.selectedDates,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      noWeekends = _ref.noWeekends,
      ariaLabelPrevious = _ref.ariaLabelPrevious,
      ariaLabelNext = _ref.ariaLabelNext,
      ariaLabelDatePicker = _ref.ariaLabelDatePicker,
      ariaLabelButtonDateFormat = _ref.ariaLabelButtonDateFormat,
      qa = _ref.qa;
  return /*#__PURE__*/React__default.createElement(Calendar$1, {
    selectDay: clickOnDate.bind(_this),
    format: format,
    locale: locale,
    activeDate: activeDate,
    selectedDates: selectedDates,
    minDate: minDate,
    maxDate: maxDate,
    noWeekends: noWeekends,
    ariaLabelPrevious: ariaLabelPrevious,
    ariaLabelNext: ariaLabelNext,
    ariaLabelDatePicker: ariaLabelDatePicker,
    ariaLabelButtonDateFormat: ariaLabelButtonDateFormat,
    qa: qa
  });
};

var Calendar = /*#__PURE__*/function (_Component) {
  _inherits$2(Calendar, _Component);

  var _super = _createSuper$2(Calendar);

  function Calendar(props) {
    var _this;

    _classCallCheck$2(this, Calendar);

    _this = _super.call(this, props);
    var _this$props = _this.props,
        activeDate = _this$props.activeDate,
        format = _this$props.format,
        locale = _this$props.locale;
    Moment.locale(locale ? locale : 'nl');
    _this.state = {
      activeDate: activeDate ? Moment(activeDate, format) : ''
    };
    return _this;
  }

  _createClass$2(Calendar, [{
    key: "changeDate",
    value: function changeDate(day) {
      var _this$props2 = this.props,
          onChange = _this$props2.onChange,
          format = _this$props2.format;
      if (onChange) onChange(Moment(day).format(format));
      this.setState({
        activeDate: day
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          format = _this$props3.format,
          locale = _this$props3.locale,
          selectedDates = _this$props3.selectedDates,
          minDate = _this$props3.minDate,
          maxDate = _this$props3.maxDate,
          noWeekends = _this$props3.noWeekends,
          ariaLabelPrevious = _this$props3.ariaLabelPrevious,
          ariaLabelNext = _this$props3.ariaLabelNext,
          ariaLabelDatePicker = _this$props3.ariaLabelDatePicker,
          ariaLabelButtonDateFormat = _this$props3.ariaLabelButtonDateFormat,
          qa = _this$props3.qa;
      var activeDate = this.state.activeDate;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "m-datepicker is-open",
        "data-qa": qa
      }, /*#__PURE__*/React__default.createElement(DatePicker, {
        format: format,
        locale: locale,
        activeDate: activeDate,
        selectedDates: selectedDates,
        minDate: Moment(minDate, format),
        maxDate: Moment(maxDate, format),
        noWeekends: noWeekends,
        ariaLabelPrevious: ariaLabelPrevious,
        ariaLabelNext: ariaLabelNext,
        ariaLabelDatePicker: ariaLabelDatePicker,
        ariaLabelButtonDateFormat: ariaLabelButtonDateFormat,
        qa: qa,
        clickOnDate: this.changeDate.bind(this)
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.activeDate) {
        return {
          activeDate: Moment(nextProps.activeDate, nextProps.format)
        };
      }

      return null;
    }
  }]);

  return Calendar;
}(Component);

_defineProperty$2(Calendar, "defaultProps", {
  format: 'DD/MM/YYYY',
  noWeekends: false
});

var stateClasses$1 = {
  success: 'has-success',
  warning: 'has-warning',
  error: 'has-error'
};

var Datepicker = /*#__PURE__*/function (_Component) {
  _inherits$1$1(Datepicker, _Component);

  var _super = _createSuper$1$1(Datepicker);

  function Datepicker(props) {
    var _this;

    _classCallCheck$1$1(this, Datepicker);

    _this = _super.call(this, props);

    _defineProperty$1$1(_assertThisInitialized$1$1(_this), "defaultId", 'aui-date-' + Math.random().toString(36));

    _defineProperty$1$1(_assertThisInitialized$1$1(_this), "handleClickOutside", function (e) {
      if (_this.datepicker && _this.datepicker.contains(e.target)) {
        return;
      }

      _this.setState({
        open: false
      });
    });

    var open = _this.props.open;
    _this.state = {
      input: '',
      open: open || false
    };
    return _this;
  }

  _createClass$1$1(Datepicker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (typeof window !== 'undefined') {
        document.addEventListener('mousedown', this.handleClickOutside);
        document.addEventListener('touchstart', this.handleClickOutside);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (typeof window !== 'undefined') {
        document.removeEventListener('mousedown', this.handleClickOutside);
        document.removeEventListener('touchstart', this.handleClickOutside);
      }
    }
  }, {
    key: "onClickInput",
    value: function onClickInput() {
      if (this.props.readOnly) {
        this.toggleCalendar();
      }
    }
  }, {
    key: "resetDate",
    value: function resetDate() {
      this.setState({
        input: '',
        activeDate: null
      });
    }
  }, {
    key: "changeDate",
    value: function changeDate(date) {
      var _this$props = this.props,
          onChange = _this$props.onChange,
          format = _this$props.format,
          autoClose = _this$props.autoClose;
      var momentDate = Moment(date, format, true);
      var isValid = momentDate.isValid();
      if (onChange) onChange(date, isValid);
      this.setState(function () {
        var updateDate = {};

        if (isValid) {
          updateDate = {
            activeDate: momentDate
          };
        }

        return _objectSpread2(_objectSpread2({}, updateDate), {}, {
          input: date,
          open: !autoClose || false
        });
      });
    }
  }, {
    key: "toggleCalendar",
    value: function toggleCalendar() {
      if (!this.props.disabled) {
        this.setState({
          open: !this.state.open
        });
      }
    }
  }, {
    key: "keyPressed",
    value: function keyPressed(e) {
      if (e.key === 'Enter' && !this.props.disabled) {
        this.setState({
          open: !this.state.open
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames,
          _this2 = this;

      var _this$props2 = this.props,
          label = _this$props2.label,
          id = _this$props2.id,
          state = _this$props2.state,
          description = _this$props2.description,
          errorDescription = _this$props2.errorDescription,
          mask = _this$props2.mask,
          required = _this$props2.required,
          disabled = _this$props2.disabled,
          readOnly = _this$props2.readOnly,
          placeholder = _this$props2.placeholder,
          name = _this$props2.name,
          format = _this$props2.format,
          _this$props2$locale = _this$props2.locale,
          locale = _this$props2$locale === void 0 ? 'nl' : _this$props2$locale,
          selectedDates = _this$props2.selectedDates,
          minDate = _this$props2.minDate,
          maxDate = _this$props2.maxDate,
          noWeekends = _this$props2.noWeekends,
          onBlur = _this$props2.onBlur,
          qa = _this$props2.qa,
          size = _this$props2.size;
      var _this$state = this.state,
          input = _this$state.input,
          activeDate = _this$state.activeDate,
          open = _this$state.open;
      var datepickerWrapperClass = classNames('a-input', 'has-icon-right', (_classNames = {
        'is-required': !!required
      }, _defineProperty$1$1(_classNames, "".concat(stateClasses$1[state]), !!state), _defineProperty$1$1(_classNames, "a-input--".concat(size), !!size), _classNames));
      var datepickerClass = classNames('m-datepicker', 'm-datepicker--fixed', {
        'is-open': open
      });
      return /*#__PURE__*/React__default.createElement("div", {
        className: datepickerWrapperClass,
        ref: function ref(node) {
          return _this2.datepicker = node;
        },
        "data-qa": qa
      }, label && /*#__PURE__*/React__default.createElement(InputLabel, {
        htmlFor: id || this.defaultId
      }, label), /*#__PURE__*/React__default.createElement("div", {
        className: "a-input__wrapper"
      }, /*#__PURE__*/React__default.createElement(TextField, {
        mask: mask,
        name: name,
        id: id || this.defaultId,
        value: input,
        placeholder: placeholder,
        required: required,
        readOnly: readOnly,
        disabled: disabled,
        onClick: function onClick() {
          return _this2.onClickInput();
        },
        onChange: function onChange(e) {
          return _this2.changeDate(e.target.value);
        },
        onBlur: onBlur
      }), /*#__PURE__*/React__default.createElement("span", {
        role: "button",
        className: "ai is-clickable",
        tabIndex: "0",
        onClick: this.toggleCalendar.bind(this),
        onKeyPress: this.keyPressed.bind(this),
        "aria-label": "Open"
      }, /*#__PURE__*/React__default.createElement(Icon$1$1, {
        name: "ai-calendar-3"
      })), open && /*#__PURE__*/React__default.createElement("div", {
        className: datepickerClass,
        "aria-hidden": "false"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "m-datepicker is-open"
      }, /*#__PURE__*/React__default.createElement(Calendar, {
        locale: locale,
        format: format,
        activeDate: activeDate,
        selectedDates: selectedDates,
        minDate: minDate,
        maxDate: maxDate,
        noWeekends: noWeekends,
        onChange: this.changeDate.bind(this)
      })))), description && /*#__PURE__*/React__default.createElement("small", null, description), errorDescription && /*#__PURE__*/React__default.createElement("small", {
        className: "u-text-danger"
      }, errorDescription));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      // Reset input value
      if (props.activeDate === '') {
        return {
          activeDate: null,
          input: props.activeDate
        };
      }

      if (props.activeDate) {
        var momentDate = Moment(props.activeDate, props.format, true);

        if (momentDate.isValid()) {
          return {
            activeDate: momentDate,
            input: props.activeDate
          };
        }
      }

      return null;
    }
  }]);

  return Datepicker;
}(Component);

_defineProperty$1$1(Datepicker, "defaultProps", {
  required: false,
  format: 'DD/MM/YYYY',
  autoClose: true,
  noWeekends: false,
  readOnly: false,
  disabled: false
});

var countryCodes = [{
  "value": "+1",
  "label": "+1"
}, {
  "value": "+20",
  "label": "+20"
}, {
  "value": "+211",
  "label": "+211"
}, {
  "value": "+212",
  "label": "+212"
}, {
  "value": "+213",
  "label": "+213"
}, {
  "value": "+216",
  "label": "+216"
}, {
  "value": "+218",
  "label": "+218"
}, {
  "value": "+220",
  "label": "+220"
}, {
  "value": "+221",
  "label": "+221"
}, {
  "value": "+222",
  "label": "+222"
}, {
  "value": "+223",
  "label": "+223"
}, {
  "value": "+224",
  "label": "+224"
}, {
  "value": "+225",
  "label": "+225"
}, {
  "value": "+226",
  "label": "+226"
}, {
  "value": "+227",
  "label": "+227"
}, {
  "value": "+228",
  "label": "+228"
}, {
  "value": "+229",
  "label": "+229"
}, {
  "value": "+230",
  "label": "+230"
}, {
  "value": "+231",
  "label": "+231"
}, {
  "value": "+232",
  "label": "+232"
}, {
  "value": "+233",
  "label": "+233"
}, {
  "value": "+234",
  "label": "+234"
}, {
  "value": "+235",
  "label": "+235"
}, {
  "value": "+236",
  "label": "+236"
}, {
  "value": "+237",
  "label": "+237"
}, {
  "value": "+238",
  "label": "+238"
}, {
  "value": "+239",
  "label": "+239"
}, {
  "value": "+240",
  "label": "+240"
}, {
  "value": "+241",
  "label": "+241"
}, {
  "value": "+242",
  "label": "+242"
}, {
  "value": "+243",
  "label": "+243"
}, {
  "value": "+244",
  "label": "+244"
}, {
  "value": "+245",
  "label": "+245"
}, {
  "value": "+246",
  "label": "+246"
}, {
  "value": "+248",
  "label": "+248"
}, {
  "value": "+249",
  "label": "+249"
}, {
  "value": "+250",
  "label": "+250"
}, {
  "value": "+251",
  "label": "+251"
}, {
  "value": "+252",
  "label": "+252"
}, {
  "value": "+253",
  "label": "+253"
}, {
  "value": "+254",
  "label": "+254"
}, {
  "value": "+255",
  "label": "+255"
}, {
  "value": "+256",
  "label": "+256"
}, {
  "value": "+257",
  "label": "+257"
}, {
  "value": "+258",
  "label": "+258"
}, {
  "value": "+260",
  "label": "+260"
}, {
  "value": "+261",
  "label": "+261"
}, {
  "value": "+262",
  "label": "+262"
}, {
  "value": "+263",
  "label": "+263"
}, {
  "value": "+264",
  "label": "+264"
}, {
  "value": "+265",
  "label": "+265"
}, {
  "value": "+266",
  "label": "+266"
}, {
  "value": "+267",
  "label": "+267"
}, {
  "value": "+268",
  "label": "+268"
}, {
  "value": "+269",
  "label": "+269"
}, {
  "value": "+27",
  "label": "+27"
}, {
  "value": "+290",
  "label": "+290"
}, {
  "value": "+291",
  "label": "+291"
}, {
  "value": "+297",
  "label": "+297"
}, {
  "value": "+298",
  "label": "+298"
}, {
  "value": "+299",
  "label": "+299"
}, {
  "value": "+30",
  "label": "+30"
}, {
  "value": "+31",
  "label": "+31"
}, {
  "value": "+32",
  "label": "+32"
}, {
  "value": "+33",
  "label": "+33"
}, {
  "value": "+34",
  "label": "+34"
}, {
  "value": "+350",
  "label": "+350"
}, {
  "value": "+351",
  "label": "+351"
}, {
  "value": "+352",
  "label": "+352"
}, {
  "value": "+353",
  "label": "+353"
}, {
  "value": "+354",
  "label": "+354"
}, {
  "value": "+355",
  "label": "+355"
}, {
  "value": "+356",
  "label": "+356"
}, {
  "value": "+357",
  "label": "+357"
}, {
  "value": "+358",
  "label": "+358"
}, {
  "value": "+358-18",
  "label": "+358-18"
}, {
  "value": "+359",
  "label": "+359"
}, {
  "value": "+36",
  "label": "+36"
}, {
  "value": "+370",
  "label": "+370"
}, {
  "value": "+371",
  "label": "+371"
}, {
  "value": "+372",
  "label": "+372"
}, {
  "value": "+373",
  "label": "+373"
}, {
  "value": "+374",
  "label": "+374"
}, {
  "value": "+375",
  "label": "+375"
}, {
  "value": "+376",
  "label": "+376"
}, {
  "value": "+377",
  "label": "+377"
}, {
  "value": "+378",
  "label": "+378"
}, {
  "value": "+379",
  "label": "+379"
}, {
  "value": "+380",
  "label": "+380"
}, {
  "value": "+381",
  "label": "+381"
}, {
  "value": "+382",
  "label": "+382"
}, {
  "value": "+385",
  "label": "+385"
}, {
  "value": "+386",
  "label": "+386"
}, {
  "value": "+387",
  "label": "+387"
}, {
  "value": "+389",
  "label": "+389"
}, {
  "value": "+39",
  "label": "+39"
}, {
  "value": "+40",
  "label": "+40"
}, {
  "value": "+41",
  "label": "+41"
}, {
  "value": "+420",
  "label": "+420"
}, {
  "value": "+421",
  "label": "+421"
}, {
  "value": "+423",
  "label": "+423"
}, {
  "value": "+43",
  "label": "+43"
}, {
  "value": "+44",
  "label": "+44"
}, {
  "value": "+44-1481",
  "label": "+44-1481"
}, {
  "value": "+44-1534",
  "label": "+44-1534"
}, {
  "value": "+44-1624",
  "label": "+44-1624"
}, {
  "value": "+45",
  "label": "+45"
}, {
  "value": "+46",
  "label": "+46"
}, {
  "value": "+47",
  "label": "+47"
}, {
  "value": "+48",
  "label": "+48"
}, {
  "value": "+49",
  "label": "+49"
}, {
  "value": "+500",
  "label": "+500"
}, {
  "value": "+501",
  "label": "+501"
}, {
  "value": "+502",
  "label": "+502"
}, {
  "value": "+503",
  "label": "+503"
}, {
  "value": "+504",
  "label": "+504"
}, {
  "value": "+505",
  "label": "+505"
}, {
  "value": "+506",
  "label": "+506"
}, {
  "value": "+507",
  "label": "+507"
}, {
  "value": "+508",
  "label": "+508"
}, {
  "value": "+509",
  "label": "+509"
}, {
  "value": "+51",
  "label": "+51"
}, {
  "value": "+52",
  "label": "+52"
}, {
  "value": "+53",
  "label": "+53"
}, {
  "value": "+54",
  "label": "+54"
}, {
  "value": "+55",
  "label": "+55"
}, {
  "value": "+56",
  "label": "+56"
}, {
  "value": "+57",
  "label": "+57"
}, {
  "value": "+58",
  "label": "+58"
}, {
  "value": "+590",
  "label": "+590"
}, {
  "value": "+591",
  "label": "+591"
}, {
  "value": "+592",
  "label": "+592"
}, {
  "value": "+593",
  "label": "+593"
}, {
  "value": "+594",
  "label": "+594"
}, {
  "value": "+595",
  "label": "+595"
}, {
  "value": "+596",
  "label": "+596"
}, {
  "value": "+597",
  "label": "+597"
}, {
  "value": "+598",
  "label": "+598"
}, {
  "value": "+599",
  "label": "+599"
}, {
  "value": "+60",
  "label": "+60"
}, {
  "value": "+61",
  "label": "+61"
}, {
  "value": "+62",
  "label": "+62"
}, {
  "value": "+63",
  "label": "+63"
}, {
  "value": "+64",
  "label": "+64"
}, {
  "value": "+65",
  "label": "+65"
}, {
  "value": "+66",
  "label": "+66"
}, {
  "value": "+670",
  "label": "+670"
}, {
  "value": "+672",
  "label": "+672"
}, {
  "value": "+673",
  "label": "+673"
}, {
  "value": "+674",
  "label": "+674"
}, {
  "value": "+675",
  "label": "+675"
}, {
  "value": "+676",
  "label": "+676"
}, {
  "value": "+677",
  "label": "+677"
}, {
  "value": "+678",
  "label": "+678"
}, {
  "value": "+679",
  "label": "+679"
}, {
  "value": "+680",
  "label": "+680"
}, {
  "value": "+681",
  "label": "+681"
}, {
  "value": "+682",
  "label": "+682"
}, {
  "value": "+683",
  "label": "+683"
}, {
  "value": "+685",
  "label": "+685"
}, {
  "value": "+686",
  "label": "+686"
}, {
  "value": "+687",
  "label": "+687"
}, {
  "value": "+688",
  "label": "+688"
}, {
  "value": "+689",
  "label": "+689"
}, {
  "value": "+690",
  "label": "+690"
}, {
  "value": "+691",
  "label": "+691"
}, {
  "value": "+692",
  "label": "+692"
}, {
  "value": "+7",
  "label": "+7"
}, {
  "value": "+81",
  "label": "+81"
}, {
  "value": "+82",
  "label": "+82"
}, {
  "value": "+84",
  "label": "+84"
}, {
  "value": "+850",
  "label": "+850"
}, {
  "value": "+852",
  "label": "+852"
}, {
  "value": "+853",
  "label": "+853"
}, {
  "value": "+855",
  "label": "+855"
}, {
  "value": "+856",
  "label": "+856"
}, {
  "value": "+86",
  "label": "+86"
}, {
  "value": "+870",
  "label": "+870"
}, {
  "value": "+880",
  "label": "+880"
}, {
  "value": "+886",
  "label": "+886"
}, {
  "value": "+90",
  "label": "+90"
}, {
  "value": "+91",
  "label": "+91"
}, {
  "value": "+92",
  "label": "+92"
}, {
  "value": "+93",
  "label": "+93"
}, {
  "value": "+94",
  "label": "+94"
}, {
  "value": "+95",
  "label": "+95"
}, {
  "value": "+960",
  "label": "+960"
}, {
  "value": "+961",
  "label": "+961"
}, {
  "value": "+962",
  "label": "+962"
}, {
  "value": "+963",
  "label": "+963"
}, {
  "value": "+964",
  "label": "+964"
}, {
  "value": "+965",
  "label": "+965"
}, {
  "value": "+966",
  "label": "+966"
}, {
  "value": "+967",
  "label": "+967"
}, {
  "value": "+968",
  "label": "+968"
}, {
  "value": "+970",
  "label": "+970"
}, {
  "value": "+971",
  "label": "+971"
}, {
  "value": "+972",
  "label": "+972"
}, {
  "value": "+973",
  "label": "+973"
}, {
  "value": "+974",
  "label": "+974"
}, {
  "value": "+975",
  "label": "+975"
}, {
  "value": "+976",
  "label": "+976"
}, {
  "value": "+977",
  "label": "+977"
}, {
  "value": "+98",
  "label": "+98"
}, {
  "value": "+992",
  "label": "+992"
}, {
  "value": "+993",
  "label": "+993"
}, {
  "value": "+994",
  "label": "+994"
}, {
  "value": "+995",
  "label": "+995"
}, {
  "value": "+996",
  "label": "+996"
}, {
  "value": "+998",
  "label": "+998"
}];

___$insertStyle$1(".a-input-telephone .a-input__wrapper {\n  display: flex;\n}\n.a-input-telephone .a-input__wrapper .a-input-telephone__number {\n  flex: 1;\n}\n.a-input-telephone .a-input__wrapper .a-input-telephone__number input:not([class*=a-button]):not([type=checkbox]):not([type=radio]) {\n  border-left: none;\n}\n.a-input-telephone .a-input__wrapper .a-input-telephone__area-code select:focus,\n.a-input-telephone .a-input__wrapper input:not([class*=a-button]):not([type=checkbox]):not([type=radio]).a-input-telephone__number:focus {\n  z-index: 1;\n}\n.a-input-telephone .a-input__wrapper .a-input-telephone__area-code select:focus + .ai,\n.a-input-telephone .a-input__wrapper input:not([class*=a-button]):not([type=checkbox]):not([type=radio]).a-input-telephone__number:focus + .ai {\n  z-index: 2;\n}\n\n.a-input.has-success .a-input-telephone__area-code .a-input__wrapper:before, .a-input.has-warning .a-input-telephone__area-code .a-input__wrapper:before, .a-input.has-error .a-input-telephone__area-code .a-input__wrapper:before {\n  content: none;\n}");

var _excluded$2 = ["id", "label", "value", "name", "placeholder", "qa", "className", "style", "required", "state", "loading", "onChange", "defaultAreaCode", "description", "errorDescription"];
var stateClasses = {
  success: 'has-success',
  warning: 'has-warning',
  error: 'has-error'
};

var TelephoneNumber = function TelephoneNumber(props) {
  var id = props.id,
      label = props.label,
      value = props.value,
      name = props.name,
      placeholder = props.placeholder,
      qa = props.qa,
      className = props.className,
      style = props.style,
      required = props.required,
      state = props.state,
      loading = props.loading,
      onChange = props.onChange;
  props.defaultAreaCode;

  var description = props.description,
      errorDescription = props.errorDescription,
      extraProps = _objectWithoutProperties$2(props, _excluded$2);

  var valueIsValidObject = function valueIsValidObject(value) {
    return _typeof(value) === 'object' && value !== null;
  };

  var valueIsEqualToInternalValue = function valueIsEqualToInternalValue(val, internalVal) {
    return val.areaCode === internalVal.areaCode && val.number === internalVal.number;
  };

  var _useState = useState(valueIsValidObject(value) ? value : {
    areaCode: internalValue && internalValue.areaCode ? internalValue.areaCode : '+32',
    number: internalValue && internalValue.number ? internalValue.number : ''
  }),
      _useState2 = _slicedToArray(_useState, 2),
      internalValue = _useState2[0],
      setInternalValue = _useState2[1];

  useEffect(function () {
    if (!valueIsValidObject(value) || !valueIsEqualToInternalValue(value, internalValue)) {
      onChange(internalValue);
    }
  }, [internalValue]);
  useEffect(function () {
    if (valueIsValidObject(value) && !valueIsEqualToInternalValue(value, internalValue)) {
      setInternalValue(value);
    }
  }, [value]);

  var updateNumber = function updateNumber(e) {
    setInternalValue(_objectSpread2(_objectSpread2({}, internalValue), {}, {
      number: e.target.value
    }));
  };

  var updateAreaCode = function updateAreaCode(e) {
    setInternalValue(_objectSpread2(_objectSpread2({}, internalValue), {}, {
      areaCode: e.target.value
    }));
  };

  var options = countryCodes;
  var telephoneNumberClass = classNames('a-input', 'a-input-telephone', _defineProperty$1$1({
    'is-required': !!required
  }, "".concat(stateClasses[state]), !!state), className);
  return /*#__PURE__*/React__default.createElement("div", {
    className: telephoneNumberClass,
    style: style,
    "data-qa": qa
  }, label && /*#__PURE__*/React__default.createElement(InputLabel, {
    id: "".concat(id, "-areacode-label"),
    htmlFor: id
  }, label), /*#__PURE__*/React__default.createElement("div", {
    className: "a-input__wrapper"
  }, /*#__PURE__*/React__default.createElement(Select, _extends$1({
    className: "a-input-telephone__area-code",
    id: "".concat(id, "-areacode"),
    ariaLabelledby: "".concat(id, "-areacode-label"),
    name: "".concat(name, "-areacode"),
    required: required,
    onChange: updateAreaCode,
    value: internalValue.areaCode,
    options: options
  }, extraProps)), /*#__PURE__*/React__default.createElement(TextField, _extends$1({
    className: "a-input-telephone__number",
    id: id,
    placeholder: placeholder,
    name: name,
    required: required,
    loading: loading,
    onChange: updateNumber,
    value: internalValue.number
  }, extraProps))), description ? /*#__PURE__*/React__default.createElement("small", null, description) : null, errorDescription && /*#__PURE__*/React__default.createElement("small", {
    className: "u-text-danger"
  }, errorDescription));
};

function asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator$1(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$1(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$1(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$1(Constructor, staticProps);
  return Constructor;
}

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inherits$1(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$1(subClass, superClass);
}

function _getPrototypeOf$1(o) {
  _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$1(o);
}

function _setPrototypeOf$1(o, p) {
  _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$1(o, p);
}

function _isNativeReflectConstruct$1() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties$1(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$1(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized$1(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn$1(self, call) {
  if (call && (_typeof$1(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized$1(self);
}

function _createSuper$1(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$1();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf$1(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$1(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn$1(this, result);
  };
}

var Icon$1 = function Icon(_ref) {
  var name = _ref.name,
      style = _ref.style,
      className = _ref.className,
      ariaLabel = _ref.ariaLabel,
      onClick = _ref.onClick,
      src = _ref.src,
      qa = _ref.qa;
  /**
   * Inject SVG icons from core branding into page
   */

  var fetchAntwerpIcons = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator$1( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var xlinkHref, response, svgText, svgWrapper;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (fetch) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              _context.prev = 2;
              xlinkHref = 'https://cdn.antwerpen.be/core_branding_scss/5.0.0/assets/images/ai.svg';
              _context.next = 6;
              return fetch(xlinkHref);

            case 6:
              response = _context.sent;
              _context.next = 9;
              return response.text();

            case 9:
              svgText = _context.sent;
              svgWrapper = document.createElement('svg');
              svgWrapper.id = 'aiSvg';
              svgWrapper.innerHTML = svgText;

              if (!document.getElementById('aiSvg')) {
                document.body.appendChild(svgWrapper);
              }

              _context.next = 19;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](2);
              throw new Error(_context.t0);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 16]]);
    }));

    return function fetchAntwerpIcons() {
      return _ref2.apply(this, arguments);
    };
  }();

  if (typeof document !== 'undefined' && !document.getElementById('aiSvg')) {
    fetchAntwerpIcons();
  }

  var iconClass = classNames(className, name, 'ai');
  return /*#__PURE__*/React__default.createElement("span", {
    className: iconClass,
    style: style,
    "data-qa": qa,
    onClick: onClick
  }, name && /*#__PURE__*/React__default.createElement("svg", {
    "aria-hidden": "true"
  }, /*#__PURE__*/React__default.createElement("use", {
    href: "#".concat(name)
  })), src, ariaLabel && /*#__PURE__*/React__default.createElement("span", {
    className: "u-screen-reader-only"
  }, ariaLabel));
};

var sizeClasses = {
  tiny: 'a-button--tiny',
  small: 'a-button--small',
  large: 'a-button--large'
};
var typeClasses = {
  primary: '',
  secondary: 'a-button--secondary',
  success: 'a-button--success',
  warning: 'a-button--warning',
  danger: 'a-button--danger',
  transparent: 'a-button--transparent',
  default: 'a-button--default'
};

var Button = /*#__PURE__*/function (_Component) {
  _inherits$1(Button, _Component);

  var _super = _createSuper$1(Button);

  function Button() {
    _classCallCheck$1(this, Button);

    return _super.apply(this, arguments);
  }

  _createClass$1(Button, [{
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props = this.props,
          id = _this$props.id,
          negative = _this$props.negative,
          outline = _this$props.outline,
          transparent = _this$props.transparent,
          className = _this$props.className,
          children = _this$props.children,
          icon = _this$props.icon,
          iconLeft = _this$props.iconLeft,
          iconRight = _this$props.iconRight,
          onClick = _this$props.onClick,
          _this$props$title = _this$props.title,
          title = _this$props$title === void 0 ? '' : _this$props$title,
          _this$props$ariaLabel = _this$props.ariaLabel,
          ariaLabel = _this$props$ariaLabel === void 0 ? '' : _this$props$ariaLabel,
          type = _this$props.type,
          size = _this$props.size,
          _this$props$block = _this$props.block,
          block = _this$props$block === void 0 ? false : _this$props$block,
          _this$props$style = _this$props.style,
          style = _this$props$style === void 0 ? {} : _this$props$style,
          _this$props$disabled = _this$props.disabled,
          disabled = _this$props$disabled === void 0 ? false : _this$props$disabled,
          htmlType = _this$props.htmlType,
          qa = _this$props.qa;
      var btnClass = classNames(className, (_classNames = {
        'a-button': !outline && !negative && !(type === 'default' && !!transparent)
      }, _defineProperty$1(_classNames, "".concat(typeClasses[type]), !!type), _defineProperty$1(_classNames, "".concat(sizeClasses[size]), !!size), _defineProperty$1(_classNames, 'has-icon', !!icon), _defineProperty$1(_classNames, 'has-icon-left', !!iconLeft), _defineProperty$1(_classNames, 'has-icon-right', !!iconRight), _defineProperty$1(_classNames, 'a-button-negative', !!negative), _defineProperty$1(_classNames, 'a-button-outline', !!outline), _defineProperty$1(_classNames, 'a-button-transparent', !!transparent), _defineProperty$1(_classNames, 'a-button--block', block), _classNames));
      return /*#__PURE__*/React__default.createElement("button", {
        id: id,
        className: btnClass,
        title: title || '',
        onClick: onClick,
        style: style,
        disabled: disabled,
        type: htmlType,
        "aria-label": ariaLabel,
        "data-qa": qa
      }, icon ? /*#__PURE__*/React__default.createElement(Icon$1, {
        name: icon
      }) : null, iconLeft ? /*#__PURE__*/React__default.createElement(Icon$1, {
        name: iconLeft
      }) : null, iconRight ? /*#__PURE__*/React__default.createElement(Icon$1, {
        name: iconRight
      }) : null, children);
    }
  }]);

  return Button;
}(Component);

var FlyoutContent = function FlyoutContent(props) {
  var hasPadding = props.hasPadding,
      children = props.children,
      qa = props.qa;
  var classes = classNames('m-flyout__content', {
    'has-padding': !!hasPadding
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: classes,
    "data-qa": qa
  }, children);
};

var _excluded$1 = ["label", "flyoutHasPadding", "children", "qa"];
var flyoutSizes = {
  small: 'sm',
  medium: 'md',
  large: 'lg',
  full: 'full'
};

var FlyoutButton = /*#__PURE__*/function (_Component) {
  _inherits$1(FlyoutButton, _Component);

  var _super = _createSuper$1(FlyoutButton);

  function FlyoutButton() {
    var _this;

    _classCallCheck$1(this, FlyoutButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$1(_assertThisInitialized$1(_this), "state", {
      isOpen: false
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "handleClick", function (event) {
      if (_this.containerRef && !_this.containerRef.contains(event.target)) {
        _this.close();
      }
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "close", function () {
      return _this.setState({
        isOpen: false
      });
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "toggleIsOpen", function () {
      return _this.setState({
        isOpen: !_this.state.isOpen
      });
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "componentDidMount", function () {
      return document.addEventListener('mousedown', _this.handleClick);
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "componentWillUnMount", function () {
      return document.removeEventListener('mousedown', _this.handleClick);
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "getClassNames", function () {
      return classNames('m-flyout', "m-flyout--".concat(_this.props.flyoutDirection), _defineProperty$1({
        'is-open': _this.state.isOpen
      }, "m-flyout--".concat(flyoutSizes[_this.props.flyoutSize]), !!flyoutSizes[_this.props.flyoutSize]));
    });

    return _this;
  }

  _createClass$1(FlyoutButton, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          label = _this$props.label,
          flyoutHasPadding = _this$props.flyoutHasPadding;
      _this$props.children;

      var qa = _this$props.qa,
          buttonProps = _objectWithoutProperties$1(_this$props, _excluded$1);

      var isOpen = this.state.isOpen;
      var flyoutClass = this.getClassNames();
      return /*#__PURE__*/React__default.createElement("div", {
        className: flyoutClass,
        ref: function ref(_ref) {
          _this2.containerRef = _ref;
        },
        "aria-haspopup": "true",
        "aria-expanded": isOpen,
        "data-qa": qa
      }, /*#__PURE__*/React__default.createElement(Button, _extends({}, buttonProps, {
        onClick: this.toggleIsOpen
      }), label), /*#__PURE__*/React__default.createElement(FlyoutContent, {
        hasPadding: flyoutHasPadding
      }, this.props.children));
    }
  }]);

  return FlyoutButton;
}(Component);

_defineProperty$1(FlyoutButton, "defaultProps", {
  label: '',
  flyoutDirection: 'left',
  flyoutSize: 'medium',
  flyoutHasPadding: false,
  icon: false
});

var Filter = function Filter(_ref) {
  var filters = _ref.filters,
      columns = _ref.columns,
      extraFilterMessage = _ref.extraFilterMessage,
      columnOrderChanged = _ref.columnOrderChanged,
      columnVisibilityChanged = _ref.columnVisibilityChanged,
      filtersChanged = _ref.filtersChanged,
      disableColumnSorting = _ref.disableColumnSorting,
      extraTableActions = _ref.extraTableActions;
  var genericFilter = filters.find(function (filter) {
    return filter.display === 'generic';
  });
  var restFilters = filters.filter(function (filter) {
    return filter.display !== 'generic';
  });

  var _useState = useState(false),
      _useState2 = _slicedToArray$1(_useState, 2),
      extraFiltersOpen = _useState2[0],
      setExtraFiltersOpen = _useState2[1];

  var renderFilter = function renderFilter(filter, isGeneric) {
    switch (filter.type) {
      case "select":
        return /*#__PURE__*/React__default.createElement(Select, {
          key: filter.id,
          label: filter.label,
          id: filter.id,
          name: filter.id,
          options: filter.options,
          value: filter.value,
          onChange: function onChange(e) {
            return handleFilter(filter.id, e.target.value);
          },
          size: isGeneric ? "medium" : "small"
        });

      case "datepicker":
        return /*#__PURE__*/React__default.createElement(Datepicker, {
          key: filter.id,
          label: filter.label,
          id: filter.id,
          name: filter.id,
          value: filter.value,
          onChange: function onChange(value) {
            return handleFilter(filter.id, value);
          },
          size: isGeneric ? "medium" : "small"
        });

      case "telephone-number":
        return /*#__PURE__*/React__default.createElement(TelephoneNumber, {
          key: filter.id,
          label: filter.label,
          id: filter.id,
          name: filter.id,
          value: filter.value,
          onChange: function onChange(value) {
            return handleFilter(filter.id, value);
          },
          size: isGeneric ? "medium" : "small"
        });

      default:
        return /*#__PURE__*/React__default.createElement(TextField, {
          key: filter.id,
          label: filter.label,
          id: filter.id,
          name: filter.id,
          placeholder: filter.placeholder,
          value: filter.value,
          onChange: function onChange(e) {
            return handleFilter(filter.id, e.target.value);
          },
          size: isGeneric ? "medium" : "small"
        });
    }
  };

  var handleColumnOrderChange = function handleColumnOrderChange(columnIndex, direction) {
    var tempColumns = columns;
    var selectedColumn = columns[columnIndex];
    tempColumns.splice(columnIndex, 1);
    tempColumns.splice(direction === 'up' ? columnIndex - 1 : columnIndex + 1, 0, selectedColumn);
    columnOrderChanged(tempColumns);
  };

  var handleColumnVisibilityChange = function handleColumnVisibilityChange(columnIndex) {
    var tempColumns = columns;
    tempColumns[columnIndex].visible = !tempColumns[columnIndex].visible;
    columnVisibilityChanged(tempColumns);
  };

  var handleFilter = function handleFilter(fieldName, value) {
    filtersChanged(_objectSpread2$1(_objectSpread2$1({}, filters.reduce(function (acc, filter) {
      return !!filter.value ? _objectSpread2$1(_objectSpread2$1({}, acc), {}, _defineProperty$5({}, filter.id, filter.value)) : acc;
    }, {})), {}, _defineProperty$5({}, fieldName, value)));
  };

  if (!genericFilter && !restFilters.length && disableColumnSorting) {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
  }

  return /*#__PURE__*/React__default.createElement("div", {
    className: "m-table-filter"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "m-table-filter__top-bar"
  }, genericFilter && /*#__PURE__*/React__default.createElement("div", {
    className: "m-table-filter__generic-filter"
  }, renderFilter(genericFilter, true)), !!restFilters.length && /*#__PURE__*/React__default.createElement(Button$2, {
    iconRight: extraFiltersOpen ? "ai-arrow-up-1" : "ai-arrow-down-1",
    onClick: function onClick() {
      return setExtraFiltersOpen(!extraFiltersOpen);
    },
    className: genericFilter ? "u-margin-left-xs" : undefined,
    outline: true
  }, extraFilterMessage), /*#__PURE__*/React__default.createElement("div", {
    className: "m-table-filter__actions"
  }, extraTableActions ? extraTableActions : null, !disableColumnSorting && /*#__PURE__*/React__default.createElement(FlyoutButton, {
    icon: "ai-layout-column",
    flyoutHasPadding: true,
    outline: true,
    flyoutDirection: "right",
    flyoutSize: "small"
  }, columns.map(function (column, i) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "m-table-column-selector",
      key: i
    }, /*#__PURE__*/React__default.createElement(Checkbox, {
      label: column.label,
      id: column.value,
      name: column.label,
      checked: column.visible,
      onChange: function onChange() {
        return handleColumnVisibilityChange(i);
      }
    }), /*#__PURE__*/React__default.createElement("div", {
      className: "m-table-column-selector__order"
    }, /*#__PURE__*/React__default.createElement(Button$2, {
      icon: "ai-arrow-up-1",
      size: "small",
      negative: true,
      disabled: i === 0,
      onClick: function onClick() {
        return handleColumnOrderChange(i, 'up');
      }
    }), /*#__PURE__*/React__default.createElement(Button$2, {
      icon: "ai-arrow-down-1",
      size: "small",
      negative: true,
      disabled: i === columns.length - 1,
      onClick: function onClick() {
        return handleColumnOrderChange(i, 'down');
      }
    })));
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: classNames({
      'm-table-filter__optional-filters': true,
      'm-table-filter__optional-filters--open': extraFiltersOpen
    })
  }, restFilters.map(function (filter) {
    return renderFilter(filter);
  })));
};

var DEFAULT_PAGINATION_OPTIONS = [{
  value: 10,
  label: 10
}, {
  value: 30,
  label: 30
}, {
  value: 50,
  label: 50
}];

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof$1(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

var _excluded = ["component", "children"];

var Link = function Link(_ref) {
  var component = _ref.component,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(component, props, children);
};

Link.defaultProps = {
  component: 'a'
};

var Icon = function Icon(_ref) {
  var name = _ref.name,
      style = _ref.style,
      className = _ref.className,
      ariaLabel = _ref.ariaLabel,
      onClick = _ref.onClick,
      src = _ref.src,
      qa = _ref.qa;
  /**
   * Inject SVG icons from core branding into page
   */

  var fetchAntwerpIcons = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var xlinkHref, response, svgText, svgWrapper;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (fetch) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              _context.prev = 2;
              xlinkHref = 'https://cdn.antwerpen.be/core_branding_scss/5.0.0/assets/images/ai.svg';
              _context.next = 6;
              return fetch(xlinkHref);

            case 6:
              response = _context.sent;
              _context.next = 9;
              return response.text();

            case 9:
              svgText = _context.sent;
              svgWrapper = document.createElement('svg');
              svgWrapper.id = 'aiSvg';
              svgWrapper.innerHTML = svgText;

              if (!document.getElementById('aiSvg')) {
                document.body.appendChild(svgWrapper);
              }

              _context.next = 19;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](2);
              throw new Error(_context.t0);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 16]]);
    }));

    return function fetchAntwerpIcons() {
      return _ref2.apply(this, arguments);
    };
  }();

  if (typeof document !== 'undefined' && !document.getElementById('aiSvg')) {
    fetchAntwerpIcons();
  }

  var iconClass = classNames(className, name, 'ai');
  return /*#__PURE__*/React__default.createElement("span", {
    className: iconClass,
    style: style,
    "data-qa": qa,
    onClick: onClick
  }, name && /*#__PURE__*/React__default.createElement("svg", {
    "aria-hidden": "true"
  }, /*#__PURE__*/React__default.createElement("use", {
    href: "#".concat(name)
  })), src, ariaLabel && /*#__PURE__*/React__default.createElement("span", {
    className: "u-screen-reader-only"
  }, ariaLabel));
};

var Pagination = /*#__PURE__*/function (_Component) {
  _inherits(Pagination, _Component);

  var _super = _createSuper(Pagination);

  function Pagination(props) {
    var _this;

    _classCallCheck(this, Pagination);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onPrev", function (e) {
      e.preventDefault();
      var currentPage = _this.state.currentPage;

      if (currentPage > 1) {
        _this.onChange(currentPage - 1);
      }

      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "onNext", function (e) {
      e.preventDefault();
      var _this$state = _this.state,
          currentPage = _this$state.currentPage,
          totalPages = _this$state.totalPages;

      if (currentPage < totalPages) {
        _this.onChange(currentPage + 1);
      }

      return false;
    });

    _this.state = _this.setValues();
    return _this;
  }

  _createClass(Pagination, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.currentPage !== this.props.currentPage || prevProps.itemsPerPage !== this.props.itemsPerPage || prevProps.totalValues !== this.props.totalValues) {
        this.setState(this.setValues);
      }
    }
  }, {
    key: "onChange",
    value: function onChange(i, e) {
      if (e) {
        e.preventDefault();
      }

      var onUpdate = this.props.onUpdate;
      var parsedValue = parseInt(i, 10); // input from numbers array is a string

      if (parsedValue && onUpdate) {
        onUpdate(parsedValue);
      }

      return false;
    }
  }, {
    key: "setValues",
    value: function setValues() {
      var _this$props = this.props,
          totalValues = _this$props.totalValues,
          itemsPerPage = _this$props.itemsPerPage,
          currentPage = _this$props.currentPage;
      var _currentPage = 0;
      var _numbers = 0;
      var _totalPages = 0;

      if (totalValues && itemsPerPage) {
        _currentPage = Number(currentPage);
        _totalPages = Math.ceil(totalValues / itemsPerPage);
        var generateNumbers = Array(_totalPages).fill('').map(function (e, i) {
          return String(i + 1);
        });

        if (generateNumbers.length < 8) {
          return {
            numbers: generateNumbers,
            totalPages: _totalPages,
            currentPage: _currentPage
          };
        }

        if (_currentPage < 5) {
          _numbers = generateNumbers.slice(0, 5);
        } else if (_currentPage > _totalPages - 4) {
          _numbers = generateNumbers.slice(_totalPages - 5);
        } else {
          _numbers = generateNumbers.slice(_currentPage - 2, _currentPage + 1);
        } // First page


        if (_numbers.indexOf('1') === -1) {
          _numbers.unshift('1');
        } // Last Page


        if (_numbers.indexOf(String(_totalPages)) === -1) {
          _numbers.push(String(_totalPages));
        } // Add dots at the beginning


        if (_numbers.indexOf('2') === -1) {
          _numbers.splice(1, 0, '...');
        } // Add dots at the end


        if (_numbers.indexOf(String(_totalPages - 1)) === -1) {
          _numbers.splice(_numbers.length - 1, 0, '...');
        }
      }

      return {
        numbers: _numbers,
        totalPages: _totalPages,
        currentPage: _currentPage
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          styling = _this$props2.styling,
          display = _this$props2.display,
          _this$props2$ariaLabe = _this$props2.ariaLabel,
          ariaLabel = _this$props2$ariaLabe === void 0 ? 'Paginering' : _this$props2$ariaLabe,
          _this$props2$ariaLabe2 = _this$props2.ariaLabelNextPage,
          ariaLabelNextPage = _this$props2$ariaLabe2 === void 0 ? 'Volgende pagina' : _this$props2$ariaLabe2,
          _this$props2$ariaLabe3 = _this$props2.ariaLabelPreviousPage,
          ariaLabelPreviousPage = _this$props2$ariaLabe3 === void 0 ? 'Vorige pagina' : _this$props2$ariaLabe3,
          _this$props2$ariaLabe4 = _this$props2.ariaLabelPage,
          ariaLabelPage = _this$props2$ariaLabe4 === void 0 ? 'Pagina' : _this$props2$ariaLabe4,
          qa = _this$props2.qa; // we render this, so it must be capitalized

      var _this$state2 = this.state,
          numbers = _this$state2.numbers,
          currentPage = _this$state2.currentPage,
          totalPages = _this$state2.totalPages;
      var paginationClasses = classNames('m-pagination', styling);
      var previousDisabledClasses = classNames('pagination-prev-page', {
        'is-disabled': currentPage <= 1
      });
      var nextDisabledClasses = classNames('pagination-next-page', {
        'is-disabled': currentPage >= totalPages
      });

      if (totalPages < 1) {
        return null;
      }

      return /*#__PURE__*/React__default.createElement("nav", {
        role: "navigation",
        "aria-label": ariaLabel,
        "data-qa": qa
      }, /*#__PURE__*/React__default.createElement("ul", {
        className: paginationClasses
      }, /*#__PURE__*/React__default.createElement("li", {
        className: "m-pagination__prev",
        key: "pagination__prev"
      }, /*#__PURE__*/React__default.createElement(Link, {
        className: previousDisabledClasses,
        href: currentPage > 1 ? '#' : null,
        onClick: function onClick(e) {
          return _this2.onPrev(e);
        },
        "aria-label": ariaLabelPreviousPage
      }, /*#__PURE__*/React__default.createElement(Icon, {
        name: "ai-arrow-left-1",
        ariaLabel: ariaLabelPreviousPage
      }))), display === 'text' && /*#__PURE__*/React__default.createElement("li", {
        className: "m-pagination__label",
        key: "pagination__label"
      }, "".concat(currentPage, " - ").concat(totalPages)), display === 'numbers' && numbers.map(function (number, i) {
        if (number === '...') {
          return /*#__PURE__*/React__default.createElement("li", {
            key: i
          }, "...");
        } else {
          return /*#__PURE__*/React__default.createElement("li", {
            key: i
          }, /*#__PURE__*/React__default.createElement(Link, {
            className: classNames({
              'is-active': number === "".concat(currentPage)
            }, "pagination-button-".concat(i)),
            href: '#',
            onClick: function onClick(e) {
              return _this2.onChange(number, e);
            },
            "aria-label": "".concat(ariaLabelPage, " ").concat(number),
            "aria-current": number === "".concat(currentPage) ? 'page' : null
          }, number));
        }
      }), /*#__PURE__*/React__default.createElement("li", {
        className: "m-pagination__next",
        key: "pagination__next"
      }, /*#__PURE__*/React__default.createElement(Link, {
        className: nextDisabledClasses,
        href: currentPage < totalPages ? '#' : null,
        onClick: function onClick(e) {
          return _this2.onNext(e);
        },
        "aria-label": ariaLabelNextPage
      }, /*#__PURE__*/React__default.createElement(Icon, {
        name: "ai-arrow-right-1",
        ariaLabel: ariaLabelNextPage
      })))));
    }
  }]);

  return Pagination;
}(Component);

_defineProperty(Pagination, "defaultProps", {
  currentPage: 1,
  styling: 'basic',
  display: 'numbers'
});

___$insertStyle("/**\n * QUARKS\n * -------------------------------------------------------------------\n */\n/**\n * MIXINS\n * -------------------------------------------------------------------\n * Collection of custom mixins\n */\n/**\n * FONT FACE\n * -------------------------------------------------------------------\n */\n/**\n * BUTTON MIXIN\n * -------------------------------------------------------------------\n */\n/**\n * BUTTON OUTLINE MIXIN\n * -------------------------------------------------------------------\n */\n/**\n * INPUT MIXIN\n * -------------------------------------------------------------------\n */\n/**\n * INPUT PLACEHOLDER MIXIN\n * -------------------------------------------------------------------\n * Change base styling for placeholder text on input fields\n * Note: Styling the placeholder text is not supported on older\n * browsers, use a html5-placeholder polyfill for that\n *\n * Background info:\n * - http://davidwalsh.name/html5-placeholder\n * - http://davidwalsh.name/placeholder-overflow\n * - http://jamesallardice.github.io/Placeholders.js\n */\n/**\n * ALERT MIXIN\n * -------------------------------------------------------------------\n */\n/**\n * BADGE MIXIN\n * -------------------------------------------------------------------\n */\n/**\n * LABEL MIXIN\n * -------------------------------------------------------------------\n */\n/**\n * TOOLTIP MIXIN\n * -------------------------------------------------------------------\n */\n/**\n * FOCUS\n * -------------------------------------------------------------------\n */\n/**\n * CLEARFIX\n * -------------------------------------------------------------------\n */\n/**\n * MEDIA QUERIES MIXIN\n * -------------------------------------------------------------------\n */\n/**\n * FUNCTIONS\n * -------------------------------------------------------------------\n * Collection of custom functions\n */\n/**\n * STRIP UNIT FROM VALUE\n * -------------------------------------------------------------------\n */\n/**\n * CONVERT PX TO REM\n * -------------------------------------------------------------------\n */\n/**\n * RAISE NUMBER TO CERTAIN POWER\n * -------------------------------------------------------------------\n */\n/**\n * HANDLING Z-INDEX LAYERS\n * -------------------------------------------------------------------\n */\n/**\n * COLORS\n * -------------------------------------------------------------------\n * Collection of all available branding colors\n */\n/**\n * COMPLETE COLOR PALETTE\n * -------------------------------------------------------------------\n * Variable names generated by Name That Color\n * http://chir.ag/projects/name-that-color\n */\n/**\n * GRAY COLOR PALETTE\n * -------------------------------------------------------------------\n * Collection of warm gray colors\n */\n/**\n * WEB GRAYSCALE COLOR PALETTE\n * -------------------------------------------------------------------\n * Collection of grayscale colors\n */\n/**\n * SOCIAL BRAND COLOR PALETTE\n * -------------------------------------------------------------------\n * Collection of social branding colors\n */\n/**\n * GLOBAL VARIABLES\n * -------------------------------------------------------------------\n * Leave here for renderer\n */\n/**\n * COLORS\n * -------------------------------------------------------------------\n * Collection of all available branding colors\n */\n/**\n * COMPLETE COLOR PALETTE\n * -------------------------------------------------------------------\n * Variable names generated by Name That Color\n * http://chir.ag/projects/name-that-color\n */\n/**\n * GRAY COLOR PALETTE\n * -------------------------------------------------------------------\n * Collection of warm gray colors\n */\n/**\n * WEB GRAYSCALE COLOR PALETTE\n * -------------------------------------------------------------------\n * Collection of grayscale colors\n */\n/**\n * SOCIAL BRAND COLOR PALETTE\n * -------------------------------------------------------------------\n * Collection of social branding colors\n */\n/**\n * FUNCTIONS\n * -------------------------------------------------------------------\n * Collection of custom functions\n */\n/**\n * STRIP UNIT FROM VALUE\n * -------------------------------------------------------------------\n */\n/**\n * CONVERT PX TO REM\n * -------------------------------------------------------------------\n */\n/**\n * RAISE NUMBER TO CERTAIN POWER\n * -------------------------------------------------------------------\n */\n/**\n * HANDLING Z-INDEX LAYERS\n * -------------------------------------------------------------------\n */\n/**\n * MIXINS\n * -------------------------------------------------------------------\n * Collection of custom mixins\n */\n/**\n * FONT FACE\n * -------------------------------------------------------------------\n */\n/**\n * BUTTON MIXIN\n * -------------------------------------------------------------------\n */\n/**\n * BUTTON OUTLINE MIXIN\n * -------------------------------------------------------------------\n */\n/**\n * INPUT MIXIN\n * -------------------------------------------------------------------\n */\n/**\n * INPUT PLACEHOLDER MIXIN\n * -------------------------------------------------------------------\n * Change base styling for placeholder text on input fields\n * Note: Styling the placeholder text is not supported on older\n * browsers, use a html5-placeholder polyfill for that\n *\n * Background info:\n * - http://davidwalsh.name/html5-placeholder\n * - http://davidwalsh.name/placeholder-overflow\n * - http://jamesallardice.github.io/Placeholders.js\n */\n/**\n * ALERT MIXIN\n * -------------------------------------------------------------------\n */\n/**\n * BADGE MIXIN\n * -------------------------------------------------------------------\n */\n/**\n * LABEL MIXIN\n * -------------------------------------------------------------------\n */\n/**\n * TOOLTIP MIXIN\n * -------------------------------------------------------------------\n */\n/**\n * FOCUS\n * -------------------------------------------------------------------\n */\n/**\n * CLEARFIX\n * -------------------------------------------------------------------\n */\n/**\n * MEDIA QUERIES MIXIN\n * -------------------------------------------------------------------\n */\n/**\n * SPECIFIC COLOR PALETTE\n * -------------------------------------------------------------------\n */\n/**\n * SPACERS\n * -------------------------------------------------------------------\n */\n/**\n * BREAKPOINTS\n * -------------------------------------------------------------------\n */\n/**\n * $screen-xl =\n *    max-width of u-container\n *    + width of official logo * 2\n *    + space between logo and u-container * 2\n */\n/**\n * FONT FAMILIES\n * -------------------------------------------------------------------\n */\n/**\n * FONT SIZES\n * -------------------------------------------------------------------\n */\n/**\n * LINE HEIGHTS\n * -------------------------------------------------------------------\n */\n/**\n * FONT WEIGHTS\n * -------------------------------------------------------------------\n */\n/**\n * OTHER TYPOGRAPHY\n * -------------------------------------------------------------------\n */\n/**\n * ANIMATIONS\n * -------------------------------------------------------------------\n */\n/**\n * Z-INDEXES\n * -------------------------------------------------------------------\n * http://www.sitepoint.com/better-solution-managing-z-index-sass/\n *\n * Use like this:\n *   z-index: layer('overlay');\n *     where overlay is a list item of the default list \"$z-indexes\" (see below)\n *\n * The list is also upgradeable in that nesting is permitted, e.g.:\n * z-indexes: (\n *   'modal': (\n *     'back': 50,\n *     'front': 60\n *   ),\n *   'navigation': 40,\n *   ...\n * )\n */\n/**\n * ICON SIZES\n * -------------------------------------------------------------------\n */\n/**\n * BOX SHADOWS\n * -------------------------------------------------------------------\n */\n/**\n * LINKS\n * -------------------------------------------------------------------\n * Define text and hover color for each hyperlink\n */\n/**\n * LISTS\n * -------------------------------------------------------------------\n * Define default paddings for lists\n */\n/**\n * PRE\n * -------------------------------------------------------------------\n * Define text and background color for each code element\n */\n/**\n * CODE\n * -------------------------------------------------------------------\n * Define text and background color for each code element\n */\n/**\n * MARK\n * -------------------------------------------------------------------\n * Define text and background color for each mark element\n */\n/**\n * CITE\n * -------------------------------------------------------------------\n */\n/**\n * FIGCAPTION\n * -------------------------------------------------------------------\n */\n/**\n * TABLES\n * -------------------------------------------------------------------\n * Define background and border color for each table\n */\n/**\n * BUTTONS\n * -------------------------------------------------------------------\n * Define text, background and border color for each button\n */\n/**\n * FORMS\n * -------------------------------------------------------------------\n * Define text, background, border and placeholder color for each input\n */\n/**\n * RADIO BUTTONS & CHECKBOXES\n * -------------------------------------------------------------------\n */\n/**\n * SWITCHES\n * -------------------------------------------------------------------\n * WATCH OUT\n * $progress-height and $range-slider-height are equal to $switch-height\n * In this way, changing the height of the switch will also affect the height of the progress bar and range slider\n */\n/**\n * FIELDSET\n * -------------------------------------------------------------------\n */\n/**\n * TOOLTIP\n * -------------------------------------------------------------------\n */\n/**\n * PROGRESS\n * -------------------------------------------------------------------\n * WATCH OUT\n * $range-slider-offset is equal to $tooltip-offset\n * In this way, changing the offset of the progress bar will also affect the offset of the range slider\n */\n/**\n * RANGE SLIDER\n * -------------------------------------------------------------------\n */\n/**\n * LINK LIST\n * -------------------------------------------------------------------\n */\n/**\n * DATEPICKER\n * -------------------------------------------------------------------\n */\n/**\n * ACCORDION\n * -------------------------------------------------------------------\n */\n/**\n * ALERTS\n * -------------------------------------------------------------------\n */\n/**\n * AVATARS\n * -------------------------------------------------------------------\n */\n/**\n * BADGES\n * -------------------------------------------------------------------\n */\n/**\n * BREADCRUMBS\n * -------------------------------------------------------------------\n */\n/**\n * CARDS\n * -------------------------------------------------------------------\n */\n/**\n * COPYRIGHT\n * -------------------------------------------------------------------\n */\n/**\n * LABELS\n * -------------------------------------------------------------------\n */\n/**\n * TAGS\n * -------------------------------------------------------------------\n */\n/**\n * FLYOUT\n * -------------------------------------------------------------------\n */\n/**\n * FOOTER\n * -------------------------------------------------------------------\n */\n/**\n * HEADER\n * -------------------------------------------------------------------\n */\n/**\n * SPINNER\n * -------------------------------------------------------------------\n */\n/**\n * ICON LIST\n * -------------------------------------------------------------------\n */\n/**\n * OVERLAY\n * -------------------------------------------------------------------\n */\n/**\n * MODAL\n * -------------------------------------------------------------------\n */\n/**\n * NAVIGATION\n * -------------------------------------------------------------------\n */\n/**\n * PAGINATION\n * -------------------------------------------------------------------\n */\n/**\n * STEP INDICATOR\n * -------------------------------------------------------------------\n */\n/**\n * UPLOAD\n * -------------------------------------------------------------------\n */\n/**\n * GALLERY\n * -------------------------------------------------------------------\n */\n/**\n * SLIDESHOW\n * -------------------------------------------------------------------\n */\n/**\n * NAVIGATION MENU\n * -------------------------------------------------------------------\n */\n/**\n * ARTICLE\n * -------------------------------------------------------------------\n */\n.a-table__wrapper-responsive tbody tr {\n  border-bottom: none;\n}\n.a-table__wrapper-responsive td {\n  position: relative;\n}\n.a-table__wrapper-responsive td::after {\n  content: \"\";\n  width: 100%;\n  height: 1px;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  border-bottom: 1px solid #949494;\n}\n\n.a-table.a-table--fixed {\n  table-layout: fixed;\n}\n.a-table th > .a-table__header-button {\n  padding-left: 0;\n  width: auto;\n}\n.a-table th > .a-table__header-button .fa {\n  font-size: 1rem;\n}\n.a-table.a-table--primary th > .a-table__header-button, .a-table.a-table--secondary th > .a-table__header-button {\n  color: #fff;\n}\n.a-table.a-table--has-placeholder,\n.a-table .a-table--loading {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  min-width: 100%;\n}\n.a-table.a-table--has-placeholder {\n  border: 1px dashed #949494;\n  padding: 1.5rem;\n  flex-direction: column;\n  align-items: flex-start;\n}\n.a-table.a-table--has-placeholder .a-table--has-placeholder__item:not(:last-child) {\n  margin-bottom: 0.75rem;\n}\n.a-table .a-table-expanded-row {\n  background-color: #fff !important;\n}\n.a-table .a-table__row--level-1 td:first-child::after {\n  left: 0;\n}\n.a-table .a-table__row--level-2 td:first-child {\n  padding-left: 3.75rem;\n}\n.a-table .a-table__row--level-2 td:first-child::before {\n  content: \"\";\n  background: white;\n  width: 2.25rem;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n.a-table .a-table__row--level-2 td:first-child::after {\n  left: 2.25rem;\n}\n.a-table .a-table__row--level-2.a-table__row--last-in-level td:first-child::after {\n  left: 0;\n}\n.a-table .a-table__row--collapse {\n  display: none;\n}\n\n.m-table-filter {\n  margin-bottom: 1.5rem;\n}\n.m-table-filter__actions {\n  margin-left: auto;\n}\n.m-table-filter__top-bar {\n  display: flex;\n  align-items: flex-end;\n}\n.m-table-filter__generic-filter {\n  min-width: 40%;\n}\n.m-table-filter__optional-filters {\n  align-items: flex-end;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  display: none;\n}\n.m-table-filter__optional-filters--open {\n  margin-top: 0.75rem;\n  display: flex;\n}\n.m-table-filter__optional-filters > .a-input {\n  flex: 1;\n}\n\n.m-table-column-selector {\n  display: flex;\n  align-items: center;\n}\n.m-table-column-selector__order {\n  margin-left: auto;\n}\n.m-table-column-selector .a-input__label {\n  margin-bottom: 0;\n}\n\n.m-table-pagination {\n  display: flex;\n  align-items: center;\n  margin-top: 1.5rem;\n}\n.m-table-pagination nav {\n  margin-left: auto;\n}");

var Table = function Table(_ref) {
  var tableId = _ref.tableId,
      className = _ref.className,
      tableClassName = _ref.tableClassName,
      _ref$rows = _ref.rows,
      rows = _ref$rows === void 0 ? [] : _ref$rows,
      _ref$columns = _ref.columns,
      columns = _ref$columns === void 0 ? [] : _ref$columns,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      _ref$responsive = _ref.responsive,
      responsive = _ref$responsive === void 0 ? true : _ref$responsive,
      _ref$fixed = _ref.fixed,
      fixed = _ref$fixed === void 0 ? false : _ref$fixed,
      _ref$hasClickAction = _ref.hasClickAction,
      hasClickAction = _ref$hasClickAction === void 0 ? false : _ref$hasClickAction,
      sorting = _ref.sorting,
      sortingChanged = _ref.sortingChanged,
      filtersChanged = _ref.filtersChanged;
  _ref.rowClicked;
  var paginationChanged = _ref.paginationChanged,
      _ref$striped = _ref.striped,
      striped = _ref$striped === void 0 ? true : _ref$striped,
      _ref$saveFilters = _ref.saveFilters,
      saveFilters = _ref$saveFilters === void 0 ? false : _ref$saveFilters;
  _ref.saveColumns;
  var _ref$disableColumnSor = _ref.disableColumnSorting,
      disableColumnSorting = _ref$disableColumnSor === void 0 ? false : _ref$disableColumnSor,
      type = _ref.type,
      _ref$draggable = _ref.draggable,
      draggable = _ref$draggable === void 0 ? false : _ref$draggable,
      _ref$paginationOption = _ref.paginationOptions,
      paginationOptions = _ref$paginationOption === void 0 ? DEFAULT_PAGINATION_OPTIONS : _ref$paginationOption,
      _ref$ariaLabels = _ref.ariaLabels,
      ariaLabels = _ref$ariaLabels === void 0 ? {
    loadDataMessage: 'Aan het laden...',
    extraFilterMessage: 'Extra filters',
    perPageMessage: 'Items per pagina',
    ofMessage: 'van'
  } : _ref$ariaLabels,
      _ref$filters = _ref.filters,
      filters = _ref$filters === void 0 ? [] : _ref$filters,
      extraTableActions = _ref.extraTableActions,
      itemsPerPage = _ref.itemsPerPage,
      currentPage = _ref.currentPage,
      totalItems = _ref.totalItems;

  var _useState = useState(localStorage.getItem("antwerp-ui_table_columns_".concat(tableId)) ? JSON.parse(localStorage.getItem("antwerp-ui_table_columns_".concat(tableId))) : []),
      _useState2 = _slicedToArray$1(_useState, 2),
      savedColumns = _useState2[0],
      setSavedColumns = _useState2[1];

  var _useState3 = useState(localStorage.getItem("antwerp-ui_table_filters_".concat(tableId)) ? JSON.parse(localStorage.getItem("antwerp-ui_table_filters_".concat(tableId))) : {}),
      _useState4 = _slicedToArray$1(_useState3, 2),
      savedFilters = _useState4[0],
      setSavedFilters = _useState4[1];

  !loading && columns.length > 0;
  !loading && rows.length > 0;
  var showLoader = !!loading;
  var mappedColumns = columns.reduce(function (acc, column) {
    var savedColumnIndex = savedColumns.findIndex(function (x) {
      return x.id === column.id;
    });

    if (savedColumnIndex === -1) {
      acc.push(_objectSpread2$1(_objectSpread2$1({}, column), {}, {
        visible: true
      }));
      return acc;
    }

    var savedColumn = savedColumns[savedColumnIndex];
    acc.splice(savedColumnIndex, 0, _objectSpread2$1(_objectSpread2$1({}, column), {}, {
      visible: savedColumn.visible !== undefined ? savedColumn.visible : true
    }));
    return acc;
  }, []);
  var mappedFilters = filters.map(function (filter) {
    return _objectSpread2$1(_objectSpread2$1({}, filter), {}, {
      value: savedFilters[filter.id] || undefined
    });
  });

  var onSortClick = function onSortClick(key, order) {
    if (sortingChanged) {
      sortingChanged({
        key: key,
        order: order
      });
    }
  };

  var handleColumnsChanged = function handleColumnsChanged(newColumns) {
    localStorage.setItem("antwerp-ui_table_columns_".concat(tableId), JSON.stringify(newColumns));
    setSavedColumns(newColumns);
  };

  var handleFiltersChanged = function handleFiltersChanged(newFilters) {
    if (saveFilters) {
      localStorage.setItem("antwerp-ui_table_filters_".concat(tableId), JSON.stringify(newFilters));
    }

    if (filtersChanged) {
      filtersChanged(newFilters);
    }

    setSavedFilters(newFilters);
  };

  var renderLoader = function renderLoader() {
    return /*#__PURE__*/React__default.createElement(TableLoader, {
      loadDataMessage: ariaLabels.loadDataMessage
    });
  };

  var renderTableRow = function renderTableRow(row, rowIndex, level, isLast) {
    var _row$rows;

    return /*#__PURE__*/React__default.createElement(Fragment, {
      key: "table-row-".concat(level, "-").concat(rowIndex)
    }, /*#__PURE__*/React__default.createElement(TableRow, {
      className: row && row.classList ? row.classList : '',
      hasClickAction: hasClickAction,
      level: level,
      isLast: isLast
    }, mappedColumns.filter(function (column) {
      return column.visible;
    }).map(function (col) {
      return /*#__PURE__*/React__default.createElement(TableCell, getCellProps(col, row, rowIndex));
    })), row !== null && row !== void 0 && (_row$rows = row.rows) !== null && _row$rows !== void 0 && _row$rows.length ? row.rows.map(function (subRow, subRowIndex) {
      return renderTableRow(subRow, subRowIndex, level + 1, row.rows.length - 1 === subRowIndex);
    }) : null);
  };

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Filter, {
    filters: mappedFilters,
    columns: mappedColumns,
    extraFilterMessage: ariaLabels.extraFilterMessage,
    columnOrderChanged: handleColumnsChanged,
    columnVisibilityChanged: handleColumnsChanged,
    filtersChanged: handleFiltersChanged,
    disableColumnSorting: disableColumnSorting,
    extraTableActions: extraTableActions
  }), /*#__PURE__*/React__default.createElement("div", {
    className: classNames(className, {
      'a-table__wrapper-responsive': responsive
    })
  }, /*#__PURE__*/React__default.createElement("table", {
    className: classNames('a-table', tableClassName, _defineProperty$5({
      'a-table--draggable': draggable,
      'a-table--striped': striped,
      'a-table--fixed': fixed
    }, "a-table--".concat(type), type))
  }, mappedColumns.length > 0 && /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement(TableRow, null, mappedColumns.filter(function (column) {
    return column.visible;
  }).map(function (col, index) {
    return /*#__PURE__*/React__default.createElement(TableHeader, getHeaderProps(col, sorting, onSortClick, index));
  }))), /*#__PURE__*/React__default.createElement("tbody", null, showLoader ? renderLoader() : rows.map(function (row, index) {
    return renderTableRow(row, index);
  })))), currentPage && totalItems && currentPage && /*#__PURE__*/React__default.createElement("div", {
    className: "m-table-pagination"
  }, /*#__PURE__*/React__default.createElement(Select, {
    inline: true,
    placeholder: itemsPerPage,
    options: paginationOptions,
    onChange: function onChange(e) {
      return paginationChanged({
        currentPage: currentPage,
        itemsPerPage: parseInt(e.target.value),
        totalItems: totalItems
      });
    }
  }), /*#__PURE__*/React__default.createElement("p", {
    className: "u-margin-left-xs"
  }, ariaLabels.perPageMessage, " | ", (currentPage - 1) * itemsPerPage + 1, " - ", (currentPage - 1) * itemsPerPage + itemsPerPage, " ", ariaLabels.ofMessage, " ", totalItems), /*#__PURE__*/React__default.createElement(Pagination, {
    currentPage: currentPage,
    itemsPerPage: itemsPerPage,
    totalValues: totalItems,
    styling: "m-pagination--outline",
    display: "numbers",
    buttonType: "button",
    onUpdate: function onUpdate(n) {
      return paginationChanged({
        currentPage: n,
        itemsPerPage: itemsPerPage,
        totalItems: totalItems
      });
    }
  })));
};

export { Accordion, AccordionTab, AccordionTabContent, AccordionTabHeader, Alert, Autocomplete, Avatar$1 as Avatar, Badge, Breadcrumbs, Button$9 as Button, ButtonGroup, Calendar$3 as Calendar, Card, CardActions, CardBody, CardDescription, CardHeader, CardIcon, CardImage, CardTitle, Checkbox$1 as Checkbox, Contact, Content, Datepicker$1 as Datepicker, Environment, Fieldset, Flyout$1 as Flyout, FlyoutButton$1 as FlyoutButton, Footer, Form, Header, Hero, Icon$9 as Icon, InputLabel$3 as InputLabel, Label, Link$2 as Link, Modal, Pagination$1 as Pagination, RadioGroup, Select$1 as Select, Slider, Spinner$2 as Spinner, Step, Steps, Switch, Table, Tabs, TagList, TagListItem, TelephoneNumber$1 as TelephoneNumber, TextField$1 as TextField, Textarea, Toggle, UserMenu };
